import { Location } from 'data/location/location.types';

// eslint-disable-next-line import/prefer-default-export
export const mockLocations:Location[] = [
    {
        id: 2,
        country: 'US',
        stateCode: 'AL',
        stateName: 'Alabama',
        cities: [
            {
                id: 146,
                city: 'Abbeville',
                latitude: 31.57184,
                longitude: -85.25049,
                timezone: 'America/Chicago'
            },
            {
                id: 147,
                city: 'Adamsville',
                latitude: 33.60094,
                longitude: -86.95611,
                timezone: 'America/Chicago'
            },
            {
                id: 148,
                city: 'Alabaster',
                latitude: 33.24428,
                longitude: -86.81638,
                timezone: 'America/Chicago'
            },
            {
                id: 149,
                city: 'Albertville',
                latitude: 34.26759,
                longitude: -86.20887,
                timezone: 'America/Chicago'
            },
            {
                id: 150,
                city: 'Alexander City',
                latitude: 32.94401,
                longitude: -85.95385,
                timezone: 'America/Chicago'
            },
            {
                id: 151,
                city: 'Aliceville',
                latitude: 33.12957,
                longitude: -88.15142,
                timezone: 'America/Chicago'
            },
            {
                id: 152,
                city: 'Andalusia',
                latitude: 31.3085,
                longitude: -86.48329,
                timezone: 'America/Chicago'
            },
            {
                id: 153,
                city: 'Anniston',
                latitude: 33.65983,
                longitude: -85.83163,
                timezone: 'America/Chicago'
            },
            {
                id: 154,
                city: 'Arab',
                latitude: 34.33239,
                longitude: -86.50117,
                timezone: 'America/Chicago'
            },
            {
                id: 155,
                city: 'Ashville',
                latitude: 33.83704,
                longitude: -86.25442,
                timezone: 'America/Chicago'
            },
            {
                id: 156,
                city: 'Athens',
                latitude: 34.80287,
                longitude: -86.97167,
                timezone: 'America/Chicago'
            },
            {
                id: 157,
                city: 'Atmore',
                latitude: 31.02379,
                longitude: -87.49387,
                timezone: 'America/Chicago'
            },
            {
                id: 158,
                city: 'Attalla',
                latitude: 34.02176,
                longitude: -86.08859,
                timezone: 'America/Chicago'
            },
            {
                id: 159,
                city: 'Auburn',
                latitude: 32.60986,
                longitude: -85.48078,
                timezone: 'America/Chicago'
            },
            {
                id: 160,
                city: 'Bay Minette',
                latitude: 30.88296,
                longitude: -87.77305,
                timezone: 'America/Chicago'
            },
            {
                id: 161,
                city: 'Bayou La Batre',
                latitude: 30.40352,
                longitude: -88.24852,
                timezone: 'America/Chicago'
            },
            {
                id: 162,
                city: 'Bessemer',
                latitude: 33.40178,
                longitude: -86.95444,
                timezone: 'America/Chicago'
            },
            {
                id: 163,
                city: 'Birmingham',
                latitude: 33.52744,
                longitude: -86.79905,
                timezone: 'America/Chicago'
            },
            {
                id: 164,
                city: 'Boaz',
                latitude: 34.19902,
                longitude: -86.15515,
                timezone: 'America/Chicago'
            },
            {
                id: 165,
                city: 'Brent',
                latitude: 32.93735,
                longitude: -87.16472,
                timezone: 'America/Chicago'
            },
            {
                id: 166,
                city: 'Brewton',
                latitude: 31.10518,
                longitude: -87.07219,
                timezone: 'America/Chicago'
            },
            {
                id: 167,
                city: 'Bridgeport',
                latitude: 34.94758,
                longitude: -85.71442,
                timezone: 'America/Chicago'
            },
            {
                id: 168,
                city: 'Brighton',
                latitude: 33.43428,
                longitude: -86.94721,
                timezone: 'America/Chicago'
            },
            {
                id: 169,
                city: 'Brundidge',
                latitude: 31.72016,
                longitude: -85.81606,
                timezone: 'America/Chicago'
            },
            {
                id: 170,
                city: 'Calera',
                latitude: 33.12232,
                longitude: -86.74564,
                timezone: 'America/Chicago'
            },
            {
                id: 171,
                city: 'Camden',
                latitude: 31.99098,
                longitude: -87.29055,
                timezone: 'America/Chicago'
            },
            {
                id: 172,
                city: 'Carbon Hill',
                latitude: 33.89177,
                longitude: -87.52612,
                timezone: 'America/Chicago'
            },
            {
                id: 173,
                city: 'Center Point',
                latitude: 33.64566,
                longitude: -86.6836,
                timezone: 'America/Chicago'
            },
            {
                id: 174,
                city: 'Centre',
                latitude: 34.15204,
                longitude: -85.67885,
                timezone: 'America/Chicago'
            },
            {
                id: 175,
                city: 'Centreville',
                latitude: 32.94457,
                longitude: -87.13861,
                timezone: 'America/Chicago'
            },
            {
                id: 176,
                city: 'Chelsea',
                latitude: 33.34011,
                longitude: -86.63026,
                timezone: 'America/Chicago'
            },
            {
                id: 177,
                city: 'Chickasaw',
                latitude: 30.7638,
                longitude: -88.07472,
                timezone: 'America/Chicago'
            },
            {
                id: 178,
                city: 'Childersburg',
                latitude: 33.27817,
                longitude: -86.35498,
                timezone: 'America/Chicago'
            },
            {
                id: 179,
                city: 'Citronelle',
                latitude: 31.09073,
                longitude: -88.22806,
                timezone: 'America/Chicago'
            },
            {
                id: 180,
                city: 'Clanton',
                latitude: 32.83874,
                longitude: -86.62943,
                timezone: 'America/Chicago'
            },
            {
                id: 181,
                city: 'Clay',
                latitude: 33.7026,
                longitude: -86.59971,
                timezone: 'America/Chicago'
            },
            {
                id: 182,
                city: 'Clio',
                latitude: 31.70878,
                longitude: -85.6105,
                timezone: 'America/Chicago'
            },
            {
                id: 183,
                city: 'Columbiana',
                latitude: 33.17817,
                longitude: -86.60721,
                timezone: 'America/Chicago'
            },
            {
                id: 184,
                city: 'Cordova',
                latitude: 33.75983,
                longitude: -87.18333,
                timezone: 'America/Chicago'
            },
            {
                id: 185,
                city: 'Creola',
                latitude: 30.89185,
                longitude: -88.03972,
                timezone: 'America/Chicago'
            },
            {
                id: 186,
                city: 'Cullman',
                latitude: 34.17482,
                longitude: -86.84361,
                timezone: 'America/Chicago'
            },
            {
                id: 187,
                city: 'Dadeville',
                latitude: 32.83124,
                longitude: -85.76357,
                timezone: 'America/Chicago'
            },
            {
                id: 188,
                city: 'Daleville',
                latitude: 31.31017,
                longitude: -85.71299,
                timezone: 'America/Chicago'
            },
            {
                id: 189,
                city: 'Daphne',
                latitude: 30.60353,
                longitude: -87.9036,
                timezone: 'America/Chicago'
            },
            {
                id: 190,
                city: 'Decatur',
                latitude: 34.573,
                longitude: -86.9899,
                timezone: 'America/Chicago'
            },
            {
                id: 191,
                city: 'Demopolis',
                latitude: 32.51764,
                longitude: -87.8364,
                timezone: 'America/Chicago'
            },
            {
                id: 192,
                city: 'Dora',
                latitude: 33.72872,
                longitude: -87.09028,
                timezone: 'America/Chicago'
            },
            {
                id: 193,
                city: 'Dothan',
                latitude: 31.2337,
                longitude: -85.40682,
                timezone: 'America/Chicago'
            },
            {
                id: 194,
                city: 'East Brewton',
                latitude: 31.09323,
                longitude: -87.06275,
                timezone: 'America/Chicago'
            },
            {
                id: 195,
                city: 'Elba',
                latitude: 31.41461,
                longitude: -86.06772,
                timezone: 'America/Chicago'
            },
            {
                id: 196,
                city: 'Enterprise',
                latitude: 31.3269,
                longitude: -85.84402,
                timezone: 'America/Chicago'
            },
            {
                id: 197,
                city: 'Eufaula',
                latitude: 31.89127,
                longitude: -85.14549,
                timezone: 'America/Chicago'
            },
            {
                id: 198,
                city: 'Evergreen',
                latitude: 31.4335,
                longitude: -86.95692,
                timezone: 'America/Chicago'
            },
            {
                id: 199,
                city: 'Fairfield',
                latitude: 33.47471,
                longitude: -86.91934,
                timezone: 'America/Chicago'
            },
            {
                id: 200,
                city: 'Fairhope',
                latitude: 30.52297,
                longitude: -87.90333,
                timezone: 'America/Chicago'
            },
            {
                id: 201,
                city: 'Fayette',
                latitude: 33.68455,
                longitude: -87.83085,
                timezone: 'America/Chicago'
            },
            {
                id: 202,
                city: 'Florence',
                latitude: 34.79981,
                longitude: -87.67725,
                timezone: 'America/Chicago'
            },
            {
                id: 203,
                city: 'Foley',
                latitude: 30.40659,
                longitude: -87.6836,
                timezone: 'America/Chicago'
            },
            {
                id: 204,
                city: 'Fort Payne',
                latitude: 34.44425,
                longitude: -85.71969,
                timezone: 'America/Chicago'
            },
            {
                id: 205,
                city: 'Fultondale',
                latitude: 33.60483,
                longitude: -86.79388,
                timezone: 'America/Chicago'
            },
            {
                id: 206,
                city: 'Gadsden',
                latitude: 34.01426,
                longitude: -86.00664,
                timezone: 'America/Chicago'
            },
            {
                id: 207,
                city: 'Gardendale',
                latitude: 33.6601,
                longitude: -86.81277,
                timezone: 'America/Chicago'
            },
            {
                id: 208,
                city: 'Geneva',
                latitude: 31.03296,
                longitude: -85.86382,
                timezone: 'America/Chicago'
            },
            {
                id: 209,
                city: 'Glencoe',
                latitude: 33.94834,
                longitude: -85.93361,
                timezone: 'America/Chicago'
            },
            {
                id: 210,
                city: 'Good Hope',
                latitude: 34.11593,
                longitude: -86.86361,
                timezone: 'America/Chicago'
            },
            {
                id: 211,
                city: 'Graysville',
                latitude: 33.62066,
                longitude: -86.97138,
                timezone: 'America/Chicago'
            },
            {
                id: 212,
                city: 'Greensboro',
                latitude: 32.70458,
                longitude: -87.59584,
                timezone: 'America/Chicago'
            },
            {
                id: 213,
                city: 'Greenville',
                latitude: 31.8296,
                longitude: -86.61775,
                timezone: 'America/Chicago'
            },
            {
                id: 214,
                city: 'Guin',
                latitude: 33.96566,
                longitude: -87.91475,
                timezone: 'America/Chicago'
            },
            {
                id: 215,
                city: 'Gulf Shores',
                latitude: 30.24604,
                longitude: -87.70082,
                timezone: 'America/Chicago'
            },
            {
                id: 216,
                city: 'Guntersville',
                latitude: 34.35815,
                longitude: -86.2947,
                timezone: 'America/Chicago'
            },
            {
                id: 217,
                city: 'Haleyville',
                latitude: 34.23383,
                longitude: -87.61757,
                timezone: 'America/Chicago'
            },
            {
                id: 218,
                city: 'Hamilton',
                latitude: 34.14232,
                longitude: -87.98864,
                timezone: 'America/Chicago'
            },
            {
                id: 219,
                city: 'Hanceville',
                latitude: 34.06065,
                longitude: -86.7675,
                timezone: 'America/Chicago'
            },
            {
                id: 220,
                city: 'Hartford',
                latitude: 31.1024,
                longitude: -85.69688,
                timezone: 'America/Chicago'
            },
            {
                id: 221,
                city: 'Hartselle',
                latitude: 34.44343,
                longitude: -86.93528,
                timezone: 'America/Chicago'
            },
            {
                id: 222,
                city: 'Headland',
                latitude: 31.35128,
                longitude: -85.34216,
                timezone: 'America/Chicago'
            },
            {
                id: 223,
                city: 'Heflin',
                latitude: 33.64899,
                longitude: -85.58746,
                timezone: 'America/Chicago'
            },
            {
                id: 224,
                city: 'Helena',
                latitude: 33.28417,
                longitude: -86.87663,
                timezone: 'America/Chicago'
            },
            {
                id: 225,
                city: 'Henagar',
                latitude: 34.63508,
                longitude: -85.76719,
                timezone: 'America/Chicago'
            },
            {
                id: 226,
                city: 'Hokes Bluff',
                latitude: 33.99815,
                longitude: -85.86636,
                timezone: 'America/Chicago'
            },
            {
                id: 227,
                city: 'Homewood',
                latitude: 33.47177,
                longitude: -86.80082,
                timezone: 'America/Chicago'
            },
            {
                id: 228,
                city: 'Hoover',
                latitude: 33.37496,
                longitude: -86.80609,
                timezone: 'America/Chicago'
            },
            {
                id: 229,
                city: 'Hueytown',
                latitude: 33.45122,
                longitude: -86.99666,
                timezone: 'America/Chicago'
            },
            {
                id: 230,
                city: 'Huntsville',
                latitude: 34.70126,
                longitude: -86.67291,
                timezone: 'America/Chicago'
            },
            {
                id: 231,
                city: 'Indian Springs Village',
                latitude: 33.35539,
                longitude: -86.75443,
                timezone: 'America/Chicago'
            },
            {
                id: 232,
                city: 'Irondale',
                latitude: 33.53816,
                longitude: -86.70721,
                timezone: 'America/Chicago'
            },
            {
                id: 233,
                city: 'Jackson',
                latitude: 31.50905,
                longitude: -87.89444,
                timezone: 'America/Chicago'
            },
            {
                id: 234,
                city: 'Jacksonville',
                latitude: 33.81371,
                longitude: -85.76135,
                timezone: 'America/Chicago'
            },
            {
                id: 235,
                city: 'Jasper',
                latitude: 33.83122,
                longitude: -87.27751,
                timezone: 'America/Chicago'
            },
            {
                id: 236,
                city: 'Jemison',
                latitude: 32.95985,
                longitude: -86.74665,
                timezone: 'America/Chicago'
            },
            {
                id: 237,
                city: 'Kimberly',
                latitude: 33.77344,
                longitude: -86.81388,
                timezone: 'America/Chicago'
            },
            {
                id: 238,
                city: 'La Fayette',
                latitude: 32.89985,
                longitude: -85.40106,
                timezone: 'America/Chicago'
            },
            {
                id: 239,
                city: 'Lanett',
                latitude: 32.86874,
                longitude: -85.1905,
                timezone: 'America/Chicago'
            },
            {
                id: 240,
                city: 'Leeds',
                latitude: 33.54685,
                longitude: -86.57145,
                timezone: 'America/Chicago'
            },
            {
                id: 241,
                city: 'Lincoln',
                latitude: 33.61316,
                longitude: -86.11831,
                timezone: 'America/Chicago'
            },
            {
                id: 242,
                city: 'Linden',
                latitude: 32.30625,
                longitude: -87.79807,
                timezone: 'America/Chicago'
            },
            {
                id: 243,
                city: 'Lineville',
                latitude: 33.31067,
                longitude: -85.75441,
                timezone: 'America/Chicago'
            },
            {
                id: 244,
                city: 'Lipscomb',
                latitude: 33.42566,
                longitude: -86.92666,
                timezone: 'America/Chicago'
            },
            {
                id: 245,
                city: 'Livingston',
                latitude: 32.5843,
                longitude: -88.18725,
                timezone: 'America/Chicago'
            },
            {
                id: 246,
                city: 'Luverne',
                latitude: 31.71655,
                longitude: -86.26385,
                timezone: 'America/Chicago'
            },
            {
                id: 247,
                city: 'Madison',
                latitude: 34.71053,
                longitude: -86.76228,
                timezone: 'America/Chicago'
            },
            {
                id: 248,
                city: 'Marion',
                latitude: 32.63235,
                longitude: -87.31917,
                timezone: 'America/Chicago'
            },
            {
                id: 249,
                city: 'Midfield',
                latitude: 33.4615,
                longitude: -86.90888,
                timezone: 'America/Chicago'
            },
            {
                id: 250,
                city: 'Millbrook',
                latitude: 32.50147,
                longitude: -86.37391,
                timezone: 'America/Chicago'
            },
            {
                id: 251,
                city: 'Mobile',
                latitude: 30.69436,
                longitude: -88.04305,
                timezone: 'America/Chicago'
            },
            {
                id: 252,
                city: 'Monroeville',
                latitude: 31.52794,
                longitude: -87.32471,
                timezone: 'America/Chicago'
            },
            {
                id: 253,
                city: 'Montevallo',
                latitude: 33.10067,
                longitude: -86.86416,
                timezone: 'America/Chicago'
            },
            {
                id: 254,
                city: 'Montgomery',
                latitude: 32.36681,
                longitude: -86.29997,
                timezone: 'America/Chicago'
            },
            {
                id: 255,
                city: 'Moody',
                latitude: 33.59094,
                longitude: -86.49082,
                timezone: 'America/Chicago'
            },
            {
                id: 256,
                city: 'Moulton',
                latitude: 34.48121,
                longitude: -87.29335,
                timezone: 'America/Chicago'
            },
            {
                id: 257,
                city: 'Mountain Brook',
                latitude: 33.50094,
                longitude: -86.75221,
                timezone: 'America/Chicago'
            },
            {
                id: 258,
                city: 'Muscle Shoals',
                latitude: 34.74481,
                longitude: -87.66753,
                timezone: 'America/Chicago'
            },
            {
                id: 259,
                city: 'New Hope',
                latitude: 34.53703,
                longitude: -86.39443,
                timezone: 'America/Chicago'
            },
            {
                id: 260,
                city: 'Northport',
                latitude: 33.22901,
                longitude: -87.57723,
                timezone: 'America/Chicago'
            },
            {
                id: 261,
                city: 'Oneonta',
                latitude: 33.94815,
                longitude: -86.47276,
                timezone: 'America/Chicago'
            },
            {
                id: 262,
                city: 'Opelika',
                latitude: 32.64541,
                longitude: -85.37828,
                timezone: 'America/Chicago'
            },
            {
                id: 263,
                city: 'Opp',
                latitude: 31.28267,
                longitude: -86.25551,
                timezone: 'America/Chicago'
            },
            {
                id: 264,
                city: 'Orange Beach',
                latitude: 30.29437,
                longitude: -87.57359,
                timezone: 'America/Chicago'
            },
            {
                id: 265,
                city: 'Oxford',
                latitude: 33.59737,
                longitude: -85.86813,
                timezone: 'America/Chicago'
            },
            {
                id: 266,
                city: 'Ozark',
                latitude: 31.45906,
                longitude: -85.64049,
                timezone: 'America/Chicago'
            },
            {
                id: 267,
                city: 'Pelham',
                latitude: 33.28567,
                longitude: -86.80999,
                timezone: 'America/Chicago'
            },
            {
                id: 268,
                city: 'Pell City',
                latitude: 33.58621,
                longitude: -86.28609,
                timezone: 'America/Chicago'
            },
            {
                id: 269,
                city: 'Phenix City',
                latitude: 32.46167,
                longitude: -85.02502,
                timezone: 'America/Chicago'
            },
            {
                id: 270,
                city: 'Piedmont',
                latitude: 33.92756,
                longitude: -85.61527,
                timezone: 'America/Chicago'
            },
            {
                id: 271,
                city: 'Pinson',
                latitude: 33.68899,
                longitude: -86.68332,
                timezone: 'America/Chicago'
            },
            {
                id: 272,
                city: 'Pleasant Grove',
                latitude: 33.49094,
                longitude: -86.97027,
                timezone: 'America/Chicago'
            },
            {
                id: 273,
                city: 'Prattville',
                latitude: 32.46191,
                longitude: -86.45739,
                timezone: 'America/Chicago'
            },
            {
                id: 274,
                city: 'Prichard',
                latitude: 30.7388,
                longitude: -88.07889,
                timezone: 'America/Chicago'
            },
            {
                id: 275,
                city: 'Rainbow City',
                latitude: 33.95482,
                longitude: -86.04192,
                timezone: 'America/Chicago'
            },
            {
                id: 276,
                city: 'Rainsville',
                latitude: 34.49425,
                longitude: -85.84775,
                timezone: 'America/Chicago'
            },
            {
                id: 277,
                city: 'Red Bay',
                latitude: 34.43982,
                longitude: -88.14087,
                timezone: 'America/Chicago'
            },
            {
                id: 278,
                city: 'Riverside',
                latitude: 33.60621,
                longitude: -86.20442,
                timezone: 'America/Chicago'
            },
            {
                id: 279,
                city: 'Roanoke',
                latitude: 33.15123,
                longitude: -85.37217,
                timezone: 'America/Chicago'
            },
            {
                id: 280,
                city: 'Robertsdale',
                latitude: 30.5538,
                longitude: -87.71193,
                timezone: 'America/Chicago'
            },
            {
                id: 281,
                city: 'Russellville',
                latitude: 34.50787,
                longitude: -87.72864,
                timezone: 'America/Chicago'
            },
            {
                id: 282,
                city: 'Samson',
                latitude: 31.11295,
                longitude: -86.04605,
                timezone: 'America/Chicago'
            },
            {
                id: 283,
                city: 'Saraland',
                latitude: 30.82074,
                longitude: -88.07056,
                timezone: 'America/Chicago'
            },
            {
                id: 284,
                city: 'Satsuma',
                latitude: 30.85324,
                longitude: -88.05611,
                timezone: 'America/Chicago'
            },
            {
                id: 285,
                city: 'Scottsboro',
                latitude: 34.67231,
                longitude: -86.03415,
                timezone: 'America/Chicago'
            },
            {
                id: 286,
                city: 'Selma',
                latitude: 32.40736,
                longitude: -87.0211,
                timezone: 'America/Chicago'
            },
            {
                id: 287,
                city: 'Semmes',
                latitude: 30.77824,
                longitude: -88.25917,
                timezone: 'America/Chicago'
            },
            {
                id: 288,
                city: 'Sheffield',
                latitude: 34.76509,
                longitude: -87.69864,
                timezone: 'America/Chicago'
            },
            {
                id: 289,
                city: 'Slocomb',
                latitude: 31.10823,
                longitude: -85.59438,
                timezone: 'America/Chicago'
            },
            {
                id: 290,
                city: 'Smiths Station',
                latitude: 32.54014,
                longitude: -85.09855,
                timezone: 'America/Chicago'
            },
            {
                id: 291,
                city: 'Southside',
                latitude: 33.89084,
                longitude: -86.01802,
                timezone: 'America/Chicago'
            },
            {
                id: 292,
                city: 'Spanish Fort',
                latitude: 30.67491,
                longitude: -87.91527,
                timezone: 'America/Chicago'
            },
            {
                id: 293,
                city: 'Springville',
                latitude: 33.7751,
                longitude: -86.47165,
                timezone: 'America/Chicago'
            },
            {
                id: 294,
                city: 'Stevenson',
                latitude: 34.86869,
                longitude: -85.83942,
                timezone: 'America/Chicago'
            },
            {
                id: 295,
                city: 'Sulligent',
                latitude: 33.90177,
                longitude: -88.13448,
                timezone: 'America/Chicago'
            },
            {
                id: 296,
                city: 'Sumiton',
                latitude: 33.74927,
                longitude: -87.0469,
                timezone: 'America/Chicago'
            },
            {
                id: 297,
                city: 'Sylacauga',
                latitude: 33.17317,
                longitude: -86.25164,
                timezone: 'America/Chicago'
            },
            {
                id: 298,
                city: 'Talladega',
                latitude: 33.43594,
                longitude: -86.1058,
                timezone: 'America/Chicago'
            },
            {
                id: 299,
                city: 'Tallassee',
                latitude: 32.53002,
                longitude: -85.89008,
                timezone: 'America/Chicago'
            },
            {
                id: 300,
                city: 'Tarrant',
                latitude: 33.58344,
                longitude: -86.77277,
                timezone: 'America/Chicago'
            },
            {
                id: 301,
                city: 'Thomasville',
                latitude: 31.91349,
                longitude: -87.73584,
                timezone: 'America/Chicago'
            },
            {
                id: 302,
                city: 'Troy',
                latitude: 31.80877,
                longitude: -85.96995,
                timezone: 'America/Chicago'
            },
            {
                id: 303,
                city: 'Trussville',
                latitude: 33.63938,
                longitude: -86.58164,
                timezone: 'America/Chicago'
            },
            {
                id: 304,
                city: 'Tuscaloosa',
                latitude: 33.20984,
                longitude: -87.56917,
                timezone: 'America/Chicago'
            },
            {
                id: 305,
                city: 'Tuscumbia',
                latitude: 34.7312,
                longitude: -87.70253,
                timezone: 'America/Chicago'
            },
            {
                id: 306,
                city: 'Tuskegee',
                latitude: 32.42403,
                longitude: -85.69162,
                timezone: 'America/Chicago'
            },
            {
                id: 307,
                city: 'Union Springs',
                latitude: 32.14432,
                longitude: -85.71495,
                timezone: 'America/Chicago'
            },
            {
                id: 308,
                city: 'Valley',
                latitude: 32.81874,
                longitude: -85.17939,
                timezone: 'America/Chicago'
            },
            {
                id: 309,
                city: 'Valley Grande',
                latitude: 32.50902,
                longitude: -86.98749,
                timezone: 'America/Chicago'
            },
            {
                id: 310,
                city: 'Vernon',
                latitude: 33.75705,
                longitude: -88.10892,
                timezone: 'America/Chicago'
            },
            {
                id: 311,
                city: 'Vestavia Hills',
                latitude: 33.4625,
                longitude: -86.73951,
                timezone: 'America/Chicago'
            },
            {
                id: 312,
                city: 'Warrior',
                latitude: 33.81427,
                longitude: -86.80944,
                timezone: 'America/Chicago'
            },
            {
                id: 313,
                city: 'Weaver',
                latitude: 33.75205,
                longitude: -85.81135,
                timezone: 'America/Chicago'
            },
            {
                id: 314,
                city: 'Wetumpka',
                latitude: 32.54374,
                longitude: -86.21191,
                timezone: 'America/Chicago'
            },
            {
                id: 315,
                city: 'Winfield',
                latitude: 33.93472,
                longitude: -87.79131,
                timezone: 'America/Chicago'
            },
            {
                id: 316,
                city: 'York',
                latitude: 32.48625,
                longitude: -88.29642,
                timezone: 'America/Chicago'
            }
        ]
    },
    {
        id: 4,
        country: 'US',
        stateCode: 'AZ',
        stateName: 'Arizona',
        cities: [
            {
                id: 630,
                city: 'Apache Junction',
                latitude: 33.39831,
                longitude: -111.53535,
                timezone: 'America/Phoenix'
            },
            {
                id: 631,
                city: 'Avondale',
                latitude: 33.4356,
                longitude: -112.3496,
                timezone: 'America/Phoenix'
            },
            {
                id: 632,
                city: 'Benson',
                latitude: 31.96786,
                longitude: -110.29452,
                timezone: 'America/Phoenix'
            },
            {
                id: 633,
                city: 'Bisbee',
                latitude: 31.44815,
                longitude: -109.92841,
                timezone: 'America/Phoenix'
            },
            {
                id: 634,
                city: 'Buckeye',
                latitude: 33.37032,
                longitude: -112.58378,
                timezone: 'America/Phoenix'
            },
            {
                id: 635,
                city: 'Bullhead City',
                latitude: 35.14778,
                longitude: -114.5683,
                timezone: 'America/Phoenix'
            },
            {
                id: 636,
                city: 'Casa Grande',
                latitude: 32.8795,
                longitude: -111.75735,
                timezone: 'America/Phoenix'
            },
            {
                id: 637,
                city: 'Chandler',
                latitude: 33.30616,
                longitude: -111.84125,
                timezone: 'America/Phoenix'
            },
            {
                id: 638,
                city: 'Coolidge',
                latitude: 32.97784,
                longitude: -111.51762,
                timezone: 'America/Phoenix'
            },
            {
                id: 639,
                city: 'Cottonwood',
                latitude: 34.73919,
                longitude: -112.00988,
                timezone: 'America/Phoenix'
            },
            {
                id: 640,
                city: 'Douglas',
                latitude: 31.34455,
                longitude: -109.54534,
                timezone: 'America/Phoenix'
            },
            {
                id: 641,
                city: 'El Mirage',
                latitude: 33.59022,
                longitude: -112.3271,
                timezone: 'America/Phoenix'
            },
            {
                id: 642,
                city: 'Eloy',
                latitude: 32.7559,
                longitude: -111.55484,
                timezone: 'America/Phoenix'
            },
            {
                id: 643,
                city: 'Flagstaff',
                latitude: 35.19807,
                longitude: -111.65127,
                timezone: 'America/Phoenix'
            },
            {
                id: 644,
                city: 'Glendale',
                latitude: 33.53865,
                longitude: -112.18599,
                timezone: 'America/Phoenix'
            },
            {
                id: 645,
                city: 'Globe',
                latitude: 33.39422,
                longitude: -110.7865,
                timezone: 'America/Phoenix'
            },
            {
                id: 646,
                city: 'Goodyear',
                latitude: 33.43532,
                longitude: -112.35821,
                timezone: 'America/Phoenix'
            },
            {
                id: 647,
                city: 'Holbrook',
                latitude: 34.90225,
                longitude: -110.15818,
                timezone: 'America/Phoenix'
            },
            {
                id: 648,
                city: 'Kingman',
                latitude: 35.18944,
                longitude: -114.05301,
                timezone: 'America/Phoenix'
            },
            {
                id: 649,
                city: 'Lake Havasu City',
                latitude: 34.4839,
                longitude: -114.32245,
                timezone: 'America/Phoenix'
            },
            {
                id: 650,
                city: 'Litchfield Park',
                latitude: 33.49337,
                longitude: -112.35794,
                timezone: 'America/Phoenix'
            },
            {
                id: 651,
                city: 'Maricopa',
                latitude: 33.05811,
                longitude: -112.04764,
                timezone: 'America/Phoenix'
            },
            {
                id: 652,
                city: 'Mesa',
                latitude: 33.42227,
                longitude: -111.82264,
                timezone: 'America/Phoenix'
            },
            {
                id: 653,
                city: 'Nogales',
                latitude: 31.34038,
                longitude: -110.93425,
                timezone: 'America/Phoenix'
            },
            {
                id: 654,
                city: 'Page',
                latitude: 36.91472,
                longitude: -111.45583,
                timezone: 'America/Denver'
            },
            {
                id: 655,
                city: 'Peoria',
                latitude: 33.78652,
                longitude: -112.30813,
                timezone: 'America/Phoenix'
            },
            {
                id: 656,
                city: 'Phoenix',
                latitude: 33.44838,
                longitude: -112.07404,
                timezone: 'America/Phoenix'
            },
            {
                id: 657,
                city: 'Prescott',
                latitude: 34.54002,
                longitude: -112.4685,
                timezone: 'America/Phoenix'
            },
            {
                id: 658,
                city: 'Safford',
                latitude: 32.83395,
                longitude: -109.70758,
                timezone: 'America/Phoenix'
            },
            {
                id: 659,
                city: 'San Luis',
                latitude: 32.487,
                longitude: -114.78218,
                timezone: 'America/Phoenix'
            },
            {
                id: 660,
                city: 'Scottsdale',
                latitude: 33.50921,
                longitude: -111.89903,
                timezone: 'America/Phoenix'
            },
            {
                id: 661,
                city: 'Sedona',
                latitude: 34.85737,
                longitude: -111.79529,
                timezone: 'America/Phoenix'
            },
            {
                id: 662,
                city: 'Show Low',
                latitude: 34.25421,
                longitude: -110.02983,
                timezone: 'America/Phoenix'
            },
            {
                id: 663,
                city: 'Sierra Vista',
                latitude: 31.55454,
                longitude: -110.30369,
                timezone: 'America/Phoenix'
            },
            {
                id: 664,
                city: 'Somerton',
                latitude: 32.59644,
                longitude: -114.70968,
                timezone: 'America/Phoenix'
            },
            {
                id: 665,
                city: 'South Tucson',
                latitude: 32.19952,
                longitude: -110.96843,
                timezone: 'America/Phoenix'
            },
            {
                id: 666,
                city: 'St. Johns',
                latitude: 34.50587,
                longitude: -109.36093,
                timezone: 'America/Phoenix'
            },
            {
                id: 667,
                city: 'Surprise',
                latitude: 33.63059,
                longitude: -112.33322,
                timezone: 'America/Phoenix'
            },
            {
                id: 668,
                city: 'Tempe',
                latitude: 33.41477,
                longitude: -111.90931,
                timezone: 'America/Phoenix'
            },
            {
                id: 669,
                city: 'Tolleson',
                latitude: 33.45004,
                longitude: -112.25932,
                timezone: 'America/Phoenix'
            },
            {
                id: 670,
                city: 'Tombstone',
                latitude: 31.71287,
                longitude: -110.06758,
                timezone: 'America/Phoenix'
            },
            {
                id: 671,
                city: 'Tucson',
                latitude: 32.22174,
                longitude: -110.92648,
                timezone: 'America/Phoenix'
            },
            {
                id: 672,
                city: 'Willcox',
                latitude: 32.25285,
                longitude: -109.83201,
                timezone: 'America/Phoenix'
            },
            {
                id: 673,
                city: 'Williams',
                latitude: 35.24946,
                longitude: -112.191,
                timezone: 'America/Phoenix'
            },
            {
                id: 674,
                city: 'Winslow',
                latitude: 35.02419,
                longitude: -110.69736,
                timezone: 'America/Phoenix'
            },
            {
                id: 675,
                city: 'Yuma',
                latitude: 32.72532,
                longitude: -114.6244,
                timezone: 'America/Phoenix'
            }
        ]
    },
    {
        id: 5,
        country: 'US',
        stateCode: 'CA',
        stateName: 'California',
        cities: [
            {
                id: 676,
                city: 'Adelanto',
                latitude: 34.58277,
                longitude: -117.40922,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 677,
                city: 'Agoura Hills',
                latitude: 34.13639,
                longitude: -118.77453,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 678,
                city: 'Alameda',
                latitude: 37.76521,
                longitude: -122.24164,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 679,
                city: 'Albany',
                latitude: 37.88687,
                longitude: -122.29775,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 680,
                city: 'Alhambra',
                latitude: 34.09529,
                longitude: -118.12701,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 681,
                city: 'Aliso Viejo',
                latitude: 33.56504,
                longitude: -117.72712,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 682,
                city: 'Alturas',
                latitude: 41.48711,
                longitude: -120.54246,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 683,
                city: 'Amador City',
                latitude: 38.41936,
                longitude: -120.8241,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 684,
                city: 'American Canyon',
                latitude: 38.17492,
                longitude: -122.2608,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 685,
                city: 'Anaheim',
                latitude: 33.83529,
                longitude: -117.9145,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 686,
                city: 'Anderson',
                latitude: 40.44821,
                longitude: -122.29778,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 687,
                city: 'Angels',
                latitude: 38.07104,
                longitude: -120.55173,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 688,
                city: 'Antioch',
                latitude: 38.00492,
                longitude: -121.80579,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 689,
                city: 'Arcadia',
                latitude: 34.13973,
                longitude: -118.03534,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 690,
                city: 'Arcata',
                latitude: 40.86652,
                longitude: -124.08284,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 691,
                city: 'Arroyo Grande',
                latitude: 35.11859,
                longitude: -120.59073,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 692,
                city: 'Artesia',
                latitude: 33.86585,
                longitude: -118.08312,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 693,
                city: 'Arvin',
                latitude: 35.20913,
                longitude: -118.82843,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 694,
                city: 'Atascadero',
                latitude: 35.48942,
                longitude: -120.67073,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 695,
                city: 'Atwater',
                latitude: 37.34772,
                longitude: -120.60908,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 696,
                city: 'Auburn',
                latitude: 38.89657,
                longitude: -121.07689,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 697,
                city: 'Avalon',
                latitude: 33.34281,
                longitude: -118.32785,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 698,
                city: 'Avenal',
                latitude: 36.00412,
                longitude: -120.12903,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 699,
                city: 'Azusa',
                latitude: 34.13362,
                longitude: -117.90756,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 700,
                city: 'Bakersfield',
                latitude: 35.37329,
                longitude: -119.01871,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 701,
                city: 'Baldwin Park',
                latitude: 34.08529,
                longitude: -117.9609,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 702,
                city: 'Banning',
                latitude: 33.92557,
                longitude: -116.87641,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 703,
                city: 'Barstow',
                latitude: 34.89859,
                longitude: -117.02282,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 704,
                city: 'Beaumont',
                latitude: 33.92946,
                longitude: -116.97725,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 705,
                city: 'Bell',
                latitude: 33.97751,
                longitude: -118.18702,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 707,
                city: 'Bell Gardens',
                latitude: 33.96529,
                longitude: -118.15146,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 706,
                city: 'Bellflower',
                latitude: 33.88168,
                longitude: -118.11701,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 708,
                city: 'Belmont',
                latitude: 37.52021,
                longitude: -122.2758,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 709,
                city: 'Belvedere',
                latitude: 37.87278,
                longitude: -122.46444,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 710,
                city: 'Benicia',
                latitude: 38.04937,
                longitude: -122.15858,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 711,
                city: 'Berkeley',
                latitude: 37.87159,
                longitude: -122.27275,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 712,
                city: 'Beverly Hills',
                latitude: 34.07362,
                longitude: -118.40036,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 713,
                city: 'Big Bear Lake',
                latitude: 34.2439,
                longitude: -116.91142,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 714,
                city: 'Biggs',
                latitude: 39.41239,
                longitude: -121.71275,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 715,
                city: 'Bishop',
                latitude: 37.36354,
                longitude: -118.39511,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 716,
                city: 'Blue Lake',
                latitude: 40.88291,
                longitude: -123.98395,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 717,
                city: 'Blythe',
                latitude: 33.6103,
                longitude: -114.59635,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 718,
                city: 'Bradbury',
                latitude: 34.14695,
                longitude: -117.9709,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 719,
                city: 'Brawley',
                latitude: 32.97866,
                longitude: -115.53027,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 720,
                city: 'Brea',
                latitude: 33.91668,
                longitude: -117.90006,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 721,
                city: 'Brentwood',
                latitude: 37.93187,
                longitude: -121.69579,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 722,
                city: 'Brisbane',
                latitude: 37.68083,
                longitude: -122.4,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 723,
                city: 'Buellton',
                latitude: 34.6136,
                longitude: -120.19265,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 724,
                city: 'Buena Park',
                latitude: 33.86751,
                longitude: -117.99812,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 725,
                city: 'Burbank',
                latitude: 34.18084,
                longitude: -118.30897,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 726,
                city: 'Burlingame',
                latitude: 37.5841,
                longitude: -122.36608,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 727,
                city: 'Calabasas',
                latitude: 34.15778,
                longitude: -118.63842,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 728,
                city: 'Calexico',
                latitude: 32.67895,
                longitude: -115.49888,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 729,
                city: 'California City',
                latitude: 35.1258,
                longitude: -117.9859,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 730,
                city: 'Calimesa',
                latitude: 34.0039,
                longitude: -117.06198,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 731,
                city: 'Calipatria',
                latitude: 33.1256,
                longitude: -115.51415,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 732,
                city: 'Calistoga',
                latitude: 38.5788,
                longitude: -122.57971,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 733,
                city: 'Camarillo',
                latitude: 34.21639,
                longitude: -119.0376,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 734,
                city: 'Campbell',
                latitude: 37.28717,
                longitude: -121.94996,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 735,
                city: 'Canyon Lake',
                latitude: 33.68502,
                longitude: -117.27309,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 736,
                city: 'Capitola',
                latitude: 36.97523,
                longitude: -121.95329,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 737,
                city: 'Carlsbad',
                latitude: 33.15809,
                longitude: -117.35059,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 738,
                city: 'Carmel-by-the-Sea',
                latitude: 36.55524,
                longitude: -121.92329,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 739,
                city: 'Carpinteria',
                latitude: 34.39888,
                longitude: -119.51846,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 740,
                city: 'Carson',
                latitude: 33.83141,
                longitude: -118.28202,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 741,
                city: 'Cathedral City',
                latitude: 33.77974,
                longitude: -116.46529,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 742,
                city: 'Ceres',
                latitude: 37.59493,
                longitude: -120.95771,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 743,
                city: 'Cerritos',
                latitude: 33.85835,
                longitude: -118.06479,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 744,
                city: 'Chico',
                latitude: 39.72849,
                longitude: -121.83748,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 745,
                city: 'Chino',
                latitude: 34.01223,
                longitude: -117.68894,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 746,
                city: 'Chino Hills',
                latitude: 33.9938,
                longitude: -117.75888,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 747,
                city: 'Chowchilla',
                latitude: 37.123,
                longitude: -120.26018,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 748,
                city: 'Chula Vista',
                latitude: 32.64,
                longitude: -117.08417,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 749,
                city: 'Citrus Heights',
                latitude: 38.70712,
                longitude: -121.28106,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 750,
                city: 'Claremont',
                latitude: 34.09668,
                longitude: -117.71978,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 751,
                city: 'Clayton',
                latitude: 37.94103,
                longitude: -121.93579,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 752,
                city: 'Clearlake',
                latitude: 38.95823,
                longitude: -122.62637,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 753,
                city: 'Cloverdale',
                latitude: 38.80546,
                longitude: -123.01722,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 754,
                city: 'Clovis',
                latitude: 36.82523,
                longitude: -119.70292,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 755,
                city: 'Coachella',
                latitude: 33.6803,
                longitude: -116.17389,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 756,
                city: 'Coalinga',
                latitude: 36.13968,
                longitude: -120.36015,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 757,
                city: 'Colfax',
                latitude: 39.10073,
                longitude: -120.95328,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 758,
                city: 'Colton',
                latitude: 34.0739,
                longitude: -117.31365,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 759,
                city: 'Colusa',
                latitude: 39.21433,
                longitude: -122.00942,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 760,
                city: 'Commerce',
                latitude: 34.00057,
                longitude: -118.15979,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 761,
                city: 'Compton',
                latitude: 33.89585,
                longitude: -118.22007,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 762,
                city: 'Concord',
                latitude: 37.97798,
                longitude: -122.03107,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 763,
                city: 'Corcoran',
                latitude: 36.09801,
                longitude: -119.5604,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 764,
                city: 'Corning',
                latitude: 39.92766,
                longitude: -122.17916,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 765,
                city: 'Corona',
                latitude: 33.87529,
                longitude: -117.56644,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 766,
                city: 'Coronado',
                latitude: 32.68583,
                longitude: -117.18306,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 767,
                city: 'Costa Mesa',
                latitude: 33.64113,
                longitude: -117.91867,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 768,
                city: 'Cotati',
                latitude: 38.32686,
                longitude: -122.70721,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 769,
                city: 'Covina',
                latitude: 34.09001,
                longitude: -117.89034,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 770,
                city: 'Crescent City',
                latitude: 41.75595,
                longitude: -124.20175,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 771,
                city: 'Cudahy',
                latitude: 33.96057,
                longitude: -118.18535,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 772,
                city: 'Culver City',
                latitude: 34.02112,
                longitude: -118.39647,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 773,
                city: 'Cupertino',
                latitude: 37.323,
                longitude: -122.03218,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 774,
                city: 'Cypress',
                latitude: 33.81696,
                longitude: -118.03729,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 775,
                city: 'Daly City',
                latitude: 37.70583,
                longitude: -122.46194,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 776,
                city: 'Dana Point',
                latitude: 33.46697,
                longitude: -117.69811,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 777,
                city: 'Davis',
                latitude: 38.54491,
                longitude: -121.74052,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 779,
                city: 'Del Mar',
                latitude: 32.95949,
                longitude: -117.26531,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 780,
                city: 'Del Rey Oaks',
                latitude: 36.59329,
                longitude: -121.83495,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 778,
                city: 'Delano',
                latitude: 35.76884,
                longitude: -119.24705,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 781,
                city: 'Desert Hot Springs',
                latitude: 33.96112,
                longitude: -116.50168,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 782,
                city: 'Diamond Bar',
                latitude: 34.02862,
                longitude: -117.81034,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 783,
                city: 'Dinuba',
                latitude: 36.54328,
                longitude: -119.38707,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 784,
                city: 'Dixon',
                latitude: 38.44546,
                longitude: -121.8233,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 785,
                city: 'Dorris',
                latitude: 41.96737,
                longitude: -121.91806,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 786,
                city: 'Dos Palos',
                latitude: 36.98606,
                longitude: -120.62657,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 787,
                city: 'Downey',
                latitude: 33.94001,
                longitude: -118.13257,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 788,
                city: 'Duarte',
                latitude: 34.13945,
                longitude: -117.97729,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 789,
                city: 'Dublin',
                latitude: 37.70215,
                longitude: -121.93579,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 790,
                city: 'Dunsmuir',
                latitude: 41.20821,
                longitude: -122.27195,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 791,
                city: 'East Palo Alto',
                latitude: 37.46883,
                longitude: -122.14108,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 792,
                city: 'Eastvale',
                latitude: 33.96358,
                longitude: -117.56418,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 793,
                city: 'El Cajon',
                latitude: 32.79477,
                longitude: -116.96253,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 794,
                city: 'El Centro',
                latitude: 32.792,
                longitude: -115.56305,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 795,
                city: 'El Cerrito',
                latitude: 37.91576,
                longitude: -122.31164,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 797,
                city: 'El Monte',
                latitude: 34.06862,
                longitude: -118.02757,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 798,
                city: 'El Paso de Robles (Paso Robles)',
                latitude: 35.62789,
                longitude: -120.65026,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 799,
                city: 'El Segundo',
                latitude: 33.91918,
                longitude: -118.41647,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 796,
                city: 'Elk Grove',
                latitude: 38.4088,
                longitude: -121.37162,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 800,
                city: 'Emeryville',
                latitude: 37.83132,
                longitude: -122.28525,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 801,
                city: 'Encinitas',
                latitude: 33.03699,
                longitude: -117.29198,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 802,
                city: 'Escalon',
                latitude: 37.79743,
                longitude: -120.9966,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 803,
                city: 'Escondido',
                latitude: 33.11921,
                longitude: -117.08642,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 804,
                city: 'Etna',
                latitude: 41.45681,
                longitude: -122.89476,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 805,
                city: 'Eureka',
                latitude: 40.80207,
                longitude: -124.16367,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 806,
                city: 'Exeter',
                latitude: 36.29606,
                longitude: -119.14205,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 807,
                city: 'Fairfield',
                latitude: 38.24936,
                longitude: -122.03997,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 808,
                city: 'Farmersville',
                latitude: 36.29773,
                longitude: -119.20678,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 809,
                city: 'Ferndale',
                latitude: 40.57624,
                longitude: -124.26394,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 810,
                city: 'Fillmore',
                latitude: 34.39916,
                longitude: -118.91815,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 811,
                city: 'Firebaugh',
                latitude: 36.85884,
                longitude: -120.45601,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 812,
                city: 'Folsom',
                latitude: 38.67796,
                longitude: -121.17606,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 813,
                city: 'Fontana',
                latitude: 34.09223,
                longitude: -117.43505,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 814,
                city: 'Fort Bragg',
                latitude: 39.44572,
                longitude: -123.80529,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 815,
                city: 'Fort Jones',
                latitude: 41.60764,
                longitude: -122.84031,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 816,
                city: 'Fortuna',
                latitude: 40.59819,
                longitude: -124.15728,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 817,
                city: 'Foster City',
                latitude: 37.55855,
                longitude: -122.27108,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 818,
                city: 'Fountain Valley',
                latitude: 33.70918,
                longitude: -117.95367,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 819,
                city: 'Fowler',
                latitude: 36.63051,
                longitude: -119.67847,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 820,
                city: 'Fremont',
                latitude: 37.54827,
                longitude: -121.98857,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 821,
                city: 'Fresno',
                latitude: 36.74773,
                longitude: -119.77237,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 822,
                city: 'Fullerton',
                latitude: 33.87029,
                longitude: -117.92534,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 823,
                city: 'Galt',
                latitude: 38.25464,
                longitude: -121.29995,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 825,
                city: 'Garden Grove',
                latitude: 33.77391,
                longitude: -117.94145,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 824,
                city: 'Gardena',
                latitude: 33.88835,
                longitude: -118.30896,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 826,
                city: 'Gilroy',
                latitude: 37.00578,
                longitude: -121.56828,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 827,
                city: 'Glendale',
                latitude: 34.14251,
                longitude: -118.25508,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 828,
                city: 'Glendora',
                latitude: 34.13612,
                longitude: -117.86534,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 829,
                city: 'Goleta',
                latitude: 34.43583,
                longitude: -119.82764,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 830,
                city: 'Gonzales',
                latitude: 36.50663,
                longitude: -121.44438,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 831,
                city: 'Grand Terrace',
                latitude: 34.0339,
                longitude: -117.31365,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 832,
                city: 'Grass Valley',
                latitude: 39.21906,
                longitude: -121.06106,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 833,
                city: 'Greenfield',
                latitude: 36.3208,
                longitude: -121.24381,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 834,
                city: 'Gridley',
                latitude: 39.36378,
                longitude: -121.69358,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 835,
                city: 'Grover Beach',
                latitude: 35.12164,
                longitude: -120.62128,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 836,
                city: 'Guadalupe',
                latitude: 34.97164,
                longitude: -120.57184,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 837,
                city: 'Gustine',
                latitude: 37.25772,
                longitude: -120.99882,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 838,
                city: 'Half Moon Bay',
                latitude: 37.46355,
                longitude: -122.42859,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 839,
                city: 'Hanford',
                latitude: 36.32745,
                longitude: -119.64568,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 840,
                city: 'Hawaiian Gardens',
                latitude: 33.8314,
                longitude: -118.07284,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 841,
                city: 'Hawthorne',
                latitude: 33.9164,
                longitude: -118.35257,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 842,
                city: 'Hayward',
                latitude: 37.66882,
                longitude: -122.0808,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 843,
                city: 'Healdsburg',
                latitude: 38.61047,
                longitude: -122.86916,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 844,
                city: 'Hemet',
                latitude: 33.74752,
                longitude: -116.97197,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 845,
                city: 'Hercules',
                latitude: 38.01714,
                longitude: -122.28858,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 846,
                city: 'Hermosa Beach',
                latitude: 33.86224,
                longitude: -118.39952,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 847,
                city: 'Hesperia',
                latitude: 34.42639,
                longitude: -117.30088,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 848,
                city: 'Hidden Hills',
                latitude: 34.16028,
                longitude: -118.65231,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 849,
                city: 'Highland',
                latitude: 34.12834,
                longitude: -117.20865,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 850,
                city: 'Hollister',
                latitude: 36.85245,
                longitude: -121.4016,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 851,
                city: 'Holtville',
                latitude: 32.81116,
                longitude: -115.38026,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 852,
                city: 'Hughson',
                latitude: 37.59688,
                longitude: -120.86604,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 853,
                city: 'Huntington Beach',
                latitude: 33.6603,
                longitude: -117.99923,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 854,
                city: 'Huntington Park',
                latitude: 33.98168,
                longitude: -118.22507,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 855,
                city: 'Huron',
                latitude: 36.20273,
                longitude: -120.10292,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 856,
                city: 'Imperial',
                latitude: 32.84755,
                longitude: -115.56944,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 857,
                city: 'Imperial Beach',
                latitude: 32.58389,
                longitude: -117.11306,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 858,
                city: 'Indian Wells',
                latitude: 33.71863,
                longitude: -116.30834,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 859,
                city: 'Indio',
                latitude: 33.72058,
                longitude: -116.21556,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 860,
                city: 'Industry',
                latitude: 34.01973,
                longitude: -117.95868,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 861,
                city: 'Inglewood',
                latitude: 33.96168,
                longitude: -118.35313,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 862,
                city: 'Ione',
                latitude: 38.35269,
                longitude: -120.93272,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 863,
                city: 'Irvine',
                latitude: 33.66946,
                longitude: -117.82311,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 864,
                city: 'Irwindale',
                latitude: 34.10695,
                longitude: -117.93534,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 865,
                city: 'Isleton',
                latitude: 38.16186,
                longitude: -121.61162,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 866,
                city: 'Jackson',
                latitude: 38.3488,
                longitude: -120.7741,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 867,
                city: 'Jurupa Valley',
                latitude: 34.00259,
                longitude: -117.46761,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 868,
                city: 'Kerman',
                latitude: 36.72356,
                longitude: -120.05988,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 869,
                city: 'King City',
                latitude: 36.21274,
                longitude: -121.12603,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 870,
                city: 'Kingsburg',
                latitude: 36.51384,
                longitude: -119.55402,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 871,
                city: 'La CaÃ±ada Flintridge',
                latitude: 34.20969,
                longitude: -118.20014,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 877,
                city: 'La Habra',
                latitude: 33.93196,
                longitude: -117.94617,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 878,
                city: 'La Habra Heights',
                latitude: 33.96085,
                longitude: -117.95062,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 883,
                city: 'La Mesa',
                latitude: 32.76778,
                longitude: -117.02306,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 884,
                city: 'La Mirada',
                latitude: 33.91724,
                longitude: -118.01201,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 886,
                city: 'La Palma',
                latitude: 33.84639,
                longitude: -118.04667,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 887,
                city: 'La Puente',
                latitude: 34.02001,
                longitude: -117.94951,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 888,
                city: 'La Quinta',
                latitude: 33.66336,
                longitude: -116.31001,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 891,
                city: 'La Verne',
                latitude: 34.10084,
                longitude: -117.76784,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 872,
                city: 'Lafayette',
                latitude: 37.88576,
                longitude: -122.11802,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 873,
                city: 'Laguna Beach',
                latitude: 33.54225,
                longitude: -117.78311,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 874,
                city: 'Laguna Hills',
                latitude: 33.61252,
                longitude: -117.71283,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 875,
                city: 'Laguna Niguel',
                latitude: 33.52253,
                longitude: -117.70755,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 876,
                city: 'Laguna Woods',
                latitude: 33.6103,
                longitude: -117.72533,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 879,
                city: 'Lake Elsinore',
                latitude: 33.66808,
                longitude: -117.32726,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 880,
                city: 'Lake Forest',
                latitude: 33.64697,
                longitude: -117.68922,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 881,
                city: 'Lakeport',
                latitude: 39.04295,
                longitude: -122.91583,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 882,
                city: 'Lakewood',
                latitude: 33.85363,
                longitude: -118.13396,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 885,
                city: 'Lancaster',
                latitude: 34.69804,
                longitude: -118.13674,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 889,
                city: 'Larkspur',
                latitude: 37.93417,
                longitude: -122.53528,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 890,
                city: 'Lathrop',
                latitude: 37.8227,
                longitude: -121.27661,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 892,
                city: 'Lawndale',
                latitude: 33.88724,
                longitude: -118.35257,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 893,
                city: 'Lemon Grove',
                latitude: 32.74255,
                longitude: -117.03142,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 894,
                city: 'Lemoore',
                latitude: 36.30078,
                longitude: -119.78291,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 895,
                city: 'Lincoln',
                latitude: 38.89157,
                longitude: -121.29301,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 896,
                city: 'Lindsay',
                latitude: 36.20301,
                longitude: -119.08816,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 897,
                city: 'Live Oak',
                latitude: 39.27572,
                longitude: -121.65997,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 898,
                city: 'Livermore',
                latitude: 37.68187,
                longitude: -121.76801,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 899,
                city: 'Livingston',
                latitude: 37.38688,
                longitude: -120.72353,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 900,
                city: 'Lodi',
                latitude: 38.1302,
                longitude: -121.27245,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 901,
                city: 'Loma Linda',
                latitude: 34.04835,
                longitude: -117.26115,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 902,
                city: 'Lomita',
                latitude: 33.79224,
                longitude: -118.31507,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 903,
                city: 'Lompoc',
                latitude: 34.63915,
                longitude: -120.45794,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 904,
                city: 'Long Beach',
                latitude: 33.76696,
                longitude: -118.18923,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 905,
                city: 'Los Alamitos',
                latitude: 33.80306,
                longitude: -118.0725,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 906,
                city: 'Los Altos',
                latitude: 37.38522,
                longitude: -122.11413,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 907,
                city: 'Los Angeles',
                latitude: 34.05223,
                longitude: -118.24368,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 908,
                city: 'Los Banos',
                latitude: 37.05828,
                longitude: -120.84992,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 909,
                city: 'Loyalton',
                latitude: 39.67629,
                longitude: -120.24104,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 910,
                city: 'Lynwood',
                latitude: 33.93029,
                longitude: -118.21146,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 911,
                city: 'Madera',
                latitude: 36.96134,
                longitude: -120.06072,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 912,
                city: 'Malibu',
                latitude: 34.00501,
                longitude: -118.81009,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 913,
                city: 'Manhattan Beach',
                latitude: 33.88474,
                longitude: -118.41091,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 914,
                city: 'Manteca',
                latitude: 37.79743,
                longitude: -121.21605,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 915,
                city: 'Maricopa',
                latitude: 35.05886,
                longitude: -119.40095,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 916,
                city: 'Marina',
                latitude: 36.6844,
                longitude: -121.80217,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 917,
                city: 'Martinez',
                latitude: 38.01937,
                longitude: -122.13413,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 918,
                city: 'Marysville',
                latitude: 39.14573,
                longitude: -121.59135,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 919,
                city: 'Maywood',
                latitude: 33.98668,
                longitude: -118.18535,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 920,
                city: 'McFarland',
                latitude: 35.67801,
                longitude: -119.22927,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 921,
                city: 'Mendota',
                latitude: 36.75356,
                longitude: -120.38156,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 922,
                city: 'Menifee',
                latitude: 33.72835,
                longitude: -117.14642,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 923,
                city: 'Menlo Park',
                latitude: 37.45383,
                longitude: -122.18219,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 924,
                city: 'Merced',
                latitude: 37.30216,
                longitude: -120.48297,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 926,
                city: 'Mill Valley',
                latitude: 37.90611,
                longitude: -122.545,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 925,
                city: 'Millbrae',
                latitude: 37.59855,
                longitude: -122.38719,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 927,
                city: 'Milpitas',
                latitude: 37.42827,
                longitude: -121.90662,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 928,
                city: 'Mission Viejo',
                latitude: 33.60002,
                longitude: -117.672,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 929,
                city: 'Modesto',
                latitude: 37.6391,
                longitude: -120.99688,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 930,
                city: 'Monrovia',
                latitude: 34.14806,
                longitude: -117.99895,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 931,
                city: 'Montague',
                latitude: 41.7282,
                longitude: -122.5278,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 932,
                city: 'Montclair',
                latitude: 34.07751,
                longitude: -117.68978,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 936,
                city: 'Monte Sereno',
                latitude: 37.23633,
                longitude: -121.99246,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 933,
                city: 'Montebello',
                latitude: 34.00944,
                longitude: -118.10528,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 934,
                city: 'Monterey',
                latitude: 36.60024,
                longitude: -121.89468,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 935,
                city: 'Monterey Park',
                latitude: 34.06251,
                longitude: -118.12285,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 937,
                city: 'Moorpark',
                latitude: 34.28556,
                longitude: -118.88204,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 938,
                city: 'Moreno Valley',
                latitude: 33.93752,
                longitude: -117.23059,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 939,
                city: 'Morgan Hill',
                latitude: 37.1305,
                longitude: -121.65439,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 940,
                city: 'Morro Bay',
                latitude: 35.36581,
                longitude: -120.8499,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 942,
                city: 'Mount Shasta',
                latitude: 41.30987,
                longitude: -122.31057,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 941,
                city: 'Mountain View',
                latitude: 37.38605,
                longitude: -122.08385,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 943,
                city: 'Murrieta',
                latitude: 33.55391,
                longitude: -117.21392,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 944,
                city: 'Napa',
                latitude: 38.29714,
                longitude: -122.28553,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 945,
                city: 'National City',
                latitude: 32.67806,
                longitude: -117.09917,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 946,
                city: 'Needles',
                latitude: 34.84806,
                longitude: -114.61413,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 947,
                city: 'Nevada City',
                latitude: 39.26156,
                longitude: -121.01606,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 948,
                city: 'Newark',
                latitude: 37.52966,
                longitude: -122.04024,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 949,
                city: 'Newman',
                latitude: 37.31383,
                longitude: -121.02076,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 950,
                city: 'Newport Beach',
                latitude: 33.61891,
                longitude: -117.92895,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 951,
                city: 'Norco',
                latitude: 33.93113,
                longitude: -117.54866,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 952,
                city: 'Norwalk',
                latitude: 33.90224,
                longitude: -118.08173,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 953,
                city: 'Novato',
                latitude: 38.10742,
                longitude: -122.5697,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 954,
                city: 'Oakdale',
                latitude: 37.76659,
                longitude: -120.84715,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 955,
                city: 'Oakland',
                latitude: 37.80437,
                longitude: -122.2708,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 956,
                city: 'Oakley',
                latitude: 37.99742,
                longitude: -121.71245,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 957,
                city: 'Oceanside',
                latitude: 33.19587,
                longitude: -117.37948,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 958,
                city: 'Ojai',
                latitude: 34.44805,
                longitude: -119.24289,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 959,
                city: 'Ontario',
                latitude: 34.06334,
                longitude: -117.65089,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 960,
                city: 'Orange',
                latitude: 33.78779,
                longitude: -117.85311,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 961,
                city: 'Orange Cove',
                latitude: 36.62439,
                longitude: -119.31373,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 962,
                city: 'Orinda',
                latitude: 37.87715,
                longitude: -122.17969,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 963,
                city: 'Orland',
                latitude: 39.74738,
                longitude: -122.19637,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 964,
                city: 'Oroville',
                latitude: 39.51378,
                longitude: -121.55636,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 965,
                city: 'Oxnard',
                latitude: 34.1975,
                longitude: -119.17705,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 967,
                city: 'Pacific Grove',
                latitude: 36.61774,
                longitude: -121.91662,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 966,
                city: 'Pacifica',
                latitude: 37.61383,
                longitude: -122.48692,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 969,
                city: 'Palm Desert',
                latitude: 33.72224,
                longitude: -116.37446,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 970,
                city: 'Palm Springs',
                latitude: 33.8303,
                longitude: -116.54529,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 968,
                city: 'Palmdale',
                latitude: 34.57943,
                longitude: -118.11646,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 971,
                city: 'Palo Alto',
                latitude: 37.44188,
                longitude: -122.14302,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 972,
                city: 'Palos Verdes Estates',
                latitude: 33.80057,
                longitude: -118.39007,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 973,
                city: 'Paramount',
                latitude: 33.88946,
                longitude: -118.15979,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 974,
                city: 'Parlier',
                latitude: 36.61162,
                longitude: -119.52707,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 975,
                city: 'Pasadena',
                latitude: 34.14778,
                longitude: -118.14452,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 976,
                city: 'Patterson',
                latitude: 37.4716,
                longitude: -121.12966,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 977,
                city: 'Perris',
                latitude: 33.78252,
                longitude: -117.22865,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 978,
                city: 'Petaluma',
                latitude: 38.23242,
                longitude: -122.63665,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 979,
                city: 'Pico Rivera',
                latitude: 33.98307,
                longitude: -118.09674,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 980,
                city: 'Piedmont',
                latitude: 37.82437,
                longitude: -122.23164,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 981,
                city: 'Pinole',
                latitude: 38.00437,
                longitude: -122.29886,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 982,
                city: 'Pismo Beach',
                latitude: 35.14275,
                longitude: -120.64128,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 983,
                city: 'Pittsburg',
                latitude: 38.02798,
                longitude: -121.88468,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 984,
                city: 'Placentia',
                latitude: 33.87224,
                longitude: -117.87034,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 985,
                city: 'Placerville',
                latitude: 38.72963,
                longitude: -120.79855,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 986,
                city: 'Pleasant Hill',
                latitude: 37.94798,
                longitude: -122.0608,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 987,
                city: 'Pleasanton',
                latitude: 37.66243,
                longitude: -121.87468,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 988,
                city: 'Plymouth',
                latitude: 38.48185,
                longitude: -120.84466,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 989,
                city: 'Point Arena',
                latitude: 38.9088,
                longitude: -123.69307,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 990,
                city: 'Pomona',
                latitude: 34.05529,
                longitude: -117.75228,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 992,
                city: 'Port Hueneme',
                latitude: 34.14778,
                longitude: -119.19511,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 991,
                city: 'Porterville',
                latitude: 36.06523,
                longitude: -119.01677,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 993,
                city: 'Portola',
                latitude: 39.81046,
                longitude: -120.4691,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 994,
                city: 'Poway',
                latitude: 32.96282,
                longitude: -117.03586,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 995,
                city: 'Rancho Cordova',
                latitude: 38.58907,
                longitude: -121.30273,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 996,
                city: 'Rancho Cucamonga',
                latitude: 34.1064,
                longitude: -117.59311,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 997,
                city: 'Rancho Mirage',
                latitude: 33.73974,
                longitude: -116.41279,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 998,
                city: 'Rancho Palos Verdes',
                latitude: 33.74446,
                longitude: -118.38702,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 999,
                city: 'Rancho Santa Margarita',
                latitude: 33.64086,
                longitude: -117.6031,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1000,
                city: 'Red Bluff',
                latitude: 40.17849,
                longitude: -122.23583,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1001,
                city: 'Redding',
                latitude: 40.58654,
                longitude: -122.39168,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1002,
                city: 'Redlands',
                latitude: 34.05557,
                longitude: -117.18254,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1003,
                city: 'Redondo Beach',
                latitude: 33.84917,
                longitude: -118.38833,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1004,
                city: 'Redwood City',
                latitude: 37.48522,
                longitude: -122.23635,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1005,
                city: 'Reedley',
                latitude: 36.59634,
                longitude: -119.4504,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1006,
                city: 'Rialto',
                latitude: 34.1064,
                longitude: -117.37032,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1007,
                city: 'Richmond',
                latitude: 37.93576,
                longitude: -122.34775,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1008,
                city: 'Ridgecrest',
                latitude: 35.62246,
                longitude: -117.6709,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1009,
                city: 'Rio Dell',
                latitude: 40.4993,
                longitude: -124.10644,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1010,
                city: 'Rio Vista',
                latitude: 38.15575,
                longitude: -121.69134,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1011,
                city: 'Ripon',
                latitude: 37.7416,
                longitude: -121.12438,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1012,
                city: 'Riverbank',
                latitude: 37.73604,
                longitude: -120.93549,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1013,
                city: 'Riverside',
                latitude: 33.95333,
                longitude: -117.39611,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1014,
                city: 'Rocklin',
                latitude: 38.79073,
                longitude: -121.23578,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1015,
                city: 'Rohnert Park',
                latitude: 38.33964,
                longitude: -122.7011,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1016,
                city: 'Rolling Hills',
                latitude: 33.75696,
                longitude: -118.35396,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1017,
                city: 'Rolling Hills Estates',
                latitude: 33.78779,
                longitude: -118.35813,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1018,
                city: 'Rosemead',
                latitude: 34.08057,
                longitude: -118.07285,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1019,
                city: 'Roseville',
                latitude: 38.75212,
                longitude: -121.28801,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1020,
                city: 'Sacramento',
                latitude: 38.58157,
                longitude: -121.4944,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1021,
                city: 'Salinas',
                latitude: 36.67774,
                longitude: -121.6555,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1022,
                city: 'San Bernardino',
                latitude: 34.10834,
                longitude: -117.28977,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1023,
                city: 'San Bruno',
                latitude: 37.63049,
                longitude: -122.41108,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1024,
                city: 'San Buenaventura (Ventura)',
                latitude: 34.26778,
                longitude: -119.25421,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1025,
                city: 'San Carlos',
                latitude: 37.50716,
                longitude: -122.26052,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1026,
                city: 'San Clemente',
                latitude: 33.42697,
                longitude: -117.61199,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1028,
                city: 'San Diego',
                latitude: 32.71533,
                longitude: -117.15726,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1029,
                city: 'San Dimas',
                latitude: 34.10668,
                longitude: -117.80673,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1030,
                city: 'San Fernando',
                latitude: 34.28195,
                longitude: -118.43897,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1031,
                city: 'San Francisco',
                latitude: 37.775,
                longitude: -122.41944,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1032,
                city: 'San Gabriel',
                latitude: 34.09611,
                longitude: -118.10583,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1034,
                city: 'San Jacinto',
                latitude: 33.78391,
                longitude: -116.95864,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1035,
                city: 'San Joaquin',
                latitude: 36.60662,
                longitude: -120.18904,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1036,
                city: 'San Jose',
                latitude: 37.33939,
                longitude: -121.89496,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1037,
                city: 'San Juan Bautista',
                latitude: 36.84551,
                longitude: -121.538,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1038,
                city: 'San Juan Capistrano',
                latitude: 33.50169,
                longitude: -117.66255,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1039,
                city: 'San Leandro',
                latitude: 37.72493,
                longitude: -122.15608,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1040,
                city: 'San Luis Obispo',
                latitude: 35.28275,
                longitude: -120.65962,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1041,
                city: 'San Marcos',
                latitude: 33.14337,
                longitude: -117.16614,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1042,
                city: 'San Marino',
                latitude: 34.1214,
                longitude: -118.10646,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1043,
                city: 'San Mateo',
                latitude: 37.56299,
                longitude: -122.32553,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1044,
                city: 'San Pablo',
                latitude: 37.96215,
                longitude: -122.34553,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1045,
                city: 'San Rafael',
                latitude: 37.97361,
                longitude: -122.53111,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1046,
                city: 'San Ramon',
                latitude: 37.77993,
                longitude: -121.97802,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1027,
                city: 'Sand City',
                latitude: 36.61718,
                longitude: -121.84829,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1033,
                city: 'Sanger',
                latitude: 36.70801,
                longitude: -119.55597,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1047,
                city: 'Santa Ana',
                latitude: 33.74557,
                longitude: -117.86783,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1048,
                city: 'Santa Barbara',
                latitude: 34.42083,
                longitude: -119.69819,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1049,
                city: 'Santa Clara',
                latitude: 37.35411,
                longitude: -121.95524,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1050,
                city: 'Santa Clarita',
                latitude: 34.39166,
                longitude: -118.54259,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1051,
                city: 'Santa Cruz',
                latitude: 36.97412,
                longitude: -122.0308,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1052,
                city: 'Santa Fe Springs',
                latitude: 33.94724,
                longitude: -118.08535,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1053,
                city: 'Santa Maria',
                latitude: 34.95303,
                longitude: -120.43572,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1054,
                city: 'Santa Monica',
                latitude: 34.01945,
                longitude: -118.49119,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1055,
                city: 'Santa Paula',
                latitude: 34.35417,
                longitude: -119.05927,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1056,
                city: 'Santa Rosa',
                latitude: 38.44047,
                longitude: -122.71443,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1057,
                city: 'Santee',
                latitude: 32.83838,
                longitude: -116.97392,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1058,
                city: 'Saratoga',
                latitude: 37.26383,
                longitude: -122.02301,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1059,
                city: 'Sausalito',
                latitude: 37.85917,
                longitude: -122.48528,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1060,
                city: 'Scotts Valley',
                latitude: 37.05106,
                longitude: -122.01468,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1061,
                city: 'Seal Beach',
                latitude: 33.74141,
                longitude: -118.10479,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1062,
                city: 'Seaside',
                latitude: 36.61104,
                longitude: -121.84461,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1063,
                city: 'Sebastopol',
                latitude: 38.40214,
                longitude: -122.82388,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1064,
                city: 'Selma',
                latitude: 36.57078,
                longitude: -119.61208,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1065,
                city: 'Shafter',
                latitude: 35.50051,
                longitude: -119.27178,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1066,
                city: 'Shasta Lake',
                latitude: 40.68043,
                longitude: -122.37084,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1067,
                city: 'Sierra Madre',
                latitude: 34.16167,
                longitude: -118.05285,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1068,
                city: 'Signal Hill',
                latitude: 33.80446,
                longitude: -118.16785,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1069,
                city: 'Simi Valley',
                latitude: 34.26945,
                longitude: -118.78148,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1070,
                city: 'Solana Beach',
                latitude: 32.99116,
                longitude: -117.27115,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1071,
                city: 'Soledad',
                latitude: 36.42469,
                longitude: -121.32632,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1072,
                city: 'Solvang',
                latitude: 34.59582,
                longitude: -120.13765,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1073,
                city: 'Sonoma',
                latitude: 38.29186,
                longitude: -122.45804,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1074,
                city: 'Sonora',
                latitude: 37.98409,
                longitude: -120.38214,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1075,
                city: 'South El Monte',
                latitude: 34.05195,
                longitude: -118.04673,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1076,
                city: 'South Gate',
                latitude: 33.95474,
                longitude: -118.21202,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1077,
                city: 'South Lake Tahoe',
                latitude: 38.93324,
                longitude: -119.98435,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1078,
                city: 'South Pasadena',
                latitude: 34.11612,
                longitude: -118.15035,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1079,
                city: 'South San Francisco',
                latitude: 37.65472,
                longitude: -122.40778,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1081,
                city: 'St. Helena',
                latitude: 38.50519,
                longitude: -122.47026,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1080,
                city: 'Stanton',
                latitude: 33.80252,
                longitude: -117.99312,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1082,
                city: 'Stockton',
                latitude: 37.9577,
                longitude: -121.29078,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1083,
                city: 'Suisun City',
                latitude: 38.23825,
                longitude: -122.04024,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1084,
                city: 'Sunnyvale',
                latitude: 37.36883,
                longitude: -122.03635,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1085,
                city: 'Susanville',
                latitude: 40.41628,
                longitude: -120.65301,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1086,
                city: 'Sutter Creek',
                latitude: 38.39297,
                longitude: -120.80244,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1087,
                city: 'Taft',
                latitude: 35.14247,
                longitude: -119.45651,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1088,
                city: 'Tehachapi',
                latitude: 35.13219,
                longitude: -118.44897,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1089,
                city: 'Tehama',
                latitude: 40.0271,
                longitude: -122.12332,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1090,
                city: 'Temecula',
                latitude: 33.49364,
                longitude: -117.14836,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1091,
                city: 'Temple City',
                latitude: 34.10723,
                longitude: -118.05785,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1092,
                city: 'Thousand Oaks',
                latitude: 34.17056,
                longitude: -118.8375,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1093,
                city: 'Torrance',
                latitude: 33.83585,
                longitude: -118.34063,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1094,
                city: 'Tracy',
                latitude: 37.73965,
                longitude: -121.42522,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1095,
                city: 'Trinidad',
                latitude: 41.05929,
                longitude: -124.14312,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1096,
                city: 'Tulare',
                latitude: 36.20773,
                longitude: -119.34734,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1097,
                city: 'Tulelake',
                latitude: 41.95599,
                longitude: -121.47749,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1098,
                city: 'Turlock',
                latitude: 37.49466,
                longitude: -120.84659,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1099,
                city: 'Tustin',
                latitude: 33.74585,
                longitude: -117.82617,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1100,
                city: 'Twentynine Palms',
                latitude: 34.13556,
                longitude: -116.05417,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1101,
                city: 'Ukiah',
                latitude: 39.15017,
                longitude: -123.20778,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1102,
                city: 'Union City',
                latitude: 37.59583,
                longitude: -122.01917,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1103,
                city: 'Upland',
                latitude: 34.09751,
                longitude: -117.64839,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1104,
                city: 'Vacaville',
                latitude: 38.35658,
                longitude: -121.98774,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1105,
                city: 'Vallejo',
                latitude: 38.10409,
                longitude: -122.25664,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1106,
                city: 'Vernon',
                latitude: 34.0039,
                longitude: -118.23007,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1107,
                city: 'Victorville',
                latitude: 34.53611,
                longitude: -117.29116,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1108,
                city: 'Villa Park',
                latitude: 33.81446,
                longitude: -117.81311,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1109,
                city: 'Visalia',
                latitude: 36.33023,
                longitude: -119.29206,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1110,
                city: 'Vista',
                latitude: 33.20004,
                longitude: -117.24254,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1111,
                city: 'Walnut',
                latitude: 34.02029,
                longitude: -117.86534,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1112,
                city: 'Walnut Creek',
                latitude: 37.90631,
                longitude: -122.06496,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1113,
                city: 'Wasco',
                latitude: 35.59412,
                longitude: -119.34095,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1114,
                city: 'Waterford',
                latitude: 37.64132,
                longitude: -120.76048,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1115,
                city: 'Watsonville',
                latitude: 36.91023,
                longitude: -121.75689,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1116,
                city: 'Weed',
                latitude: 41.42265,
                longitude: -122.38613,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1117,
                city: 'West Covina',
                latitude: 34.06862,
                longitude: -117.93895,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1118,
                city: 'West Hollywood',
                latitude: 34.09001,
                longitude: -118.36174,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1122,
                city: 'West Sacramento',
                latitude: 38.58046,
                longitude: -121.53023,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1119,
                city: 'Westlake Village',
                latitude: 34.14584,
                longitude: -118.80565,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1120,
                city: 'Westminster',
                latitude: 33.75918,
                longitude: -118.00673,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1121,
                city: 'Westmorland',
                latitude: 33.03727,
                longitude: -115.62138,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1123,
                city: 'Wheatland',
                latitude: 39.00989,
                longitude: -121.42301,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1124,
                city: 'Whittier',
                latitude: 33.97918,
                longitude: -118.03284,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1125,
                city: 'Wildomar',
                latitude: 33.59891,
                longitude: -117.28004,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1126,
                city: 'Williams',
                latitude: 39.15461,
                longitude: -122.14942,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1127,
                city: 'Willits',
                latitude: 39.40961,
                longitude: -123.35557,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1128,
                city: 'Willows',
                latitude: 39.52433,
                longitude: -122.19359,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1129,
                city: 'Winters',
                latitude: 38.52491,
                longitude: -121.9708,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1130,
                city: 'Woodlake',
                latitude: 36.41356,
                longitude: -119.09872,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1131,
                city: 'Woodland',
                latitude: 38.67852,
                longitude: -121.7733,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1132,
                city: 'Yorba Linda',
                latitude: 33.88863,
                longitude: -117.81311,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1133,
                city: 'Yountville',
                latitude: 38.40158,
                longitude: -122.36081,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1134,
                city: 'Yreka',
                latitude: 41.73542,
                longitude: -122.63447,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1135,
                city: 'Yuba City',
                latitude: 39.14045,
                longitude: -121.61691,
                timezone: 'America/Los_Angeles'
            },
            {
                id: 1136,
                city: 'Yucaipa',
                latitude: 34.03363,
                longitude: -117.04309,
                timezone: 'America/Los_Angeles'
            }
        ]
    },
    {
        id: 6,
        country: 'US',
        stateCode: 'CO',
        stateName: 'Colorado',
        cities: [
            {
                id: 1137,
                city: 'Alamosa',
                latitude: 37.46945,
                longitude: -105.87002,
                timezone: 'America/Denver'
            },
            {
                id: 1138,
                city: 'Arvada',
                latitude: 39.83373,
                longitude: -105.15031,
                timezone: 'America/Denver'
            },
            {
                id: 1139,
                city: 'Aspen',
                latitude: 39.1911,
                longitude: -106.81754,
                timezone: 'America/Denver'
            },
            {
                id: 1140,
                city: 'Aurora',
                latitude: 39.688,
                longitude: -104.68974,
                timezone: 'America/Denver'
            },
            {
                id: 1141,
                city: 'Black Hawk',
                latitude: 39.79693,
                longitude: -105.49389,
                timezone: 'America/Denver'
            },
            {
                id: 1142,
                city: 'Boulder',
                latitude: 40.01499,
                longitude: -105.27055,
                timezone: 'America/Denver'
            },
            {
                id: 1143,
                city: 'Brighton',
                latitude: 39.9657,
                longitude: -104.79417,
                timezone: 'America/Denver'
            },
            {
                id: 1144,
                city: 'Broomfield',
                latitude: 39.92054,
                longitude: -105.08665,
                timezone: 'America/Denver'
            },
            {
                id: 1145,
                city: 'Brush',
                latitude: 40.25887,
                longitude: -103.62384,
                timezone: 'America/Denver'
            },
            {
                id: 1146,
                city: 'Burlington',
                latitude: 39.30611,
                longitude: -102.26936,
                timezone: 'America/Denver'
            },
            {
                id: 1147,
                city: 'CaÃ±on City',
                latitude: 38.44189,
                longitude: -105.2209,
                timezone: 'America/Denver'
            },
            {
                id: 1148,
                city: 'Castle Pines',
                latitude: 39.45804,
                longitude: -104.89609,
                timezone: 'America/Denver'
            },
            {
                id: 1149,
                city: 'Centennial',
                latitude: 39.57916,
                longitude: -104.87692,
                timezone: 'America/Denver'
            },
            {
                id: 1150,
                city: 'Central City',
                latitude: 39.79537,
                longitude: -105.50897,
                timezone: 'America/Denver'
            },
            {
                id: 1151,
                city: 'Cherry Hills Village',
                latitude: 39.64165,
                longitude: -104.95943,
                timezone: 'America/Denver'
            },
            {
                id: 1152,
                city: 'Colorado Springs',
                latitude: 38.83388,
                longitude: -104.82136,
                timezone: 'America/Denver'
            },
            {
                id: 1153,
                city: 'Commerce City',
                latitude: 39.80832,
                longitude: -104.93387,
                timezone: 'America/Denver'
            },
            {
                id: 1154,
                city: 'Cortez',
                latitude: 37.34888,
                longitude: -108.58593,
                timezone: 'America/Denver'
            },
            {
                id: 1155,
                city: 'Craig',
                latitude: 40.51525,
                longitude: -107.54645,
                timezone: 'America/Denver'
            },
            {
                id: 1156,
                city: 'Cripple Creek',
                latitude: 38.74666,
                longitude: -105.17831,
                timezone: 'America/Denver'
            },
            {
                id: 1157,
                city: 'Dacono',
                latitude: 40.08471,
                longitude: -104.93942,
                timezone: 'America/Denver'
            },
            {
                id: 1158,
                city: 'Delta',
                latitude: 38.74221,
                longitude: -108.06896,
                timezone: 'America/Denver'
            },
            {
                id: 1159,
                city: 'Denver',
                latitude: 39.73915,
                longitude: -104.9847,
                timezone: 'America/Denver'
            },
            {
                id: 1160,
                city: 'Durango',
                latitude: 37.27528,
                longitude: -107.88007,
                timezone: 'America/Denver'
            },
            {
                id: 1161,
                city: 'Edgewater',
                latitude: 39.75304,
                longitude: -105.06415,
                timezone: 'America/Denver'
            },
            {
                id: 1162,
                city: 'Englewood',
                latitude: 39.64777,
                longitude: -104.98776,
                timezone: 'America/Denver'
            },
            {
                id: 1163,
                city: 'Evans',
                latitude: 40.37637,
                longitude: -104.69219,
                timezone: 'America/Denver'
            },
            {
                id: 1164,
                city: 'Federal Heights',
                latitude: 39.85137,
                longitude: -104.99859,
                timezone: 'America/Denver'
            },
            {
                id: 1165,
                city: 'Florence',
                latitude: 38.39028,
                longitude: -105.1186,
                timezone: 'America/Denver'
            },
            {
                id: 1166,
                city: 'Fort Collins',
                latitude: 40.58526,
                longitude: -105.08442,
                timezone: 'America/Denver'
            },
            {
                id: 1167,
                city: 'Fort Lupton',
                latitude: 40.08471,
                longitude: -104.81303,
                timezone: 'America/Denver'
            },
            {
                id: 1168,
                city: 'Fort Morgan',
                latitude: 40.25026,
                longitude: -103.79995,
                timezone: 'America/Denver'
            },
            {
                id: 1169,
                city: 'Fountain',
                latitude: 38.68222,
                longitude: -104.70081,
                timezone: 'America/Denver'
            },
            {
                id: 1170,
                city: 'Fruita',
                latitude: 39.15887,
                longitude: -108.72899,
                timezone: 'America/Denver'
            },
            {
                id: 1171,
                city: 'Glendale',
                latitude: 39.70499,
                longitude: -104.93359,
                timezone: 'America/Denver'
            },
            {
                id: 1172,
                city: 'Glenwood Springs',
                latitude: 39.55054,
                longitude: -107.32478,
                timezone: 'America/Denver'
            },
            {
                id: 1173,
                city: 'Golden',
                latitude: 39.75554,
                longitude: -105.2211,
                timezone: 'America/Denver'
            },
            {
                id: 1174,
                city: 'Grand Junction',
                latitude: 39.06387,
                longitude: -108.55065,
                timezone: 'America/Denver'
            },
            {
                id: 1175,
                city: 'Greeley',
                latitude: 40.42331,
                longitude: -104.70913,
                timezone: 'America/Denver'
            },
            {
                id: 1176,
                city: 'Greenwood Village',
                latitude: 39.61721,
                longitude: -104.95081,
                timezone: 'America/Denver'
            },
            {
                id: 1177,
                city: 'Gunnison',
                latitude: 38.54582,
                longitude: -106.92532,
                timezone: 'America/Denver'
            },
            {
                id: 1178,
                city: 'Holyoke',
                latitude: 40.58444,
                longitude: -102.30241,
                timezone: 'America/Denver'
            },
            {
                id: 1179,
                city: 'Idaho Springs',
                latitude: 39.74249,
                longitude: -105.51361,
                timezone: 'America/Denver'
            },
            {
                id: 1181,
                city: 'La Junta',
                latitude: 37.98501,
                longitude: -103.54383,
                timezone: 'America/Denver'
            },
            {
                id: 1180,
                city: 'Lafayette',
                latitude: 39.9936,
                longitude: -105.08971,
                timezone: 'America/Denver'
            },
            {
                id: 1182,
                city: 'Lakewood',
                latitude: 39.70471,
                longitude: -105.08137,
                timezone: 'America/Denver'
            },
            {
                id: 1183,
                city: 'Lamar',
                latitude: 38.08723,
                longitude: -102.62075,
                timezone: 'America/Denver'
            },
            {
                id: 1184,
                city: 'Las Animas',
                latitude: 38.06667,
                longitude: -103.22271,
                timezone: 'America/Denver'
            },
            {
                id: 1185,
                city: 'Leadville',
                latitude: 39.25082,
                longitude: -106.29252,
                timezone: 'America/Denver'
            },
            {
                id: 1186,
                city: 'Littleton',
                latitude: 39.59038,
                longitude: -105.02008,
                timezone: 'America/Denver'
            },
            {
                id: 1187,
                city: 'Lone Tree',
                latitude: 39.53138,
                longitude: -104.86196,
                timezone: 'America/Denver'
            },
            {
                id: 1188,
                city: 'Longmont',
                latitude: 40.1682,
                longitude: -105.10052,
                timezone: 'America/Denver'
            },
            {
                id: 1189,
                city: 'Louisville',
                latitude: 39.97776,
                longitude: -105.13193,
                timezone: 'America/Denver'
            },
            {
                id: 1190,
                city: 'Loveland',
                latitude: 40.39776,
                longitude: -105.07498,
                timezone: 'America/Denver'
            },
            {
                id: 1191,
                city: 'Manitou Springs',
                latitude: 38.85971,
                longitude: -104.9172,
                timezone: 'America/Denver'
            },
            {
                id: 1192,
                city: 'Monte Vista',
                latitude: 37.57917,
                longitude: -106.14808,
                timezone: 'America/Denver'
            },
            {
                id: 1193,
                city: 'Montrose',
                latitude: 38.47832,
                longitude: -107.87617,
                timezone: 'America/Denver'
            },
            {
                id: 1194,
                city: 'Northglenn',
                latitude: 39.91189,
                longitude: -104.98186,
                timezone: 'America/Denver'
            },
            {
                id: 1195,
                city: 'Ouray',
                latitude: 38.02277,
                longitude: -107.67145,
                timezone: 'America/Denver'
            },
            {
                id: 1196,
                city: 'Pueblo',
                latitude: 38.25445,
                longitude: -104.60914,
                timezone: 'America/Denver'
            },
            {
                id: 1197,
                city: 'Rifle',
                latitude: 39.5347,
                longitude: -107.78312,
                timezone: 'America/Denver'
            },
            {
                id: 1198,
                city: 'Rocky Ford',
                latitude: 38.05251,
                longitude: -103.72023,
                timezone: 'America/Denver'
            },
            {
                id: 1199,
                city: 'Salida',
                latitude: 38.53472,
                longitude: -105.9989,
                timezone: 'America/Denver'
            },
            {
                id: 1200,
                city: 'Sheridan',
                latitude: 39.64693,
                longitude: -105.02526,
                timezone: 'America/Denver'
            },
            {
                id: 1201,
                city: 'Steamboat Springs',
                latitude: 40.48498,
                longitude: -106.83172,
                timezone: 'America/Denver'
            },
            {
                id: 1202,
                city: 'Sterling',
                latitude: 40.62554,
                longitude: -103.20771,
                timezone: 'America/Denver'
            },
            {
                id: 1203,
                city: 'Thornton',
                latitude: 39.91942,
                longitude: -104.94281,
                timezone: 'America/Denver'
            },
            {
                id: 1204,
                city: 'Trinidad',
                latitude: 37.16946,
                longitude: -104.50054,
                timezone: 'America/Denver'
            },
            {
                id: 1205,
                city: 'Victor',
                latitude: 38.70999,
                longitude: -105.13998,
                timezone: 'America/Denver'
            },
            {
                id: 1206,
                city: 'Walsenburg',
                latitude: 37.62418,
                longitude: -104.78026,
                timezone: 'America/Denver'
            },
            {
                id: 1207,
                city: 'Westminster',
                latitude: 39.88012,
                longitude: -105.06151,
                timezone: 'America/Denver'
            },
            {
                id: 1208,
                city: 'Wheat Ridge',
                latitude: 39.7661,
                longitude: -105.07721,
                timezone: 'America/Denver'
            },
            {
                id: 1209,
                city: 'Woodland Park',
                latitude: 38.99388,
                longitude: -105.05693,
                timezone: 'America/Denver'
            },
            {
                id: 1210,
                city: 'Wray',
                latitude: 40.07582,
                longitude: -102.22325,
                timezone: 'America/Denver'
            },
            {
                id: 1211,
                city: 'Yuma',
                latitude: 40.12221,
                longitude: -102.72521,
                timezone: 'America/Denver'
            }
        ]
    },
    {
        id: 8,
        country: 'US',
        stateCode: 'DC',
        stateName: 'District of Columbia',
        cities: [
            {
                id: 1232,
                city: 'Washington',
                latitude: 38.90425,
                longitude: -77.01652,
                timezone: 'America/New_York'
            }
        ]
    },
    {
        id: 10,
        country: 'US',
        stateCode: 'FL',
        stateName: 'Florida',
        cities: [
            {
                id: 1243,
                city: 'Alachua',
                latitude: 29.75163,
                longitude: -82.42483,
                timezone: 'America/New_York'
            },
            {
                id: 1244,
                city: 'Altamonte Springs',
                latitude: 28.66111,
                longitude: -81.36562,
                timezone: 'America/New_York'
            },
            {
                id: 1245,
                city: 'Anna Maria',
                latitude: 27.53115,
                longitude: -82.73343,
                timezone: 'America/New_York'
            },
            {
                id: 1246,
                city: 'Apalachicola',
                latitude: 29.72577,
                longitude: -84.98324,
                timezone: 'America/New_York'
            },
            {
                id: 1247,
                city: 'Apopka',
                latitude: 28.68055,
                longitude: -81.50952,
                timezone: 'America/New_York'
            },
            {
                id: 1248,
                city: 'Arcadia',
                latitude: 27.21588,
                longitude: -81.85842,
                timezone: 'America/New_York'
            },
            {
                id: 1249,
                city: 'Archer',
                latitude: 29.52997,
                longitude: -82.519,
                timezone: 'America/New_York'
            },
            {
                id: 1250,
                city: 'Atlantic Beach',
                latitude: 30.33441,
                longitude: -81.3987,
                timezone: 'America/New_York'
            },
            {
                id: 1251,
                city: 'Atlantis',
                latitude: 26.5909,
                longitude: -80.10088,
                timezone: 'America/New_York'
            },
            {
                id: 1252,
                city: 'Auburndale',
                latitude: 28.0653,
                longitude: -81.78869,
                timezone: 'America/New_York'
            },
            {
                id: 1253,
                city: 'Aventura',
                latitude: 25.95648,
                longitude: -80.13921,
                timezone: 'America/New_York'
            },
            {
                id: 1254,
                city: 'Avon Park',
                latitude: 27.59587,
                longitude: -81.50619,
                timezone: 'America/New_York'
            },
            {
                id: 1255,
                city: 'Bartow',
                latitude: 27.89641,
                longitude: -81.84314,
                timezone: 'America/New_York'
            },
            {
                id: 1256,
                city: 'Bay Lake',
                latitude: 28.38862,
                longitude: -81.56591,
                timezone: 'America/New_York'
            },
            {
                id: 1259,
                city: 'Belle Glade',
                latitude: 26.68451,
                longitude: -80.66756,
                timezone: 'America/New_York'
            },
            {
                id: 1260,
                city: 'Belle Isle',
                latitude: 28.45834,
                longitude: -81.35924,
                timezone: 'America/New_York'
            },
            {
                id: 1257,
                city: 'Belleair Beach',
                latitude: 27.92308,
                longitude: -82.84316,
                timezone: 'America/New_York'
            },
            {
                id: 1258,
                city: 'Belleair Bluffs',
                latitude: 27.92141,
                longitude: -82.81705,
                timezone: 'America/New_York'
            },
            {
                id: 1261,
                city: 'Belleview',
                latitude: 29.05526,
                longitude: -82.06231,
                timezone: 'America/New_York'
            },
            {
                id: 1262,
                city: 'Blountstown',
                latitude: 30.44353,
                longitude: -85.0452,
                timezone: 'America/Chicago'
            },
            {
                id: 1263,
                city: 'Boca Raton',
                latitude: 26.35869,
                longitude: -80.0831,
                timezone: 'America/New_York'
            },
            {
                id: 1264,
                city: 'Bonifay',
                latitude: 30.79186,
                longitude: -85.67965,
                timezone: 'America/Chicago'
            },
            {
                id: 1265,
                city: 'Bonita Springs',
                latitude: 26.33981,
                longitude: -81.7787,
                timezone: 'America/New_York'
            },
            {
                id: 1266,
                city: 'Bowling Green',
                latitude: 27.63837,
                longitude: -81.82397,
                timezone: 'America/New_York'
            },
            {
                id: 1267,
                city: 'Boynton Beach',
                latitude: 26.52535,
                longitude: -80.06643,
                timezone: 'America/New_York'
            },
            {
                id: 1268,
                city: 'Bradenton',
                latitude: 27.49893,
                longitude: -82.57482,
                timezone: 'America/New_York'
            },
            {
                id: 1269,
                city: 'Bradenton Beach',
                latitude: 27.46698,
                longitude: -82.70399,
                timezone: 'America/New_York'
            },
            {
                id: 1270,
                city: 'Bristol',
                latitude: 30.43214,
                longitude: -84.97575,
                timezone: 'America/New_York'
            },
            {
                id: 1271,
                city: 'Brooksville',
                latitude: 28.55527,
                longitude: -82.38787,
                timezone: 'America/New_York'
            },
            {
                id: 1272,
                city: 'Bunnell',
                latitude: 29.46609,
                longitude: -81.25784,
                timezone: 'America/New_York'
            },
            {
                id: 1273,
                city: 'Bushnell',
                latitude: 28.66499,
                longitude: -82.11286,
                timezone: 'America/New_York'
            },
            {
                id: 1274,
                city: 'Callaway',
                latitude: 30.15298,
                longitude: -85.56993,
                timezone: 'America/Chicago'
            },
            {
                id: 1275,
                city: 'Cape Canaveral',
                latitude: 28.40584,
                longitude: -80.60477,
                timezone: 'America/New_York'
            },
            {
                id: 1276,
                city: 'Cape Coral',
                latitude: 26.56285,
                longitude: -81.94953,
                timezone: 'America/New_York'
            },
            {
                id: 1277,
                city: 'Carrabelle',
                latitude: 29.85326,
                longitude: -84.66435,
                timezone: 'America/New_York'
            },
            {
                id: 1278,
                city: 'Casselberry',
                latitude: 28.67778,
                longitude: -81.32785,
                timezone: 'America/New_York'
            },
            {
                id: 1279,
                city: 'Cedar Key',
                latitude: 29.13858,
                longitude: -83.03512,
                timezone: 'America/New_York'
            },
            {
                id: 1280,
                city: 'Center Hill',
                latitude: 28.64999,
                longitude: -81.99258,
                timezone: 'America/New_York'
            },
            {
                id: 1281,
                city: 'Chattahoochee',
                latitude: 30.70519,
                longitude: -84.84298,
                timezone: 'America/New_York'
            },
            {
                id: 1282,
                city: 'Chiefland',
                latitude: 29.47496,
                longitude: -82.85984,
                timezone: 'America/New_York'
            },
            {
                id: 1283,
                city: 'Chipley',
                latitude: 30.78186,
                longitude: -85.53854,
                timezone: 'America/Chicago'
            },
            {
                id: 1284,
                city: 'Clearwater',
                latitude: 27.96585,
                longitude: -82.8001,
                timezone: 'America/New_York'
            },
            {
                id: 1285,
                city: 'Clermont',
                latitude: 28.54944,
                longitude: -81.77285,
                timezone: 'America/New_York'
            },
            {
                id: 1286,
                city: 'Clewiston',
                latitude: 26.75423,
                longitude: -80.93368,
                timezone: 'America/New_York'
            },
            {
                id: 1287,
                city: 'Cocoa',
                latitude: 28.38612,
                longitude: -80.742,
                timezone: 'America/New_York'
            },
            {
                id: 1288,
                city: 'Cocoa Beach',
                latitude: 28.32001,
                longitude: -80.60755,
                timezone: 'America/New_York'
            },
            {
                id: 1289,
                city: 'Coconut Creek',
                latitude: 26.25175,
                longitude: -80.17894,
                timezone: 'America/New_York'
            },
            {
                id: 1290,
                city: 'Coleman',
                latitude: 28.79971,
                longitude: -82.07009,
                timezone: 'America/New_York'
            },
            {
                id: 1291,
                city: 'Cooper City',
                latitude: 26.05731,
                longitude: -80.27172,
                timezone: 'America/New_York'
            },
            {
                id: 1292,
                city: 'Coral Gables',
                latitude: 25.72149,
                longitude: -80.26838,
                timezone: 'America/New_York'
            },
            {
                id: 1293,
                city: 'Coral Springs',
                latitude: 26.27119,
                longitude: -80.2706,
                timezone: 'America/New_York'
            },
            {
                id: 1294,
                city: 'Crescent City',
                latitude: 29.43025,
                longitude: -81.51063,
                timezone: 'America/New_York'
            },
            {
                id: 1295,
                city: 'Crestview',
                latitude: 30.76213,
                longitude: -86.57051,
                timezone: 'America/Chicago'
            },
            {
                id: 1296,
                city: 'Crystal River',
                latitude: 28.90248,
                longitude: -82.5926,
                timezone: 'America/New_York'
            },
            {
                id: 1297,
                city: 'Dade City',
                latitude: 28.36472,
                longitude: -82.19592,
                timezone: 'America/New_York'
            },
            {
                id: 1298,
                city: 'Dania Beach',
                latitude: 26.05231,
                longitude: -80.14393,
                timezone: 'America/New_York'
            },
            {
                id: 1299,
                city: 'Davenport',
                latitude: 28.1614,
                longitude: -81.60174,
                timezone: 'America/New_York'
            },
            {
                id: 1300,
                city: 'Daytona Beach',
                latitude: 29.21081,
                longitude: -81.02283,
                timezone: 'America/New_York'
            },
            {
                id: 1301,
                city: 'Daytona Beach Shores',
                latitude: 29.17609,
                longitude: -80.98283,
                timezone: 'America/New_York'
            },
            {
                id: 1302,
                city: 'DeBary',
                latitude: 28.88305,
                longitude: -81.30868,
                timezone: 'America/New_York'
            },
            {
                id: 1303,
                city: 'Deerfield Beach',
                latitude: 26.31841,
                longitude: -80.09977,
                timezone: 'America/New_York'
            },
            {
                id: 1304,
                city: 'DeFuniak Springs',
                latitude: 30.72102,
                longitude: -86.11522,
                timezone: 'America/Chicago'
            },
            {
                id: 1305,
                city: 'DeLand',
                latitude: 29.02832,
                longitude: -81.30312,
                timezone: 'America/New_York'
            },
            {
                id: 1306,
                city: 'Delray Beach',
                latitude: 26.46146,
                longitude: -80.07282,
                timezone: 'America/New_York'
            },
            {
                id: 1307,
                city: 'Deltona',
                latitude: 28.90054,
                longitude: -81.26367,
                timezone: 'America/New_York'
            },
            {
                id: 1308,
                city: 'Destin',
                latitude: 30.39353,
                longitude: -86.49578,
                timezone: 'America/Chicago'
            },
            {
                id: 1309,
                city: 'Doral',
                latitude: 25.81954,
                longitude: -80.35533,
                timezone: 'America/New_York'
            },
            {
                id: 1310,
                city: 'Dunedin',
                latitude: 28.01974,
                longitude: -82.77177,
                timezone: 'America/New_York'
            },
            {
                id: 1311,
                city: 'Dunnellon',
                latitude: 29.04914,
                longitude: -82.46093,
                timezone: 'America/New_York'
            },
            {
                id: 1312,
                city: 'Eagle Lake',
                latitude: 27.97836,
                longitude: -81.75647,
                timezone: 'America/New_York'
            },
            {
                id: 1313,
                city: 'Edgewater',
                latitude: 28.98888,
                longitude: -80.90228,
                timezone: 'America/New_York'
            },
            {
                id: 1314,
                city: 'Edgewood',
                latitude: 28.48612,
                longitude: -81.37229,
                timezone: 'America/New_York'
            },
            {
                id: 1315,
                city: 'Eustis',
                latitude: 28.85277,
                longitude: -81.68535,
                timezone: 'America/New_York'
            },
            {
                id: 1316,
                city: 'Everglades',
                latitude: 25.8601,
                longitude: -81.38036,
                timezone: 'America/New_York'
            },
            {
                id: 1317,
                city: 'Fanning Springs',
                latitude: 29.58815,
                longitude: -82.92507,
                timezone: 'America/New_York'
            },
            {
                id: 1318,
                city: 'Fellsmere',
                latitude: 27.76781,
                longitude: -80.60144,
                timezone: 'America/New_York'
            },
            {
                id: 1319,
                city: 'Fernandina Beach',
                latitude: 30.66968,
                longitude: -81.46259,
                timezone: 'America/New_York'
            },
            {
                id: 1320,
                city: 'Flagler Beach',
                latitude: 29.47385,
                longitude: -81.13102,
                timezone: 'America/New_York'
            },
            {
                id: 1321,
                city: 'Florida City',
                latitude: 25.44789,
                longitude: -80.47922,
                timezone: 'America/New_York'
            },
            {
                id: 1322,
                city: 'Fort Lauderdale',
                latitude: 26.12231,
                longitude: -80.14338,
                timezone: 'America/New_York'
            },
            {
                id: 1323,
                city: 'Fort Meade',
                latitude: 27.75225,
                longitude: -81.80175,
                timezone: 'America/New_York'
            },
            {
                id: 1324,
                city: 'Fort Myers',
                latitude: 26.64063,
                longitude: -81.87231,
                timezone: 'America/New_York'
            },
            {
                id: 1325,
                city: 'Fort Pierce',
                latitude: 27.44671,
                longitude: -80.32561,
                timezone: 'America/New_York'
            },
            {
                id: 1326,
                city: 'Fort Walton Beach',
                latitude: 30.40576,
                longitude: -86.61884,
                timezone: 'America/Chicago'
            },
            {
                id: 1327,
                city: 'Freeport',
                latitude: 30.49825,
                longitude: -86.13605,
                timezone: 'America/Chicago'
            },
            {
                id: 1328,
                city: 'Frostproof',
                latitude: 27.74586,
                longitude: -81.53063,
                timezone: 'America/New_York'
            },
            {
                id: 1329,
                city: 'Fruitland Park',
                latitude: 28.86138,
                longitude: -81.90647,
                timezone: 'America/New_York'
            },
            {
                id: 1330,
                city: 'Gainesville',
                latitude: 29.65163,
                longitude: -82.32483,
                timezone: 'America/New_York'
            },
            {
                id: 1331,
                city: 'Graceville',
                latitude: 30.95685,
                longitude: -85.5166,
                timezone: 'America/Chicago'
            },
            {
                id: 1333,
                city: 'Green Cove Springs',
                latitude: 29.99191,
                longitude: -81.67815,
                timezone: 'America/New_York'
            },
            {
                id: 1332,
                city: 'Greenacres',
                latitude: 26.62368,
                longitude: -80.12532,
                timezone: 'America/New_York'
            },
            {
                id: 1334,
                city: 'Gretna',
                latitude: 30.61714,
                longitude: -84.65991,
                timezone: 'America/New_York'
            },
            {
                id: 1335,
                city: 'Groveland',
                latitude: 28.55805,
                longitude: -81.85119,
                timezone: 'America/New_York'
            },
            {
                id: 1336,
                city: 'Gulf Breeze',
                latitude: 30.35714,
                longitude: -87.16386,
                timezone: 'America/Chicago'
            },
            {
                id: 1337,
                city: 'Gulfport',
                latitude: 27.74836,
                longitude: -82.70343,
                timezone: 'America/New_York'
            },
            {
                id: 1338,
                city: 'Haines City',
                latitude: 28.11418,
                longitude: -81.61785,
                timezone: 'America/New_York'
            },
            {
                id: 1339,
                city: 'Hallandale Beach',
                latitude: 25.9812,
                longitude: -80.14838,
                timezone: 'America/New_York'
            },
            {
                id: 1340,
                city: 'Hampton',
                latitude: 29.86441,
                longitude: -82.13094,
                timezone: 'America/New_York'
            },
            {
                id: 1341,
                city: 'Hawthorne',
                latitude: 29.59191,
                longitude: -82.08732,
                timezone: 'America/New_York'
            },
            {
                id: 1342,
                city: 'Hialeah',
                latitude: 25.8576,
                longitude: -80.27811,
                timezone: 'America/New_York'
            },
            {
                id: 1343,
                city: 'Hialeah Gardens',
                latitude: 25.8651,
                longitude: -80.3245,
                timezone: 'America/New_York'
            },
            {
                id: 1344,
                city: 'High Springs',
                latitude: 29.82691,
                longitude: -82.59678,
                timezone: 'America/New_York'
            },
            {
                id: 1345,
                city: 'Holly Hill',
                latitude: 29.24359,
                longitude: -81.03756,
                timezone: 'America/New_York'
            },
            {
                id: 1346,
                city: 'Hollywood',
                latitude: 26.0112,
                longitude: -80.14949,
                timezone: 'America/New_York'
            },
            {
                id: 1347,
                city: 'Holmes Beach',
                latitude: 27.49532,
                longitude: -82.71093,
                timezone: 'America/New_York'
            },
            {
                id: 1348,
                city: 'Homestead',
                latitude: 25.46872,
                longitude: -80.47756,
                timezone: 'America/New_York'
            },
            {
                id: 1349,
                city: 'Indian Harbour Beach',
                latitude: 28.1489,
                longitude: -80.58839,
                timezone: 'America/New_York'
            },
            {
                id: 1350,
                city: 'Indian Rocks Beach',
                latitude: 27.8753,
                longitude: -82.85122,
                timezone: 'America/New_York'
            },
            {
                id: 1351,
                city: 'Inverness',
                latitude: 28.83582,
                longitude: -82.33037,
                timezone: 'America/New_York'
            },
            {
                id: 1352,
                city: 'Jacksonville',
                latitude: 30.33218,
                longitude: -81.65565,
                timezone: 'America/New_York'
            },
            {
                id: 1353,
                city: 'Jacksonville Beach',
                latitude: 30.29469,
                longitude: -81.39314,
                timezone: 'America/New_York'
            },
            {
                id: 1354,
                city: 'Jacob City',
                latitude: 30.88553,
                longitude: -85.41357,
                timezone: 'America/Chicago'
            },
            {
                id: 1355,
                city: 'Jasper',
                latitude: 30.51827,
                longitude: -82.94819,
                timezone: 'America/New_York'
            },
            {
                id: 1356,
                city: 'Key Colony Beach',
                latitude: 24.72097,
                longitude: -81.01868,
                timezone: 'America/New_York'
            },
            {
                id: 1358,
                city: 'Key West',
                latitude: 24.5557,
                longitude: -81.78259,
                timezone: 'America/New_York'
            },
            {
                id: 1357,
                city: 'Keystone Heights',
                latitude: 29.78608,
                longitude: -82.03149,
                timezone: 'America/New_York'
            },
            {
                id: 1359,
                city: 'Kissimmee',
                latitude: 28.29196,
                longitude: -81.40757,
                timezone: 'America/New_York'
            },
            {
                id: 1360,
                city: 'LaBelle',
                latitude: 26.76173,
                longitude: -81.43841,
                timezone: 'America/New_York'
            },
            {
                id: 1361,
                city: 'Lake Alfred',
                latitude: 28.09196,
                longitude: -81.72341,
                timezone: 'America/New_York'
            },
            {
                id: 1362,
                city: 'Lake Buena Vista',
                latitude: 28.39362,
                longitude: -81.53868,
                timezone: 'America/New_York'
            },
            {
                id: 1363,
                city: 'Lake Butler',
                latitude: 30.02274,
                longitude: -82.33956,
                timezone: 'America/New_York'
            },
            {
                id: 1364,
                city: 'Lake City',
                latitude: 30.18968,
                longitude: -82.63929,
                timezone: 'America/New_York'
            },
            {
                id: 1365,
                city: 'Lake Helen',
                latitude: 28.98082,
                longitude: -81.23339,
                timezone: 'America/New_York'
            },
            {
                id: 1367,
                city: 'Lake Mary',
                latitude: 28.75888,
                longitude: -81.31784,
                timezone: 'America/New_York'
            },
            {
                id: 1368,
                city: 'Lake Wales',
                latitude: 27.90141,
                longitude: -81.58591,
                timezone: 'America/New_York'
            },
            {
                id: 1369,
                city: 'Lake Worth',
                latitude: 26.6159,
                longitude: -80.05699,
                timezone: 'America/New_York'
            },
            {
                id: 1366,
                city: 'Lakeland',
                latitude: 28.03947,
                longitude: -81.9498,
                timezone: 'America/New_York'
            },
            {
                id: 1370,
                city: 'Largo',
                latitude: 27.90947,
                longitude: -82.78732,
                timezone: 'America/New_York'
            },
            {
                id: 1371,
                city: 'Lauderdale Lakes',
                latitude: 26.16647,
                longitude: -80.20838,
                timezone: 'America/New_York'
            },
            {
                id: 1372,
                city: 'Lauderhill',
                latitude: 26.14036,
                longitude: -80.21338,
                timezone: 'America/New_York'
            },
            {
                id: 1373,
                city: 'Laurel Hill',
                latitude: 30.96574,
                longitude: -86.45967,
                timezone: 'America/Chicago'
            },
            {
                id: 1374,
                city: 'Lawtey',
                latitude: 30.04413,
                longitude: -82.07177,
                timezone: 'America/New_York'
            },
            {
                id: 1375,
                city: 'Layton',
                latitude: 24.82403,
                longitude: -80.81368,
                timezone: 'America/New_York'
            },
            {
                id: 1376,
                city: 'Leesburg',
                latitude: 28.81082,
                longitude: -81.87786,
                timezone: 'America/New_York'
            },
            {
                id: 1377,
                city: 'Lighthouse Point',
                latitude: 26.27564,
                longitude: -80.08727,
                timezone: 'America/New_York'
            },
            {
                id: 1378,
                city: 'Live Oak',
                latitude: 30.29495,
                longitude: -82.98402,
                timezone: 'America/New_York'
            },
            {
                id: 1379,
                city: 'Longwood',
                latitude: 28.70305,
                longitude: -81.3384,
                timezone: 'America/New_York'
            },
            {
                id: 1380,
                city: 'Lynn Haven',
                latitude: 30.24548,
                longitude: -85.64826,
                timezone: 'America/Chicago'
            },
            {
                id: 1381,
                city: 'Macclenny',
                latitude: 30.28218,
                longitude: -82.12206,
                timezone: 'America/New_York'
            },
            {
                id: 1382,
                city: 'Madeira Beach',
                latitude: 27.79808,
                longitude: -82.79732,
                timezone: 'America/New_York'
            },
            {
                id: 1383,
                city: 'Madison',
                latitude: 30.46938,
                longitude: -83.41293,
                timezone: 'America/New_York'
            },
            {
                id: 1384,
                city: 'Maitland',
                latitude: 28.62778,
                longitude: -81.36312,
                timezone: 'America/New_York'
            },
            {
                id: 1385,
                city: 'Marathon',
                latitude: 24.71375,
                longitude: -81.09035,
                timezone: 'America/New_York'
            },
            {
                id: 1386,
                city: 'Marco Island',
                latitude: 25.93203,
                longitude: -81.70484,
                timezone: 'America/New_York'
            },
            {
                id: 1387,
                city: 'Margate',
                latitude: 26.24453,
                longitude: -80.20644,
                timezone: 'America/New_York'
            },
            {
                id: 1388,
                city: 'Marianna',
                latitude: 30.77436,
                longitude: -85.22687,
                timezone: 'America/Chicago'
            },
            {
                id: 1389,
                city: 'Mary Esther',
                latitude: 30.40992,
                longitude: -86.66301,
                timezone: 'America/Chicago'
            },
            {
                id: 1390,
                city: 'Mascotte',
                latitude: 28.57833,
                longitude: -81.88675,
                timezone: 'America/New_York'
            },
            {
                id: 1391,
                city: 'Melbourne',
                latitude: 28.08363,
                longitude: -80.60811,
                timezone: 'America/New_York'
            },
            {
                id: 1392,
                city: 'Mexico Beach',
                latitude: 29.94798,
                longitude: -85.41798,
                timezone: 'America/Chicago'
            },
            {
                id: 1393,
                city: 'Miami',
                latitude: 25.77427,
                longitude: -80.19366,
                timezone: 'America/New_York'
            },
            {
                id: 1394,
                city: 'Miami Beach',
                latitude: 25.79065,
                longitude: -80.13005,
                timezone: 'America/New_York'
            },
            {
                id: 1395,
                city: 'Miami Gardens',
                latitude: 25.94204,
                longitude: -80.2456,
                timezone: 'America/New_York'
            },
            {
                id: 1396,
                city: 'Miami Springs',
                latitude: 25.82232,
                longitude: -80.2895,
                timezone: 'America/New_York'
            },
            {
                id: 1397,
                city: 'Midway',
                latitude: 30.49548,
                longitude: -84.45435,
                timezone: 'America/New_York'
            },
            {
                id: 1398,
                city: 'Milton',
                latitude: 30.63241,
                longitude: -87.03969,
                timezone: 'America/Chicago'
            },
            {
                id: 1399,
                city: 'Minneola',
                latitude: 28.57444,
                longitude: -81.74619,
                timezone: 'America/New_York'
            },
            {
                id: 1400,
                city: 'Miramar',
                latitude: 25.98731,
                longitude: -80.23227,
                timezone: 'America/New_York'
            },
            {
                id: 1401,
                city: 'Monticello',
                latitude: 30.5452,
                longitude: -83.87016,
                timezone: 'America/New_York'
            },
            {
                id: 1402,
                city: 'Moore Haven',
                latitude: 26.83312,
                longitude: -81.09312,
                timezone: 'America/New_York'
            },
            {
                id: 1403,
                city: 'Mount Dora',
                latitude: 28.80249,
                longitude: -81.64452,
                timezone: 'America/New_York'
            },
            {
                id: 1404,
                city: 'Mulberry',
                latitude: 27.8953,
                longitude: -81.97342,
                timezone: 'America/New_York'
            },
            {
                id: 1405,
                city: 'Naples',
                latitude: 26.14204,
                longitude: -81.79481,
                timezone: 'America/New_York'
            },
            {
                id: 1406,
                city: 'Neptune Beach',
                latitude: 30.31191,
                longitude: -81.39647,
                timezone: 'America/New_York'
            },
            {
                id: 1408,
                city: 'New Port Richey',
                latitude: 28.24418,
                longitude: -82.71927,
                timezone: 'America/New_York'
            },
            {
                id: 1409,
                city: 'New Smyrna Beach',
                latitude: 29.02582,
                longitude: -80.927,
                timezone: 'America/New_York'
            },
            {
                id: 1407,
                city: 'Newberry',
                latitude: 29.64635,
                longitude: -82.6065,
                timezone: 'America/New_York'
            },
            {
                id: 1410,
                city: 'Niceville',
                latitude: 30.51686,
                longitude: -86.48217,
                timezone: 'America/Chicago'
            },
            {
                id: 1411,
                city: 'North Bay Village',
                latitude: 25.84621,
                longitude: -80.15394,
                timezone: 'America/New_York'
            },
            {
                id: 1412,
                city: 'North Lauderdale',
                latitude: 26.21731,
                longitude: -80.22588,
                timezone: 'America/New_York'
            },
            {
                id: 1413,
                city: 'North Miami',
                latitude: 25.89009,
                longitude: -80.18671,
                timezone: 'America/New_York'
            },
            {
                id: 1414,
                city: 'North Miami Beach',
                latitude: 25.93315,
                longitude: -80.16255,
                timezone: 'America/New_York'
            },
            {
                id: 1415,
                city: 'North Port',
                latitude: 27.04422,
                longitude: -82.23593,
                timezone: 'America/New_York'
            },
            {
                id: 1416,
                city: 'Oak Hill',
                latitude: 28.86443,
                longitude: -80.8545,
                timezone: 'America/New_York'
            },
            {
                id: 1417,
                city: 'Oakland Park',
                latitude: 26.17231,
                longitude: -80.13199,
                timezone: 'America/New_York'
            },
            {
                id: 1418,
                city: 'Ocala',
                latitude: 29.1872,
                longitude: -82.14009,
                timezone: 'America/New_York'
            },
            {
                id: 1419,
                city: 'Ocoee',
                latitude: 28.56917,
                longitude: -81.54396,
                timezone: 'America/New_York'
            },
            {
                id: 1420,
                city: 'Okeechobee',
                latitude: 27.24393,
                longitude: -80.82978,
                timezone: 'America/New_York'
            },
            {
                id: 1421,
                city: 'Oldsmar',
                latitude: 28.03418,
                longitude: -82.6651,
                timezone: 'America/New_York'
            },
            {
                id: 1422,
                city: 'Opa-locka',
                latitude: 25.90232,
                longitude: -80.25033,
                timezone: 'America/New_York'
            },
            {
                id: 1423,
                city: 'Orange City',
                latitude: 28.94888,
                longitude: -81.29867,
                timezone: 'America/New_York'
            },
            {
                id: 1424,
                city: 'Orlando',
                latitude: 28.53834,
                longitude: -81.37924,
                timezone: 'America/New_York'
            },
            {
                id: 1425,
                city: 'Ormond Beach',
                latitude: 29.28581,
                longitude: -81.05589,
                timezone: 'America/New_York'
            },
            {
                id: 1426,
                city: 'Oviedo',
                latitude: 28.67,
                longitude: -81.20812,
                timezone: 'America/New_York'
            },
            {
                id: 1427,
                city: 'Pahokee',
                latitude: 26.82006,
                longitude: -80.66534,
                timezone: 'America/New_York'
            },
            {
                id: 1428,
                city: 'Palatka',
                latitude: 29.64858,
                longitude: -81.63758,
                timezone: 'America/New_York'
            },
            {
                id: 1429,
                city: 'Palm Bay',
                latitude: 28.03446,
                longitude: -80.58866,
                timezone: 'America/New_York'
            },
            {
                id: 1430,
                city: 'Palm Beach Gardens',
                latitude: 26.82339,
                longitude: -80.13865,
                timezone: 'America/New_York'
            },
            {
                id: 1431,
                city: 'Palm Coast',
                latitude: 29.58497,
                longitude: -81.20784,
                timezone: 'America/New_York'
            },
            {
                id: 1432,
                city: 'Palmetto',
                latitude: 27.52143,
                longitude: -82.57232,
                timezone: 'America/New_York'
            },
            {
                id: 1433,
                city: 'Panama City',
                latitude: 30.15881,
                longitude: -85.66021,
                timezone: 'America/Chicago'
            },
            {
                id: 1434,
                city: 'Panama City Beach',
                latitude: 30.17659,
                longitude: -85.80549,
                timezone: 'America/Chicago'
            },
            {
                id: 1435,
                city: 'Parker',
                latitude: 30.13104,
                longitude: -85.60326,
                timezone: 'America/Chicago'
            },
            {
                id: 1436,
                city: 'Parkland',
                latitude: 26.31008,
                longitude: -80.23727,
                timezone: 'America/New_York'
            },
            {
                id: 1437,
                city: 'Pembroke Pines',
                latitude: 26.00315,
                longitude: -80.22394,
                timezone: 'America/New_York'
            },
            {
                id: 1438,
                city: 'Pensacola',
                latitude: 30.42131,
                longitude: -87.21691,
                timezone: 'America/Chicago'
            },
            {
                id: 1439,
                city: 'Perry',
                latitude: 30.11744,
                longitude: -83.58181,
                timezone: 'America/New_York'
            },
            {
                id: 1440,
                city: 'Pinellas Park',
                latitude: 27.8428,
                longitude: -82.69954,
                timezone: 'America/New_York'
            },
            {
                id: 1442,
                city: 'Plant City',
                latitude: 28.01863,
                longitude: -82.11286,
                timezone: 'America/New_York'
            },
            {
                id: 1441,
                city: 'Plantation',
                latitude: 26.12759,
                longitude: -80.2331,
                timezone: 'America/New_York'
            },
            {
                id: 1443,
                city: 'Pompano Beach',
                latitude: 26.23786,
                longitude: -80.12477,
                timezone: 'America/New_York'
            },
            {
                id: 1444,
                city: 'Port Orange',
                latitude: 29.13832,
                longitude: -80.99561,
                timezone: 'America/New_York'
            },
            {
                id: 1445,
                city: 'Port Richey',
                latitude: 28.27168,
                longitude: -82.71955,
                timezone: 'America/New_York'
            },
            {
                id: 1446,
                city: 'Port St. Joe',
                latitude: 29.81188,
                longitude: -85.30297,
                timezone: 'America/New_York'
            },
            {
                id: 1447,
                city: 'Port St. Lucie',
                latitude: 27.29393,
                longitude: -80.35033,
                timezone: 'America/New_York'
            },
            {
                id: 1448,
                city: 'Punta Gorda',
                latitude: 26.92978,
                longitude: -82.04537,
                timezone: 'America/New_York'
            },
            {
                id: 1449,
                city: 'Quincy',
                latitude: 30.58714,
                longitude: -84.58325,
                timezone: 'America/New_York'
            },
            {
                id: 1450,
                city: 'Riviera Beach',
                latitude: 26.77534,
                longitude: -80.0581,
                timezone: 'America/New_York'
            },
            {
                id: 1451,
                city: 'Rockledge',
                latitude: 28.35084,
                longitude: -80.72533,
                timezone: 'America/New_York'
            },
            {
                id: 1452,
                city: 'Safety Harbor',
                latitude: 27.99085,
                longitude: -82.69316,
                timezone: 'America/New_York'
            },
            {
                id: 1453,
                city: 'San Antonio',
                latitude: 28.33611,
                longitude: -82.27453,
                timezone: 'America/New_York'
            },
            {
                id: 1454,
                city: 'Sanford',
                latitude: 28.80055,
                longitude: -81.27312,
                timezone: 'America/New_York'
            },
            {
                id: 1455,
                city: 'Sanibel',
                latitude: 26.44897,
                longitude: -82.02231,
                timezone: 'America/New_York'
            },
            {
                id: 1456,
                city: 'Sarasota',
                latitude: 27.33643,
                longitude: -82.53065,
                timezone: 'America/New_York'
            },
            {
                id: 1457,
                city: 'Satellite Beach',
                latitude: 28.17612,
                longitude: -80.59005,
                timezone: 'America/New_York'
            },
            {
                id: 1458,
                city: 'Sebastian',
                latitude: 27.81642,
                longitude: -80.47061,
                timezone: 'America/New_York'
            },
            {
                id: 1459,
                city: 'Sebring',
                latitude: 27.49559,
                longitude: -81.44091,
                timezone: 'America/New_York'
            },
            {
                id: 1460,
                city: 'Seminole',
                latitude: 27.83975,
                longitude: -82.79121,
                timezone: 'America/New_York'
            },
            {
                id: 1461,
                city: 'Sopchoppy',
                latitude: 30.05993,
                longitude: -84.48879,
                timezone: 'America/New_York'
            },
            {
                id: 1462,
                city: 'South Bay',
                latitude: 26.66396,
                longitude: -80.71617,
                timezone: 'America/New_York'
            },
            {
                id: 1463,
                city: 'South Daytona',
                latitude: 29.16582,
                longitude: -81.0045,
                timezone: 'America/New_York'
            },
            {
                id: 1464,
                city: 'South Miami',
                latitude: 25.7076,
                longitude: -80.29338,
                timezone: 'America/New_York'
            },
            {
                id: 1465,
                city: 'South Pasadena',
                latitude: 27.75503,
                longitude: -82.7376,
                timezone: 'America/New_York'
            },
            {
                id: 1466,
                city: 'Springfield',
                latitude: 30.15326,
                longitude: -85.61132,
                timezone: 'America/Chicago'
            },
            {
                id: 1468,
                city: 'St. Augustine',
                latitude: 29.89469,
                longitude: -81.31452,
                timezone: 'America/New_York'
            },
            {
                id: 1469,
                city: 'St. Augustine Beach',
                latitude: 29.85053,
                longitude: -81.26535,
                timezone: 'America/New_York'
            },
            {
                id: 1470,
                city: 'St. Cloud',
                latitude: 28.2489,
                longitude: -81.28118,
                timezone: 'America/New_York'
            },
            {
                id: 1471,
                city: 'St. Marks',
                latitude: 30.16104,
                longitude: -84.20628,
                timezone: 'America/New_York'
            },
            {
                id: 1472,
                city: 'St. Pete Beach',
                latitude: 27.72531,
                longitude: -82.74121,
                timezone: 'America/New_York'
            },
            {
                id: 1473,
                city: 'St. Petersburg',
                latitude: 27.77086,
                longitude: -82.67927,
                timezone: 'America/New_York'
            },
            {
                id: 1467,
                city: 'Starke',
                latitude: 29.94413,
                longitude: -82.10983,
                timezone: 'America/New_York'
            },
            {
                id: 1474,
                city: 'Stuart',
                latitude: 27.19755,
                longitude: -80.25283,
                timezone: 'America/New_York'
            },
            {
                id: 1475,
                city: 'Sunny Isles Beach',
                latitude: 25.95065,
                longitude: -80.12282,
                timezone: 'America/New_York'
            },
            {
                id: 1476,
                city: 'Sunrise',
                latitude: 26.1716,
                longitude: -80.26163,
                timezone: 'America/New_York'
            },
            {
                id: 1477,
                city: 'Sweetwater',
                latitude: 25.76343,
                longitude: -80.37311,
                timezone: 'America/New_York'
            },
            {
                id: 1478,
                city: 'Tallahassee',
                latitude: 30.43826,
                longitude: -84.28073,
                timezone: 'America/New_York'
            },
            {
                id: 1479,
                city: 'Tamarac',
                latitude: 26.21286,
                longitude: -80.24977,
                timezone: 'America/New_York'
            },
            {
                id: 1480,
                city: 'Tampa',
                latitude: 27.94752,
                longitude: -82.45843,
                timezone: 'America/New_York'
            },
            {
                id: 1481,
                city: 'Tarpon Springs',
                latitude: 28.14612,
                longitude: -82.75677,
                timezone: 'America/New_York'
            },
            {
                id: 1482,
                city: 'Tavares',
                latitude: 28.80416,
                longitude: -81.72563,
                timezone: 'America/New_York'
            },
            {
                id: 1483,
                city: 'Temple Terrace',
                latitude: 28.0353,
                longitude: -82.38926,
                timezone: 'America/New_York'
            },
            {
                id: 1484,
                city: 'Titusville',
                latitude: 28.61222,
                longitude: -80.80755,
                timezone: 'America/New_York'
            },
            {
                id: 1485,
                city: 'Treasure Island',
                latitude: 27.76919,
                longitude: -82.76899,
                timezone: 'America/New_York'
            },
            {
                id: 1486,
                city: 'Trenton',
                latitude: 29.61329,
                longitude: -82.81762,
                timezone: 'America/New_York'
            },
            {
                id: 1487,
                city: 'Umatilla',
                latitude: 28.92943,
                longitude: -81.66563,
                timezone: 'America/New_York'
            },
            {
                id: 1488,
                city: 'Valparaiso',
                latitude: 30.50853,
                longitude: -86.50273,
                timezone: 'America/Chicago'
            },
            {
                id: 1489,
                city: 'Venice',
                latitude: 27.09978,
                longitude: -82.45426,
                timezone: 'America/New_York'
            },
            {
                id: 1490,
                city: 'Vernon',
                latitude: 30.62297,
                longitude: -85.71215,
                timezone: 'America/Chicago'
            },
            {
                id: 1491,
                city: 'Vero Beach',
                latitude: 27.63864,
                longitude: -80.39727,
                timezone: 'America/New_York'
            },
            {
                id: 1492,
                city: 'Waldo',
                latitude: 29.78969,
                longitude: -82.16732,
                timezone: 'America/New_York'
            },
            {
                id: 1493,
                city: 'Wauchula',
                latitude: 27.54726,
                longitude: -81.81147,
                timezone: 'America/New_York'
            },
            {
                id: 1494,
                city: 'Webster',
                latitude: 28.60999,
                longitude: -82.05508,
                timezone: 'America/New_York'
            },
            {
                id: 1495,
                city: 'Weeki Wachee',
                latitude: 28.51555,
                longitude: -82.57288,
                timezone: 'America/New_York'
            },
            {
                id: 1497,
                city: 'West Melbourne',
                latitude: 28.07168,
                longitude: -80.65339,
                timezone: 'America/New_York'
            },
            {
                id: 1498,
                city: 'West Miami',
                latitude: 25.76343,
                longitude: -80.29616,
                timezone: 'America/New_York'
            },
            {
                id: 1500,
                city: 'West Palm Beach',
                latitude: 26.71534,
                longitude: -80.05337,
                timezone: 'America/New_York'
            },
            {
                id: 1501,
                city: 'West Park',
                latitude: 25.98454,
                longitude: -80.19894,
                timezone: 'America/New_York'
            },
            {
                id: 1496,
                city: 'Westlake',
                latitude: 26.7582,
                longitude: -80.30727,
                timezone: 'America/New_York'
            },
            {
                id: 1499,
                city: 'Weston',
                latitude: 26.10037,
                longitude: -80.39977,
                timezone: 'America/New_York'
            },
            {
                id: 1502,
                city: 'Wewahitchka',
                latitude: 30.1127,
                longitude: -85.20047,
                timezone: 'America/Chicago'
            },
            {
                id: 1503,
                city: 'Wildwood',
                latitude: 28.86526,
                longitude: -82.03897,
                timezone: 'America/New_York'
            },
            {
                id: 1504,
                city: 'Williston',
                latitude: 29.38747,
                longitude: -82.44677,
                timezone: 'America/New_York'
            },
            {
                id: 1505,
                city: 'Wilton Manors',
                latitude: 26.16036,
                longitude: -80.13893,
                timezone: 'America/New_York'
            },
            {
                id: 1506,
                city: 'Winter Garden',
                latitude: 28.56528,
                longitude: -81.58618,
                timezone: 'America/New_York'
            },
            {
                id: 1507,
                city: 'Winter Haven',
                latitude: 28.02224,
                longitude: -81.73286,
                timezone: 'America/New_York'
            },
            {
                id: 1508,
                city: 'Winter Park',
                latitude: 28.6,
                longitude: -81.33924,
                timezone: 'America/New_York'
            },
            {
                id: 1509,
                city: 'Winter Springs',
                latitude: 28.69889,
                longitude: -81.30812,
                timezone: 'America/New_York'
            },
            {
                id: 1510,
                city: 'Zephyrhills',
                latitude: 28.23362,
                longitude: -82.18119,
                timezone: 'America/New_York'
            }
        ]
    },
    {
        id: 12,
        country: 'US',
        stateCode: 'IA',
        stateName: 'Iowa',
        cities: [
            {
                id: 1939,
                city: 'Ackley',
                latitude: 42.5517,
                longitude: -93.05227,
                timezone: 'America/Chicago'
            },
            {
                id: 1940,
                city: 'Ackworth',
                latitude: 41.36694,
                longitude: -93.47271,
                timezone: 'America/Chicago'
            },
            {
                id: 1941,
                city: 'Adair',
                latitude: 41.50015,
                longitude: -94.64295,
                timezone: 'America/Chicago'
            },
            {
                id: 1942,
                city: 'Adel',
                latitude: 41.61443,
                longitude: -94.01745,
                timezone: 'America/Chicago'
            },
            {
                id: 1943,
                city: 'Afton',
                latitude: 41.02749,
                longitude: -94.19801,
                timezone: 'America/Chicago'
            },
            {
                id: 1944,
                city: 'Agency',
                latitude: 40.99502,
                longitude: -92.30685,
                timezone: 'America/Chicago'
            },
            {
                id: 1945,
                city: 'Ainsworth',
                latitude: 41.28891,
                longitude: -91.55238,
                timezone: 'America/Chicago'
            },
            {
                id: 1946,
                city: 'Akron',
                latitude: 42.82888,
                longitude: -96.55948,
                timezone: 'America/Chicago'
            },
            {
                id: 1947,
                city: 'Albert City',
                latitude: 42.78192,
                longitude: -94.9486,
                timezone: 'America/Chicago'
            },
            {
                id: 1948,
                city: 'Albia',
                latitude: 41.02667,
                longitude: -92.80575,
                timezone: 'America/Chicago'
            },
            {
                id: 1949,
                city: 'Albion',
                latitude: 42.11249,
                longitude: -92.98853,
                timezone: 'America/Chicago'
            },
            {
                id: 1950,
                city: 'Alburnett',
                latitude: 42.14833,
                longitude: -91.61851,
                timezone: 'America/Chicago'
            },
            {
                id: 1951,
                city: 'Alden',
                latitude: 42.52026,
                longitude: -93.37604,
                timezone: 'America/Chicago'
            },
            {
                id: 1952,
                city: 'Alexander',
                latitude: 42.8058,
                longitude: -93.47659,
                timezone: 'America/Chicago'
            },
            {
                id: 1953,
                city: 'Algona',
                latitude: 43.06997,
                longitude: -94.23302,
                timezone: 'America/Chicago'
            },
            {
                id: 1954,
                city: 'Alleman',
                latitude: 41.81999,
                longitude: -93.61161,
                timezone: 'America/Chicago'
            },
            {
                id: 1955,
                city: 'Allerton',
                latitude: 40.7064,
                longitude: -93.36521,
                timezone: 'America/Chicago'
            },
            {
                id: 1956,
                city: 'Allison',
                latitude: 42.75275,
                longitude: -92.79519,
                timezone: 'America/Chicago'
            },
            {
                id: 1957,
                city: 'Alta',
                latitude: 42.67359,
                longitude: -95.29055,
                timezone: 'America/Chicago'
            },
            {
                id: 1958,
                city: 'Alta Vista',
                latitude: 43.19858,
                longitude: -92.41712,
                timezone: 'America/Chicago'
            },
            {
                id: 1959,
                city: 'Alton',
                latitude: 42.98749,
                longitude: -96.01057,
                timezone: 'America/Chicago'
            },
            {
                id: 1960,
                city: 'Altoona',
                latitude: 41.64416,
                longitude: -93.46466,
                timezone: 'America/Chicago'
            },
            {
                id: 1961,
                city: 'Alvord',
                latitude: 43.3422,
                longitude: -96.30114,
                timezone: 'America/Chicago'
            },
            {
                id: 1962,
                city: 'Ames',
                latitude: 42.03471,
                longitude: -93.61994,
                timezone: 'America/Chicago'
            },
            {
                id: 1963,
                city: 'Anamosa',
                latitude: 42.10834,
                longitude: -91.28516,
                timezone: 'America/Chicago'
            },
            {
                id: 1964,
                city: 'Andover',
                latitude: 41.97919,
                longitude: -90.2518,
                timezone: 'America/Chicago'
            },
            {
                id: 1965,
                city: 'Andrew',
                latitude: 42.15363,
                longitude: -90.59235,
                timezone: 'America/Chicago'
            },
            {
                id: 1966,
                city: 'Anita',
                latitude: 41.44527,
                longitude: -94.7647,
                timezone: 'America/Chicago'
            },
            {
                id: 1967,
                city: 'Ankeny',
                latitude: 41.72971,
                longitude: -93.60577,
                timezone: 'America/Chicago'
            },
            {
                id: 1968,
                city: 'Anthon',
                latitude: 42.38832,
                longitude: -95.86668,
                timezone: 'America/Chicago'
            },
            {
                id: 1969,
                city: 'Aplington',
                latitude: 42.58415,
                longitude: -92.88436,
                timezone: 'America/Chicago'
            },
            {
                id: 1970,
                city: 'Arcadia',
                latitude: 42.08721,
                longitude: -95.0461,
                timezone: 'America/Chicago'
            },
            {
                id: 1971,
                city: 'Archer',
                latitude: 43.11526,
                longitude: -95.74585,
                timezone: 'America/Chicago'
            },
            {
                id: 1972,
                city: 'Aredale',
                latitude: 42.83303,
                longitude: -93.00547,
                timezone: 'America/Chicago'
            },
            {
                id: 1973,
                city: 'Arion',
                latitude: 41.94916,
                longitude: -95.46361,
                timezone: 'America/Chicago'
            },
            {
                id: 1974,
                city: 'Arispe',
                latitude: 40.94944,
                longitude: -94.21912,
                timezone: 'America/Chicago'
            },
            {
                id: 1975,
                city: 'Arlington',
                latitude: 42.74915,
                longitude: -91.67127,
                timezone: 'America/Chicago'
            },
            {
                id: 1976,
                city: 'Armstrong',
                latitude: 43.39607,
                longitude: -94.47831,
                timezone: 'America/Chicago'
            },
            {
                id: 1977,
                city: 'Arnolds Park',
                latitude: 43.37274,
                longitude: -95.12388,
                timezone: 'America/Chicago'
            },
            {
                id: 1978,
                city: 'Arthur',
                latitude: 42.33471,
                longitude: -95.3475,
                timezone: 'America/Chicago'
            },
            {
                id: 1979,
                city: 'Asbury',
                latitude: 42.51445,
                longitude: -90.75152,
                timezone: 'America/Chicago'
            },
            {
                id: 1980,
                city: 'Ashton',
                latitude: 43.31136,
                longitude: -95.79113,
                timezone: 'America/Chicago'
            },
            {
                id: 1981,
                city: 'Aspinwall',
                latitude: 41.91193,
                longitude: -95.13555,
                timezone: 'America/Chicago'
            },
            {
                id: 1982,
                city: 'Atalissa',
                latitude: 41.57114,
                longitude: -91.16599,
                timezone: 'America/Chicago'
            },
            {
                id: 1983,
                city: 'Atkins',
                latitude: 41.99694,
                longitude: -91.86213,
                timezone: 'America/Chicago'
            },
            {
                id: 1984,
                city: 'Atlantic',
                latitude: 41.4036,
                longitude: -95.01388,
                timezone: 'America/Chicago'
            },
            {
                id: 1985,
                city: 'Auburn',
                latitude: 42.25137,
                longitude: -94.87776,
                timezone: 'America/Chicago'
            },
            {
                id: 1986,
                city: 'Audubon',
                latitude: 41.71804,
                longitude: -94.93249,
                timezone: 'America/Chicago'
            },
            {
                id: 1987,
                city: 'Aurelia',
                latitude: 42.71276,
                longitude: -95.43667,
                timezone: 'America/Chicago'
            },
            {
                id: 1988,
                city: 'Aurora',
                latitude: 42.61887,
                longitude: -91.7285,
                timezone: 'America/Chicago'
            },
            {
                id: 1989,
                city: 'Avoca',
                latitude: 41.47666,
                longitude: -95.33805,
                timezone: 'America/Chicago'
            },
            {
                id: 1990,
                city: 'Ayrshire',
                latitude: 43.03913,
                longitude: -94.83276,
                timezone: 'America/Chicago'
            },
            {
                id: 1991,
                city: 'Badger',
                latitude: 42.61441,
                longitude: -94.14607,
                timezone: 'America/Chicago'
            },
            {
                id: 1992,
                city: 'Bagley',
                latitude: 41.8461,
                longitude: -94.42997,
                timezone: 'America/Chicago'
            },
            {
                id: 1993,
                city: 'Baldwin',
                latitude: 42.07418,
                longitude: -90.84153,
                timezone: 'America/Chicago'
            },
            {
                id: 1994,
                city: 'Balltown',
                latitude: 42.63805,
                longitude: -90.86874,
                timezone: 'America/Chicago'
            },
            {
                id: 1995,
                city: 'Bancroft',
                latitude: 43.29274,
                longitude: -94.21802,
                timezone: 'America/Chicago'
            },
            {
                id: 1996,
                city: 'Bankston',
                latitude: 42.51861,
                longitude: -90.96124,
                timezone: 'America/Chicago'
            },
            {
                id: 1997,
                city: 'Barnes City',
                latitude: 41.50706,
                longitude: -92.46962,
                timezone: 'America/Chicago'
            },
            {
                id: 1998,
                city: 'Barnum',
                latitude: 42.50858,
                longitude: -94.36525,
                timezone: 'America/Chicago'
            },
            {
                id: 1999,
                city: 'Bassett',
                latitude: 43.06303,
                longitude: -92.51546,
                timezone: 'America/Chicago'
            },
            {
                id: 2000,
                city: 'Batavia',
                latitude: 40.99418,
                longitude: -92.1674,
                timezone: 'America/Chicago'
            },
            {
                id: 2001,
                city: 'Battle Creek',
                latitude: 42.31554,
                longitude: -95.59861,
                timezone: 'America/Chicago'
            },
            {
                id: 2002,
                city: 'Baxter',
                latitude: 41.8261,
                longitude: -93.15159,
                timezone: 'America/Chicago'
            },
            {
                id: 2003,
                city: 'Bayard',
                latitude: 41.85193,
                longitude: -94.55831,
                timezone: 'America/Chicago'
            },
            {
                id: 2004,
                city: 'Beacon',
                latitude: 41.27695,
                longitude: -92.67964,
                timezone: 'America/Chicago'
            },
            {
                id: 2005,
                city: 'Beaconsfield',
                latitude: 40.80777,
                longitude: -94.05051,
                timezone: 'America/Chicago'
            },
            {
                id: 2006,
                city: 'Beaman',
                latitude: 42.21971,
                longitude: -92.82353,
                timezone: 'America/Chicago'
            },
            {
                id: 2007,
                city: 'Beaver',
                latitude: 42.03831,
                longitude: -94.14218,
                timezone: 'America/Chicago'
            },
            {
                id: 2008,
                city: 'Bedford',
                latitude: 40.66693,
                longitude: -94.72136,
                timezone: 'America/Chicago'
            },
            {
                id: 2009,
                city: 'Belle Plaine',
                latitude: 41.89694,
                longitude: -92.27824,
                timezone: 'America/Chicago'
            },
            {
                id: 2010,
                city: 'Bellevue',
                latitude: 42.25863,
                longitude: -90.42291,
                timezone: 'America/Chicago'
            },
            {
                id: 2011,
                city: 'Belmond',
                latitude: 42.84608,
                longitude: -93.6141,
                timezone: 'America/Chicago'
            },
            {
                id: 2012,
                city: 'Bennett',
                latitude: 41.7403,
                longitude: -90.97376,
                timezone: 'America/Chicago'
            },
            {
                id: 2013,
                city: 'Benton',
                latitude: 40.70332,
                longitude: -94.35829,
                timezone: 'America/Chicago'
            },
            {
                id: 2014,
                city: 'Berkley',
                latitude: 41.94498,
                longitude: -94.11468,
                timezone: 'America/Chicago'
            },
            {
                id: 2015,
                city: 'Bernard',
                latitude: 42.31223,
                longitude: -90.8318,
                timezone: 'America/Chicago'
            },
            {
                id: 2016,
                city: 'Bertram',
                latitude: 41.94973,
                longitude: -91.53545,
                timezone: 'America/Chicago'
            },
            {
                id: 2017,
                city: 'Bettendorf',
                latitude: 41.52448,
                longitude: -90.51569,
                timezone: 'America/Chicago'
            },
            {
                id: 2018,
                city: 'Bevington',
                latitude: 41.35995,
                longitude: -93.78424,
                timezone: 'America/Chicago'
            },
            {
                id: 2019,
                city: 'Birmingham',
                latitude: 40.87891,
                longitude: -91.94712,
                timezone: 'America/Chicago'
            },
            {
                id: 2020,
                city: 'Blairsburg',
                latitude: 42.47998,
                longitude: -93.64299,
                timezone: 'America/Chicago'
            },
            {
                id: 2021,
                city: 'Blairstown',
                latitude: 41.90944,
                longitude: -92.08435,
                timezone: 'America/Chicago'
            },
            {
                id: 2022,
                city: 'Blakesburg',
                latitude: 40.96223,
                longitude: -92.63408,
                timezone: 'America/Chicago'
            },
            {
                id: 2023,
                city: 'Blanchard',
                latitude: 40.57916,
                longitude: -95.22165,
                timezone: 'America/Chicago'
            },
            {
                id: 2024,
                city: 'Blencoe',
                latitude: 41.93027,
                longitude: -96.08085,
                timezone: 'America/Chicago'
            },
            {
                id: 2025,
                city: 'Blockton',
                latitude: 40.61555,
                longitude: -94.47718,
                timezone: 'America/Chicago'
            },
            {
                id: 2026,
                city: 'Bloomfield',
                latitude: 40.75169,
                longitude: -92.41491,
                timezone: 'America/Chicago'
            },
            {
                id: 2027,
                city: 'Blue Grass',
                latitude: 41.50957,
                longitude: -90.76485,
                timezone: 'America/Chicago'
            },
            {
                id: 2028,
                city: 'Bode',
                latitude: 42.8683,
                longitude: -94.28969,
                timezone: 'America/Chicago'
            },
            {
                id: 2029,
                city: 'Bonaparte',
                latitude: 40.69809,
                longitude: -91.80322,
                timezone: 'America/Chicago'
            },
            {
                id: 2030,
                city: 'Bondurant',
                latitude: 41.70054,
                longitude: -93.46216,
                timezone: 'America/Chicago'
            },
            {
                id: 2031,
                city: 'Boone',
                latitude: 42.0597,
                longitude: -93.88023,
                timezone: 'America/Chicago'
            },
            {
                id: 2032,
                city: 'Bouton',
                latitude: 41.85137,
                longitude: -94.00912,
                timezone: 'America/Chicago'
            },
            {
                id: 2033,
                city: 'Boxholm',
                latitude: 42.17581,
                longitude: -94.10607,
                timezone: 'America/Chicago'
            },
            {
                id: 2034,
                city: 'Boyden',
                latitude: 43.19109,
                longitude: -96.00585,
                timezone: 'America/Chicago'
            },
            {
                id: 2035,
                city: 'Braddyville',
                latitude: 40.57888,
                longitude: -95.02998,
                timezone: 'America/Chicago'
            },
            {
                id: 2036,
                city: 'Bradgate',
                latitude: 42.80303,
                longitude: -94.41803,
                timezone: 'America/Chicago'
            },
            {
                id: 2037,
                city: 'Brandon',
                latitude: 42.31444,
                longitude: -92.00212,
                timezone: 'America/Chicago'
            },
            {
                id: 2038,
                city: 'Brayton',
                latitude: 41.54443,
                longitude: -94.92415,
                timezone: 'America/Chicago'
            },
            {
                id: 2039,
                city: 'Breda',
                latitude: 42.18165,
                longitude: -94.97693,
                timezone: 'America/Chicago'
            },
            {
                id: 2040,
                city: 'Bridgewater',
                latitude: 41.24499,
                longitude: -94.66886,
                timezone: 'America/Chicago'
            },
            {
                id: 2041,
                city: 'Brighton',
                latitude: 41.17474,
                longitude: -91.81961,
                timezone: 'America/Chicago'
            },
            {
                id: 2042,
                city: 'Bristow',
                latitude: 42.77386,
                longitude: -92.90742,
                timezone: 'America/Chicago'
            },
            {
                id: 2043,
                city: 'Britt',
                latitude: 43.09774,
                longitude: -93.80189,
                timezone: 'America/Chicago'
            },
            {
                id: 2044,
                city: 'Bronson',
                latitude: 42.41083,
                longitude: -96.21391,
                timezone: 'America/Chicago'
            },
            {
                id: 2045,
                city: 'Brooklyn',
                latitude: 41.73361,
                longitude: -92.44546,
                timezone: 'America/Chicago'
            },
            {
                id: 2046,
                city: 'Brunsville',
                latitude: 42.80971,
                longitude: -96.26919,
                timezone: 'America/Chicago'
            },
            {
                id: 2048,
                city: 'Buck Grove',
                latitude: 41.91804,
                longitude: -95.39611,
                timezone: 'America/Chicago'
            },
            {
                id: 2047,
                city: 'Buckeye',
                latitude: 42.4172,
                longitude: -93.37493,
                timezone: 'America/Chicago'
            },
            {
                id: 2049,
                city: 'Buffalo',
                latitude: 41.45642,
                longitude: -90.72347,
                timezone: 'America/Chicago'
            },
            {
                id: 2050,
                city: 'Buffalo Center',
                latitude: 43.38579,
                longitude: -93.94662,
                timezone: 'America/Chicago'
            },
            {
                id: 2051,
                city: 'Burlington',
                latitude: 40.80754,
                longitude: -91.11292,
                timezone: 'America/Chicago'
            },
            {
                id: 2052,
                city: 'Burt',
                latitude: 43.19746,
                longitude: -94.21969,
                timezone: 'America/Chicago'
            },
            {
                id: 2053,
                city: 'Bussey',
                latitude: 41.20445,
                longitude: -92.8827,
                timezone: 'America/Chicago'
            },
            {
                id: 2054,
                city: 'Calamus',
                latitude: 41.82586,
                longitude: -90.7582,
                timezone: 'America/Chicago'
            },
            {
                id: 2055,
                city: 'Callender',
                latitude: 42.36192,
                longitude: -94.2958,
                timezone: 'America/Chicago'
            },
            {
                id: 2056,
                city: 'Calmar',
                latitude: 43.18358,
                longitude: -91.86405,
                timezone: 'America/Chicago'
            },
            {
                id: 2057,
                city: 'Calumet',
                latitude: 42.94637,
                longitude: -95.55001,
                timezone: 'America/Chicago'
            },
            {
                id: 2058,
                city: 'Camanche',
                latitude: 41.78809,
                longitude: -90.25624,
                timezone: 'America/Chicago'
            },
            {
                id: 2059,
                city: 'Cambridge',
                latitude: 41.89832,
                longitude: -93.5291,
                timezone: 'America/Chicago'
            },
            {
                id: 2060,
                city: 'Cantril',
                latitude: 40.6442,
                longitude: -92.0699,
                timezone: 'America/Chicago'
            },
            {
                id: 2061,
                city: 'Carbon',
                latitude: 41.04999,
                longitude: -94.82331,
                timezone: 'America/Chicago'
            },
            {
                id: 2062,
                city: 'Carlisle',
                latitude: 41.518,
                longitude: -93.48515,
                timezone: 'America/Chicago'
            },
            {
                id: 2063,
                city: 'Carpenter',
                latitude: 43.41496,
                longitude: -93.01492,
                timezone: 'America/Chicago'
            },
            {
                id: 2064,
                city: 'Carroll',
                latitude: 42.06582,
                longitude: -94.86693,
                timezone: 'America/Chicago'
            },
            {
                id: 2065,
                city: 'Carson',
                latitude: 41.23666,
                longitude: -95.41806,
                timezone: 'America/Chicago'
            },
            {
                id: 2066,
                city: 'Carter Lake',
                latitude: 41.29055,
                longitude: -95.91807,
                timezone: 'America/Chicago'
            },
            {
                id: 2067,
                city: 'Cascade',
                latitude: 42.30179,
                longitude: -91.00467,
                timezone: 'America/Chicago'
            },
            {
                id: 2068,
                city: 'Casey',
                latitude: 41.50746,
                longitude: -94.52127,
                timezone: 'America/Chicago'
            },
            {
                id: 2069,
                city: 'Castalia',
                latitude: 43.11192,
                longitude: -91.67626,
                timezone: 'America/Chicago'
            },
            {
                id: 2070,
                city: 'Castana',
                latitude: 42.07443,
                longitude: -95.90862,
                timezone: 'America/Chicago'
            },
            {
                id: 2071,
                city: 'Cedar Falls',
                latitude: 42.52776,
                longitude: -92.44547,
                timezone: 'America/Chicago'
            },
            {
                id: 2072,
                city: 'Cedar Rapids',
                latitude: 42.00833,
                longitude: -91.64407,
                timezone: 'America/Chicago'
            },
            {
                id: 2073,
                city: 'Center Point',
                latitude: 42.19083,
                longitude: -91.78518,
                timezone: 'America/Chicago'
            },
            {
                id: 2074,
                city: 'Centerville',
                latitude: 40.73418,
                longitude: -92.87409,
                timezone: 'America/Chicago'
            },
            {
                id: 2075,
                city: 'Central City',
                latitude: 42.20388,
                longitude: -91.52406,
                timezone: 'America/Chicago'
            },
            {
                id: 2076,
                city: 'Centralia',
                latitude: 42.47222,
                longitude: -90.83707,
                timezone: 'America/Chicago'
            },
            {
                id: 2077,
                city: 'Chariton',
                latitude: 41.01389,
                longitude: -93.3066,
                timezone: 'America/Chicago'
            },
            {
                id: 2078,
                city: 'Charles City',
                latitude: 43.06636,
                longitude: -92.67241,
                timezone: 'America/Chicago'
            },
            {
                id: 2079,
                city: 'Charlotte',
                latitude: 41.9603,
                longitude: -90.46513,
                timezone: 'America/Chicago'
            },
            {
                id: 2080,
                city: 'Charter Oak',
                latitude: 42.06832,
                longitude: -95.59167,
                timezone: 'America/Chicago'
            },
            {
                id: 2081,
                city: 'Chatsworth',
                latitude: 42.9161,
                longitude: -96.51642,
                timezone: 'America/Chicago'
            },
            {
                id: 2082,
                city: 'Chelsea',
                latitude: 41.91916,
                longitude: -92.39463,
                timezone: 'America/Chicago'
            },
            {
                id: 2083,
                city: 'Cherokee',
                latitude: 42.74943,
                longitude: -95.55167,
                timezone: 'America/Chicago'
            },
            {
                id: 2084,
                city: 'Chester',
                latitude: 43.49108,
                longitude: -92.36045,
                timezone: 'America/Chicago'
            },
            {
                id: 2085,
                city: 'Chillicothe',
                latitude: 41.08557,
                longitude: -92.52936,
                timezone: 'America/Chicago'
            },
            {
                id: 2086,
                city: 'Churdan',
                latitude: 42.15193,
                longitude: -94.47442,
                timezone: 'America/Chicago'
            },
            {
                id: 2087,
                city: 'Cincinnati',
                latitude: 40.63085,
                longitude: -92.92465,
                timezone: 'America/Chicago'
            },
            {
                id: 2088,
                city: 'Clare',
                latitude: 42.58719,
                longitude: -94.34552,
                timezone: 'America/Chicago'
            },
            {
                id: 2089,
                city: 'Clarence',
                latitude: 41.88891,
                longitude: -91.05654,
                timezone: 'America/Chicago'
            },
            {
                id: 2090,
                city: 'Clarinda',
                latitude: 40.74194,
                longitude: -95.03831,
                timezone: 'America/Chicago'
            },
            {
                id: 2091,
                city: 'Clarion',
                latitude: 42.73164,
                longitude: -93.73299,
                timezone: 'America/Chicago'
            },
            {
                id: 2092,
                city: 'Clarksville',
                latitude: 42.7847,
                longitude: -92.66769,
                timezone: 'America/Chicago'
            },
            {
                id: 2093,
                city: 'Clayton',
                latitude: 42.90388,
                longitude: -91.14735,
                timezone: 'America/Chicago'
            },
            {
                id: 2095,
                city: 'Clear Lake',
                latitude: 43.13802,
                longitude: -93.37937,
                timezone: 'America/Chicago'
            },
            {
                id: 2094,
                city: 'Clearfield',
                latitude: 40.80065,
                longitude: -94.48307,
                timezone: 'America/Chicago'
            },
            {
                id: 2096,
                city: 'Cleghorn',
                latitude: 42.81221,
                longitude: -95.71279,
                timezone: 'America/Chicago'
            },
            {
                id: 2097,
                city: 'Clemons',
                latitude: 42.11388,
                longitude: -93.15604,
                timezone: 'America/Chicago'
            },
            {
                id: 2098,
                city: 'Clermont',
                latitude: 43.00359,
                longitude: -91.65237,
                timezone: 'America/Chicago'
            },
            {
                id: 2099,
                city: 'Clinton',
                latitude: 41.84447,
                longitude: -90.18874,
                timezone: 'America/Chicago'
            },
            {
                id: 2100,
                city: 'Clio',
                latitude: 40.63501,
                longitude: -93.45133,
                timezone: 'America/Chicago'
            },
            {
                id: 2101,
                city: 'Clive',
                latitude: 41.61324,
                longitude: -93.79787,
                timezone: 'America/Chicago'
            },
            {
                id: 2102,
                city: 'Clutier',
                latitude: 42.07944,
                longitude: -92.40213,
                timezone: 'America/Chicago'
            },
            {
                id: 2103,
                city: 'Coburg',
                latitude: 40.91749,
                longitude: -95.26443,
                timezone: 'America/Chicago'
            },
            {
                id: 2104,
                city: 'Coggon',
                latitude: 42.28082,
                longitude: -91.53044,
                timezone: 'America/Chicago'
            },
            {
                id: 2105,
                city: 'Coin',
                latitude: 40.65444,
                longitude: -95.23026,
                timezone: 'America/Chicago'
            },
            {
                id: 2106,
                city: 'Colesburg',
                latitude: 42.63944,
                longitude: -91.20208,
                timezone: 'America/Chicago'
            },
            {
                id: 2107,
                city: 'Colfax',
                latitude: 41.67777,
                longitude: -93.24521,
                timezone: 'America/Chicago'
            },
            {
                id: 2108,
                city: 'College Springs',
                latitude: 40.61916,
                longitude: -95.12081,
                timezone: 'America/Chicago'
            },
            {
                id: 2109,
                city: 'Collins',
                latitude: 41.90277,
                longitude: -93.30632,
                timezone: 'America/Chicago'
            },
            {
                id: 2110,
                city: 'Colo',
                latitude: 42.01777,
                longitude: -93.31521,
                timezone: 'America/Chicago'
            },
            {
                id: 2111,
                city: 'Columbus City',
                latitude: 41.25864,
                longitude: -91.37432,
                timezone: 'America/Chicago'
            },
            {
                id: 2112,
                city: 'Columbus Junction',
                latitude: 41.28003,
                longitude: -91.36071,
                timezone: 'America/Chicago'
            },
            {
                id: 2113,
                city: 'Colwell',
                latitude: 43.15581,
                longitude: -92.59407,
                timezone: 'America/Chicago'
            },
            {
                id: 2114,
                city: 'Conesville',
                latitude: 41.38197,
                longitude: -91.34988,
                timezone: 'America/Chicago'
            },
            {
                id: 2115,
                city: 'Conrad',
                latitude: 42.22471,
                longitude: -92.87465,
                timezone: 'America/Chicago'
            },
            {
                id: 2116,
                city: 'Conway',
                latitude: 40.7486,
                longitude: -94.61886,
                timezone: 'America/Chicago'
            },
            {
                id: 2117,
                city: 'Coon Rapids',
                latitude: 41.87477,
                longitude: -94.67845,
                timezone: 'America/Chicago'
            },
            {
                id: 2118,
                city: 'Coppock',
                latitude: 41.16425,
                longitude: -91.71483,
                timezone: 'America/Chicago'
            },
            {
                id: 2119,
                city: 'Coralville',
                latitude: 41.6764,
                longitude: -91.58045,
                timezone: 'America/Chicago'
            },
            {
                id: 2120,
                city: 'Corning',
                latitude: 40.98999,
                longitude: -94.74081,
                timezone: 'America/Chicago'
            },
            {
                id: 2121,
                city: 'Correctionville',
                latitude: 42.47499,
                longitude: -95.78557,
                timezone: 'America/Chicago'
            },
            {
                id: 2122,
                city: 'Corwith',
                latitude: 42.99274,
                longitude: -93.95745,
                timezone: 'America/Chicago'
            },
            {
                id: 2123,
                city: 'Corydon',
                latitude: 40.75695,
                longitude: -93.31882,
                timezone: 'America/Chicago'
            },
            {
                id: 2124,
                city: 'Cotter',
                latitude: 41.29197,
                longitude: -91.46155,
                timezone: 'America/Chicago'
            },
            {
                id: 2125,
                city: 'Coulter',
                latitude: 42.7372,
                longitude: -93.36993,
                timezone: 'America/Chicago'
            },
            {
                id: 2126,
                city: 'Council Bluffs',
                latitude: 41.26194,
                longitude: -95.86083,
                timezone: 'America/Chicago'
            },
            {
                id: 2127,
                city: 'Craig',
                latitude: 42.89582,
                longitude: -96.30975,
                timezone: 'America/Chicago'
            },
            {
                id: 2128,
                city: 'Crawfordsville',
                latitude: 41.21456,
                longitude: -91.53731,
                timezone: 'America/Chicago'
            },
            {
                id: 2129,
                city: 'Crescent',
                latitude: 41.365,
                longitude: -95.85807,
                timezone: 'America/Chicago'
            },
            {
                id: 2130,
                city: 'Cresco',
                latitude: 43.38136,
                longitude: -92.11405,
                timezone: 'America/Chicago'
            },
            {
                id: 2131,
                city: 'Creston',
                latitude: 41.0586,
                longitude: -94.36135,
                timezone: 'America/Chicago'
            },
            {
                id: 2132,
                city: 'Cromwell',
                latitude: 41.03943,
                longitude: -94.46191,
                timezone: 'America/Chicago'
            },
            {
                id: 2133,
                city: 'Crystal Lake',
                latitude: 43.22329,
                longitude: -93.79244,
                timezone: 'America/Chicago'
            },
            {
                id: 2134,
                city: 'Cumberland',
                latitude: 41.27416,
                longitude: -94.87026,
                timezone: 'America/Chicago'
            },
            {
                id: 2135,
                city: 'Cumming',
                latitude: 41.48332,
                longitude: -93.76244,
                timezone: 'America/Chicago'
            },
            {
                id: 2136,
                city: 'Curlew',
                latitude: 42.97886,
                longitude: -94.74109,
                timezone: 'America/Chicago'
            },
            {
                id: 2137,
                city: 'Cushing',
                latitude: 42.46471,
                longitude: -95.67501,
                timezone: 'America/Chicago'
            },
            {
                id: 2138,
                city: 'Cylinder',
                latitude: 43.08886,
                longitude: -94.55303,
                timezone: 'America/Chicago'
            },
            {
                id: 2139,
                city: 'Dakota City',
                latitude: 42.72219,
                longitude: -94.19718,
                timezone: 'America/Chicago'
            },
            {
                id: 2140,
                city: 'Dallas Center',
                latitude: 41.68443,
                longitude: -93.96106,
                timezone: 'America/Chicago'
            },
            {
                id: 2141,
                city: 'Dana',
                latitude: 42.10748,
                longitude: -94.2408,
                timezone: 'America/Chicago'
            },
            {
                id: 2142,
                city: 'Danbury',
                latitude: 42.23416,
                longitude: -95.72223,
                timezone: 'America/Chicago'
            },
            {
                id: 2143,
                city: 'Danville',
                latitude: 40.86448,
                longitude: -91.3146,
                timezone: 'America/Chicago'
            },
            {
                id: 2144,
                city: 'Davenport',
                latitude: 41.52364,
                longitude: -90.57764,
                timezone: 'America/Chicago'
            },
            {
                id: 2145,
                city: 'Davis City',
                latitude: 40.63917,
                longitude: -93.81161,
                timezone: 'America/Chicago'
            },
            {
                id: 2146,
                city: 'Dawson',
                latitude: 41.84276,
                longitude: -94.22246,
                timezone: 'America/Chicago'
            },
            {
                id: 2147,
                city: 'Dayton',
                latitude: 42.26136,
                longitude: -94.06857,
                timezone: 'America/Chicago'
            },
            {
                id: 2163,
                city: 'De Soto',
                latitude: 41.53166,
                longitude: -94.00967,
                timezone: 'America/Chicago'
            },
            {
                id: 2148,
                city: 'Decatur City',
                latitude: 40.74194,
                longitude: -93.83383,
                timezone: 'America/Chicago'
            },
            {
                id: 2149,
                city: 'Decorah',
                latitude: 43.30331,
                longitude: -91.78571,
                timezone: 'America/Chicago'
            },
            {
                id: 2150,
                city: 'Dedham',
                latitude: 41.9061,
                longitude: -94.82221,
                timezone: 'America/Chicago'
            },
            {
                id: 2151,
                city: 'Deep River',
                latitude: 41.58028,
                longitude: -92.37491,
                timezone: 'America/Chicago'
            },
            {
                id: 2152,
                city: 'Defiance',
                latitude: 41.82415,
                longitude: -95.34278,
                timezone: 'America/Chicago'
            },
            {
                id: 2153,
                city: 'Delaware',
                latitude: 42.47527,
                longitude: -91.34542,
                timezone: 'America/Chicago'
            },
            {
                id: 2154,
                city: 'Delhi',
                latitude: 42.42971,
                longitude: -91.33098,
                timezone: 'America/Chicago'
            },
            {
                id: 2155,
                city: 'Delmar',
                latitude: 42.00225,
                longitude: -90.60708,
                timezone: 'America/Chicago'
            },
            {
                id: 2156,
                city: 'Deloit',
                latitude: 42.09777,
                longitude: -95.3225,
                timezone: 'America/Chicago'
            },
            {
                id: 2157,
                city: 'Delphos',
                latitude: 40.6636,
                longitude: -94.3394,
                timezone: 'America/Chicago'
            },
            {
                id: 2158,
                city: 'Delta',
                latitude: 41.32279,
                longitude: -92.33018,
                timezone: 'America/Chicago'
            },
            {
                id: 2159,
                city: 'Denison',
                latitude: 42.01777,
                longitude: -95.35528,
                timezone: 'America/Chicago'
            },
            {
                id: 2160,
                city: 'Denver',
                latitude: 42.67137,
                longitude: -92.3374,
                timezone: 'America/Chicago'
            },
            {
                id: 2161,
                city: 'Derby',
                latitude: 40.93167,
                longitude: -93.45632,
                timezone: 'America/Chicago'
            },
            {
                id: 2162,
                city: 'Des Moines',
                latitude: 41.57259,
                longitude: -93.61024,
                timezone: 'America/Chicago'
            },
            {
                id: 2164,
                city: 'DeWitt',
                latitude: 41.82336,
                longitude: -90.53819,
                timezone: 'America/Chicago'
            },
            {
                id: 2165,
                city: 'Dexter',
                latitude: 41.51832,
                longitude: -94.22635,
                timezone: 'America/Chicago'
            },
            {
                id: 2166,
                city: 'Diagonal',
                latitude: 40.80943,
                longitude: -94.34218,
                timezone: 'America/Chicago'
            },
            {
                id: 2167,
                city: 'Dickens',
                latitude: 43.13136,
                longitude: -95.0236,
                timezone: 'America/Chicago'
            },
            {
                id: 2168,
                city: 'Dike',
                latitude: 42.46415,
                longitude: -92.62825,
                timezone: 'America/Chicago'
            },
            {
                id: 2169,
                city: 'Dixon',
                latitude: 41.7428,
                longitude: -90.78237,
                timezone: 'America/Chicago'
            },
            {
                id: 2170,
                city: 'Dolliver',
                latitude: 43.4644,
                longitude: -94.62526,
                timezone: 'America/Chicago'
            },
            {
                id: 2171,
                city: 'Donahue',
                latitude: 41.69475,
                longitude: -90.67542,
                timezone: 'America/Chicago'
            },
            {
                id: 2172,
                city: 'Donnellson',
                latitude: 40.64282,
                longitude: -91.5646,
                timezone: 'America/Chicago'
            },
            {
                id: 2173,
                city: 'Doon',
                latitude: 43.27942,
                longitude: -96.2328,
                timezone: 'America/Chicago'
            },
            {
                id: 2174,
                city: 'Dougherty',
                latitude: 42.92219,
                longitude: -93.04214,
                timezone: 'America/Chicago'
            },
            {
                id: 2175,
                city: 'Dow City',
                latitude: 41.92888,
                longitude: -95.49389,
                timezone: 'America/Chicago'
            },
            {
                id: 2176,
                city: 'Dows',
                latitude: 42.65836,
                longitude: -93.50204,
                timezone: 'America/Chicago'
            },
            {
                id: 2177,
                city: 'Drakesville',
                latitude: 40.79835,
                longitude: -92.48158,
                timezone: 'America/Chicago'
            },
            {
                id: 2178,
                city: 'Dubuque',
                latitude: 42.50056,
                longitude: -90.66457,
                timezone: 'America/Chicago'
            },
            {
                id: 2179,
                city: 'Dumont',
                latitude: 42.75192,
                longitude: -92.97547,
                timezone: 'America/Chicago'
            },
            {
                id: 2180,
                city: 'Duncombe',
                latitude: 42.47053,
                longitude: -93.99356,
                timezone: 'America/Chicago'
            },
            {
                id: 2181,
                city: 'Dundee',
                latitude: 42.57915,
                longitude: -91.54654,
                timezone: 'America/Chicago'
            },
            {
                id: 2182,
                city: 'Dunkerton',
                latitude: 42.56999,
                longitude: -92.16046,
                timezone: 'America/Chicago'
            },
            {
                id: 2183,
                city: 'Dunlap',
                latitude: 41.85248,
                longitude: -95.60124,
                timezone: 'America/Chicago'
            },
            {
                id: 2184,
                city: 'Durango',
                latitude: 42.56028,
                longitude: -90.77568,
                timezone: 'America/Chicago'
            },
            {
                id: 2185,
                city: 'Durant',
                latitude: 41.60114,
                longitude: -90.91385,
                timezone: 'America/Chicago'
            },
            {
                id: 2186,
                city: 'Dyersville',
                latitude: 42.48149,
                longitude: -91.1166,
                timezone: 'America/Chicago'
            },
            {
                id: 2187,
                city: 'Dysart',
                latitude: 42.17166,
                longitude: -92.3063,
                timezone: 'America/Chicago'
            },
            {
                id: 2188,
                city: 'Eagle Grove',
                latitude: 42.66414,
                longitude: -93.90439,
                timezone: 'America/Chicago'
            },
            {
                id: 2189,
                city: 'Earlham',
                latitude: 41.49193,
                longitude: -94.12412,
                timezone: 'America/Chicago'
            },
            {
                id: 2190,
                city: 'Earling',
                latitude: 41.77554,
                longitude: -95.4175,
                timezone: 'America/Chicago'
            },
            {
                id: 2191,
                city: 'Earlville',
                latitude: 42.48166,
                longitude: -91.27236,
                timezone: 'America/Chicago'
            },
            {
                id: 2192,
                city: 'Early',
                latitude: 42.46137,
                longitude: -95.15194,
                timezone: 'America/Chicago'
            },
            {
                id: 2193,
                city: 'East Peru',
                latitude: 41.22694,
                longitude: -93.92634,
                timezone: 'America/Chicago'
            },
            {
                id: 2194,
                city: 'Eddyville',
                latitude: 41.15921,
                longitude: -92.62979,
                timezone: 'America/Chicago'
            },
            {
                id: 2195,
                city: 'Edgewood',
                latitude: 42.64423,
                longitude: -91.40169,
                timezone: 'America/Chicago'
            },
            {
                id: 2196,
                city: 'Elberon',
                latitude: 42.00611,
                longitude: -92.31685,
                timezone: 'America/Chicago'
            },
            {
                id: 2197,
                city: 'Eldon',
                latitude: 40.91863,
                longitude: -92.22296,
                timezone: 'America/Chicago'
            },
            {
                id: 2198,
                city: 'Eldora',
                latitude: 42.36082,
                longitude: -93.09965,
                timezone: 'America/Chicago'
            },
            {
                id: 2199,
                city: 'Eldridge',
                latitude: 41.65809,
                longitude: -90.58458,
                timezone: 'America/Chicago'
            },
            {
                id: 2200,
                city: 'Elgin',
                latitude: 42.95748,
                longitude: -91.63071,
                timezone: 'America/Chicago'
            },
            {
                id: 2203,
                city: 'Elk Horn',
                latitude: 41.59166,
                longitude: -95.05999,
                timezone: 'America/Chicago'
            },
            {
                id: 2205,
                city: 'Elk Run Heights',
                latitude: 42.46693,
                longitude: -92.25657,
                timezone: 'America/Chicago'
            },
            {
                id: 2201,
                city: 'Elkader',
                latitude: 42.85387,
                longitude: -91.40542,
                timezone: 'America/Chicago'
            },
            {
                id: 2202,
                city: 'Elkhart',
                latitude: 41.79165,
                longitude: -93.52216,
                timezone: 'America/Chicago'
            },
            {
                id: 2204,
                city: 'Elkport',
                latitude: 42.73971,
                longitude: -91.27791,
                timezone: 'America/Chicago'
            },
            {
                id: 2206,
                city: 'Elliott',
                latitude: 41.14916,
                longitude: -95.16388,
                timezone: 'America/Chicago'
            },
            {
                id: 2207,
                city: 'Ellston',
                latitude: 40.84027,
                longitude: -94.10856,
                timezone: 'America/Chicago'
            },
            {
                id: 2208,
                city: 'Ellsworth',
                latitude: 42.31276,
                longitude: -93.57882,
                timezone: 'America/Chicago'
            },
            {
                id: 2209,
                city: 'Elma',
                latitude: 43.24664,
                longitude: -92.43601,
                timezone: 'America/Chicago'
            },
            {
                id: 2210,
                city: 'Ely',
                latitude: 41.87362,
                longitude: -91.58518,
                timezone: 'America/Chicago'
            },
            {
                id: 2211,
                city: 'Emerson',
                latitude: 41.01722,
                longitude: -95.40222,
                timezone: 'America/Chicago'
            },
            {
                id: 2212,
                city: 'Emmetsburg',
                latitude: 43.11274,
                longitude: -94.68304,
                timezone: 'America/Chicago'
            },
            {
                id: 2213,
                city: 'Epworth',
                latitude: 42.445,
                longitude: -90.93208,
                timezone: 'America/Chicago'
            },
            {
                id: 2214,
                city: 'Essex',
                latitude: 40.83361,
                longitude: -95.30832,
                timezone: 'America/Chicago'
            },
            {
                id: 2215,
                city: 'Estherville',
                latitude: 43.40163,
                longitude: -94.83276,
                timezone: 'America/Chicago'
            },
            {
                id: 2216,
                city: 'Evansdale',
                latitude: 42.46915,
                longitude: -92.28102,
                timezone: 'America/Chicago'
            },
            {
                id: 2217,
                city: 'Everly',
                latitude: 43.15997,
                longitude: -95.3275,
                timezone: 'America/Chicago'
            },
            {
                id: 2218,
                city: 'Exira',
                latitude: 41.59082,
                longitude: -94.87554,
                timezone: 'America/Chicago'
            },
            {
                id: 2219,
                city: 'Exline',
                latitude: 40.64918,
                longitude: -92.84048,
                timezone: 'America/Chicago'
            },
            {
                id: 2220,
                city: 'Fairbank',
                latitude: 42.64014,
                longitude: -92.04779,
                timezone: 'America/Chicago'
            },
            {
                id: 2221,
                city: 'Fairfax',
                latitude: 41.91945,
                longitude: -91.78101,
                timezone: 'America/Chicago'
            },
            {
                id: 2222,
                city: 'Fairfield',
                latitude: 41.00863,
                longitude: -91.96267,
                timezone: 'America/Chicago'
            },
            {
                id: 2223,
                city: 'Farley',
                latitude: 42.44278,
                longitude: -91.00625,
                timezone: 'America/Chicago'
            },
            {
                id: 2224,
                city: 'Farmersburg',
                latitude: 42.9611,
                longitude: -91.36791,
                timezone: 'America/Chicago'
            },
            {
                id: 2225,
                city: 'Farmington',
                latitude: 40.64031,
                longitude: -91.74294,
                timezone: 'America/Chicago'
            },
            {
                id: 2226,
                city: 'Farnhamville',
                latitude: 42.27648,
                longitude: -94.40771,
                timezone: 'America/Chicago'
            },
            {
                id: 2227,
                city: 'Farragut',
                latitude: 40.72194,
                longitude: -95.48082,
                timezone: 'America/Chicago'
            },
            {
                id: 2228,
                city: 'Fayette',
                latitude: 42.84193,
                longitude: -91.80211,
                timezone: 'America/Chicago'
            },
            {
                id: 2229,
                city: 'Fenton',
                latitude: 43.21969,
                longitude: -94.43053,
                timezone: 'America/Chicago'
            },
            {
                id: 2230,
                city: 'Ferguson',
                latitude: 41.93693,
                longitude: -92.86575,
                timezone: 'America/Chicago'
            },
            {
                id: 2231,
                city: 'Fertile',
                latitude: 43.2644,
                longitude: -93.41826,
                timezone: 'America/Chicago'
            },
            {
                id: 2232,
                city: 'Floris',
                latitude: 40.86502,
                longitude: -92.33296,
                timezone: 'America/Chicago'
            },
            {
                id: 2233,
                city: 'Floyd',
                latitude: 43.12775,
                longitude: -92.7363,
                timezone: 'America/Chicago'
            },
            {
                id: 2234,
                city: 'Fonda',
                latitude: 42.58137,
                longitude: -94.8461,
                timezone: 'America/Chicago'
            },
            {
                id: 2235,
                city: 'Fontanelle',
                latitude: 41.28971,
                longitude: -94.56164,
                timezone: 'America/Chicago'
            },
            {
                id: 2236,
                city: 'Forest City',
                latitude: 43.25701,
                longitude: -93.63642,
                timezone: 'America/Chicago'
            },
            {
                id: 2237,
                city: 'Fort Atkinson',
                latitude: 43.14331,
                longitude: -91.93266,
                timezone: 'America/Chicago'
            },
            {
                id: 2238,
                city: 'Fort Dodge',
                latitude: 42.49747,
                longitude: -94.16802,
                timezone: 'America/Chicago'
            },
            {
                id: 2239,
                city: 'Fort Madison',
                latitude: 40.62976,
                longitude: -91.31515,
                timezone: 'America/Chicago'
            },
            {
                id: 2240,
                city: 'Fostoria',
                latitude: 43.24219,
                longitude: -95.15555,
                timezone: 'America/Chicago'
            },
            {
                id: 2241,
                city: 'Franklin',
                latitude: 40.66809,
                longitude: -91.51127,
                timezone: 'America/Chicago'
            },
            {
                id: 2242,
                city: 'Fraser',
                latitude: 42.1272,
                longitude: -93.96495,
                timezone: 'America/Chicago'
            },
            {
                id: 2243,
                city: 'Fredericksburg',
                latitude: 42.96525,
                longitude: -92.19962,
                timezone: 'America/Chicago'
            },
            {
                id: 2244,
                city: 'Frederika',
                latitude: 42.88165,
                longitude: -92.30823,
                timezone: 'America/Chicago'
            },
            {
                id: 2245,
                city: 'Fredonia',
                latitude: 41.28475,
                longitude: -91.33877,
                timezone: 'America/Chicago'
            },
            {
                id: 2246,
                city: 'Fremont',
                latitude: 41.21251,
                longitude: -92.43546,
                timezone: 'America/Chicago'
            },
            {
                id: 2247,
                city: 'Fruitland',
                latitude: 41.35614,
                longitude: -91.12932,
                timezone: 'America/Chicago'
            },
            {
                id: 2248,
                city: 'Galt',
                latitude: 42.69358,
                longitude: -93.60549,
                timezone: 'America/Chicago'
            },
            {
                id: 2249,
                city: 'Galva',
                latitude: 42.50693,
                longitude: -95.41722,
                timezone: 'America/Chicago'
            },
            {
                id: 2250,
                city: 'Garber',
                latitude: 42.74193,
                longitude: -91.26208,
                timezone: 'America/Chicago'
            },
            {
                id: 2251,
                city: 'Garden Grove',
                latitude: 40.82722,
                longitude: -93.60716,
                timezone: 'America/Chicago'
            },
            {
                id: 2252,
                city: 'Garnavillo',
                latitude: 42.8686,
                longitude: -91.23596,
                timezone: 'America/Chicago'
            },
            {
                id: 2253,
                city: 'Garner',
                latitude: 43.10246,
                longitude: -93.60188,
                timezone: 'America/Chicago'
            },
            {
                id: 2254,
                city: 'Garrison',
                latitude: 42.14416,
                longitude: -92.14379,
                timezone: 'America/Chicago'
            },
            {
                id: 2255,
                city: 'Garwin',
                latitude: 42.0936,
                longitude: -92.67575,
                timezone: 'America/Chicago'
            },
            {
                id: 2256,
                city: 'Geneva',
                latitude: 42.67553,
                longitude: -93.12937,
                timezone: 'America/Chicago'
            },
            {
                id: 2257,
                city: 'George',
                latitude: 43.34386,
                longitude: -96.00224,
                timezone: 'America/Chicago'
            },
            {
                id: 2258,
                city: 'Gibson',
                latitude: 41.48112,
                longitude: -92.39352,
                timezone: 'America/Chicago'
            },
            {
                id: 2259,
                city: 'Gilbert',
                latitude: 42.10693,
                longitude: -93.64966,
                timezone: 'America/Chicago'
            },
            {
                id: 2260,
                city: 'Gilbertville',
                latitude: 42.4161,
                longitude: -92.2149,
                timezone: 'America/Chicago'
            },
            {
                id: 2261,
                city: 'Gillett Grove',
                latitude: 43.0158,
                longitude: -95.03749,
                timezone: 'America/Chicago'
            },
            {
                id: 2262,
                city: 'Gilman',
                latitude: 41.87888,
                longitude: -92.78936,
                timezone: 'America/Chicago'
            },
            {
                id: 2263,
                city: 'Gilmore City',
                latitude: 42.7269,
                longitude: -94.43691,
                timezone: 'America/Chicago'
            },
            {
                id: 2264,
                city: 'Gladbrook',
                latitude: 42.18776,
                longitude: -92.7152,
                timezone: 'America/Chicago'
            },
            {
                id: 2265,
                city: 'Glenwood',
                latitude: 41.04694,
                longitude: -95.74251,
                timezone: 'America/Chicago'
            },
            {
                id: 2266,
                city: 'Glidden',
                latitude: 42.05693,
                longitude: -94.72887,
                timezone: 'America/Chicago'
            },
            {
                id: 2267,
                city: 'Goldfield',
                latitude: 42.7358,
                longitude: -93.92078,
                timezone: 'America/Chicago'
            },
            {
                id: 2268,
                city: 'Goodell',
                latitude: 42.92302,
                longitude: -93.61632,
                timezone: 'America/Chicago'
            },
            {
                id: 2269,
                city: 'Goose Lake',
                latitude: 41.96753,
                longitude: -90.38291,
                timezone: 'America/Chicago'
            },
            {
                id: 2270,
                city: 'Gowrie',
                latitude: 42.28053,
                longitude: -94.2908,
                timezone: 'America/Chicago'
            },
            {
                id: 2271,
                city: 'Graettinger',
                latitude: 43.23774,
                longitude: -94.75137,
                timezone: 'America/Chicago'
            },
            {
                id: 2272,
                city: 'Graf',
                latitude: 42.49306,
                longitude: -90.87124,
                timezone: 'America/Chicago'
            },
            {
                id: 2273,
                city: 'Grafton',
                latitude: 43.32996,
                longitude: -93.06937,
                timezone: 'America/Chicago'
            },
            {
                id: 2274,
                city: 'Grand Junction',
                latitude: 42.03165,
                longitude: -94.2408,
                timezone: 'America/Chicago'
            },
            {
                id: 2275,
                city: 'Grand Mound',
                latitude: 41.82419,
                longitude: -90.64792,
                timezone: 'America/Chicago'
            },
            {
                id: 2276,
                city: 'Grand River',
                latitude: 40.81944,
                longitude: -93.96245,
                timezone: 'America/Chicago'
            },
            {
                id: 2277,
                city: 'Grandview',
                latitude: 41.27586,
                longitude: -91.18848,
                timezone: 'America/Chicago'
            },
            {
                id: 2278,
                city: 'Granger',
                latitude: 41.7615,
                longitude: -93.82328,
                timezone: 'America/Chicago'
            },
            {
                id: 2279,
                city: 'Grant',
                latitude: 41.14277,
                longitude: -94.98471,
                timezone: 'America/Chicago'
            },
            {
                id: 2280,
                city: 'Granville',
                latitude: 42.98554,
                longitude: -95.87363,
                timezone: 'America/Chicago'
            },
            {
                id: 2281,
                city: 'Gravity',
                latitude: 40.76054,
                longitude: -94.74358,
                timezone: 'America/Chicago'
            },
            {
                id: 2282,
                city: 'Gray',
                latitude: 41.83943,
                longitude: -94.98304,
                timezone: 'America/Chicago'
            },
            {
                id: 2283,
                city: 'Greeley',
                latitude: 42.58582,
                longitude: -91.34153,
                timezone: 'America/Chicago'
            },
            {
                id: 2284,
                city: 'Greene',
                latitude: 42.89651,
                longitude: -92.80354,
                timezone: 'America/Chicago'
            },
            {
                id: 2285,
                city: 'Greenfield',
                latitude: 41.30527,
                longitude: -94.46135,
                timezone: 'America/Chicago'
            },
            {
                id: 2286,
                city: 'Greenville',
                latitude: 43.01664,
                longitude: -95.1461,
                timezone: 'America/Chicago'
            },
            {
                id: 2287,
                city: 'Grimes',
                latitude: 41.67784,
                longitude: -93.80261,
                timezone: 'America/Chicago'
            },
            {
                id: 2288,
                city: 'Grinnell',
                latitude: 41.74305,
                longitude: -92.72241,
                timezone: 'America/Chicago'
            },
            {
                id: 2289,
                city: 'Griswold',
                latitude: 41.23499,
                longitude: -95.13749,
                timezone: 'America/Chicago'
            },
            {
                id: 2290,
                city: 'Grundy Center',
                latitude: 42.36165,
                longitude: -92.76853,
                timezone: 'America/Chicago'
            },
            {
                id: 2291,
                city: 'Gruver',
                latitude: 43.39329,
                longitude: -94.70526,
                timezone: 'America/Chicago'
            },
            {
                id: 2292,
                city: 'Guernsey',
                latitude: 41.64861,
                longitude: -92.34268,
                timezone: 'America/Chicago'
            },
            {
                id: 2293,
                city: 'Guthrie Center',
                latitude: 41.67721,
                longitude: -94.5033,
                timezone: 'America/Chicago'
            },
            {
                id: 2294,
                city: 'Guttenberg',
                latitude: 42.78582,
                longitude: -91.09957,
                timezone: 'America/Chicago'
            },
            {
                id: 2295,
                city: 'Halbur',
                latitude: 42.00693,
                longitude: -94.96999,
                timezone: 'America/Chicago'
            },
            {
                id: 2296,
                city: 'Hamburg',
                latitude: 40.60445,
                longitude: -95.65777,
                timezone: 'America/Chicago'
            },
            {
                id: 2297,
                city: 'Hamilton',
                latitude: 41.16917,
                longitude: -92.90326,
                timezone: 'America/Chicago'
            },
            {
                id: 2298,
                city: 'Hampton',
                latitude: 42.74192,
                longitude: -93.20242,
                timezone: 'America/Chicago'
            },
            {
                id: 2299,
                city: 'Hancock',
                latitude: 41.38999,
                longitude: -95.3625,
                timezone: 'America/Chicago'
            },
            {
                id: 2300,
                city: 'Hanlontown',
                latitude: 43.28023,
                longitude: -93.37882,
                timezone: 'America/Chicago'
            },
            {
                id: 2301,
                city: 'Hansell',
                latitude: 42.75775,
                longitude: -93.10409,
                timezone: 'America/Chicago'
            },
            {
                id: 2302,
                city: 'Harcourt',
                latitude: 42.26275,
                longitude: -94.17579,
                timezone: 'America/Chicago'
            },
            {
                id: 2303,
                city: 'Hardy',
                latitude: 42.81053,
                longitude: -94.05134,
                timezone: 'America/Chicago'
            },
            {
                id: 2304,
                city: 'Harlan',
                latitude: 41.65304,
                longitude: -95.32555,
                timezone: 'America/Chicago'
            },
            {
                id: 2305,
                city: 'Harper',
                latitude: 41.36251,
                longitude: -92.05101,
                timezone: 'America/Chicago'
            },
            {
                id: 2306,
                city: 'Harpers Ferry',
                latitude: 43.20054,
                longitude: -91.15319,
                timezone: 'America/Chicago'
            },
            {
                id: 2307,
                city: 'Harris',
                latitude: 43.44524,
                longitude: -95.43417,
                timezone: 'America/Chicago'
            },
            {
                id: 2308,
                city: 'Hartford',
                latitude: 41.45944,
                longitude: -93.40493,
                timezone: 'America/Chicago'
            },
            {
                id: 2309,
                city: 'Hartley',
                latitude: 43.17997,
                longitude: -95.47695,
                timezone: 'America/Chicago'
            },
            {
                id: 2310,
                city: 'Hartwick',
                latitude: 41.78472,
                longitude: -92.34352,
                timezone: 'America/Chicago'
            },
            {
                id: 2311,
                city: 'Harvey',
                latitude: 41.31583,
                longitude: -92.92409,
                timezone: 'America/Chicago'
            },
            {
                id: 2312,
                city: 'Hastings',
                latitude: 41.02278,
                longitude: -95.49917,
                timezone: 'America/Chicago'
            },
            {
                id: 2313,
                city: 'Havelock',
                latitude: 42.83608,
                longitude: -94.70054,
                timezone: 'America/Chicago'
            },
            {
                id: 2314,
                city: 'Haverhill',
                latitude: 41.94499,
                longitude: -92.96075,
                timezone: 'America/Chicago'
            },
            {
                id: 2315,
                city: 'Hawarden',
                latitude: 42.99582,
                longitude: -96.48531,
                timezone: 'America/Chicago'
            },
            {
                id: 2316,
                city: 'Hawkeye',
                latitude: 42.93859,
                longitude: -91.95017,
                timezone: 'America/Chicago'
            },
            {
                id: 2317,
                city: 'Hayesville',
                latitude: 41.26446,
                longitude: -92.24907,
                timezone: 'America/Chicago'
            },
            {
                id: 2318,
                city: 'Hazleton',
                latitude: 42.62082,
                longitude: -91.90017,
                timezone: 'America/Chicago'
            },
            {
                id: 2319,
                city: 'Hedrick',
                latitude: 41.17251,
                longitude: -92.30879,
                timezone: 'America/Chicago'
            },
            {
                id: 2320,
                city: 'Henderson',
                latitude: 41.14055,
                longitude: -95.43111,
                timezone: 'America/Chicago'
            },
            {
                id: 2321,
                city: 'Hepburn',
                latitude: 40.84916,
                longitude: -95.0172,
                timezone: 'America/Chicago'
            },
            {
                id: 2322,
                city: 'Hiawatha',
                latitude: 42.03583,
                longitude: -91.68212,
                timezone: 'America/Chicago'
            },
            {
                id: 2323,
                city: 'Hills',
                latitude: 41.55419,
                longitude: -91.53489,
                timezone: 'America/Chicago'
            },
            {
                id: 2324,
                city: 'Hillsboro',
                latitude: 40.8367,
                longitude: -91.71572,
                timezone: 'America/Chicago'
            },
            {
                id: 2325,
                city: 'Hinton',
                latitude: 42.62777,
                longitude: -96.29169,
                timezone: 'America/Chicago'
            },
            {
                id: 2326,
                city: 'Holland',
                latitude: 42.39887,
                longitude: -92.80048,
                timezone: 'America/Chicago'
            },
            {
                id: 2327,
                city: 'Holstein',
                latitude: 42.48915,
                longitude: -95.545,
                timezone: 'America/Chicago'
            },
            {
                id: 2328,
                city: 'Holy Cross',
                latitude: 42.60055,
                longitude: -90.99569,
                timezone: 'America/Chicago'
            },
            {
                id: 2329,
                city: 'Hopkinton',
                latitude: 42.34389,
                longitude: -91.24848,
                timezone: 'America/Chicago'
            },
            {
                id: 2330,
                city: 'Hornick',
                latitude: 42.23055,
                longitude: -96.09752,
                timezone: 'America/Chicago'
            },
            {
                id: 2331,
                city: 'Hospers',
                latitude: 43.07193,
                longitude: -95.90446,
                timezone: 'America/Chicago'
            },
            {
                id: 2332,
                city: 'Houghton',
                latitude: 40.78364,
                longitude: -91.60294,
                timezone: 'America/Chicago'
            },
            {
                id: 2333,
                city: 'Hubbard',
                latitude: 42.30554,
                longitude: -93.30021,
                timezone: 'America/Chicago'
            },
            {
                id: 2334,
                city: 'Hudson',
                latitude: 42.40665,
                longitude: -92.45547,
                timezone: 'America/Chicago'
            },
            {
                id: 2335,
                city: 'Hull',
                latitude: 43.18859,
                longitude: -96.13363,
                timezone: 'America/Chicago'
            },
            {
                id: 2336,
                city: 'Humboldt',
                latitude: 42.7208,
                longitude: -94.21524,
                timezone: 'America/Chicago'
            },
            {
                id: 2337,
                city: 'Humeston',
                latitude: 40.85889,
                longitude: -93.49744,
                timezone: 'America/Chicago'
            },
            {
                id: 2338,
                city: 'Huxley',
                latitude: 41.89527,
                longitude: -93.60077,
                timezone: 'America/Chicago'
            },
            {
                id: 2339,
                city: 'Ida Grove',
                latitude: 42.34499,
                longitude: -95.47167,
                timezone: 'America/Chicago'
            },
            {
                id: 2340,
                city: 'Imogene',
                latitude: 40.87944,
                longitude: -95.42694,
                timezone: 'America/Chicago'
            },
            {
                id: 2341,
                city: 'Independence',
                latitude: 42.4686,
                longitude: -91.88934,
                timezone: 'America/Chicago'
            },
            {
                id: 2342,
                city: 'Indianola',
                latitude: 41.35805,
                longitude: -93.55744,
                timezone: 'America/Chicago'
            },
            {
                id: 2343,
                city: 'Inwood',
                latitude: 43.3072,
                longitude: -96.43198,
                timezone: 'America/Chicago'
            },
            {
                id: 2344,
                city: 'Ionia',
                latitude: 43.03414,
                longitude: -92.45601,
                timezone: 'America/Chicago'
            },
            {
                id: 2345,
                city: 'Iowa City',
                latitude: 41.66113,
                longitude: -91.53017,
                timezone: 'America/Chicago'
            },
            {
                id: 2346,
                city: 'Iowa Falls',
                latitude: 42.52248,
                longitude: -93.25131,
                timezone: 'America/Chicago'
            },
            {
                id: 2347,
                city: 'Ireton',
                latitude: 42.97471,
                longitude: -96.31836,
                timezone: 'America/Chicago'
            },
            {
                id: 2348,
                city: 'Irwin',
                latitude: 41.79165,
                longitude: -95.20583,
                timezone: 'America/Chicago'
            },
            {
                id: 2349,
                city: 'Jackson Junction',
                latitude: 43.11497,
                longitude: -92.03239,
                timezone: 'America/Chicago'
            },
            {
                id: 2350,
                city: 'Jamaica',
                latitude: 41.8461,
                longitude: -94.30969,
                timezone: 'America/Chicago'
            },
            {
                id: 2351,
                city: 'Janesville',
                latitude: 42.64581,
                longitude: -92.4624,
                timezone: 'America/Chicago'
            },
            {
                id: 2352,
                city: 'Jefferson',
                latitude: 42.01526,
                longitude: -94.37747,
                timezone: 'America/Chicago'
            },
            {
                id: 2353,
                city: 'Jesup',
                latitude: 42.47457,
                longitude: -92.06569,
                timezone: 'America/Chicago'
            },
            {
                id: 2354,
                city: 'Jewell Junction',
                latitude: 42.31165,
                longitude: -93.63871,
                timezone: 'America/Chicago'
            },
            {
                id: 2355,
                city: 'Johnston',
                latitude: 41.67304,
                longitude: -93.69772,
                timezone: 'America/Chicago'
            },
            {
                id: 2356,
                city: 'Joice',
                latitude: 43.36273,
                longitude: -93.45382,
                timezone: 'America/Chicago'
            },
            {
                id: 2357,
                city: 'Jolley',
                latitude: 42.47887,
                longitude: -94.71887,
                timezone: 'America/Chicago'
            },
            {
                id: 2358,
                city: 'Kalona',
                latitude: 41.48307,
                longitude: -91.706,
                timezone: 'America/Chicago'
            },
            {
                id: 2359,
                city: 'Kamrar',
                latitude: 42.3922,
                longitude: -93.72938,
                timezone: 'America/Chicago'
            },
            {
                id: 2360,
                city: 'Kanawha',
                latitude: 42.93774,
                longitude: -93.79327,
                timezone: 'America/Chicago'
            },
            {
                id: 2361,
                city: 'Kellerton',
                latitude: 40.71083,
                longitude: -94.04995,
                timezone: 'America/Chicago'
            },
            {
                id: 2362,
                city: 'Kelley',
                latitude: 41.95054,
                longitude: -93.66522,
                timezone: 'America/Chicago'
            },
            {
                id: 2363,
                city: 'Kellogg',
                latitude: 41.71805,
                longitude: -92.90742,
                timezone: 'America/Chicago'
            },
            {
                id: 2364,
                city: 'Kensett',
                latitude: 43.35357,
                longitude: -93.21048,
                timezone: 'America/Chicago'
            },
            {
                id: 2365,
                city: 'Keokuk',
                latitude: 40.39727,
                longitude: -91.38487,
                timezone: 'America/Chicago'
            },
            {
                id: 2366,
                city: 'Keomah Village',
                latitude: 41.28834,
                longitude: -92.53658,
                timezone: 'America/Chicago'
            },
            {
                id: 2367,
                city: 'Keosauqua',
                latitude: 40.73031,
                longitude: -91.96239,
                timezone: 'America/Chicago'
            },
            {
                id: 2368,
                city: 'Keota',
                latitude: 41.3651,
                longitude: -91.95334,
                timezone: 'America/Chicago'
            },
            {
                id: 2369,
                city: 'Keswick',
                latitude: 41.45251,
                longitude: -92.23935,
                timezone: 'America/Chicago'
            },
            {
                id: 2370,
                city: 'Keystone',
                latitude: 41.99833,
                longitude: -92.19741,
                timezone: 'America/Chicago'
            },
            {
                id: 2371,
                city: 'Kimballton',
                latitude: 41.6286,
                longitude: -95.07305,
                timezone: 'America/Chicago'
            },
            {
                id: 2372,
                city: 'Kingsley',
                latitude: 42.58832,
                longitude: -95.96752,
                timezone: 'America/Chicago'
            },
            {
                id: 2373,
                city: 'Kinross',
                latitude: 41.46084,
                longitude: -91.98684,
                timezone: 'America/Chicago'
            },
            {
                id: 2374,
                city: 'Kirkman',
                latitude: 41.7286,
                longitude: -95.26527,
                timezone: 'America/Chicago'
            },
            {
                id: 2375,
                city: 'Kirkville',
                latitude: 41.14557,
                longitude: -92.50408,
                timezone: 'America/Chicago'
            },
            {
                id: 2376,
                city: 'Kiron',
                latitude: 42.19554,
                longitude: -95.32777,
                timezone: 'America/Chicago'
            },
            {
                id: 2377,
                city: 'Klemme',
                latitude: 43.00691,
                longitude: -93.60299,
                timezone: 'America/Chicago'
            },
            {
                id: 2378,
                city: 'Knierim',
                latitude: 42.45553,
                longitude: -94.45692,
                timezone: 'America/Chicago'
            },
            {
                id: 2379,
                city: 'Knoxville',
                latitude: 41.32083,
                longitude: -93.10937,
                timezone: 'America/Chicago'
            },
            {
                id: 2391,
                city: 'La Motte',
                latitude: 42.29585,
                longitude: -90.62096,
                timezone: 'America/Chicago'
            },
            {
                id: 2394,
                city: 'La Porte City',
                latitude: 42.31499,
                longitude: -92.19213,
                timezone: 'America/Chicago'
            },
            {
                id: 2380,
                city: 'Lacona',
                latitude: 41.18972,
                longitude: -93.38299,
                timezone: 'America/Chicago'
            },
            {
                id: 2381,
                city: 'Ladora',
                latitude: 41.75472,
                longitude: -92.18352,
                timezone: 'America/Chicago'
            },
            {
                id: 2382,
                city: 'Lake City',
                latitude: 42.26748,
                longitude: -94.73387,
                timezone: 'America/Chicago'
            },
            {
                id: 2383,
                city: 'Lake Mills',
                latitude: 43.4194,
                longitude: -93.53327,
                timezone: 'America/Chicago'
            },
            {
                id: 2384,
                city: 'Lake Park',
                latitude: 43.45552,
                longitude: -95.32083,
                timezone: 'America/Chicago'
            },
            {
                id: 2386,
                city: 'Lake View',
                latitude: 42.302,
                longitude: -95.03576,
                timezone: 'America/Chicago'
            },
            {
                id: 2385,
                city: 'Lakeside',
                latitude: 42.62137,
                longitude: -95.17333,
                timezone: 'America/Chicago'
            },
            {
                id: 2387,
                city: 'Lakota',
                latitude: 43.37718,
                longitude: -94.09385,
                timezone: 'America/Chicago'
            },
            {
                id: 2388,
                city: 'Lambs Grove',
                latitude: 41.70305,
                longitude: -93.07937,
                timezone: 'America/Chicago'
            },
            {
                id: 2389,
                city: 'Lamoni',
                latitude: 40.62278,
                longitude: -93.93412,
                timezone: 'America/Chicago'
            },
            {
                id: 2390,
                city: 'Lamont',
                latitude: 42.5986,
                longitude: -91.6421,
                timezone: 'America/Chicago'
            },
            {
                id: 2392,
                city: 'Lanesboro',
                latitude: 42.18443,
                longitude: -94.69137,
                timezone: 'America/Chicago'
            },
            {
                id: 2393,
                city: 'Lansing',
                latitude: 43.3622,
                longitude: -91.21652,
                timezone: 'America/Chicago'
            },
            {
                id: 2395,
                city: 'Larchwood',
                latitude: 43.45359,
                longitude: -96.43421,
                timezone: 'America/Chicago'
            },
            {
                id: 2396,
                city: 'Larrabee',
                latitude: 42.86081,
                longitude: -95.54528,
                timezone: 'America/Chicago'
            },
            {
                id: 2397,
                city: 'Latimer',
                latitude: 42.76331,
                longitude: -93.36826,
                timezone: 'America/Chicago'
            },
            {
                id: 2398,
                city: 'Laurel',
                latitude: 41.88416,
                longitude: -92.92214,
                timezone: 'America/Chicago'
            },
            {
                id: 2399,
                city: 'Laurens',
                latitude: 42.84664,
                longitude: -94.85193,
                timezone: 'America/Chicago'
            },
            {
                id: 2400,
                city: 'Lawler',
                latitude: 43.07053,
                longitude: -92.15017,
                timezone: 'America/Chicago'
            },
            {
                id: 2401,
                city: 'Lawton',
                latitude: 42.4786,
                longitude: -96.18391,
                timezone: 'America/Chicago'
            },
            {
                id: 2402,
                city: 'Le Claire',
                latitude: 41.59864,
                longitude: -90.34346,
                timezone: 'America/Chicago'
            },
            {
                id: 2404,
                city: 'Le Grand',
                latitude: 42.00625,
                longitude: -92.77506,
                timezone: 'America/Chicago'
            },
            {
                id: 2408,
                city: 'Le Mars',
                latitude: 42.79416,
                longitude: -96.16558,
                timezone: 'America/Chicago'
            },
            {
                id: 2411,
                city: 'Le Roy',
                latitude: 40.87778,
                longitude: -93.59272,
                timezone: 'America/Chicago'
            },
            {
                id: 2403,
                city: 'Ledyard',
                latitude: 43.42162,
                longitude: -94.16218,
                timezone: 'America/Chicago'
            },
            {
                id: 2405,
                city: 'Lehigh',
                latitude: 42.35997,
                longitude: -94.05218,
                timezone: 'America/Chicago'
            },
            {
                id: 2406,
                city: 'Leighton',
                latitude: 41.33722,
                longitude: -92.78714,
                timezone: 'America/Chicago'
            },
            {
                id: 2407,
                city: 'Leland',
                latitude: 43.33718,
                longitude: -93.63522,
                timezone: 'America/Chicago'
            },
            {
                id: 2409,
                city: 'Lenox',
                latitude: 40.88318,
                longitude: -94.55865,
                timezone: 'America/Chicago'
            },
            {
                id: 2410,
                city: 'Leon',
                latitude: 40.73972,
                longitude: -93.74772,
                timezone: 'America/Chicago'
            },
            {
                id: 2412,
                city: 'Lester',
                latitude: 43.4447,
                longitude: -96.33309,
                timezone: 'America/Chicago'
            },
            {
                id: 2413,
                city: 'Letts',
                latitude: 41.32836,
                longitude: -91.2371,
                timezone: 'America/Chicago'
            },
            {
                id: 2414,
                city: 'Lewis',
                latitude: 41.30582,
                longitude: -95.08332,
                timezone: 'America/Chicago'
            },
            {
                id: 2415,
                city: 'Libertyville',
                latitude: 40.95752,
                longitude: -92.05129,
                timezone: 'America/Chicago'
            },
            {
                id: 2416,
                city: 'Lidderdale',
                latitude: 42.12443,
                longitude: -94.78304,
                timezone: 'America/Chicago'
            },
            {
                id: 2417,
                city: 'Lime Springs',
                latitude: 43.44886,
                longitude: -92.28073,
                timezone: 'America/Chicago'
            },
            {
                id: 2418,
                city: 'Lincoln',
                latitude: 42.26276,
                longitude: -92.69187,
                timezone: 'America/Chicago'
            },
            {
                id: 2419,
                city: 'Linden',
                latitude: 41.64443,
                longitude: -94.26913,
                timezone: 'America/Chicago'
            },
            {
                id: 2420,
                city: 'Lineville',
                latitude: 40.5814,
                longitude: -93.52383,
                timezone: 'America/Chicago'
            },
            {
                id: 2421,
                city: 'Linn Grove',
                latitude: 42.89164,
                longitude: -95.24666,
                timezone: 'America/Chicago'
            },
            {
                id: 2422,
                city: 'Lisbon',
                latitude: 41.92112,
                longitude: -91.38545,
                timezone: 'America/Chicago'
            },
            {
                id: 2423,
                city: 'Liscomb',
                latitude: 42.18999,
                longitude: -93.00381,
                timezone: 'America/Chicago'
            },
            {
                id: 2424,
                city: 'Little Rock',
                latitude: 43.44414,
                longitude: -95.88335,
                timezone: 'America/Chicago'
            },
            {
                id: 2425,
                city: 'Little Sioux',
                latitude: 41.80943,
                longitude: -96.02112,
                timezone: 'America/Chicago'
            },
            {
                id: 2426,
                city: 'Livermore',
                latitude: 42.86858,
                longitude: -94.18524,
                timezone: 'America/Chicago'
            },
            {
                id: 2427,
                city: 'Lockridge',
                latitude: 40.99475,
                longitude: -91.74822,
                timezone: 'America/Chicago'
            },
            {
                id: 2428,
                city: 'Logan',
                latitude: 41.64305,
                longitude: -95.7889,
                timezone: 'America/Chicago'
            },
            {
                id: 2429,
                city: 'Lohrville',
                latitude: 42.27026,
                longitude: -94.54859,
                timezone: 'America/Chicago'
            },
            {
                id: 2430,
                city: 'Lone Rock',
                latitude: 43.21857,
                longitude: -94.32691,
                timezone: 'America/Chicago'
            },
            {
                id: 2431,
                city: 'Lone Tree',
                latitude: 41.48808,
                longitude: -91.42599,
                timezone: 'America/Chicago'
            },
            {
                id: 2432,
                city: 'Long Grove',
                latitude: 41.69753,
                longitude: -90.58264,
                timezone: 'America/Chicago'
            },
            {
                id: 2433,
                city: 'Lorimor',
                latitude: 41.12832,
                longitude: -94.05328,
                timezone: 'America/Chicago'
            },
            {
                id: 2434,
                city: 'Lost Nation',
                latitude: 41.96391,
                longitude: -90.81764,
                timezone: 'America/Chicago'
            },
            {
                id: 2435,
                city: 'Lovilia',
                latitude: 41.13584,
                longitude: -92.90409,
                timezone: 'America/Chicago'
            },
            {
                id: 2437,
                city: 'Low Moor',
                latitude: 41.8017,
                longitude: -90.35485,
                timezone: 'America/Chicago'
            },
            {
                id: 2436,
                city: 'Lowden',
                latitude: 41.85752,
                longitude: -90.9282,
                timezone: 'America/Chicago'
            },
            {
                id: 2441,
                city: 'Lu Verne',
                latitude: 42.90923,
                longitude: -94.08363,
                timezone: 'America/Chicago'
            },
            {
                id: 2438,
                city: 'Luana',
                latitude: 43.06026,
                longitude: -91.45403,
                timezone: 'America/Chicago'
            },
            {
                id: 2439,
                city: 'Lucas',
                latitude: 41.02833,
                longitude: -93.45993,
                timezone: 'America/Chicago'
            },
            {
                id: 2440,
                city: 'Luther',
                latitude: 41.96776,
                longitude: -93.81884,
                timezone: 'America/Chicago'
            },
            {
                id: 2442,
                city: 'Luxemburg',
                latitude: 42.60277,
                longitude: -91.07402,
                timezone: 'America/Chicago'
            },
            {
                id: 2443,
                city: 'Luzerne',
                latitude: 41.89805,
                longitude: -92.17991,
                timezone: 'America/Chicago'
            },
            {
                id: 2444,
                city: 'Lynnville',
                latitude: 41.5775,
                longitude: -92.78353,
                timezone: 'America/Chicago'
            },
            {
                id: 2445,
                city: 'Lytton',
                latitude: 42.4233,
                longitude: -94.8605,
                timezone: 'America/Chicago'
            },
            {
                id: 2446,
                city: 'Macedonia',
                latitude: 41.19277,
                longitude: -95.42556,
                timezone: 'America/Chicago'
            },
            {
                id: 2447,
                city: 'Macksburg',
                latitude: 41.21471,
                longitude: -94.18523,
                timezone: 'America/Chicago'
            },
            {
                id: 2448,
                city: 'Madrid',
                latitude: 41.87665,
                longitude: -93.82328,
                timezone: 'America/Chicago'
            },
            {
                id: 2449,
                city: 'Magnolia',
                latitude: 41.69582,
                longitude: -95.87668,
                timezone: 'America/Chicago'
            },
            {
                id: 2450,
                city: 'Maharishi Vedic City',
                latitude: 41.05252,
                longitude: -91.9949,
                timezone: 'America/Chicago'
            },
            {
                id: 2451,
                city: 'Malcom',
                latitude: 41.70833,
                longitude: -92.55908,
                timezone: 'America/Chicago'
            },
            {
                id: 2452,
                city: 'Mallard',
                latitude: 42.93636,
                longitude: -94.6822,
                timezone: 'America/Chicago'
            },
            {
                id: 2453,
                city: 'Maloy',
                latitude: 40.67443,
                longitude: -94.41218,
                timezone: 'America/Chicago'
            },
            {
                id: 2454,
                city: 'Malvern',
                latitude: 41.00278,
                longitude: -95.58528,
                timezone: 'America/Chicago'
            },
            {
                id: 2455,
                city: 'Manchester',
                latitude: 42.48415,
                longitude: -91.45543,
                timezone: 'America/Chicago'
            },
            {
                id: 2456,
                city: 'Manilla',
                latitude: 41.88971,
                longitude: -95.23222,
                timezone: 'America/Chicago'
            },
            {
                id: 2457,
                city: 'Manly',
                latitude: 43.28718,
                longitude: -93.20215,
                timezone: 'America/Chicago'
            },
            {
                id: 2458,
                city: 'Manning',
                latitude: 41.90915,
                longitude: -95.06499,
                timezone: 'America/Chicago'
            },
            {
                id: 2459,
                city: 'Manson',
                latitude: 42.52914,
                longitude: -94.53414,
                timezone: 'America/Chicago'
            },
            {
                id: 2460,
                city: 'Mapleton',
                latitude: 42.16582,
                longitude: -95.79306,
                timezone: 'America/Chicago'
            },
            {
                id: 2461,
                city: 'Maquoketa',
                latitude: 42.06053,
                longitude: -90.66386,
                timezone: 'America/Chicago'
            },
            {
                id: 2462,
                city: 'Marathon',
                latitude: 42.86164,
                longitude: -94.98249,
                timezone: 'America/Chicago'
            },
            {
                id: 2463,
                city: 'Marble Rock',
                latitude: 42.96525,
                longitude: -92.86853,
                timezone: 'America/Chicago'
            },
            {
                id: 2464,
                city: 'Marcus',
                latitude: 42.82582,
                longitude: -95.80751,
                timezone: 'America/Chicago'
            },
            {
                id: 2465,
                city: 'Marengo',
                latitude: 41.79806,
                longitude: -92.07074,
                timezone: 'America/Chicago'
            },
            {
                id: 2466,
                city: 'Marion',
                latitude: 42.03417,
                longitude: -91.59768,
                timezone: 'America/Chicago'
            },
            {
                id: 2467,
                city: 'Marne',
                latitude: 41.45138,
                longitude: -95.11138,
                timezone: 'America/Chicago'
            },
            {
                id: 2468,
                city: 'Marquette',
                latitude: 43.04443,
                longitude: -91.17819,
                timezone: 'America/Chicago'
            },
            {
                id: 2469,
                city: 'Marshalltown',
                latitude: 42.04943,
                longitude: -92.90798,
                timezone: 'America/Chicago'
            },
            {
                id: 2470,
                city: 'Martelle',
                latitude: 42.02167,
                longitude: -91.35989,
                timezone: 'America/Chicago'
            },
            {
                id: 2471,
                city: 'Martensdale',
                latitude: 41.37305,
                longitude: -93.73578,
                timezone: 'America/Chicago'
            },
            {
                id: 2472,
                city: 'Martinsburg',
                latitude: 41.1789,
                longitude: -92.25185,
                timezone: 'America/Chicago'
            },
            {
                id: 2473,
                city: 'Marysville',
                latitude: 41.18056,
                longitude: -92.94909,
                timezone: 'America/Chicago'
            },
            {
                id: 2474,
                city: 'Mason City',
                latitude: 43.15357,
                longitude: -93.20104,
                timezone: 'America/Chicago'
            },
            {
                id: 2475,
                city: 'Masonville',
                latitude: 42.47943,
                longitude: -91.59127,
                timezone: 'America/Chicago'
            },
            {
                id: 2476,
                city: 'Massena',
                latitude: 41.25415,
                longitude: -94.76831,
                timezone: 'America/Chicago'
            },
            {
                id: 2477,
                city: 'Matlock',
                latitude: 43.24387,
                longitude: -95.9353,
                timezone: 'America/Chicago'
            },
            {
                id: 2478,
                city: 'Maurice',
                latitude: 42.96638,
                longitude: -96.18058,
                timezone: 'America/Chicago'
            },
            {
                id: 2479,
                city: 'Maxwell',
                latitude: 41.89193,
                longitude: -93.39965,
                timezone: 'America/Chicago'
            },
            {
                id: 2480,
                city: 'Maynard',
                latitude: 42.77387,
                longitude: -91.88239,
                timezone: 'America/Chicago'
            },
            {
                id: 2481,
                city: 'Maysville',
                latitude: 41.64864,
                longitude: -90.71681,
                timezone: 'America/Chicago'
            },
            {
                id: 2482,
                city: 'McCallsburg',
                latitude: 42.16637,
                longitude: -93.38576,
                timezone: 'America/Chicago'
            },
            {
                id: 2483,
                city: 'McCausland',
                latitude: 41.74614,
                longitude: -90.44319,
                timezone: 'America/Chicago'
            },
            {
                id: 2484,
                city: 'McClelland',
                latitude: 41.32944,
                longitude: -95.6839,
                timezone: 'America/Chicago'
            },
            {
                id: 2485,
                city: 'McGregor',
                latitude: 43.01832,
                longitude: -91.18263,
                timezone: 'America/Chicago'
            },
            {
                id: 2486,
                city: 'McIntire',
                latitude: 43.4358,
                longitude: -92.59379,
                timezone: 'America/Chicago'
            },
            {
                id: 2487,
                city: 'Mechanicsville',
                latitude: 41.90446,
                longitude: -91.25461,
                timezone: 'America/Chicago'
            },
            {
                id: 2488,
                city: 'Mediapolis',
                latitude: 41.00809,
                longitude: -91.16404,
                timezone: 'America/Chicago'
            },
            {
                id: 2489,
                city: 'Melbourne',
                latitude: 41.94138,
                longitude: -93.10326,
                timezone: 'America/Chicago'
            },
            {
                id: 2490,
                city: 'Melcher-Dallas',
                latitude: 41.225,
                longitude: -93.24132,
                timezone: 'America/Chicago'
            },
            {
                id: 2491,
                city: 'Melrose',
                latitude: 40.97612,
                longitude: -93.05048,
                timezone: 'America/Chicago'
            },
            {
                id: 2492,
                city: 'Melvin',
                latitude: 43.28747,
                longitude: -95.60918,
                timezone: 'America/Chicago'
            },
            {
                id: 2493,
                city: 'Menlo',
                latitude: 41.51915,
                longitude: -94.40441,
                timezone: 'America/Chicago'
            },
            {
                id: 2494,
                city: 'Meriden',
                latitude: 42.79471,
                longitude: -95.63445,
                timezone: 'America/Chicago'
            },
            {
                id: 2495,
                city: 'Merrill',
                latitude: 42.71971,
                longitude: -96.24864,
                timezone: 'America/Chicago'
            },
            {
                id: 2496,
                city: 'Meservey',
                latitude: 42.91274,
                longitude: -93.47826,
                timezone: 'America/Chicago'
            },
            {
                id: 2497,
                city: 'Middletown',
                latitude: 40.82837,
                longitude: -91.25904,
                timezone: 'America/Chicago'
            },
            {
                id: 2498,
                city: 'Miles',
                latitude: 42.04836,
                longitude: -90.31569,
                timezone: 'America/Chicago'
            },
            {
                id: 2499,
                city: 'Milford',
                latitude: 43.32469,
                longitude: -95.15,
                timezone: 'America/Chicago'
            },
            {
                id: 2500,
                city: 'Millersburg',
                latitude: 41.57334,
                longitude: -92.1599,
                timezone: 'America/Chicago'
            },
            {
                id: 2501,
                city: 'Millerton',
                latitude: 40.84945,
                longitude: -93.30549,
                timezone: 'America/Chicago'
            },
            {
                id: 2502,
                city: 'Milo',
                latitude: 41.29166,
                longitude: -93.44243,
                timezone: 'America/Chicago'
            },
            {
                id: 2503,
                city: 'Milton',
                latitude: 40.67336,
                longitude: -92.16212,
                timezone: 'America/Chicago'
            },
            {
                id: 2504,
                city: 'Minburn',
                latitude: 41.75638,
                longitude: -94.02745,
                timezone: 'America/Chicago'
            },
            {
                id: 2505,
                city: 'Minden',
                latitude: 41.46694,
                longitude: -95.54278,
                timezone: 'America/Chicago'
            },
            {
                id: 2506,
                city: 'Mingo',
                latitude: 41.76749,
                longitude: -93.28354,
                timezone: 'America/Chicago'
            },
            {
                id: 2507,
                city: 'Missouri Valley',
                latitude: 41.55638,
                longitude: -95.88779,
                timezone: 'America/Chicago'
            },
            {
                id: 2508,
                city: 'Mitchell',
                latitude: 43.32191,
                longitude: -92.8677,
                timezone: 'America/Chicago'
            },
            {
                id: 2509,
                city: 'Mitchellville',
                latitude: 41.66812,
                longitude: -93.36394,
                timezone: 'America/Chicago'
            },
            {
                id: 2510,
                city: 'Modale',
                latitude: 41.61971,
                longitude: -96.01196,
                timezone: 'America/Chicago'
            },
            {
                id: 2511,
                city: 'Mondamin',
                latitude: 41.71054,
                longitude: -96.02168,
                timezone: 'America/Chicago'
            },
            {
                id: 2512,
                city: 'Monmouth',
                latitude: 42.07696,
                longitude: -90.87986,
                timezone: 'America/Chicago'
            },
            {
                id: 2513,
                city: 'Monona',
                latitude: 43.05165,
                longitude: -91.3893,
                timezone: 'America/Chicago'
            },
            {
                id: 2514,
                city: 'Monroe',
                latitude: 41.52221,
                longitude: -93.10187,
                timezone: 'America/Chicago'
            },
            {
                id: 2515,
                city: 'Montezuma',
                latitude: 41.58583,
                longitude: -92.52741,
                timezone: 'America/Chicago'
            },
            {
                id: 2516,
                city: 'Monticello',
                latitude: 42.23834,
                longitude: -91.18709,
                timezone: 'America/Chicago'
            },
            {
                id: 2517,
                city: 'Montour',
                latitude: 41.98138,
                longitude: -92.71492,
                timezone: 'America/Chicago'
            },
            {
                id: 2518,
                city: 'Montrose',
                latitude: 40.53226,
                longitude: -91.41488,
                timezone: 'America/Chicago'
            },
            {
                id: 2519,
                city: 'Moorhead',
                latitude: 41.92249,
                longitude: -95.8514,
                timezone: 'America/Chicago'
            },
            {
                id: 2520,
                city: 'Moorland',
                latitude: 42.44164,
                longitude: -94.29497,
                timezone: 'America/Chicago'
            },
            {
                id: 2521,
                city: 'Moravia',
                latitude: 40.89166,
                longitude: -92.81997,
                timezone: 'America/Chicago'
            },
            {
                id: 2522,
                city: 'Morley',
                latitude: 42.00612,
                longitude: -91.24627,
                timezone: 'America/Chicago'
            },
            {
                id: 2523,
                city: 'Morning Sun',
                latitude: 41.09614,
                longitude: -91.25765,
                timezone: 'America/Chicago'
            },
            {
                id: 2524,
                city: 'Morrison',
                latitude: 42.34415,
                longitude: -92.67381,
                timezone: 'America/Chicago'
            },
            {
                id: 2525,
                city: 'Moulton',
                latitude: 40.68585,
                longitude: -92.67741,
                timezone: 'America/Chicago'
            },
            {
                id: 2526,
                city: 'Mount Auburn',
                latitude: 42.25499,
                longitude: -92.09268,
                timezone: 'America/Chicago'
            },
            {
                id: 2527,
                city: 'Mount Ayr',
                latitude: 40.71471,
                longitude: -94.23523,
                timezone: 'America/Chicago'
            },
            {
                id: 2528,
                city: 'Mount Pleasant',
                latitude: 40.96364,
                longitude: -91.55794,
                timezone: 'America/Chicago'
            },
            {
                id: 2529,
                city: 'Mount Vernon',
                latitude: 41.92195,
                longitude: -91.41684,
                timezone: 'America/Chicago'
            },
            {
                id: 2530,
                city: 'Moville',
                latitude: 42.48888,
                longitude: -96.07252,
                timezone: 'America/Chicago'
            },
            {
                id: 2531,
                city: 'Murray',
                latitude: 41.04166,
                longitude: -93.94939,
                timezone: 'America/Chicago'
            },
            {
                id: 2532,
                city: 'Muscatine',
                latitude: 41.42447,
                longitude: -91.04321,
                timezone: 'America/Chicago'
            },
            {
                id: 2533,
                city: 'Mystic',
                latitude: 40.77751,
                longitude: -92.94381,
                timezone: 'America/Chicago'
            },
            {
                id: 2534,
                city: 'Nashua',
                latitude: 42.95039,
                longitude: -92.54254,
                timezone: 'America/Chicago'
            },
            {
                id: 2535,
                city: 'Nemaha',
                latitude: 42.51581,
                longitude: -95.08832,
                timezone: 'America/Chicago'
            },
            {
                id: 2536,
                city: 'Neola',
                latitude: 41.44888,
                longitude: -95.61556,
                timezone: 'America/Chicago'
            },
            {
                id: 2537,
                city: 'Nevada',
                latitude: 42.02277,
                longitude: -93.45243,
                timezone: 'America/Chicago'
            },
            {
                id: 2538,
                city: 'New Albin',
                latitude: 43.49664,
                longitude: -91.28958,
                timezone: 'America/Chicago'
            },
            {
                id: 2541,
                city: 'New Hampton',
                latitude: 43.05914,
                longitude: -92.31768,
                timezone: 'America/Chicago'
            },
            {
                id: 2542,
                city: 'New Hartford',
                latitude: 42.56693,
                longitude: -92.62214,
                timezone: 'America/Chicago'
            },
            {
                id: 2543,
                city: 'New Liberty',
                latitude: 41.7178,
                longitude: -90.87904,
                timezone: 'America/Chicago'
            },
            {
                id: 2544,
                city: 'New London',
                latitude: 40.92698,
                longitude: -91.3996,
                timezone: 'America/Chicago'
            },
            {
                id: 2545,
                city: 'New Market',
                latitude: 40.7311,
                longitude: -94.8997,
                timezone: 'America/Chicago'
            },
            {
                id: 2546,
                city: 'New Providence',
                latitude: 42.2811,
                longitude: -93.17159,
                timezone: 'America/Chicago'
            },
            {
                id: 2547,
                city: 'New Sharon',
                latitude: 41.47,
                longitude: -92.6513,
                timezone: 'America/Chicago'
            },
            {
                id: 2549,
                city: 'New Vienna',
                latitude: 42.54805,
                longitude: -91.1143,
                timezone: 'America/Chicago'
            },
            {
                id: 2550,
                city: 'New Virginia',
                latitude: 41.18222,
                longitude: -93.72883,
                timezone: 'America/Chicago'
            },
            {
                id: 2539,
                city: 'Newell',
                latitude: 42.60553,
                longitude: -95.00277,
                timezone: 'America/Chicago'
            },
            {
                id: 2540,
                city: 'Newhall',
                latitude: 41.99556,
                longitude: -91.96768,
                timezone: 'America/Chicago'
            },
            {
                id: 2548,
                city: 'Newton',
                latitude: 41.69971,
                longitude: -93.04798,
                timezone: 'America/Chicago'
            },
            {
                id: 2551,
                city: 'Nichols',
                latitude: 41.48114,
                longitude: -91.30766,
                timezone: 'America/Chicago'
            },
            {
                id: 2552,
                city: 'Nodaway',
                latitude: 40.93721,
                longitude: -94.89498,
                timezone: 'America/Chicago'
            },
            {
                id: 2553,
                city: 'Nora Springs',
                latitude: 43.14408,
                longitude: -93.00893,
                timezone: 'America/Chicago'
            },
            {
                id: 2555,
                city: 'North Buena Vista',
                latitude: 42.67972,
                longitude: -90.95652,
                timezone: 'America/Chicago'
            },
            {
                id: 2556,
                city: 'North English',
                latitude: 41.51679,
                longitude: -92.0777,
                timezone: 'America/Chicago'
            },
            {
                id: 2557,
                city: 'North Liberty',
                latitude: 41.74918,
                longitude: -91.59795,
                timezone: 'America/Chicago'
            },
            {
                id: 2558,
                city: 'North Washington',
                latitude: 43.11803,
                longitude: -92.41685,
                timezone: 'America/Chicago'
            },
            {
                id: 2554,
                city: 'Northboro',
                latitude: 40.60777,
                longitude: -95.29165,
                timezone: 'America/Chicago'
            },
            {
                id: 2559,
                city: 'Northwood',
                latitude: 43.44412,
                longitude: -93.22104,
                timezone: 'America/Chicago'
            },
            {
                id: 2560,
                city: 'Norwalk',
                latitude: 41.49168,
                longitude: -93.70212,
                timezone: 'America/Chicago'
            },
            {
                id: 2561,
                city: 'Norway',
                latitude: 41.90278,
                longitude: -91.92157,
                timezone: 'America/Chicago'
            },
            {
                id: 2562,
                city: 'Numa',
                latitude: 40.68807,
                longitude: -92.97798,
                timezone: 'America/Chicago'
            },
            {
                id: 2563,
                city: 'Oakland',
                latitude: 41.30916,
                longitude: -95.39667,
                timezone: 'America/Chicago'
            },
            {
                id: 2564,
                city: 'Oakland Acres',
                latitude: 41.71722,
                longitude: -92.82047,
                timezone: 'America/Chicago'
            },
            {
                id: 2565,
                city: 'Oakville',
                latitude: 41.09976,
                longitude: -91.04459,
                timezone: 'America/Chicago'
            },
            {
                id: 2566,
                city: 'Ocheyedan',
                latitude: 43.41608,
                longitude: -95.53473,
                timezone: 'America/Chicago'
            },
            {
                id: 2567,
                city: 'Odebolt',
                latitude: 42.31221,
                longitude: -95.25055,
                timezone: 'America/Chicago'
            },
            {
                id: 2568,
                city: 'Oelwein',
                latitude: 42.67332,
                longitude: -91.9135,
                timezone: 'America/Chicago'
            },
            {
                id: 2569,
                city: 'Ogden',
                latitude: 42.03915,
                longitude: -94.02773,
                timezone: 'America/Chicago'
            },
            {
                id: 2570,
                city: 'Okoboji',
                latitude: 43.38635,
                longitude: -95.14833,
                timezone: 'America/Chicago'
            },
            {
                id: 2571,
                city: 'Olds',
                latitude: 41.13419,
                longitude: -91.54488,
                timezone: 'America/Chicago'
            },
            {
                id: 2572,
                city: 'Olin',
                latitude: 41.99807,
                longitude: -91.14155,
                timezone: 'America/Chicago'
            },
            {
                id: 2573,
                city: 'Ollie',
                latitude: 41.19807,
                longitude: -92.0924,
                timezone: 'America/Chicago'
            },
            {
                id: 2574,
                city: 'Onawa',
                latitude: 42.02665,
                longitude: -96.09724,
                timezone: 'America/Chicago'
            },
            {
                id: 2575,
                city: 'Onslow',
                latitude: 42.10696,
                longitude: -91.01515,
                timezone: 'America/Chicago'
            },
            {
                id: 2576,
                city: 'Orange City',
                latitude: 43.00721,
                longitude: -96.05835,
                timezone: 'America/Chicago'
            },
            {
                id: 2577,
                city: 'Orchard',
                latitude: 43.22747,
                longitude: -92.77214,
                timezone: 'America/Chicago'
            },
            {
                id: 2578,
                city: 'Orient',
                latitude: 41.20304,
                longitude: -94.41468,
                timezone: 'America/Chicago'
            },
            {
                id: 2579,
                city: 'Orleans',
                latitude: 43.44718,
                longitude: -95.09249,
                timezone: 'America/Chicago'
            },
            {
                id: 2580,
                city: 'Osage',
                latitude: 43.28414,
                longitude: -92.81103,
                timezone: 'America/Chicago'
            },
            {
                id: 2581,
                city: 'Osceola',
                latitude: 41.03389,
                longitude: -93.7655,
                timezone: 'America/Chicago'
            },
            {
                id: 2582,
                city: 'Oskaloosa',
                latitude: 41.2964,
                longitude: -92.64436,
                timezone: 'America/Chicago'
            },
            {
                id: 2583,
                city: 'Ossian',
                latitude: 43.14636,
                longitude: -91.7646,
                timezone: 'America/Chicago'
            },
            {
                id: 2584,
                city: 'Osterdock',
                latitude: 42.7336,
                longitude: -91.15791,
                timezone: 'America/Chicago'
            },
            {
                id: 2585,
                city: 'Otho',
                latitude: 42.42469,
                longitude: -94.15024,
                timezone: 'America/Chicago'
            },
            {
                id: 2586,
                city: 'Oto',
                latitude: 42.28388,
                longitude: -95.89307,
                timezone: 'America/Chicago'
            },
            {
                id: 2587,
                city: 'Ottosen',
                latitude: 42.89497,
                longitude: -94.37997,
                timezone: 'America/Chicago'
            },
            {
                id: 2588,
                city: 'Ottumwa',
                latitude: 41.02001,
                longitude: -92.4113,
                timezone: 'America/Chicago'
            },
            {
                id: 2589,
                city: 'Owasa',
                latitude: 42.43359,
                longitude: -93.20715,
                timezone: 'America/Chicago'
            },
            {
                id: 2590,
                city: 'Oxford',
                latitude: 41.72334,
                longitude: -91.79045,
                timezone: 'America/Chicago'
            },
            {
                id: 2591,
                city: 'Oxford Junction',
                latitude: 41.98363,
                longitude: -90.95626,
                timezone: 'America/Chicago'
            },
            {
                id: 2592,
                city: 'Oyens',
                latitude: 42.82027,
                longitude: -96.0578,
                timezone: 'America/Chicago'
            },
            {
                id: 2593,
                city: 'Pacific Junction',
                latitude: 41.01861,
                longitude: -95.79917,
                timezone: 'America/Chicago'
            },
            {
                id: 2594,
                city: 'Packwood',
                latitude: 41.13279,
                longitude: -92.08268,
                timezone: 'America/Chicago'
            },
            {
                id: 2595,
                city: 'Palmer',
                latitude: 42.63053,
                longitude: -94.60053,
                timezone: 'America/Chicago'
            },
            {
                id: 2596,
                city: 'Palo',
                latitude: 42.06611,
                longitude: -91.79546,
                timezone: 'America/Chicago'
            },
            {
                id: 2597,
                city: 'Panama',
                latitude: 41.72638,
                longitude: -95.47222,
                timezone: 'America/Chicago'
            },
            {
                id: 2598,
                city: 'Panora',
                latitude: 41.69165,
                longitude: -94.36302,
                timezone: 'America/Chicago'
            },
            {
                id: 2599,
                city: 'Panorama Park',
                latitude: 41.55559,
                longitude: -90.45319,
                timezone: 'America/Chicago'
            },
            {
                id: 2600,
                city: 'Parkersburg',
                latitude: 42.57748,
                longitude: -92.78686,
                timezone: 'America/Chicago'
            },
            {
                id: 2601,
                city: 'Parnell',
                latitude: 41.58306,
                longitude: -92.00407,
                timezone: 'America/Chicago'
            },
            {
                id: 2602,
                city: 'Paton',
                latitude: 42.16442,
                longitude: -94.25524,
                timezone: 'America/Chicago'
            },
            {
                id: 2603,
                city: 'Patterson',
                latitude: 41.34832,
                longitude: -93.8805,
                timezone: 'America/Chicago'
            },
            {
                id: 2604,
                city: 'Paullina',
                latitude: 42.97915,
                longitude: -95.68807,
                timezone: 'America/Chicago'
            },
            {
                id: 2605,
                city: 'Pella',
                latitude: 41.40514,
                longitude: -92.91775,
                timezone: 'America/Chicago'
            },
            {
                id: 2606,
                city: 'Peosta',
                latitude: 42.45056,
                longitude: -90.85041,
                timezone: 'America/Chicago'
            },
            {
                id: 2607,
                city: 'Perry',
                latitude: 41.8386,
                longitude: -94.10718,
                timezone: 'America/Chicago'
            },
            {
                id: 2608,
                city: 'Persia',
                latitude: 41.57999,
                longitude: -95.56806,
                timezone: 'America/Chicago'
            },
            {
                id: 2609,
                city: 'Peterson',
                latitude: 42.91803,
                longitude: -95.34389,
                timezone: 'America/Chicago'
            },
            {
                id: 2610,
                city: 'Pierson',
                latitude: 42.54416,
                longitude: -95.86751,
                timezone: 'America/Chicago'
            },
            {
                id: 2611,
                city: 'Pilot Mound',
                latitude: 42.16442,
                longitude: -94.01662,
                timezone: 'America/Chicago'
            },
            {
                id: 2612,
                city: 'Pioneer',
                latitude: 42.65386,
                longitude: -94.39247,
                timezone: 'America/Chicago'
            },
            {
                id: 2613,
                city: 'Pisgah',
                latitude: 41.83138,
                longitude: -95.92557,
                timezone: 'America/Chicago'
            },
            {
                id: 2614,
                city: 'Plainfield',
                latitude: 42.84748,
                longitude: -92.53713,
                timezone: 'America/Chicago'
            },
            {
                id: 2615,
                city: 'Plano',
                latitude: 40.75556,
                longitude: -93.04659,
                timezone: 'America/Chicago'
            },
            {
                id: 2616,
                city: 'Pleasant Hill',
                latitude: 41.58388,
                longitude: -93.51994,
                timezone: 'America/Chicago'
            },
            {
                id: 2618,
                city: 'Pleasant Plain',
                latitude: 41.14724,
                longitude: -91.85906,
                timezone: 'America/Chicago'
            },
            {
                id: 2617,
                city: 'Pleasanton',
                latitude: 40.58056,
                longitude: -93.74383,
                timezone: 'America/Chicago'
            },
            {
                id: 2619,
                city: 'Pleasantville',
                latitude: 41.38583,
                longitude: -93.26937,
                timezone: 'America/Chicago'
            },
            {
                id: 2620,
                city: 'Plover',
                latitude: 42.8783,
                longitude: -94.62053,
                timezone: 'America/Chicago'
            },
            {
                id: 2621,
                city: 'Plymouth',
                latitude: 43.2458,
                longitude: -93.12298,
                timezone: 'America/Chicago'
            },
            {
                id: 2622,
                city: 'Pocahontas',
                latitude: 42.73553,
                longitude: -94.66915,
                timezone: 'America/Chicago'
            },
            {
                id: 2623,
                city: 'Polk City',
                latitude: 41.77138,
                longitude: -93.713,
                timezone: 'America/Chicago'
            },
            {
                id: 2624,
                city: 'Pomeroy',
                latitude: 42.55109,
                longitude: -94.68387,
                timezone: 'America/Chicago'
            },
            {
                id: 2625,
                city: 'Popejoy',
                latitude: 42.59387,
                longitude: -93.42604,
                timezone: 'America/Chicago'
            },
            {
                id: 2626,
                city: 'Portsmouth',
                latitude: 41.65027,
                longitude: -95.51861,
                timezone: 'America/Chicago'
            },
            {
                id: 2627,
                city: 'Postville',
                latitude: 43.08395,
                longitude: -91.56821,
                timezone: 'America/Chicago'
            },
            {
                id: 2629,
                city: 'Prairie City',
                latitude: 41.59943,
                longitude: -93.23521,
                timezone: 'America/Chicago'
            },
            {
                id: 2628,
                city: 'Prairieburg',
                latitude: 42.23833,
                longitude: -91.42238,
                timezone: 'America/Chicago'
            },
            {
                id: 2630,
                city: 'Prescott',
                latitude: 41.02304,
                longitude: -94.61358,
                timezone: 'America/Chicago'
            },
            {
                id: 2631,
                city: 'Preston',
                latitude: 42.0503,
                longitude: -90.41402,
                timezone: 'America/Chicago'
            },
            {
                id: 2632,
                city: 'Primghar',
                latitude: 43.08692,
                longitude: -95.62723,
                timezone: 'America/Chicago'
            },
            {
                id: 2633,
                city: 'Princeton',
                latitude: 41.67475,
                longitude: -90.34041,
                timezone: 'America/Chicago'
            },
            {
                id: 2634,
                city: 'Promise City',
                latitude: 40.74751,
                longitude: -93.14715,
                timezone: 'America/Chicago'
            },
            {
                id: 2635,
                city: 'Protivin',
                latitude: 43.21679,
                longitude: -92.08902,
                timezone: 'America/Chicago'
            },
            {
                id: 2636,
                city: 'Pulaski',
                latitude: 40.69697,
                longitude: -92.27324,
                timezone: 'America/Chicago'
            },
            {
                id: 2637,
                city: 'Quasqueton',
                latitude: 42.39443,
                longitude: -91.761,
                timezone: 'America/Chicago'
            },
            {
                id: 2638,
                city: 'Quimby',
                latitude: 42.63026,
                longitude: -95.64195,
                timezone: 'America/Chicago'
            },
            {
                id: 2639,
                city: 'Radcliffe',
                latitude: 42.31526,
                longitude: -93.43438,
                timezone: 'America/Chicago'
            },
            {
                id: 2640,
                city: 'Rake',
                latitude: 43.48384,
                longitude: -93.91884,
                timezone: 'America/Chicago'
            },
            {
                id: 2641,
                city: 'Ralston',
                latitude: 42.04177,
                longitude: -94.6293,
                timezone: 'America/Chicago'
            },
            {
                id: 2642,
                city: 'Randalia',
                latitude: 42.86304,
                longitude: -91.88572,
                timezone: 'America/Chicago'
            },
            {
                id: 2643,
                city: 'Randall',
                latitude: 42.23832,
                longitude: -93.60077,
                timezone: 'America/Chicago'
            },
            {
                id: 2644,
                city: 'Randolph',
                latitude: 40.87305,
                longitude: -95.56639,
                timezone: 'America/Chicago'
            },
            {
                id: 2645,
                city: 'Rathbun',
                latitude: 40.80112,
                longitude: -92.88881,
                timezone: 'America/Chicago'
            },
            {
                id: 2646,
                city: 'Raymond',
                latitude: 42.46888,
                longitude: -92.21963,
                timezone: 'America/Chicago'
            },
            {
                id: 2647,
                city: 'Readlyn',
                latitude: 42.70221,
                longitude: -92.22546,
                timezone: 'America/Chicago'
            },
            {
                id: 2648,
                city: 'Reasnor',
                latitude: 41.57833,
                longitude: -93.02325,
                timezone: 'America/Chicago'
            },
            {
                id: 2651,
                city: 'Red Oak',
                latitude: 41.00972,
                longitude: -95.22555,
                timezone: 'America/Chicago'
            },
            {
                id: 2649,
                city: 'Redding',
                latitude: 40.60471,
                longitude: -94.38774,
                timezone: 'America/Chicago'
            },
            {
                id: 2650,
                city: 'Redfield',
                latitude: 41.58943,
                longitude: -94.19607,
                timezone: 'America/Chicago'
            },
            {
                id: 2652,
                city: 'Reinbeck',
                latitude: 42.3236,
                longitude: -92.59936,
                timezone: 'America/Chicago'
            },
            {
                id: 2653,
                city: 'Rembrandt',
                latitude: 42.82553,
                longitude: -95.16638,
                timezone: 'America/Chicago'
            },
            {
                id: 2654,
                city: 'Remsen',
                latitude: 42.81471,
                longitude: -95.97335,
                timezone: 'America/Chicago'
            },
            {
                id: 2655,
                city: 'Renwick',
                latitude: 42.82803,
                longitude: -93.98106,
                timezone: 'America/Chicago'
            },
            {
                id: 2656,
                city: 'Rhodes',
                latitude: 41.92554,
                longitude: -93.18631,
                timezone: 'America/Chicago'
            },
            {
                id: 2657,
                city: 'Riceville',
                latitude: 43.36248,
                longitude: -92.55331,
                timezone: 'America/Chicago'
            },
            {
                id: 2658,
                city: 'Richland',
                latitude: 41.18557,
                longitude: -91.99295,
                timezone: 'America/Chicago'
            },
            {
                id: 2659,
                city: 'Rickardsville',
                latitude: 42.58333,
                longitude: -90.88402,
                timezone: 'America/Chicago'
            },
            {
                id: 2660,
                city: 'Ricketts',
                latitude: 42.12693,
                longitude: -95.575,
                timezone: 'America/Chicago'
            },
            {
                id: 2661,
                city: 'Ridgeway',
                latitude: 43.29775,
                longitude: -91.98766,
                timezone: 'America/Chicago'
            },
            {
                id: 2662,
                city: 'Rinard',
                latitude: 42.3397,
                longitude: -94.48858,
                timezone: 'America/Chicago'
            },
            {
                id: 2663,
                city: 'Ringsted',
                latitude: 43.29468,
                longitude: -94.51164,
                timezone: 'America/Chicago'
            },
            {
                id: 2664,
                city: 'Rippey',
                latitude: 41.93387,
                longitude: -94.20135,
                timezone: 'America/Chicago'
            },
            {
                id: 2665,
                city: 'Riverdale',
                latitude: 41.54448,
                longitude: -90.45819,
                timezone: 'America/Chicago'
            },
            {
                id: 2666,
                city: 'Riverside',
                latitude: 41.47974,
                longitude: -91.58128,
                timezone: 'America/Chicago'
            },
            {
                id: 2667,
                city: 'Riverton',
                latitude: 40.68695,
                longitude: -95.5686,
                timezone: 'America/Chicago'
            },
            {
                id: 2668,
                city: 'Robins',
                latitude: 42.07111,
                longitude: -91.66684,
                timezone: 'America/Chicago'
            },
            {
                id: 2669,
                city: 'Rock Falls',
                latitude: 43.20747,
                longitude: -93.08465,
                timezone: 'America/Chicago'
            },
            {
                id: 2671,
                city: 'Rock Rapids',
                latitude: 43.42719,
                longitude: -96.17586,
                timezone: 'America/Chicago'
            },
            {
                id: 2672,
                city: 'Rock Valley',
                latitude: 43.20526,
                longitude: -96.29503,
                timezone: 'America/Chicago'
            },
            {
                id: 2670,
                city: 'Rockford',
                latitude: 43.05219,
                longitude: -92.94853,
                timezone: 'America/Chicago'
            },
            {
                id: 2673,
                city: 'Rockwell',
                latitude: 42.98524,
                longitude: -93.19187,
                timezone: 'America/Chicago'
            },
            {
                id: 2674,
                city: 'Rockwell City',
                latitude: 42.39526,
                longitude: -94.63387,
                timezone: 'America/Chicago'
            },
            {
                id: 2675,
                city: 'Rodman',
                latitude: 43.02858,
                longitude: -94.53109,
                timezone: 'America/Chicago'
            },
            {
                id: 2676,
                city: 'Rodney',
                latitude: 42.20555,
                longitude: -95.95251,
                timezone: 'America/Chicago'
            },
            {
                id: 2677,
                city: 'Roland',
                latitude: 42.16637,
                longitude: -93.50188,
                timezone: 'America/Chicago'
            },
            {
                id: 2678,
                city: 'Rolfe',
                latitude: 42.81275,
                longitude: -94.52692,
                timezone: 'America/Chicago'
            },
            {
                id: 2679,
                city: 'Rome',
                latitude: 40.98141,
                longitude: -91.68239,
                timezone: 'America/Chicago'
            },
            {
                id: 2680,
                city: 'Rose Hill',
                latitude: 41.32195,
                longitude: -92.46213,
                timezone: 'America/Chicago'
            },
            {
                id: 2681,
                city: 'Rossie',
                latitude: 43.01331,
                longitude: -95.18861,
                timezone: 'America/Chicago'
            },
            {
                id: 2682,
                city: 'Rowan',
                latitude: 42.74081,
                longitude: -93.55271,
                timezone: 'America/Chicago'
            },
            {
                id: 2683,
                city: 'Rowley',
                latitude: 42.36999,
                longitude: -91.84406,
                timezone: 'America/Chicago'
            },
            {
                id: 2684,
                city: 'Royal',
                latitude: 43.06553,
                longitude: -95.28389,
                timezone: 'America/Chicago'
            },
            {
                id: 2685,
                city: 'Rudd',
                latitude: 43.12608,
                longitude: -92.90575,
                timezone: 'America/Chicago'
            },
            {
                id: 2686,
                city: 'Runnells',
                latitude: 41.5111,
                longitude: -93.35743,
                timezone: 'America/Chicago'
            },
            {
                id: 2687,
                city: 'Russell',
                latitude: 40.98195,
                longitude: -93.19854,
                timezone: 'America/Chicago'
            },
            {
                id: 2688,
                city: 'Ruthven',
                latitude: 43.12913,
                longitude: -94.89915,
                timezone: 'America/Chicago'
            },
            {
                id: 2689,
                city: 'Rutland',
                latitude: 42.75914,
                longitude: -94.29774,
                timezone: 'America/Chicago'
            },
            {
                id: 2690,
                city: 'Ryan',
                latitude: 42.35138,
                longitude: -91.48155,
                timezone: 'America/Chicago'
            },
            {
                id: 2691,
                city: 'Sabula',
                latitude: 42.07113,
                longitude: -90.17402,
                timezone: 'America/Chicago'
            },
            {
                id: 2692,
                city: 'Sac City',
                latitude: 42.4222,
                longitude: -94.98971,
                timezone: 'America/Chicago'
            },
            {
                id: 2693,
                city: 'Sageville',
                latitude: 42.55278,
                longitude: -90.70902,
                timezone: 'America/Chicago'
            },
            {
                id: 2694,
                city: 'Salem',
                latitude: 40.85281,
                longitude: -91.62016,
                timezone: 'America/Chicago'
            },
            {
                id: 2695,
                city: 'Salix',
                latitude: 42.30833,
                longitude: -96.2878,
                timezone: 'America/Chicago'
            },
            {
                id: 2696,
                city: 'Sanborn',
                latitude: 43.18164,
                longitude: -95.65557,
                timezone: 'America/Chicago'
            },
            {
                id: 2697,
                city: 'Sandyville',
                latitude: 41.37083,
                longitude: -93.38632,
                timezone: 'America/Chicago'
            },
            {
                id: 2698,
                city: 'Scarville',
                latitude: 43.47051,
                longitude: -93.61772,
                timezone: 'America/Chicago'
            },
            {
                id: 2699,
                city: 'Schaller',
                latitude: 42.4997,
                longitude: -95.29305,
                timezone: 'America/Chicago'
            },
            {
                id: 2700,
                city: 'Schleswig',
                latitude: 42.16527,
                longitude: -95.43694,
                timezone: 'America/Chicago'
            },
            {
                id: 2701,
                city: 'Scranton',
                latitude: 42.02248,
                longitude: -94.54525,
                timezone: 'America/Chicago'
            },
            {
                id: 2702,
                city: 'Searsboro',
                latitude: 41.58055,
                longitude: -92.70352,
                timezone: 'America/Chicago'
            },
            {
                id: 2703,
                city: 'Sergeant Bluff',
                latitude: 42.40388,
                longitude: -96.35864,
                timezone: 'America/Chicago'
            },
            {
                id: 2704,
                city: 'Seymour',
                latitude: 40.68251,
                longitude: -93.12104,
                timezone: 'America/Chicago'
            },
            {
                id: 2705,
                city: 'Shambaugh',
                latitude: 40.65888,
                longitude: -95.03192,
                timezone: 'America/Chicago'
            },
            {
                id: 2706,
                city: 'Shannon City',
                latitude: 40.89875,
                longitude: -94.26365,
                timezone: 'America/Chicago'
            },
            {
                id: 2707,
                city: 'Sharpsburg',
                latitude: 40.80249,
                longitude: -94.64247,
                timezone: 'America/Chicago'
            },
            {
                id: 2708,
                city: 'Sheffield',
                latitude: 42.8933,
                longitude: -93.2152,
                timezone: 'America/Chicago'
            },
            {
                id: 2709,
                city: 'Shelby',
                latitude: 41.50667,
                longitude: -95.45058,
                timezone: 'America/Chicago'
            },
            {
                id: 2710,
                city: 'Sheldahl',
                latitude: 41.86428,
                longitude: -93.69666,
                timezone: 'America/Chicago'
            },
            {
                id: 2711,
                city: 'Sheldon',
                latitude: 43.1796,
                longitude: -95.84411,
                timezone: 'America/Chicago'
            },
            {
                id: 2712,
                city: 'Shell Rock',
                latitude: 42.71026,
                longitude: -92.58297,
                timezone: 'America/Chicago'
            },
            {
                id: 2713,
                city: 'Shellsburg',
                latitude: 42.09444,
                longitude: -91.86935,
                timezone: 'America/Chicago'
            },
            {
                id: 2714,
                city: 'Shenandoah',
                latitude: 40.7583,
                longitude: -95.37206,
                timezone: 'America/Chicago'
            },
            {
                id: 2715,
                city: 'Sherrill',
                latitude: 42.60389,
                longitude: -90.78457,
                timezone: 'America/Chicago'
            },
            {
                id: 2716,
                city: 'Shueyville',
                latitude: 41.85056,
                longitude: -91.64656,
                timezone: 'America/Chicago'
            },
            {
                id: 2717,
                city: 'Sibley',
                latitude: 43.39914,
                longitude: -95.75196,
                timezone: 'America/Chicago'
            },
            {
                id: 2718,
                city: 'Sidney',
                latitude: 40.74833,
                longitude: -95.6475,
                timezone: 'America/Chicago'
            },
            {
                id: 2719,
                city: 'Sigourney',
                latitude: 41.33334,
                longitude: -92.20463,
                timezone: 'America/Chicago'
            },
            {
                id: 2720,
                city: 'Silver City',
                latitude: 41.11333,
                longitude: -95.63723,
                timezone: 'America/Chicago'
            },
            {
                id: 2721,
                city: 'Sioux Center',
                latitude: 43.07971,
                longitude: -96.17558,
                timezone: 'America/Chicago'
            },
            {
                id: 2722,
                city: 'Sioux City',
                latitude: 42.49567,
                longitude: -96.39053,
                timezone: 'America/Chicago'
            },
            {
                id: 2723,
                city: 'Sioux Rapids',
                latitude: 42.89331,
                longitude: -95.15111,
                timezone: 'America/Chicago'
            },
            {
                id: 2724,
                city: 'Slater',
                latitude: 41.88072,
                longitude: -93.69117,
                timezone: 'America/Chicago'
            },
            {
                id: 2725,
                city: 'Sloan',
                latitude: 42.23277,
                longitude: -96.22808,
                timezone: 'America/Chicago'
            },
            {
                id: 2726,
                city: 'Smithland',
                latitude: 42.22916,
                longitude: -95.93084,
                timezone: 'America/Chicago'
            },
            {
                id: 2727,
                city: 'Soldier',
                latitude: 41.98527,
                longitude: -95.77945,
                timezone: 'America/Chicago'
            },
            {
                id: 2728,
                city: 'Solon',
                latitude: 41.80723,
                longitude: -91.49406,
                timezone: 'America/Chicago'
            },
            {
                id: 2729,
                city: 'Somers',
                latitude: 42.37831,
                longitude: -94.42997,
                timezone: 'America/Chicago'
            },
            {
                id: 2730,
                city: 'South English',
                latitude: 41.45223,
                longitude: -92.09046,
                timezone: 'America/Chicago'
            },
            {
                id: 2731,
                city: 'Spencer',
                latitude: 43.14136,
                longitude: -95.14444,
                timezone: 'America/Chicago'
            },
            {
                id: 2732,
                city: 'Spillville',
                latitude: 43.20497,
                longitude: -91.951,
                timezone: 'America/Chicago'
            },
            {
                id: 2733,
                city: 'Spirit Lake',
                latitude: 43.42218,
                longitude: -95.10222,
                timezone: 'America/Chicago'
            },
            {
                id: 2734,
                city: 'Spragueville',
                latitude: 42.07252,
                longitude: -90.43513,
                timezone: 'America/Chicago'
            },
            {
                id: 2736,
                city: 'Spring Hill',
                latitude: 41.41138,
                longitude: -93.64494,
                timezone: 'America/Chicago'
            },
            {
                id: 2735,
                city: 'Springbrook',
                latitude: 42.16419,
                longitude: -90.47652,
                timezone: 'America/Chicago'
            },
            {
                id: 2737,
                city: 'Springville',
                latitude: 42.05945,
                longitude: -91.44267,
                timezone: 'America/Chicago'
            },
            {
                id: 2741,
                city: 'St. Ansgar',
                latitude: 43.3783,
                longitude: -92.91881,
                timezone: 'America/Chicago'
            },
            {
                id: 2742,
                city: 'St. Anthony',
                latitude: 42.12221,
                longitude: -93.19493,
                timezone: 'America/Chicago'
            },
            {
                id: 2746,
                city: 'St. Charles',
                latitude: 41.28833,
                longitude: -93.80939,
                timezone: 'America/Chicago'
            },
            {
                id: 2747,
                city: 'St. Donatus',
                latitude: 42.36084,
                longitude: -90.5393,
                timezone: 'America/Chicago'
            },
            {
                id: 2749,
                city: 'St. Lucas',
                latitude: 43.06636,
                longitude: -91.9335,
                timezone: 'America/Chicago'
            },
            {
                id: 2750,
                city: 'St. Marys',
                latitude: 41.30805,
                longitude: -93.72966,
                timezone: 'America/Chicago'
            },
            {
                id: 2753,
                city: 'St. Olaf',
                latitude: 42.9286,
                longitude: -91.38625,
                timezone: 'America/Chicago'
            },
            {
                id: 2757,
                city: 'St. Paul',
                latitude: 40.76948,
                longitude: -91.5171,
                timezone: 'America/Chicago'
            },
            {
                id: 2738,
                city: 'Stacyville',
                latitude: 43.43608,
                longitude: -92.78241,
                timezone: 'America/Chicago'
            },
            {
                id: 2739,
                city: 'Stanhope',
                latitude: 42.28887,
                longitude: -93.79606,
                timezone: 'America/Chicago'
            },
            {
                id: 2740,
                city: 'Stanley',
                latitude: 42.64196,
                longitude: -91.81189,
                timezone: 'America/Chicago'
            },
            {
                id: 2743,
                city: 'Stanton',
                latitude: 40.98166,
                longitude: -95.10415,
                timezone: 'America/Chicago'
            },
            {
                id: 2744,
                city: 'Stanwood',
                latitude: 41.89307,
                longitude: -91.15071,
                timezone: 'America/Chicago'
            },
            {
                id: 2745,
                city: 'State Center',
                latitude: 42.01665,
                longitude: -93.16354,
                timezone: 'America/Chicago'
            },
            {
                id: 2748,
                city: 'Steamboat Rock',
                latitude: 42.40943,
                longitude: -93.06576,
                timezone: 'America/Chicago'
            },
            {
                id: 2751,
                city: 'Stockport',
                latitude: 40.85753,
                longitude: -91.83517,
                timezone: 'America/Chicago'
            },
            {
                id: 2752,
                city: 'Stockton',
                latitude: 41.59142,
                longitude: -90.85876,
                timezone: 'America/Chicago'
            },
            {
                id: 2754,
                city: 'Storm Lake',
                latitude: 42.64109,
                longitude: -95.20972,
                timezone: 'America/Chicago'
            },
            {
                id: 2755,
                city: 'Story City',
                latitude: 42.18721,
                longitude: -93.59577,
                timezone: 'America/Chicago'
            },
            {
                id: 2756,
                city: 'Stout',
                latitude: 42.52637,
                longitude: -92.71186,
                timezone: 'America/Chicago'
            },
            {
                id: 2758,
                city: 'Stratford',
                latitude: 42.26912,
                longitude: -93.92724,
                timezone: 'America/Chicago'
            },
            {
                id: 2759,
                city: 'Strawberry Point',
                latitude: 42.6836,
                longitude: -91.53403,
                timezone: 'America/Chicago'
            },
            {
                id: 2760,
                city: 'Struble',
                latitude: 42.89527,
                longitude: -96.1953,
                timezone: 'America/Chicago'
            },
            {
                id: 2761,
                city: 'Stuart',
                latitude: 41.50027,
                longitude: -94.31868,
                timezone: 'America/Chicago'
            },
            {
                id: 2762,
                city: 'Sully',
                latitude: 41.57833,
                longitude: -92.84492,
                timezone: 'America/Chicago'
            },
            {
                id: 2763,
                city: 'Sumner',
                latitude: 42.84937,
                longitude: -92.09715,
                timezone: 'America/Chicago'
            },
            {
                id: 2764,
                city: 'Superior',
                latitude: 43.43024,
                longitude: -94.94638,
                timezone: 'America/Chicago'
            },
            {
                id: 2765,
                city: 'Sutherland',
                latitude: 42.97414,
                longitude: -95.49751,
                timezone: 'America/Chicago'
            },
            {
                id: 2766,
                city: 'Swaledale',
                latitude: 42.97858,
                longitude: -93.31687,
                timezone: 'America/Chicago'
            },
            {
                id: 2767,
                city: 'Swan',
                latitude: 41.46527,
                longitude: -93.31132,
                timezone: 'America/Chicago'
            },
            {
                id: 2768,
                city: 'Swea City',
                latitude: 43.3844,
                longitude: -94.31497,
                timezone: 'America/Chicago'
            },
            {
                id: 2769,
                city: 'Swisher',
                latitude: 41.84556,
                longitude: -91.69295,
                timezone: 'America/Chicago'
            },
            {
                id: 2770,
                city: 'Tabor',
                latitude: 40.89494,
                longitude: -95.67371,
                timezone: 'America/Chicago'
            },
            {
                id: 2771,
                city: 'Tama',
                latitude: 41.96666,
                longitude: -92.57686,
                timezone: 'America/Chicago'
            },
            {
                id: 2772,
                city: 'Templeton',
                latitude: 41.91832,
                longitude: -94.94277,
                timezone: 'America/Chicago'
            },
            {
                id: 2773,
                city: 'Tennant',
                latitude: 41.5936,
                longitude: -95.44111,
                timezone: 'America/Chicago'
            },
            {
                id: 2774,
                city: 'Terril',
                latitude: 43.30579,
                longitude: -94.97166,
                timezone: 'America/Chicago'
            },
            {
                id: 2775,
                city: 'Thayer',
                latitude: 41.02805,
                longitude: -94.05078,
                timezone: 'America/Chicago'
            },
            {
                id: 2776,
                city: 'Thompson',
                latitude: 43.37134,
                longitude: -93.77356,
                timezone: 'America/Chicago'
            },
            {
                id: 2777,
                city: 'Thor',
                latitude: 42.68803,
                longitude: -94.0494,
                timezone: 'America/Chicago'
            },
            {
                id: 2778,
                city: 'Thornburg',
                latitude: 41.45473,
                longitude: -92.33574,
                timezone: 'America/Chicago'
            },
            {
                id: 2779,
                city: 'Thornton',
                latitude: 42.94469,
                longitude: -93.38465,
                timezone: 'America/Chicago'
            },
            {
                id: 2780,
                city: 'Thurman',
                latitude: 40.82,
                longitude: -95.74778,
                timezone: 'America/Chicago'
            },
            {
                id: 2781,
                city: 'Tiffin',
                latitude: 41.70585,
                longitude: -91.66295,
                timezone: 'America/Chicago'
            },
            {
                id: 2782,
                city: 'Tingley',
                latitude: 40.85277,
                longitude: -94.19523,
                timezone: 'America/Chicago'
            },
            {
                id: 2783,
                city: 'Tipton',
                latitude: 41.76974,
                longitude: -91.12794,
                timezone: 'America/Chicago'
            },
            {
                id: 2784,
                city: 'Titonka',
                latitude: 43.23691,
                longitude: -94.04134,
                timezone: 'America/Chicago'
            },
            {
                id: 2785,
                city: 'Toledo',
                latitude: 41.99555,
                longitude: -92.57686,
                timezone: 'America/Chicago'
            },
            {
                id: 2786,
                city: 'Toronto',
                latitude: 41.90502,
                longitude: -90.86403,
                timezone: 'America/Chicago'
            },
            {
                id: 2787,
                city: 'Traer',
                latitude: 42.1936,
                longitude: -92.46547,
                timezone: 'America/Chicago'
            },
            {
                id: 2788,
                city: 'Treynor',
                latitude: 41.2325,
                longitude: -95.61306,
                timezone: 'America/Chicago'
            },
            {
                id: 2789,
                city: 'Tripoli',
                latitude: 42.80804,
                longitude: -92.25823,
                timezone: 'America/Chicago'
            },
            {
                id: 2790,
                city: 'Truesdale',
                latitude: 42.72915,
                longitude: -95.18277,
                timezone: 'America/Chicago'
            },
            {
                id: 2791,
                city: 'Truro',
                latitude: 41.20972,
                longitude: -93.84661,
                timezone: 'America/Chicago'
            },
            {
                id: 2792,
                city: 'Turin',
                latitude: 42.01943,
                longitude: -95.9664,
                timezone: 'America/Chicago'
            },
            {
                id: 2793,
                city: 'Udell',
                latitude: 40.78085,
                longitude: -92.74214,
                timezone: 'America/Chicago'
            },
            {
                id: 2794,
                city: 'Underwood',
                latitude: 41.38694,
                longitude: -95.67667,
                timezone: 'America/Chicago'
            },
            {
                id: 2795,
                city: 'Union',
                latitude: 42.24554,
                longitude: -93.06465,
                timezone: 'America/Chicago'
            },
            {
                id: 2796,
                city: 'Unionville',
                latitude: 40.81835,
                longitude: -92.69547,
                timezone: 'America/Chicago'
            },
            {
                id: 2797,
                city: 'University Heights',
                latitude: 41.65502,
                longitude: -91.55684,
                timezone: 'America/Chicago'
            },
            {
                id: 2798,
                city: 'University Park',
                latitude: 41.28695,
                longitude: -92.61853,
                timezone: 'America/Chicago'
            },
            {
                id: 2799,
                city: 'Urbana',
                latitude: 42.22416,
                longitude: -91.87434,
                timezone: 'America/Chicago'
            },
            {
                id: 2800,
                city: 'Urbandale',
                latitude: 41.63679,
                longitude: -93.77983,
                timezone: 'America/Chicago'
            },
            {
                id: 2801,
                city: 'Ute',
                latitude: 42.05027,
                longitude: -95.70639,
                timezone: 'America/Chicago'
            },
            {
                id: 2802,
                city: 'Vail',
                latitude: 42.06193,
                longitude: -95.19999,
                timezone: 'America/Chicago'
            },
            {
                id: 2803,
                city: 'Valeria',
                latitude: 41.72999,
                longitude: -93.32521,
                timezone: 'America/Chicago'
            },
            {
                id: 2804,
                city: 'Van Horne',
                latitude: 42.00861,
                longitude: -92.09102,
                timezone: 'America/Chicago'
            },
            {
                id: 2805,
                city: 'Van Meter',
                latitude: 41.53193,
                longitude: -93.95412,
                timezone: 'America/Chicago'
            },
            {
                id: 2806,
                city: 'Van Wert',
                latitude: 40.86972,
                longitude: -93.793,
                timezone: 'America/Chicago'
            },
            {
                id: 2807,
                city: 'Varina',
                latitude: 42.65803,
                longitude: -94.89776,
                timezone: 'America/Chicago'
            },
            {
                id: 2808,
                city: 'Ventura',
                latitude: 43.12635,
                longitude: -93.47771,
                timezone: 'America/Chicago'
            },
            {
                id: 2809,
                city: 'Victor',
                latitude: 41.7306,
                longitude: -92.29472,
                timezone: 'America/Chicago'
            },
            {
                id: 2810,
                city: 'Villisca',
                latitude: 40.92971,
                longitude: -94.97609,
                timezone: 'America/Chicago'
            },
            {
                id: 2811,
                city: 'Vincent',
                latitude: 42.59191,
                longitude: -94.02023,
                timezone: 'America/Chicago'
            },
            {
                id: 2812,
                city: 'Vining',
                latitude: 41.98999,
                longitude: -92.37991,
                timezone: 'America/Chicago'
            },
            {
                id: 2813,
                city: 'Vinton',
                latitude: 42.16861,
                longitude: -92.02351,
                timezone: 'America/Chicago'
            },
            {
                id: 2814,
                city: 'Volga',
                latitude: 42.80471,
                longitude: -91.54098,
                timezone: 'America/Chicago'
            },
            {
                id: 2815,
                city: 'Wadena',
                latitude: 42.84276,
                longitude: -91.65682,
                timezone: 'America/Chicago'
            },
            {
                id: 2816,
                city: 'Wahpeton',
                latitude: 43.36608,
                longitude: -95.17194,
                timezone: 'America/Chicago'
            },
            {
                id: 2817,
                city: 'Walcott',
                latitude: 41.58732,
                longitude: -90.78052,
                timezone: 'America/Chicago'
            },
            {
                id: 2818,
                city: 'Walford',
                latitude: 41.87964,
                longitude: -91.83078,
                timezone: 'America/Chicago'
            },
            {
                id: 2819,
                city: 'Walker',
                latitude: 42.28666,
                longitude: -91.78073,
                timezone: 'America/Chicago'
            },
            {
                id: 2821,
                city: 'Wall Lake',
                latitude: 42.2711,
                longitude: -95.09305,
                timezone: 'America/Chicago'
            },
            {
                id: 2820,
                city: 'Wallingford',
                latitude: 43.31968,
                longitude: -94.79276,
                timezone: 'America/Chicago'
            },
            {
                id: 2822,
                city: 'Walnut',
                latitude: 41.47749,
                longitude: -95.22194,
                timezone: 'America/Chicago'
            },
            {
                id: 2823,
                city: 'Wapello',
                latitude: 41.18142,
                longitude: -91.18543,
                timezone: 'America/Chicago'
            },
            {
                id: 2824,
                city: 'Washington',
                latitude: 41.29918,
                longitude: -91.69294,
                timezone: 'America/Chicago'
            },
            {
                id: 2825,
                city: 'Washta',
                latitude: 42.57554,
                longitude: -95.71751,
                timezone: 'America/Chicago'
            },
            {
                id: 2826,
                city: 'Waterloo',
                latitude: 42.49276,
                longitude: -92.34296,
                timezone: 'America/Chicago'
            },
            {
                id: 2827,
                city: 'Waterville',
                latitude: 43.20776,
                longitude: -91.29763,
                timezone: 'America/Chicago'
            },
            {
                id: 2828,
                city: 'Waucoma',
                latitude: 43.05609,
                longitude: -92.03323,
                timezone: 'America/Chicago'
            },
            {
                id: 2829,
                city: 'Waukee',
                latitude: 41.61166,
                longitude: -93.88523,
                timezone: 'America/Chicago'
            },
            {
                id: 2830,
                city: 'Waukon',
                latitude: 43.26942,
                longitude: -91.4757,
                timezone: 'America/Chicago'
            },
            {
                id: 2831,
                city: 'Waverly',
                latitude: 42.72581,
                longitude: -92.47546,
                timezone: 'America/Chicago'
            },
            {
                id: 2832,
                city: 'Wayland',
                latitude: 41.14724,
                longitude: -91.66072,
                timezone: 'America/Chicago'
            },
            {
                id: 2833,
                city: 'Webb',
                latitude: 42.94858,
                longitude: -95.01193,
                timezone: 'America/Chicago'
            },
            {
                id: 2834,
                city: 'Webster',
                latitude: 41.43834,
                longitude: -92.16907,
                timezone: 'America/Chicago'
            },
            {
                id: 2835,
                city: 'Webster City',
                latitude: 42.46942,
                longitude: -93.81605,
                timezone: 'America/Chicago'
            },
            {
                id: 2836,
                city: 'Weldon',
                latitude: 40.8975,
                longitude: -93.73494,
                timezone: 'America/Chicago'
            },
            {
                id: 2837,
                city: 'Wellman',
                latitude: 41.46418,
                longitude: -91.83823,
                timezone: 'America/Chicago'
            },
            {
                id: 2838,
                city: 'Wellsburg',
                latitude: 42.45915,
                longitude: -92.93853,
                timezone: 'America/Chicago'
            },
            {
                id: 2839,
                city: 'Welton',
                latitude: 41.90808,
                longitude: -90.59541,
                timezone: 'America/Chicago'
            },
            {
                id: 2840,
                city: 'Wesley',
                latitude: 43.0883,
                longitude: -93.99023,
                timezone: 'America/Chicago'
            },
            {
                id: 2841,
                city: 'West Bend',
                latitude: 42.95994,
                longitude: -94.44568,
                timezone: 'America/Chicago'
            },
            {
                id: 2842,
                city: 'West Branch',
                latitude: 41.66619,
                longitude: -91.34426,
                timezone: 'America/Chicago'
            },
            {
                id: 2843,
                city: 'West Burlington',
                latitude: 40.82504,
                longitude: -91.15654,
                timezone: 'America/Chicago'
            },
            {
                id: 2844,
                city: 'West Chester',
                latitude: 41.3389,
                longitude: -91.81767,
                timezone: 'America/Chicago'
            },
            {
                id: 2845,
                city: 'West Des Moines',
                latitude: 41.54994,
                longitude: -93.78135,
                timezone: 'America/Chicago'
            },
            {
                id: 2848,
                city: 'West Liberty',
                latitude: 41.57002,
                longitude: -91.26377,
                timezone: 'America/Chicago'
            },
            {
                id: 2849,
                city: 'West Okoboji',
                latitude: 43.3533,
                longitude: -95.1625,
                timezone: 'America/Chicago'
            },
            {
                id: 2851,
                city: 'West Point',
                latitude: 40.7167,
                longitude: -91.45015,
                timezone: 'America/Chicago'
            },
            {
                id: 2853,
                city: 'West Union',
                latitude: 42.96276,
                longitude: -91.80822,
                timezone: 'America/Chicago'
            },
            {
                id: 2846,
                city: 'Westfield',
                latitude: 42.75555,
                longitude: -96.60587,
                timezone: 'America/Chicago'
            },
            {
                id: 2847,
                city: 'Westgate',
                latitude: 42.76998,
                longitude: -91.99628,
                timezone: 'America/Chicago'
            },
            {
                id: 2850,
                city: 'Westphalia',
                latitude: 41.71971,
                longitude: -95.39472,
                timezone: 'America/Chicago'
            },
            {
                id: 2852,
                city: 'Westside',
                latitude: 42.05915,
                longitude: -95.09805,
                timezone: 'America/Chicago'
            },
            {
                id: 2854,
                city: 'Westwood',
                latitude: 40.96558,
                longitude: -91.62377,
                timezone: 'America/Chicago'
            },
            {
                id: 2855,
                city: 'What Cheer',
                latitude: 41.4014,
                longitude: -92.35463,
                timezone: 'America/Chicago'
            },
            {
                id: 2856,
                city: 'Wheatland',
                latitude: 41.83169,
                longitude: -90.8382,
                timezone: 'America/Chicago'
            },
            {
                id: 2857,
                city: 'Whiting',
                latitude: 42.12749,
                longitude: -96.14946,
                timezone: 'America/Chicago'
            },
            {
                id: 2858,
                city: 'Whittemore',
                latitude: 43.06191,
                longitude: -94.42692,
                timezone: 'America/Chicago'
            },
            {
                id: 2859,
                city: 'Whitten',
                latitude: 42.26082,
                longitude: -93.00548,
                timezone: 'America/Chicago'
            },
            {
                id: 2860,
                city: 'Willey',
                latitude: 41.97915,
                longitude: -94.82221,
                timezone: 'America/Chicago'
            },
            {
                id: 2861,
                city: 'Williams',
                latitude: 42.48831,
                longitude: -93.54493,
                timezone: 'America/Chicago'
            },
            {
                id: 2862,
                city: 'Williamsburg',
                latitude: 41.66112,
                longitude: -92.00907,
                timezone: 'America/Chicago'
            },
            {
                id: 2863,
                city: 'Williamson',
                latitude: 41.08778,
                longitude: -93.25493,
                timezone: 'America/Chicago'
            },
            {
                id: 2864,
                city: 'Wilton',
                latitude: 41.58911,
                longitude: -91.02548,
                timezone: 'America/Chicago'
            },
            {
                id: 2865,
                city: 'Windsor Heights',
                latitude: 41.59777,
                longitude: -93.70828,
                timezone: 'America/Chicago'
            },
            {
                id: 2866,
                city: 'Winfield',
                latitude: 41.12308,
                longitude: -91.44127,
                timezone: 'America/Chicago'
            },
            {
                id: 2867,
                city: 'Winterset',
                latitude: 41.33082,
                longitude: -94.01384,
                timezone: 'America/Chicago'
            },
            {
                id: 2868,
                city: 'Winthrop',
                latitude: 42.47332,
                longitude: -91.73433,
                timezone: 'America/Chicago'
            },
            {
                id: 2869,
                city: 'Wiota',
                latitude: 41.40027,
                longitude: -94.88693,
                timezone: 'America/Chicago'
            },
            {
                id: 2870,
                city: 'Woden',
                latitude: 43.23302,
                longitude: -93.90912,
                timezone: 'America/Chicago'
            },
            {
                id: 2871,
                city: 'Woodbine',
                latitude: 41.73832,
                longitude: -95.70278,
                timezone: 'America/Chicago'
            },
            {
                id: 2872,
                city: 'Woodburn',
                latitude: 41.01194,
                longitude: -93.5991,
                timezone: 'America/Chicago'
            },
            {
                id: 2873,
                city: 'Woodward',
                latitude: 41.85273,
                longitude: -93.92075,
                timezone: 'America/Chicago'
            },
            {
                id: 2874,
                city: 'Woolstock',
                latitude: 42.56664,
                longitude: -93.84383,
                timezone: 'America/Chicago'
            },
            {
                id: 2875,
                city: 'Worthington',
                latitude: 42.39639,
                longitude: -91.11986,
                timezone: 'America/Chicago'
            },
            {
                id: 2876,
                city: 'Wyoming',
                latitude: 42.05918,
                longitude: -91.00737,
                timezone: 'America/Chicago'
            },
            {
                id: 2877,
                city: 'Yale',
                latitude: 41.77665,
                longitude: -94.35802,
                timezone: 'America/Chicago'
            },
            {
                id: 2878,
                city: 'Yetter',
                latitude: 42.31609,
                longitude: -94.8461,
                timezone: 'America/Chicago'
            },
            {
                id: 2879,
                city: 'Yorktown',
                latitude: 40.73333,
                longitude: -95.15693,
                timezone: 'America/Chicago'
            },
            {
                id: 2880,
                city: 'Zearing',
                latitude: 42.1611,
                longitude: -93.29715,
                timezone: 'America/Chicago'
            },
            {
                id: 2881,
                city: 'Zwingle',
                latitude: 42.2972,
                longitude: -90.68744,
                timezone: 'America/Chicago'
            }
        ]
    },
    {
        id: 16,
        country: 'US',
        stateCode: 'KS',
        stateName: 'Kansas',
        cities: [
            {
                id: 3503,
                city: 'Abbyville',
                latitude: 37.97085,
                longitude: -98.20423,
                timezone: 'America/Chicago'
            },
            {
                id: 3504,
                city: 'Abilene',
                latitude: 38.91722,
                longitude: -97.21391,
                timezone: 'America/Chicago'
            },
            {
                id: 3505,
                city: 'Admire',
                latitude: 38.64112,
                longitude: -96.10305,
                timezone: 'America/Chicago'
            },
            {
                id: 3506,
                city: 'Agenda',
                latitude: 39.70778,
                longitude: -97.4317,
                timezone: 'America/Chicago'
            },
            {
                id: 3507,
                city: 'Agra',
                latitude: 39.76168,
                longitude: -99.11925,
                timezone: 'America/Chicago'
            },
            {
                id: 3508,
                city: 'Albert',
                latitude: 38.45279,
                longitude: -99.01148,
                timezone: 'America/Chicago'
            },
            {
                id: 3509,
                city: 'Alden',
                latitude: 38.24223,
                longitude: -98.31201,
                timezone: 'America/Chicago'
            },
            {
                id: 3510,
                city: 'Alexander',
                latitude: 38.46946,
                longitude: -99.55317,
                timezone: 'America/Chicago'
            },
            {
                id: 3511,
                city: 'Allen',
                latitude: 38.65612,
                longitude: -96.16972,
                timezone: 'America/Chicago'
            },
            {
                id: 3512,
                city: 'Alma',
                latitude: 39.01667,
                longitude: -96.28916,
                timezone: 'America/Chicago'
            },
            {
                id: 3513,
                city: 'Almena',
                latitude: 39.89223,
                longitude: -99.70706,
                timezone: 'America/Chicago'
            },
            {
                id: 3515,
                city: 'Alta Vista',
                latitude: 38.86389,
                longitude: -96.48917,
                timezone: 'America/Chicago'
            },
            {
                id: 3514,
                city: 'Altamont',
                latitude: 37.19034,
                longitude: -95.29719,
                timezone: 'America/Chicago'
            },
            {
                id: 3516,
                city: 'Alton',
                latitude: 39.47084,
                longitude: -98.94814,
                timezone: 'America/Chicago'
            },
            {
                id: 3517,
                city: 'Altoona',
                latitude: 37.52394,
                longitude: -95.66137,
                timezone: 'America/Chicago'
            },
            {
                id: 3518,
                city: 'Americus',
                latitude: 38.50696,
                longitude: -96.26194,
                timezone: 'America/Chicago'
            },
            {
                id: 3519,
                city: 'Andale',
                latitude: 37.79057,
                longitude: -97.62949,
                timezone: 'America/Chicago'
            },
            {
                id: 3520,
                city: 'Andover',
                latitude: 37.68766,
                longitude: -97.13669,
                timezone: 'America/Chicago'
            },
            {
                id: 3521,
                city: 'Anthony',
                latitude: 37.15336,
                longitude: -98.03117,
                timezone: 'America/Chicago'
            },
            {
                id: 3522,
                city: 'Arcadia',
                latitude: 37.64199,
                longitude: -94.62385,
                timezone: 'America/Chicago'
            },
            {
                id: 3523,
                city: 'Argonia',
                latitude: 37.26585,
                longitude: -97.76561,
                timezone: 'America/Chicago'
            },
            {
                id: 3524,
                city: 'Arkansas City',
                latitude: 37.06197,
                longitude: -97.03837,
                timezone: 'America/Chicago'
            },
            {
                id: 3525,
                city: 'Arlington',
                latitude: 37.89668,
                longitude: -98.17867,
                timezone: 'America/Chicago'
            },
            {
                id: 3526,
                city: 'Arma',
                latitude: 37.54394,
                longitude: -94.70024,
                timezone: 'America/Chicago'
            },
            {
                id: 3527,
                city: 'Ashland',
                latitude: 37.18864,
                longitude: -99.76568,
                timezone: 'America/Chicago'
            },
            {
                id: 3528,
                city: 'Assaria',
                latitude: 38.68028,
                longitude: -97.60448,
                timezone: 'America/Chicago'
            },
            {
                id: 3529,
                city: 'Atchison',
                latitude: 39.56305,
                longitude: -95.12164,
                timezone: 'America/Chicago'
            },
            {
                id: 3530,
                city: 'Athol',
                latitude: 39.76501,
                longitude: -98.91952,
                timezone: 'America/Chicago'
            },
            {
                id: 3531,
                city: 'Atlanta',
                latitude: 37.43641,
                longitude: -96.76475,
                timezone: 'America/Chicago'
            },
            {
                id: 3532,
                city: 'Attica',
                latitude: 37.24141,
                longitude: -98.22674,
                timezone: 'America/Chicago'
            },
            {
                id: 3533,
                city: 'Atwood',
                latitude: 39.80667,
                longitude: -101.0421,
                timezone: 'America/Chicago'
            },
            {
                id: 3534,
                city: 'Auburn',
                latitude: 38.90611,
                longitude: -95.8161,
                timezone: 'America/Chicago'
            },
            {
                id: 3535,
                city: 'Augusta',
                latitude: 37.68668,
                longitude: -96.9767,
                timezone: 'America/Chicago'
            },
            {
                id: 3536,
                city: 'Aurora',
                latitude: 39.45194,
                longitude: -97.52726,
                timezone: 'America/Chicago'
            },
            {
                id: 3537,
                city: 'Axtell',
                latitude: 39.87167,
                longitude: -96.2589,
                timezone: 'America/Chicago'
            },
            {
                id: 3538,
                city: 'Baldwin City',
                latitude: 38.77501,
                longitude: -95.18636,
                timezone: 'America/Chicago'
            },
            {
                id: 3539,
                city: 'Barnard',
                latitude: 39.19056,
                longitude: -98.04199,
                timezone: 'America/Chicago'
            },
            {
                id: 3540,
                city: 'Barnes',
                latitude: 39.71195,
                longitude: -96.87447,
                timezone: 'America/Chicago'
            },
            {
                id: 3541,
                city: 'Bartlett',
                latitude: 37.05479,
                longitude: -95.2108,
                timezone: 'America/Chicago'
            },
            {
                id: 3542,
                city: 'Basehor',
                latitude: 39.14167,
                longitude: -94.93858,
                timezone: 'America/Chicago'
            },
            {
                id: 3543,
                city: 'Bassett',
                latitude: 37.90281,
                longitude: -95.40415,
                timezone: 'America/Chicago'
            },
            {
                id: 3544,
                city: 'Baxter Springs',
                latitude: 37.02368,
                longitude: -94.7355,
                timezone: 'America/Chicago'
            },
            {
                id: 3545,
                city: 'Bazine',
                latitude: 38.44446,
                longitude: -99.69206,
                timezone: 'America/Chicago'
            },
            {
                id: 3546,
                city: 'Beattie',
                latitude: 39.86111,
                longitude: -96.41974,
                timezone: 'America/Chicago'
            },
            {
                id: 3547,
                city: 'Bel Aire',
                latitude: 37.77594,
                longitude: -97.24657,
                timezone: 'America/Chicago'
            },
            {
                id: 3548,
                city: 'Belle Plaine',
                latitude: 37.39391,
                longitude: -97.28116,
                timezone: 'America/Chicago'
            },
            {
                id: 3549,
                city: 'Belleville',
                latitude: 39.82445,
                longitude: -97.63254,
                timezone: 'America/Chicago'
            },
            {
                id: 3550,
                city: 'Beloit',
                latitude: 39.45612,
                longitude: -98.10616,
                timezone: 'America/Chicago'
            },
            {
                id: 3551,
                city: 'Belpre',
                latitude: 37.95002,
                longitude: -99.10038,
                timezone: 'America/Chicago'
            },
            {
                id: 3552,
                city: 'Belvue',
                latitude: 39.21666,
                longitude: -96.17805,
                timezone: 'America/Chicago'
            },
            {
                id: 3553,
                city: 'Benedict',
                latitude: 37.62533,
                longitude: -95.75054,
                timezone: 'America/Chicago'
            },
            {
                id: 3554,
                city: 'Bennington',
                latitude: 39.03056,
                longitude: -97.5942,
                timezone: 'America/Chicago'
            },
            {
                id: 3555,
                city: 'Bentley',
                latitude: 37.88612,
                longitude: -97.51699,
                timezone: 'America/Chicago'
            },
            {
                id: 3556,
                city: 'Benton',
                latitude: 37.7889,
                longitude: -97.10865,
                timezone: 'America/Chicago'
            },
            {
                id: 3557,
                city: 'Bern',
                latitude: 39.96222,
                longitude: -95.97194,
                timezone: 'America/Chicago'
            },
            {
                id: 3558,
                city: 'Beverly',
                latitude: 39.01278,
                longitude: -97.9756,
                timezone: 'America/Chicago'
            },
            {
                id: 3559,
                city: 'Bird City',
                latitude: 39.75083,
                longitude: -101.53294,
                timezone: 'America/Chicago'
            },
            {
                id: 3560,
                city: 'Bison',
                latitude: 38.52279,
                longitude: -99.19732,
                timezone: 'America/Chicago'
            },
            {
                id: 3561,
                city: 'Blue Mound',
                latitude: 38.09003,
                longitude: -95.00636,
                timezone: 'America/Chicago'
            },
            {
                id: 3562,
                city: 'Blue Rapids',
                latitude: 39.68194,
                longitude: -96.65974,
                timezone: 'America/Chicago'
            },
            {
                id: 3563,
                city: 'Bluff City',
                latitude: 37.07641,
                longitude: -97.87506,
                timezone: 'America/Chicago'
            },
            {
                id: 3564,
                city: 'Bogue',
                latitude: 39.36251,
                longitude: -99.68734,
                timezone: 'America/Chicago'
            },
            {
                id: 3565,
                city: 'Bonner Springs',
                latitude: 39.07537,
                longitude: -94.87174,
                timezone: 'America/Chicago'
            },
            {
                id: 3566,
                city: 'Brewster',
                latitude: 39.36667,
                longitude: -101.37683,
                timezone: 'America/Chicago'
            },
            {
                id: 3567,
                city: 'Bronson',
                latitude: 37.89587,
                longitude: -95.07331,
                timezone: 'America/Chicago'
            },
            {
                id: 3568,
                city: 'Brookville',
                latitude: 38.77501,
                longitude: -97.86838,
                timezone: 'America/Chicago'
            },
            {
                id: 3569,
                city: 'Brownell',
                latitude: 38.64029,
                longitude: -99.74623,
                timezone: 'America/Chicago'
            },
            {
                id: 3570,
                city: 'Bucklin',
                latitude: 37.54724,
                longitude: -99.63429,
                timezone: 'America/Chicago'
            },
            {
                id: 3571,
                city: 'Buffalo',
                latitude: 37.70977,
                longitude: -95.69748,
                timezone: 'America/Chicago'
            },
            {
                id: 3572,
                city: 'Buhler',
                latitude: 38.13445,
                longitude: -97.77005,
                timezone: 'America/Chicago'
            },
            {
                id: 3573,
                city: 'Bunker Hill',
                latitude: 38.87584,
                longitude: -98.70397,
                timezone: 'America/Chicago'
            },
            {
                id: 3574,
                city: 'Burden',
                latitude: 37.3128,
                longitude: -96.7542,
                timezone: 'America/Chicago'
            },
            {
                id: 3575,
                city: 'Burdett',
                latitude: 38.19196,
                longitude: -99.52678,
                timezone: 'America/Chicago'
            },
            {
                id: 3576,
                city: 'Burlingame',
                latitude: 38.75389,
                longitude: -95.83499,
                timezone: 'America/Chicago'
            },
            {
                id: 3577,
                city: 'Burlington',
                latitude: 38.19447,
                longitude: -95.74276,
                timezone: 'America/Chicago'
            },
            {
                id: 3578,
                city: 'Burns',
                latitude: 38.0903,
                longitude: -96.88641,
                timezone: 'America/Chicago'
            },
            {
                id: 3579,
                city: 'Burr Oak',
                latitude: 39.86612,
                longitude: -98.30505,
                timezone: 'America/Chicago'
            },
            {
                id: 3580,
                city: 'Burrton',
                latitude: 38.0239,
                longitude: -97.66977,
                timezone: 'America/Chicago'
            },
            {
                id: 3581,
                city: 'Bushong',
                latitude: 38.64306,
                longitude: -96.25722,
                timezone: 'America/Chicago'
            },
            {
                id: 3582,
                city: 'Bushton',
                latitude: 38.51251,
                longitude: -98.39534,
                timezone: 'America/Chicago'
            },
            {
                id: 3583,
                city: 'Byers',
                latitude: 37.78752,
                longitude: -98.86704,
                timezone: 'America/Chicago'
            },
            {
                id: 3584,
                city: 'Caldwell',
                latitude: 37.03225,
                longitude: -97.60699,
                timezone: 'America/Chicago'
            },
            {
                id: 3585,
                city: 'Cambridge',
                latitude: 37.31614,
                longitude: -96.66447,
                timezone: 'America/Chicago'
            },
            {
                id: 3586,
                city: 'Caney',
                latitude: 37.01146,
                longitude: -95.93526,
                timezone: 'America/Chicago'
            },
            {
                id: 3587,
                city: 'Canton',
                latitude: 38.38612,
                longitude: -97.42809,
                timezone: 'America/Chicago'
            },
            {
                id: 3588,
                city: 'Carbondale',
                latitude: 38.81862,
                longitude: -95.68915,
                timezone: 'America/Chicago'
            },
            {
                id: 3589,
                city: 'Carlton',
                latitude: 38.68723,
                longitude: -97.29336,
                timezone: 'America/Chicago'
            },
            {
                id: 3590,
                city: 'Cassoday',
                latitude: 38.03891,
                longitude: -96.63918,
                timezone: 'America/Chicago'
            },
            {
                id: 3591,
                city: 'Cawker City',
                latitude: 39.51251,
                longitude: -98.43367,
                timezone: 'America/Chicago'
            },
            {
                id: 3592,
                city: 'Cedar',
                latitude: 39.65723,
                longitude: -98.94036,
                timezone: 'America/Chicago'
            },
            {
                id: 3593,
                city: 'Cedar Point',
                latitude: 38.26002,
                longitude: -96.81974,
                timezone: 'America/Chicago'
            },
            {
                id: 3594,
                city: 'Cedar Vale',
                latitude: 37.1042,
                longitude: -96.50001,
                timezone: 'America/Chicago'
            },
            {
                id: 3595,
                city: 'Centralia',
                latitude: 39.72583,
                longitude: -96.12722,
                timezone: 'America/Chicago'
            },
            {
                id: 3596,
                city: 'Chanute',
                latitude: 37.67921,
                longitude: -95.4572,
                timezone: 'America/Chicago'
            },
            {
                id: 3597,
                city: 'Chapman',
                latitude: 38.97222,
                longitude: -97.02251,
                timezone: 'America/Chicago'
            },
            {
                id: 3598,
                city: 'Chase',
                latitude: 38.35501,
                longitude: -98.34951,
                timezone: 'America/Chicago'
            },
            {
                id: 3599,
                city: 'Chautauqua',
                latitude: 37.02034,
                longitude: -96.17666,
                timezone: 'America/Chicago'
            },
            {
                id: 3600,
                city: 'Cheney',
                latitude: 37.63001,
                longitude: -97.78255,
                timezone: 'America/Chicago'
            },
            {
                id: 3601,
                city: 'Cherokee',
                latitude: 37.34589,
                longitude: -94.80885,
                timezone: 'America/Chicago'
            },
            {
                id: 3602,
                city: 'Cherryvale',
                latitude: 37.27034,
                longitude: -95.55248,
                timezone: 'America/Chicago'
            },
            {
                id: 3603,
                city: 'Chetopa',
                latitude: 37.03729,
                longitude: -95.08996,
                timezone: 'America/Chicago'
            },
            {
                id: 3604,
                city: 'Cimarron',
                latitude: 37.80669,
                longitude: -100.3482,
                timezone: 'America/Chicago'
            },
            {
                id: 3605,
                city: 'Circleville',
                latitude: 39.50833,
                longitude: -95.8586,
                timezone: 'America/Chicago'
            },
            {
                id: 3606,
                city: 'Claflin',
                latitude: 38.52501,
                longitude: -98.53368,
                timezone: 'America/Chicago'
            },
            {
                id: 3607,
                city: 'Clay Center',
                latitude: 39.37694,
                longitude: -97.12474,
                timezone: 'America/Chicago'
            },
            {
                id: 3608,
                city: 'Clayton',
                latitude: 39.73687,
                longitude: -100.17648,
                timezone: 'America/Chicago'
            },
            {
                id: 3609,
                city: 'Clearwater',
                latitude: 37.5028,
                longitude: -97.50449,
                timezone: 'America/Chicago'
            },
            {
                id: 3610,
                city: 'Clifton',
                latitude: 39.56809,
                longitude: -97.28055,
                timezone: 'America/Chicago'
            },
            {
                id: 3611,
                city: 'Climax',
                latitude: 37.71975,
                longitude: -96.22333,
                timezone: 'America/Chicago'
            },
            {
                id: 3612,
                city: 'Clyde',
                latitude: 39.59111,
                longitude: -97.39892,
                timezone: 'America/Chicago'
            },
            {
                id: 3613,
                city: 'Coats',
                latitude: 37.51196,
                longitude: -98.82426,
                timezone: 'America/Chicago'
            },
            {
                id: 3614,
                city: 'Coffeyville',
                latitude: 37.0373,
                longitude: -95.61637,
                timezone: 'America/Chicago'
            },
            {
                id: 3615,
                city: 'Colby',
                latitude: 39.39584,
                longitude: -101.05238,
                timezone: 'America/Chicago'
            },
            {
                id: 3616,
                city: 'Coldwater',
                latitude: 37.26891,
                longitude: -99.32678,
                timezone: 'America/Chicago'
            },
            {
                id: 3617,
                city: 'Collyer',
                latitude: 39.03556,
                longitude: -100.11791,
                timezone: 'America/Chicago'
            },
            {
                id: 3618,
                city: 'Colony',
                latitude: 38.07086,
                longitude: -95.36554,
                timezone: 'America/Chicago'
            },
            {
                id: 3619,
                city: 'Columbus',
                latitude: 37.16923,
                longitude: -94.84412,
                timezone: 'America/Chicago'
            },
            {
                id: 3620,
                city: 'Colwich',
                latitude: 37.77918,
                longitude: -97.53644,
                timezone: 'America/Chicago'
            },
            {
                id: 3621,
                city: 'Concordia',
                latitude: 39.57084,
                longitude: -97.66254,
                timezone: 'America/Chicago'
            },
            {
                id: 3622,
                city: 'Conway Springs',
                latitude: 37.3903,
                longitude: -97.64227,
                timezone: 'America/Chicago'
            },
            {
                id: 3623,
                city: 'Coolidge',
                latitude: 38.04168,
                longitude: -102.00879,
                timezone: 'America/Denver'
            },
            {
                id: 3624,
                city: 'Copeland',
                latitude: 37.54197,
                longitude: -100.6296,
                timezone: 'America/Chicago'
            },
            {
                id: 3625,
                city: 'Corning',
                latitude: 39.65722,
                longitude: -96.02944,
                timezone: 'America/Chicago'
            },
            {
                id: 3626,
                city: 'Cottonwood Falls',
                latitude: 38.37224,
                longitude: -96.54278,
                timezone: 'America/Chicago'
            },
            {
                id: 3627,
                city: 'Council Grove',
                latitude: 38.66112,
                longitude: -96.49195,
                timezone: 'America/Chicago'
            },
            {
                id: 3628,
                city: 'Courtland',
                latitude: 39.7814,
                longitude: -97.89282,
                timezone: 'America/Chicago'
            },
            {
                id: 3629,
                city: 'Coyville',
                latitude: 37.68615,
                longitude: -95.89749,
                timezone: 'America/Chicago'
            },
            {
                id: 3630,
                city: 'Cuba',
                latitude: 39.80278,
                longitude: -97.45587,
                timezone: 'America/Chicago'
            },
            {
                id: 3631,
                city: 'Cullison',
                latitude: 37.63057,
                longitude: -98.90538,
                timezone: 'America/Chicago'
            },
            {
                id: 3632,
                city: 'Culver',
                latitude: 38.97084,
                longitude: -97.75893,
                timezone: 'America/Chicago'
            },
            {
                id: 3633,
                city: 'Cunningham',
                latitude: 37.64391,
                longitude: -98.43119,
                timezone: 'America/Chicago'
            },
            {
                id: 3634,
                city: 'Damar',
                latitude: 39.3189,
                longitude: -99.58261,
                timezone: 'America/Chicago'
            },
            {
                id: 3635,
                city: 'Danville',
                latitude: 37.28613,
                longitude: -97.892,
                timezone: 'America/Chicago'
            },
            {
                id: 3643,
                city: 'De Soto',
                latitude: 38.97917,
                longitude: -94.96858,
                timezone: 'America/Chicago'
            },
            {
                id: 3636,
                city: 'Dearing',
                latitude: 37.05869,
                longitude: -95.71331,
                timezone: 'America/Chicago'
            },
            {
                id: 3637,
                city: 'Deerfield',
                latitude: 37.97974,
                longitude: -101.13322,
                timezone: 'America/Chicago'
            },
            {
                id: 3638,
                city: 'Delia',
                latitude: 39.24055,
                longitude: -95.96694,
                timezone: 'America/Chicago'
            },
            {
                id: 3639,
                city: 'Delphos',
                latitude: 39.27389,
                longitude: -97.77198,
                timezone: 'America/Chicago'
            },
            {
                id: 3640,
                city: 'Denison',
                latitude: 39.39166,
                longitude: -95.62804,
                timezone: 'America/Chicago'
            },
            {
                id: 3641,
                city: 'Denton',
                latitude: 39.73278,
                longitude: -95.26942,
                timezone: 'America/Chicago'
            },
            {
                id: 3642,
                city: 'Derby',
                latitude: 37.54557,
                longitude: -97.26893,
                timezone: 'America/Chicago'
            },
            {
                id: 3644,
                city: 'Dexter',
                latitude: 37.17725,
                longitude: -96.71447,
                timezone: 'America/Chicago'
            },
            {
                id: 3645,
                city: 'Dighton',
                latitude: 38.48196,
                longitude: -100.46708,
                timezone: 'America/Chicago'
            },
            {
                id: 3646,
                city: 'Dodge City',
                latitude: 37.7528,
                longitude: -100.01708,
                timezone: 'America/Chicago'
            },
            {
                id: 3647,
                city: 'Dorrance',
                latitude: 38.84668,
                longitude: -98.58952,
                timezone: 'America/Chicago'
            },
            {
                id: 3648,
                city: 'Douglass',
                latitude: 37.51946,
                longitude: -97.01281,
                timezone: 'America/Chicago'
            },
            {
                id: 3649,
                city: 'Downs',
                latitude: 39.49862,
                longitude: -98.54201,
                timezone: 'America/Chicago'
            },
            {
                id: 3650,
                city: 'Dresden',
                latitude: 39.62417,
                longitude: -100.42236,
                timezone: 'America/Chicago'
            },
            {
                id: 3651,
                city: 'Dunlap',
                latitude: 38.5764,
                longitude: -96.36583,
                timezone: 'America/Chicago'
            },
            {
                id: 3652,
                city: 'Durham',
                latitude: 38.48612,
                longitude: -97.22808,
                timezone: 'America/Chicago'
            },
            {
                id: 3653,
                city: 'Dwight',
                latitude: 38.84445,
                longitude: -96.59334,
                timezone: 'America/Chicago'
            },
            {
                id: 3654,
                city: 'Earlton',
                latitude: 37.58811,
                longitude: -95.46915,
                timezone: 'America/Chicago'
            },
            {
                id: 3655,
                city: 'Eastborough',
                latitude: 37.68807,
                longitude: -97.26366,
                timezone: 'America/Chicago'
            },
            {
                id: 3656,
                city: 'Easton',
                latitude: 39.345,
                longitude: -95.1158,
                timezone: 'America/Chicago'
            },
            {
                id: 3657,
                city: 'Edgerton',
                latitude: 38.76473,
                longitude: -95.00802,
                timezone: 'America/Chicago'
            },
            {
                id: 3658,
                city: 'Edmond',
                latitude: 39.62723,
                longitude: -99.82262,
                timezone: 'America/Chicago'
            },
            {
                id: 3659,
                city: 'Edna',
                latitude: 37.0598,
                longitude: -95.35942,
                timezone: 'America/Chicago'
            },
            {
                id: 3660,
                city: 'Edwardsville',
                latitude: 39.06112,
                longitude: -94.81968,
                timezone: 'America/Chicago'
            },
            {
                id: 3661,
                city: 'Effingham',
                latitude: 39.52222,
                longitude: -95.40081,
                timezone: 'America/Chicago'
            },
            {
                id: 3663,
                city: 'El Dorado',
                latitude: 37.81724,
                longitude: -96.86225,
                timezone: 'America/Chicago'
            },
            {
                id: 3662,
                city: 'Elbing',
                latitude: 38.05279,
                longitude: -97.12781,
                timezone: 'America/Chicago'
            },
            {
                id: 3664,
                city: 'Elgin',
                latitude: 37.0045,
                longitude: -96.27666,
                timezone: 'America/Chicago'
            },
            {
                id: 3665,
                city: 'Elk City',
                latitude: 37.28923,
                longitude: -95.91165,
                timezone: 'America/Chicago'
            },
            {
                id: 3666,
                city: 'Elk Falls',
                latitude: 37.36726,
                longitude: -96.1886,
                timezone: 'America/Chicago'
            },
            {
                id: 3667,
                city: 'Elkhart',
                latitude: 37.00808,
                longitude: -101.89017,
                timezone: 'America/Chicago'
            },
            {
                id: 3668,
                city: 'Ellinwood',
                latitude: 38.35557,
                longitude: -98.58091,
                timezone: 'America/Chicago'
            },
            {
                id: 3669,
                city: 'Ellis',
                latitude: 38.93807,
                longitude: -99.56067,
                timezone: 'America/Chicago'
            },
            {
                id: 3670,
                city: 'Ellsworth',
                latitude: 38.73056,
                longitude: -98.22811,
                timezone: 'America/Chicago'
            },
            {
                id: 3671,
                city: 'Elmdale',
                latitude: 38.37363,
                longitude: -96.64473,
                timezone: 'America/Chicago'
            },
            {
                id: 3672,
                city: 'Elsmore',
                latitude: 37.79449,
                longitude: -95.15026,
                timezone: 'America/Chicago'
            },
            {
                id: 3673,
                city: 'Elwood',
                latitude: 39.75555,
                longitude: -94.87247,
                timezone: 'America/Chicago'
            },
            {
                id: 3674,
                city: 'Emmett',
                latitude: 39.30722,
                longitude: -96.0561,
                timezone: 'America/Chicago'
            },
            {
                id: 3675,
                city: 'Emporia',
                latitude: 38.4039,
                longitude: -96.18166,
                timezone: 'America/Chicago'
            },
            {
                id: 3676,
                city: 'Englewood',
                latitude: 37.03836,
                longitude: -99.98347,
                timezone: 'America/Chicago'
            },
            {
                id: 3677,
                city: 'Ensign',
                latitude: 37.6528,
                longitude: -100.23375,
                timezone: 'America/Chicago'
            },
            {
                id: 3678,
                city: 'Enterprise',
                latitude: 38.90278,
                longitude: -97.11696,
                timezone: 'America/Chicago'
            },
            {
                id: 3679,
                city: 'Erie',
                latitude: 37.56811,
                longitude: -95.24331,
                timezone: 'America/Chicago'
            },
            {
                id: 3680,
                city: 'Esbon',
                latitude: 39.82223,
                longitude: -98.43589,
                timezone: 'America/Chicago'
            },
            {
                id: 3681,
                city: 'Eskridge',
                latitude: 38.85889,
                longitude: -96.10916,
                timezone: 'America/Chicago'
            },
            {
                id: 3682,
                city: 'Eudora',
                latitude: 38.94334,
                longitude: -95.09858,
                timezone: 'America/Chicago'
            },
            {
                id: 3683,
                city: 'Eureka',
                latitude: 37.82392,
                longitude: -96.28917,
                timezone: 'America/Chicago'
            },
            {
                id: 3684,
                city: 'Everest',
                latitude: 39.67722,
                longitude: -95.4247,
                timezone: 'America/Chicago'
            },
            {
                id: 3685,
                city: 'Fairview',
                latitude: 39.84111,
                longitude: -95.72804,
                timezone: 'America/Chicago'
            },
            {
                id: 3686,
                city: 'Fairway',
                latitude: 39.02223,
                longitude: -94.6319,
                timezone: 'America/Chicago'
            },
            {
                id: 3687,
                city: 'Fall River',
                latitude: 37.60782,
                longitude: -96.02804,
                timezone: 'America/Chicago'
            },
            {
                id: 3688,
                city: 'Florence',
                latitude: 38.24446,
                longitude: -96.92808,
                timezone: 'America/Chicago'
            },
            {
                id: 3689,
                city: 'Fontana',
                latitude: 38.42585,
                longitude: -94.83829,
                timezone: 'America/Chicago'
            },
            {
                id: 3690,
                city: 'Ford',
                latitude: 37.63613,
                longitude: -99.75402,
                timezone: 'America/Chicago'
            },
            {
                id: 3691,
                city: 'Formoso',
                latitude: 39.78001,
                longitude: -97.99227,
                timezone: 'America/Chicago'
            },
            {
                id: 3692,
                city: 'Fort Scott',
                latitude: 37.83976,
                longitude: -94.7083,
                timezone: 'America/Chicago'
            },
            {
                id: 3693,
                city: 'Fowler',
                latitude: 37.38558,
                longitude: -100.1957,
                timezone: 'America/Chicago'
            },
            {
                id: 3694,
                city: 'Frankfort',
                latitude: 39.70555,
                longitude: -96.41696,
                timezone: 'America/Chicago'
            },
            {
                id: 3695,
                city: 'Frederick',
                latitude: 38.51334,
                longitude: -98.26839,
                timezone: 'America/Chicago'
            },
            {
                id: 3696,
                city: 'Fredonia',
                latitude: 37.53394,
                longitude: -95.82665,
                timezone: 'America/Chicago'
            },
            {
                id: 3697,
                city: 'Freeport',
                latitude: 37.19863,
                longitude: -97.857,
                timezone: 'America/Chicago'
            },
            {
                id: 3698,
                city: 'Frontenac',
                latitude: 37.4556,
                longitude: -94.68913,
                timezone: 'America/Chicago'
            },
            {
                id: 3699,
                city: 'Fulton',
                latitude: 38.01004,
                longitude: -94.71968,
                timezone: 'America/Chicago'
            },
            {
                id: 3700,
                city: 'Galatia',
                latitude: 38.64168,
                longitude: -98.9587,
                timezone: 'America/Chicago'
            },
            {
                id: 3701,
                city: 'Galena',
                latitude: 37.0759,
                longitude: -94.63967,
                timezone: 'America/Chicago'
            },
            {
                id: 3702,
                city: 'Galesburg',
                latitude: 37.47367,
                longitude: -95.35859,
                timezone: 'America/Chicago'
            },
            {
                id: 3703,
                city: 'Galva',
                latitude: 38.38195,
                longitude: -97.53754,
                timezone: 'America/Chicago'
            },
            {
                id: 3704,
                city: 'Garden City',
                latitude: 37.97169,
                longitude: -100.87266,
                timezone: 'America/Chicago'
            },
            {
                id: 3705,
                city: 'Garden Plain',
                latitude: 37.65835,
                longitude: -97.68366,
                timezone: 'America/Chicago'
            },
            {
                id: 3706,
                city: 'Gardner',
                latitude: 38.81084,
                longitude: -94.92719,
                timezone: 'America/Chicago'
            },
            {
                id: 3707,
                city: 'Garfield',
                latitude: 38.07779,
                longitude: -99.24483,
                timezone: 'America/Chicago'
            },
            {
                id: 3708,
                city: 'Garnett',
                latitude: 38.28058,
                longitude: -95.24192,
                timezone: 'America/Chicago'
            },
            {
                id: 3709,
                city: 'Gas',
                latitude: 37.92365,
                longitude: -95.34609,
                timezone: 'America/Chicago'
            },
            {
                id: 3710,
                city: 'Gaylord',
                latitude: 39.6439,
                longitude: -98.84758,
                timezone: 'America/Chicago'
            },
            {
                id: 3711,
                city: 'Gem',
                latitude: 39.42778,
                longitude: -100.89765,
                timezone: 'America/Chicago'
            },
            {
                id: 3712,
                city: 'Geneseo',
                latitude: 38.51612,
                longitude: -98.15672,
                timezone: 'America/Chicago'
            },
            {
                id: 3713,
                city: 'Geuda Springs',
                latitude: 37.11157,
                longitude: -97.15041,
                timezone: 'America/Chicago'
            },
            {
                id: 3714,
                city: 'Girard',
                latitude: 37.51116,
                longitude: -94.83802,
                timezone: 'America/Chicago'
            },
            {
                id: 3715,
                city: 'Glade',
                latitude: 39.68473,
                longitude: -99.30982,
                timezone: 'America/Chicago'
            },
            {
                id: 3716,
                city: 'Glasco',
                latitude: 39.35667,
                longitude: -97.84115,
                timezone: 'America/Chicago'
            },
            {
                id: 3717,
                city: 'Glen Elder',
                latitude: 39.49862,
                longitude: -98.30867,
                timezone: 'America/Chicago'
            },
            {
                id: 3718,
                city: 'Goddard',
                latitude: 37.65974,
                longitude: -97.57533,
                timezone: 'America/Chicago'
            },
            {
                id: 3719,
                city: 'Goessel',
                latitude: 38.2464,
                longitude: -97.34892,
                timezone: 'America/Chicago'
            },
            {
                id: 3720,
                city: 'Goff',
                latitude: 39.66389,
                longitude: -95.93222,
                timezone: 'America/Chicago'
            },
            {
                id: 3721,
                city: 'Goodland',
                latitude: 39.35083,
                longitude: -101.71017,
                timezone: 'America/Denver'
            },
            {
                id: 3722,
                city: 'Gorham',
                latitude: 38.88168,
                longitude: -99.02315,
                timezone: 'America/Chicago'
            },
            {
                id: 3723,
                city: 'Gove City',
                latitude: 38.95779,
                longitude: -100.48875,
                timezone: 'America/Chicago'
            },
            {
                id: 3724,
                city: 'Grainfield',
                latitude: 39.11362,
                longitude: -100.46514,
                timezone: 'America/Chicago'
            },
            {
                id: 3725,
                city: 'Grandview Plaza',
                latitude: 39.02916,
                longitude: -96.78917,
                timezone: 'America/Chicago'
            },
            {
                id: 3726,
                city: 'Great Bend',
                latitude: 38.36446,
                longitude: -98.76481,
                timezone: 'America/Chicago'
            },
            {
                id: 3727,
                city: 'Greeley',
                latitude: 38.36669,
                longitude: -95.12692,
                timezone: 'America/Chicago'
            },
            {
                id: 3728,
                city: 'Green',
                latitude: 39.42778,
                longitude: -97.00196,
                timezone: 'America/Chicago'
            },
            {
                id: 3729,
                city: 'Greenleaf',
                latitude: 39.72834,
                longitude: -96.97613,
                timezone: 'America/Chicago'
            },
            {
                id: 3730,
                city: 'Greensburg',
                latitude: 37.6028,
                longitude: -99.29261,
                timezone: 'America/Chicago'
            },
            {
                id: 3731,
                city: 'Grenola',
                latitude: 37.34864,
                longitude: -96.45056,
                timezone: 'America/Chicago'
            },
            {
                id: 3732,
                city: 'Gridley',
                latitude: 38.0978,
                longitude: -95.8836,
                timezone: 'America/Chicago'
            },
            {
                id: 3733,
                city: 'Grinnell',
                latitude: 39.12723,
                longitude: -100.62903,
                timezone: 'America/Chicago'
            },
            {
                id: 3734,
                city: 'Gypsum',
                latitude: 38.70556,
                longitude: -97.42809,
                timezone: 'America/Chicago'
            },
            {
                id: 3735,
                city: 'Haddam',
                latitude: 39.85695,
                longitude: -97.3017,
                timezone: 'America/Chicago'
            },
            {
                id: 3736,
                city: 'Halstead',
                latitude: 38.0014,
                longitude: -97.50865,
                timezone: 'America/Chicago'
            },
            {
                id: 3737,
                city: 'Hamilton',
                latitude: 37.97947,
                longitude: -96.16416,
                timezone: 'America/Chicago'
            },
            {
                id: 3738,
                city: 'Hamlin',
                latitude: 39.91611,
                longitude: -95.62804,
                timezone: 'America/Chicago'
            },
            {
                id: 3739,
                city: 'Hanover',
                latitude: 39.89389,
                longitude: -96.87947,
                timezone: 'America/Chicago'
            },
            {
                id: 3740,
                city: 'Hanston',
                latitude: 38.12196,
                longitude: -99.7129,
                timezone: 'America/Chicago'
            },
            {
                id: 3741,
                city: 'Hardtner',
                latitude: 37.01392,
                longitude: -98.64953,
                timezone: 'America/Chicago'
            },
            {
                id: 3742,
                city: 'Harper',
                latitude: 37.28669,
                longitude: -98.02589,
                timezone: 'America/Chicago'
            },
            {
                id: 3743,
                city: 'Hartford',
                latitude: 38.30835,
                longitude: -95.95582,
                timezone: 'America/Chicago'
            },
            {
                id: 3744,
                city: 'Harveyville',
                latitude: 38.79001,
                longitude: -95.96166,
                timezone: 'America/Chicago'
            },
            {
                id: 3745,
                city: 'Havana',
                latitude: 37.09174,
                longitude: -95.94193,
                timezone: 'America/Chicago'
            },
            {
                id: 3746,
                city: 'Haven',
                latitude: 37.8989,
                longitude: -97.78283,
                timezone: 'America/Chicago'
            },
            {
                id: 3747,
                city: 'Havensville',
                latitude: 39.51111,
                longitude: -96.07805,
                timezone: 'America/Chicago'
            },
            {
                id: 3748,
                city: 'Haviland',
                latitude: 37.61946,
                longitude: -99.1065,
                timezone: 'America/Chicago'
            },
            {
                id: 3749,
                city: 'Hays',
                latitude: 38.87918,
                longitude: -99.32677,
                timezone: 'America/Chicago'
            },
            {
                id: 3750,
                city: 'Haysville',
                latitude: 37.56446,
                longitude: -97.35227,
                timezone: 'America/Chicago'
            },
            {
                id: 3751,
                city: 'Hazelton',
                latitude: 37.0903,
                longitude: -98.39841,
                timezone: 'America/Chicago'
            },
            {
                id: 3752,
                city: 'Hepler',
                latitude: 37.66116,
                longitude: -94.9683,
                timezone: 'America/Chicago'
            },
            {
                id: 3753,
                city: 'Herington',
                latitude: 38.69687,
                longitude: -96.80724,
                timezone: 'America/Chicago'
            },
            {
                id: 3754,
                city: 'Herndon',
                latitude: 39.90973,
                longitude: -100.78515,
                timezone: 'America/Chicago'
            },
            {
                id: 3755,
                city: 'Hesston',
                latitude: 38.13834,
                longitude: -97.43143,
                timezone: 'America/Chicago'
            },
            {
                id: 3756,
                city: 'Hiawatha',
                latitude: 39.8525,
                longitude: -95.53582,
                timezone: 'America/Chicago'
            },
            {
                id: 3757,
                city: 'Highland',
                latitude: 39.85972,
                longitude: -95.2697,
                timezone: 'America/Chicago'
            },
            {
                id: 3758,
                city: 'Hill City',
                latitude: 39.36473,
                longitude: -99.84206,
                timezone: 'America/Chicago'
            },
            {
                id: 3759,
                city: 'Hillsboro',
                latitude: 38.35196,
                longitude: -97.20447,
                timezone: 'America/Chicago'
            },
            {
                id: 3760,
                city: 'Hoisington',
                latitude: 38.51807,
                longitude: -98.77814,
                timezone: 'America/Chicago'
            },
            {
                id: 3761,
                city: 'Holcomb',
                latitude: 37.98614,
                longitude: -100.98933,
                timezone: 'America/Chicago'
            },
            {
                id: 3762,
                city: 'Hollenberg',
                latitude: 39.98056,
                longitude: -96.99225,
                timezone: 'America/Chicago'
            },
            {
                id: 3763,
                city: 'Holton',
                latitude: 39.46527,
                longitude: -95.73637,
                timezone: 'America/Chicago'
            },
            {
                id: 3764,
                city: 'Holyrood',
                latitude: 38.58695,
                longitude: -98.41118,
                timezone: 'America/Chicago'
            },
            {
                id: 3765,
                city: 'Hope',
                latitude: 38.69028,
                longitude: -97.07668,
                timezone: 'America/Chicago'
            },
            {
                id: 3766,
                city: 'Horace',
                latitude: 38.4764,
                longitude: -101.79073,
                timezone: 'America/Denver'
            },
            {
                id: 3767,
                city: 'Horton',
                latitude: 39.66056,
                longitude: -95.52637,
                timezone: 'America/Chicago'
            },
            {
                id: 3768,
                city: 'Howard',
                latitude: 37.47031,
                longitude: -96.26361,
                timezone: 'America/Chicago'
            },
            {
                id: 3769,
                city: 'Hoxie',
                latitude: 39.3575,
                longitude: -100.44181,
                timezone: 'America/Chicago'
            },
            {
                id: 3770,
                city: 'Hoyt',
                latitude: 39.24778,
                longitude: -95.70637,
                timezone: 'America/Chicago'
            },
            {
                id: 3771,
                city: 'Hudson',
                latitude: 38.10557,
                longitude: -98.66008,
                timezone: 'America/Chicago'
            },
            {
                id: 3772,
                city: 'Hugoton',
                latitude: 37.1753,
                longitude: -101.3496,
                timezone: 'America/Chicago'
            },
            {
                id: 3773,
                city: 'Humboldt',
                latitude: 37.8106,
                longitude: -95.43693,
                timezone: 'America/Chicago'
            },
            {
                id: 3774,
                city: 'Hunnewell',
                latitude: 37.00503,
                longitude: -97.40477,
                timezone: 'America/Chicago'
            },
            {
                id: 3775,
                city: 'Hunter',
                latitude: 39.23418,
                longitude: -98.39728,
                timezone: 'America/Chicago'
            },
            {
                id: 3776,
                city: 'Huron',
                latitude: 39.63833,
                longitude: -95.35164,
                timezone: 'America/Chicago'
            },
            {
                id: 3777,
                city: 'Hutchinson',
                latitude: 38.06084,
                longitude: -97.92977,
                timezone: 'America/Chicago'
            },
            {
                id: 3778,
                city: 'Independence',
                latitude: 37.22424,
                longitude: -95.70831,
                timezone: 'America/Chicago'
            },
            {
                id: 3779,
                city: 'Ingalls',
                latitude: 37.8278,
                longitude: -100.45459,
                timezone: 'America/Chicago'
            },
            {
                id: 3780,
                city: 'Inman',
                latitude: 38.23195,
                longitude: -97.77338,
                timezone: 'America/Chicago'
            },
            {
                id: 3781,
                city: 'Iola',
                latitude: 37.92448,
                longitude: -95.39998,
                timezone: 'America/Chicago'
            },
            {
                id: 3782,
                city: 'Isabel',
                latitude: 37.46669,
                longitude: -98.55036,
                timezone: 'America/Chicago'
            },
            {
                id: 3783,
                city: 'Iuka',
                latitude: 37.72918,
                longitude: -98.73509,
                timezone: 'America/Chicago'
            },
            {
                id: 3784,
                city: 'Jamestown',
                latitude: 39.59945,
                longitude: -97.86115,
                timezone: 'America/Chicago'
            },
            {
                id: 3785,
                city: 'Jennings',
                latitude: 39.67945,
                longitude: -100.29347,
                timezone: 'America/Chicago'
            },
            {
                id: 3786,
                city: 'Jetmore',
                latitude: 38.08446,
                longitude: -99.89346,
                timezone: 'America/Chicago'
            },
            {
                id: 3787,
                city: 'Jewell',
                latitude: 39.6714,
                longitude: -98.15366,
                timezone: 'America/Chicago'
            },
            {
                id: 3788,
                city: 'Johnson City',
                latitude: 37.57057,
                longitude: -101.751,
                timezone: 'America/Chicago'
            },
            {
                id: 3789,
                city: 'Junction City',
                latitude: 39.02861,
                longitude: -96.8314,
                timezone: 'America/Chicago'
            },
            {
                id: 3790,
                city: 'Kanopolis',
                latitude: 38.71112,
                longitude: -98.15728,
                timezone: 'America/Chicago'
            },
            {
                id: 3791,
                city: 'Kanorado',
                latitude: 39.33305,
                longitude: -102.03796,
                timezone: 'America/Denver'
            },
            {
                id: 3792,
                city: 'Kansas City',
                latitude: 39.11417,
                longitude: -94.62746,
                timezone: 'America/Chicago'
            },
            {
                id: 3793,
                city: 'Kechi',
                latitude: 37.79585,
                longitude: -97.27949,
                timezone: 'America/Chicago'
            },
            {
                id: 3794,
                city: 'Kensington',
                latitude: 39.76696,
                longitude: -99.03175,
                timezone: 'America/Chicago'
            },
            {
                id: 3795,
                city: 'Kincaid',
                latitude: 38.0842,
                longitude: -95.15359,
                timezone: 'America/Chicago'
            },
            {
                id: 3796,
                city: 'Kingman',
                latitude: 37.64585,
                longitude: -98.11367,
                timezone: 'America/Chicago'
            },
            {
                id: 3797,
                city: 'Kinsley',
                latitude: 37.92307,
                longitude: -99.40984,
                timezone: 'America/Chicago'
            },
            {
                id: 3798,
                city: 'Kiowa',
                latitude: 37.01725,
                longitude: -98.48535,
                timezone: 'America/Chicago'
            },
            {
                id: 3799,
                city: 'Kirwin',
                latitude: 39.67307,
                longitude: -99.12231,
                timezone: 'America/Chicago'
            },
            {
                id: 3800,
                city: 'Kismet',
                latitude: 37.20558,
                longitude: -100.7021,
                timezone: 'America/Chicago'
            },
            {
                id: 3802,
                city: 'La Crosse',
                latitude: 38.5314,
                longitude: -99.30872,
                timezone: 'America/Chicago'
            },
            {
                id: 3803,
                city: 'La Cygne',
                latitude: 38.35002,
                longitude: -94.76135,
                timezone: 'America/Chicago'
            },
            {
                id: 3804,
                city: 'La Harpe',
                latitude: 37.91698,
                longitude: -95.29915,
                timezone: 'America/Chicago'
            },
            {
                id: 3801,
                city: 'Labette',
                latitude: 37.23062,
                longitude: -95.18358,
                timezone: 'America/Chicago'
            },
            {
                id: 3805,
                city: 'Lake Quivira',
                latitude: 39.03965,
                longitude: -94.76951,
                timezone: 'America/Chicago'
            },
            {
                id: 3806,
                city: 'Lakin',
                latitude: 37.94058,
                longitude: -101.25489,
                timezone: 'America/Chicago'
            },
            {
                id: 3807,
                city: 'Lancaster',
                latitude: 39.57278,
                longitude: -95.30275,
                timezone: 'America/Chicago'
            },
            {
                id: 3808,
                city: 'Lane',
                latitude: 38.43974,
                longitude: -95.08219,
                timezone: 'America/Chicago'
            },
            {
                id: 3809,
                city: 'Langdon',
                latitude: 37.8539,
                longitude: -98.32451,
                timezone: 'America/Chicago'
            },
            {
                id: 3810,
                city: 'Lansing',
                latitude: 39.24861,
                longitude: -94.90024,
                timezone: 'America/Chicago'
            },
            {
                id: 3811,
                city: 'Larned',
                latitude: 38.18057,
                longitude: -99.09871,
                timezone: 'America/Chicago'
            },
            {
                id: 3812,
                city: 'Latham',
                latitude: 37.53613,
                longitude: -96.64197,
                timezone: 'America/Chicago'
            },
            {
                id: 3813,
                city: 'Latimer',
                latitude: 38.73889,
                longitude: -96.84557,
                timezone: 'America/Chicago'
            },
            {
                id: 3814,
                city: 'Lawrence',
                latitude: 38.97167,
                longitude: -95.23525,
                timezone: 'America/Chicago'
            },
            {
                id: 3815,
                city: 'Leavenworth',
                latitude: 39.31111,
                longitude: -94.92246,
                timezone: 'America/Chicago'
            },
            {
                id: 3816,
                city: 'Leawood',
                latitude: 38.96667,
                longitude: -94.6169,
                timezone: 'America/Chicago'
            },
            {
                id: 3817,
                city: 'Lebanon',
                latitude: 39.80973,
                longitude: -98.55562,
                timezone: 'America/Chicago'
            },
            {
                id: 3818,
                city: 'Lebo',
                latitude: 38.41668,
                longitude: -95.85304,
                timezone: 'America/Chicago'
            },
            {
                id: 3819,
                city: 'Lecompton',
                latitude: 39.04444,
                longitude: -95.3947,
                timezone: 'America/Chicago'
            },
            {
                id: 3820,
                city: 'Lehigh',
                latitude: 38.37279,
                longitude: -97.30309,
                timezone: 'America/Chicago'
            },
            {
                id: 3821,
                city: 'Lenexa',
                latitude: 38.95362,
                longitude: -94.73357,
                timezone: 'America/Chicago'
            },
            {
                id: 3822,
                city: 'Lenora',
                latitude: 39.61056,
                longitude: -100.00263,
                timezone: 'America/Chicago'
            },
            {
                id: 3823,
                city: 'Leon',
                latitude: 37.6903,
                longitude: -96.78225,
                timezone: 'America/Chicago'
            },
            {
                id: 3824,
                city: 'Leona',
                latitude: 39.78722,
                longitude: -95.32164,
                timezone: 'America/Chicago'
            },
            {
                id: 3825,
                city: 'Leonardville',
                latitude: 39.36444,
                longitude: -96.8589,
                timezone: 'America/Chicago'
            },
            {
                id: 3826,
                city: 'Leoti',
                latitude: 38.47974,
                longitude: -101.35877,
                timezone: 'America/Chicago'
            },
            {
                id: 3827,
                city: 'LeRoy',
                latitude: 38.08392,
                longitude: -95.63443,
                timezone: 'America/Chicago'
            },
            {
                id: 3828,
                city: 'Lewis',
                latitude: 37.93613,
                longitude: -99.25261,
                timezone: 'America/Chicago'
            },
            {
                id: 3829,
                city: 'Liberal',
                latitude: 37.04308,
                longitude: -100.921,
                timezone: 'America/Chicago'
            },
            {
                id: 3830,
                city: 'Liberty',
                latitude: 37.15563,
                longitude: -95.5947,
                timezone: 'America/Chicago'
            },
            {
                id: 3831,
                city: 'Liebenthal',
                latitude: 38.65501,
                longitude: -99.31927,
                timezone: 'America/Chicago'
            },
            {
                id: 3832,
                city: 'Lincoln Center',
                latitude: 39.04294,
                longitude: -98.14673,
                timezone: 'America/Chicago'
            },
            {
                id: 3833,
                city: 'Lincolnville',
                latitude: 38.49335,
                longitude: -96.96002,
                timezone: 'America/Chicago'
            },
            {
                id: 3834,
                city: 'Lindsborg',
                latitude: 38.57362,
                longitude: -97.67448,
                timezone: 'America/Chicago'
            },
            {
                id: 3835,
                city: 'Linn',
                latitude: 39.68,
                longitude: -97.08419,
                timezone: 'America/Chicago'
            },
            {
                id: 3836,
                city: 'Linn Valley',
                latitude: 38.37752,
                longitude: -94.7094,
                timezone: 'America/Chicago'
            },
            {
                id: 3837,
                city: 'Linwood',
                latitude: 39.00139,
                longitude: -95.03914,
                timezone: 'America/Chicago'
            },
            {
                id: 3838,
                city: 'Little River',
                latitude: 38.39807,
                longitude: -98.012,
                timezone: 'America/Chicago'
            },
            {
                id: 3839,
                city: 'Logan',
                latitude: 39.66167,
                longitude: -99.57039,
                timezone: 'America/Chicago'
            },
            {
                id: 3840,
                city: 'Lone Elm',
                latitude: 38.08003,
                longitude: -95.24331,
                timezone: 'America/Chicago'
            },
            {
                id: 3842,
                city: 'Long Island',
                latitude: 39.94945,
                longitude: -99.53594,
                timezone: 'America/Chicago'
            },
            {
                id: 3841,
                city: 'Longford',
                latitude: 39.17,
                longitude: -97.33141,
                timezone: 'America/Chicago'
            },
            {
                id: 3843,
                city: 'Longton',
                latitude: 37.37782,
                longitude: -96.08082,
                timezone: 'America/Chicago'
            },
            {
                id: 3844,
                city: 'Lorraine',
                latitude: 38.5689,
                longitude: -98.31673,
                timezone: 'America/Chicago'
            },
            {
                id: 3845,
                city: 'Lost Springs',
                latitude: 38.56612,
                longitude: -96.9664,
                timezone: 'America/Chicago'
            },
            {
                id: 3846,
                city: 'Louisburg',
                latitude: 38.61946,
                longitude: -94.68079,
                timezone: 'America/Chicago'
            },
            {
                id: 3847,
                city: 'Louisville',
                latitude: 39.25027,
                longitude: -96.31472,
                timezone: 'America/Chicago'
            },
            {
                id: 3848,
                city: 'Lucas',
                latitude: 39.05612,
                longitude: -98.53646,
                timezone: 'America/Chicago'
            },
            {
                id: 3849,
                city: 'Luray',
                latitude: 39.11057,
                longitude: -98.68896,
                timezone: 'America/Chicago'
            },
            {
                id: 3850,
                city: 'Lyndon',
                latitude: 38.61001,
                longitude: -95.68443,
                timezone: 'America/Chicago'
            },
            {
                id: 3851,
                city: 'Lyons',
                latitude: 38.34501,
                longitude: -98.20173,
                timezone: 'America/Chicago'
            },
            {
                id: 3852,
                city: 'Macksville',
                latitude: 37.95918,
                longitude: -98.96871,
                timezone: 'America/Chicago'
            },
            {
                id: 3853,
                city: 'Madison',
                latitude: 38.13558,
                longitude: -96.13583,
                timezone: 'America/Chicago'
            },
            {
                id: 3854,
                city: 'Mahaska',
                latitude: 39.9875,
                longitude: -97.35421,
                timezone: 'America/Chicago'
            },
            {
                id: 3855,
                city: 'Maize',
                latitude: 37.77918,
                longitude: -97.46727,
                timezone: 'America/Chicago'
            },
            {
                id: 3856,
                city: 'Manchester',
                latitude: 39.09472,
                longitude: -97.32475,
                timezone: 'America/Chicago'
            },
            {
                id: 3857,
                city: 'Manhattan',
                latitude: 39.18831,
                longitude: -96.60586,
                timezone: 'America/Chicago'
            },
            {
                id: 3858,
                city: 'Mankato',
                latitude: 39.78723,
                longitude: -98.21005,
                timezone: 'America/Chicago'
            },
            {
                id: 3859,
                city: 'Manter',
                latitude: 37.52307,
                longitude: -101.8849,
                timezone: 'America/Chicago'
            },
            {
                id: 3860,
                city: 'Maple Hill',
                latitude: 39.08472,
                longitude: -96.02805,
                timezone: 'America/Chicago'
            },
            {
                id: 3861,
                city: 'Mapleton',
                latitude: 38.01503,
                longitude: -94.88358,
                timezone: 'America/Chicago'
            },
            {
                id: 3862,
                city: 'Marion',
                latitude: 38.34835,
                longitude: -97.01725,
                timezone: 'America/Chicago'
            },
            {
                id: 3863,
                city: 'Marquette',
                latitude: 38.55556,
                longitude: -97.83366,
                timezone: 'America/Chicago'
            },
            {
                id: 3864,
                city: 'Marysville',
                latitude: 39.84111,
                longitude: -96.64724,
                timezone: 'America/Chicago'
            },
            {
                id: 3865,
                city: 'Matfield Green',
                latitude: 38.15918,
                longitude: -96.56057,
                timezone: 'America/Chicago'
            },
            {
                id: 3866,
                city: 'Mayetta',
                latitude: 39.33889,
                longitude: -95.72248,
                timezone: 'America/Chicago'
            },
            {
                id: 3867,
                city: 'Mayfield',
                latitude: 37.25835,
                longitude: -97.54477,
                timezone: 'America/Chicago'
            },
            {
                id: 3868,
                city: 'McCracken',
                latitude: 38.58057,
                longitude: -99.57122,
                timezone: 'America/Chicago'
            },
            {
                id: 3869,
                city: 'McCune',
                latitude: 37.35478,
                longitude: -95.01663,
                timezone: 'America/Chicago'
            },
            {
                id: 3870,
                city: 'McDonald',
                latitude: 39.78583,
                longitude: -101.37572,
                timezone: 'America/Chicago'
            },
            {
                id: 3871,
                city: 'McFarland',
                latitude: 39.05278,
                longitude: -96.23777,
                timezone: 'America/Chicago'
            },
            {
                id: 3872,
                city: 'McLouth',
                latitude: 39.19583,
                longitude: -95.2083,
                timezone: 'America/Chicago'
            },
            {
                id: 3873,
                city: 'McPherson',
                latitude: 38.37084,
                longitude: -97.66421,
                timezone: 'America/Chicago'
            },
            {
                id: 3874,
                city: 'Meade',
                latitude: 37.28558,
                longitude: -100.34015,
                timezone: 'America/Chicago'
            },
            {
                id: 3875,
                city: 'Medicine Lodge',
                latitude: 37.28113,
                longitude: -98.58036,
                timezone: 'America/Chicago'
            },
            {
                id: 3876,
                city: 'Melvern',
                latitude: 38.50696,
                longitude: -95.63776,
                timezone: 'America/Chicago'
            },
            {
                id: 3877,
                city: 'Menlo',
                latitude: 39.35695,
                longitude: -100.72265,
                timezone: 'America/Chicago'
            },
            {
                id: 3878,
                city: 'Meriden',
                latitude: 39.18889,
                longitude: -95.5697,
                timezone: 'America/Chicago'
            },
            {
                id: 3879,
                city: 'Merriam',
                latitude: 39.02362,
                longitude: -94.69357,
                timezone: 'America/Chicago'
            },
            {
                id: 3880,
                city: 'Milan',
                latitude: 37.25974,
                longitude: -97.67394,
                timezone: 'America/Chicago'
            },
            {
                id: 3881,
                city: 'Mildred',
                latitude: 38.02364,
                longitude: -95.17109,
                timezone: 'America/Chicago'
            },
            {
                id: 3882,
                city: 'Milford',
                latitude: 39.16833,
                longitude: -96.91251,
                timezone: 'America/Chicago'
            },
            {
                id: 3883,
                city: 'Miltonvale',
                latitude: 39.34833,
                longitude: -97.44614,
                timezone: 'America/Chicago'
            },
            {
                id: 3884,
                city: 'Minneapolis',
                latitude: 39.12194,
                longitude: -97.7067,
                timezone: 'America/Chicago'
            },
            {
                id: 3885,
                city: 'Minneola',
                latitude: 37.44336,
                longitude: -100.01514,
                timezone: 'America/Chicago'
            },
            {
                id: 3886,
                city: 'Mission',
                latitude: 39.02778,
                longitude: -94.65579,
                timezone: 'America/Chicago'
            },
            {
                id: 3887,
                city: 'Mission Hills',
                latitude: 39.01778,
                longitude: -94.6169,
                timezone: 'America/Chicago'
            },
            {
                id: 3888,
                city: 'Mission Woods',
                latitude: 39.03501,
                longitude: -94.60857,
                timezone: 'America/Chicago'
            },
            {
                id: 3889,
                city: 'Moline',
                latitude: 37.36031,
                longitude: -96.30389,
                timezone: 'America/Chicago'
            },
            {
                id: 3890,
                city: 'Montezuma',
                latitude: 37.59586,
                longitude: -100.4432,
                timezone: 'America/Chicago'
            },
            {
                id: 3891,
                city: 'Moran',
                latitude: 37.91615,
                longitude: -95.17025,
                timezone: 'America/Chicago'
            },
            {
                id: 3892,
                city: 'Morganville',
                latitude: 39.46639,
                longitude: -97.20197,
                timezone: 'America/Chicago'
            },
            {
                id: 3893,
                city: 'Morland',
                latitude: 39.34945,
                longitude: -100.07569,
                timezone: 'America/Chicago'
            },
            {
                id: 3894,
                city: 'Morrill',
                latitude: 39.92833,
                longitude: -95.69193,
                timezone: 'America/Chicago'
            },
            {
                id: 3895,
                city: 'Morrowville',
                latitude: 39.84445,
                longitude: -97.1717,
                timezone: 'America/Chicago'
            },
            {
                id: 3896,
                city: 'Moscow',
                latitude: 37.32363,
                longitude: -101.20572,
                timezone: 'America/Chicago'
            },
            {
                id: 3897,
                city: 'Mound City',
                latitude: 38.14281,
                longitude: -94.81357,
                timezone: 'America/Chicago'
            },
            {
                id: 3899,
                city: 'Mound Valley',
                latitude: 37.20535,
                longitude: -95.40497,
                timezone: 'America/Chicago'
            },
            {
                id: 3898,
                city: 'Moundridge',
                latitude: 38.20307,
                longitude: -97.51921,
                timezone: 'America/Chicago'
            },
            {
                id: 3900,
                city: 'Mount Hope',
                latitude: 37.86862,
                longitude: -97.66505,
                timezone: 'America/Chicago'
            },
            {
                id: 3901,
                city: 'Mulberry',
                latitude: 37.55699,
                longitude: -94.6219,
                timezone: 'America/Chicago'
            },
            {
                id: 3902,
                city: 'Mullinville',
                latitude: 37.58613,
                longitude: -99.47567,
                timezone: 'America/Chicago'
            },
            {
                id: 3903,
                city: 'Mulvane',
                latitude: 37.47645,
                longitude: -97.23537,
                timezone: 'America/Chicago'
            },
            {
                id: 3904,
                city: 'Munden',
                latitude: 39.91389,
                longitude: -97.5381,
                timezone: 'America/Chicago'
            },
            {
                id: 3905,
                city: 'Muscotah',
                latitude: 39.55278,
                longitude: -95.52165,
                timezone: 'America/Chicago'
            },
            {
                id: 3906,
                city: 'Narka',
                latitude: 39.96056,
                longitude: -97.42587,
                timezone: 'America/Chicago'
            },
            {
                id: 3907,
                city: 'Nashville',
                latitude: 37.44169,
                longitude: -98.42258,
                timezone: 'America/Chicago'
            },
            {
                id: 3908,
                city: 'Natoma',
                latitude: 39.19084,
                longitude: -99.0287,
                timezone: 'America/Chicago'
            },
            {
                id: 3909,
                city: 'Neodesha',
                latitude: 37.41839,
                longitude: -95.68026,
                timezone: 'America/Chicago'
            },
            {
                id: 3910,
                city: 'Neosho Falls',
                latitude: 38.00559,
                longitude: -95.55721,
                timezone: 'America/Chicago'
            },
            {
                id: 3911,
                city: 'Neosho Rapids',
                latitude: 38.36946,
                longitude: -95.99194,
                timezone: 'America/Chicago'
            },
            {
                id: 3912,
                city: 'Ness City',
                latitude: 38.45279,
                longitude: -99.90651,
                timezone: 'America/Chicago'
            },
            {
                id: 3913,
                city: 'Netawaka',
                latitude: 39.60277,
                longitude: -95.71832,
                timezone: 'America/Chicago'
            },
            {
                id: 3914,
                city: 'New Albany',
                latitude: 37.56838,
                longitude: -95.93776,
                timezone: 'America/Chicago'
            },
            {
                id: 3915,
                city: 'New Cambria',
                latitude: 38.87917,
                longitude: -97.50586,
                timezone: 'America/Chicago'
            },
            {
                id: 3916,
                city: 'New Strawn',
                latitude: 38.26252,
                longitude: -95.74193,
                timezone: 'America/Chicago'
            },
            {
                id: 3917,
                city: 'Newton',
                latitude: 38.04668,
                longitude: -97.34504,
                timezone: 'America/Chicago'
            },
            {
                id: 3918,
                city: 'Nickerson',
                latitude: 38.14723,
                longitude: -98.08367,
                timezone: 'America/Chicago'
            },
            {
                id: 3919,
                city: 'Niotaze',
                latitude: 37.07368,
                longitude: -96.01359,
                timezone: 'America/Chicago'
            },
            {
                id: 3920,
                city: 'Norcatur',
                latitude: 39.83695,
                longitude: -100.18791,
                timezone: 'America/Chicago'
            },
            {
                id: 3921,
                city: 'North Newton',
                latitude: 38.07223,
                longitude: -97.34559,
                timezone: 'America/Chicago'
            },
            {
                id: 3922,
                city: 'Norton',
                latitude: 39.83389,
                longitude: -99.89151,
                timezone: 'America/Chicago'
            },
            {
                id: 3923,
                city: 'Nortonville',
                latitude: 39.41666,
                longitude: -95.33358,
                timezone: 'America/Chicago'
            },
            {
                id: 3924,
                city: 'Norwich',
                latitude: 37.45724,
                longitude: -97.84894,
                timezone: 'America/Chicago'
            },
            {
                id: 3925,
                city: 'Oak Hill',
                latitude: 39.24833,
                longitude: -97.34141,
                timezone: 'America/Chicago'
            },
            {
                id: 3926,
                city: 'Oakley',
                latitude: 39.12348,
                longitude: -100.84529,
                timezone: 'America/Chicago'
            },
            {
                id: 3927,
                city: 'Oberlin',
                latitude: 39.81834,
                longitude: -100.5282,
                timezone: 'America/Chicago'
            },
            {
                id: 3928,
                city: 'Offerle',
                latitude: 37.89085,
                longitude: -99.5579,
                timezone: 'America/Chicago'
            },
            {
                id: 3929,
                city: 'Ogden',
                latitude: 39.11111,
                longitude: -96.70612,
                timezone: 'America/Chicago'
            },
            {
                id: 3930,
                city: 'Oketo',
                latitude: 39.96361,
                longitude: -96.59974,
                timezone: 'America/Chicago'
            },
            {
                id: 3931,
                city: 'Olathe',
                latitude: 38.8814,
                longitude: -94.81913,
                timezone: 'America/Chicago'
            },
            {
                id: 3932,
                city: 'Olivet',
                latitude: 38.48057,
                longitude: -95.75165,
                timezone: 'America/Chicago'
            },
            {
                id: 3933,
                city: 'Olmitz',
                latitude: 38.51668,
                longitude: -98.93648,
                timezone: 'America/Chicago'
            },
            {
                id: 3934,
                city: 'Olpe',
                latitude: 38.26252,
                longitude: -96.16694,
                timezone: 'America/Chicago'
            },
            {
                id: 3935,
                city: 'Olsburg',
                latitude: 39.43055,
                longitude: -96.61556,
                timezone: 'America/Chicago'
            },
            {
                id: 3936,
                city: 'Onaga',
                latitude: 39.48888,
                longitude: -96.17,
                timezone: 'America/Chicago'
            },
            {
                id: 3937,
                city: 'Oneida',
                latitude: 39.86389,
                longitude: -95.93916,
                timezone: 'America/Chicago'
            },
            {
                id: 3938,
                city: 'Osage City',
                latitude: 38.6339,
                longitude: -95.82582,
                timezone: 'America/Chicago'
            },
            {
                id: 3939,
                city: 'Osawatomie',
                latitude: 38.49724,
                longitude: -94.95052,
                timezone: 'America/Chicago'
            },
            {
                id: 3940,
                city: 'Osborne',
                latitude: 39.4389,
                longitude: -98.69479,
                timezone: 'America/Chicago'
            },
            {
                id: 3941,
                city: 'Oskaloosa',
                latitude: 39.21528,
                longitude: -95.31275,
                timezone: 'America/Chicago'
            },
            {
                id: 3942,
                city: 'Oswego',
                latitude: 37.16764,
                longitude: -95.11205,
                timezone: 'America/Chicago'
            },
            {
                id: 3943,
                city: 'Otis',
                latitude: 38.53473,
                longitude: -99.05315,
                timezone: 'America/Chicago'
            },
            {
                id: 3944,
                city: 'Ottawa',
                latitude: 38.61557,
                longitude: -95.26775,
                timezone: 'America/Chicago'
            },
            {
                id: 3945,
                city: 'Overbrook',
                latitude: 38.78056,
                longitude: -95.5572,
                timezone: 'America/Chicago'
            },
            {
                id: 3946,
                city: 'Overland Park',
                latitude: 38.98223,
                longitude: -94.67079,
                timezone: 'America/Chicago'
            },
            {
                id: 3947,
                city: 'Oxford',
                latitude: 37.27419,
                longitude: -97.16893,
                timezone: 'America/Chicago'
            },
            {
                id: 3948,
                city: 'Ozawkie',
                latitude: 39.23333,
                longitude: -95.46692,
                timezone: 'America/Chicago'
            },
            {
                id: 3949,
                city: 'Palco',
                latitude: 39.25223,
                longitude: -99.56289,
                timezone: 'America/Chicago'
            },
            {
                id: 3950,
                city: 'Palmer',
                latitude: 39.63195,
                longitude: -97.1403,
                timezone: 'America/Chicago'
            },
            {
                id: 3951,
                city: 'Paola',
                latitude: 38.57224,
                longitude: -94.87913,
                timezone: 'America/Chicago'
            },
            {
                id: 3952,
                city: 'Paradise',
                latitude: 39.11362,
                longitude: -98.91842,
                timezone: 'America/Chicago'
            },
            {
                id: 3953,
                city: 'Park',
                latitude: 39.11251,
                longitude: -100.35875,
                timezone: 'America/Chicago'
            },
            {
                id: 3954,
                city: 'Park City',
                latitude: 37.80001,
                longitude: -97.31838,
                timezone: 'America/Chicago'
            },
            {
                id: 3955,
                city: 'Parker',
                latitude: 38.32835,
                longitude: -94.99191,
                timezone: 'America/Chicago'
            },
            {
                id: 3956,
                city: 'Parkerfield',
                latitude: 37.07503,
                longitude: -96.9992,
                timezone: 'America/Chicago'
            },
            {
                id: 3957,
                city: 'Parkerville',
                latitude: 38.76389,
                longitude: -96.6614,
                timezone: 'America/Chicago'
            },
            {
                id: 3958,
                city: 'Parsons',
                latitude: 37.34034,
                longitude: -95.26108,
                timezone: 'America/Chicago'
            },
            {
                id: 3959,
                city: 'Partridge',
                latitude: 37.96723,
                longitude: -98.09256,
                timezone: 'America/Chicago'
            },
            {
                id: 3960,
                city: 'Pawnee Rock',
                latitude: 38.26529,
                longitude: -98.98093,
                timezone: 'America/Chicago'
            },
            {
                id: 3961,
                city: 'Paxico',
                latitude: 39.06944,
                longitude: -96.16638,
                timezone: 'America/Chicago'
            },
            {
                id: 3962,
                city: 'Peabody',
                latitude: 38.16946,
                longitude: -97.1067,
                timezone: 'America/Chicago'
            },
            {
                id: 3963,
                city: 'Penalosa',
                latitude: 37.71668,
                longitude: -98.31979,
                timezone: 'America/Chicago'
            },
            {
                id: 3964,
                city: 'Perry',
                latitude: 39.07583,
                longitude: -95.39331,
                timezone: 'America/Chicago'
            },
            {
                id: 3965,
                city: 'Peru',
                latitude: 37.08867,
                longitude: -96.09471,
                timezone: 'America/Chicago'
            },
            {
                id: 3966,
                city: 'Phillipsburg',
                latitude: 39.75612,
                longitude: -99.32399,
                timezone: 'America/Chicago'
            },
            {
                id: 3967,
                city: 'Pittsburg',
                latitude: 37.41088,
                longitude: -94.70496,
                timezone: 'America/Chicago'
            },
            {
                id: 3968,
                city: 'Plains',
                latitude: 37.2603,
                longitude: -100.59265,
                timezone: 'America/Chicago'
            },
            {
                id: 3969,
                city: 'Plainville',
                latitude: 39.23473,
                longitude: -99.29816,
                timezone: 'America/Chicago'
            },
            {
                id: 3970,
                city: 'Pleasanton',
                latitude: 38.17781,
                longitude: -94.71135,
                timezone: 'America/Chicago'
            },
            {
                id: 3971,
                city: 'Plevna',
                latitude: 37.97224,
                longitude: -98.30868,
                timezone: 'America/Chicago'
            },
            {
                id: 3972,
                city: 'Pomona',
                latitude: 38.60834,
                longitude: -95.45165,
                timezone: 'America/Chicago'
            },
            {
                id: 3973,
                city: 'Portis',
                latitude: 39.56362,
                longitude: -98.69341,
                timezone: 'America/Chicago'
            },
            {
                id: 3974,
                city: 'Potwin',
                latitude: 37.93891,
                longitude: -97.01976,
                timezone: 'America/Chicago'
            },
            {
                id: 3975,
                city: 'Powhattan',
                latitude: 39.76167,
                longitude: -95.62998,
                timezone: 'America/Chicago'
            },
            {
                id: 3976,
                city: 'Prairie View',
                latitude: 39.83251,
                longitude: -99.57261,
                timezone: 'America/Chicago'
            },
            {
                id: 3977,
                city: 'Prairie Village',
                latitude: 38.99167,
                longitude: -94.63357,
                timezone: 'America/Chicago'
            },
            {
                id: 3978,
                city: 'Pratt',
                latitude: 37.64391,
                longitude: -98.73759,
                timezone: 'America/Chicago'
            },
            {
                id: 3979,
                city: 'Prescott',
                latitude: 38.06364,
                longitude: -94.69551,
                timezone: 'America/Chicago'
            },
            {
                id: 3980,
                city: 'Preston',
                latitude: 37.75891,
                longitude: -98.55314,
                timezone: 'America/Chicago'
            },
            {
                id: 3981,
                city: 'Pretty Prairie',
                latitude: 37.78001,
                longitude: -98.01978,
                timezone: 'America/Chicago'
            },
            {
                id: 3982,
                city: 'Princeton',
                latitude: 38.4889,
                longitude: -95.27525,
                timezone: 'America/Chicago'
            },
            {
                id: 3983,
                city: 'Protection',
                latitude: 37.20141,
                longitude: -99.48401,
                timezone: 'America/Chicago'
            },
            {
                id: 3984,
                city: 'Quenemo',
                latitude: 38.57973,
                longitude: -95.52693,
                timezone: 'America/Chicago'
            },
            {
                id: 3985,
                city: 'Quinter',
                latitude: 39.06945,
                longitude: -100.23236,
                timezone: 'America/Chicago'
            },
            {
                id: 3986,
                city: 'Radium',
                latitude: 38.17418,
                longitude: -98.89343,
                timezone: 'America/Chicago'
            },
            {
                id: 3987,
                city: 'Ramona',
                latitude: 38.59723,
                longitude: -97.06196,
                timezone: 'America/Chicago'
            },
            {
                id: 3988,
                city: 'Randall',
                latitude: 39.64251,
                longitude: -98.04477,
                timezone: 'America/Chicago'
            },
            {
                id: 3989,
                city: 'Randolph',
                latitude: 39.43055,
                longitude: -96.76001,
                timezone: 'America/Chicago'
            },
            {
                id: 3990,
                city: 'Ransom',
                latitude: 38.63613,
                longitude: -99.93373,
                timezone: 'America/Chicago'
            },
            {
                id: 3991,
                city: 'Rantoul',
                latitude: 38.54862,
                longitude: -95.10025,
                timezone: 'America/Chicago'
            },
            {
                id: 3992,
                city: 'Raymond',
                latitude: 38.27696,
                longitude: -98.4159,
                timezone: 'America/Chicago'
            },
            {
                id: 3993,
                city: 'Reading',
                latitude: 38.51946,
                longitude: -95.9586,
                timezone: 'America/Chicago'
            },
            {
                id: 3994,
                city: 'Redfield',
                latitude: 37.83671,
                longitude: -94.88108,
                timezone: 'America/Chicago'
            },
            {
                id: 3995,
                city: 'Republic',
                latitude: 39.92362,
                longitude: -97.82171,
                timezone: 'America/Chicago'
            },
            {
                id: 3996,
                city: 'Reserve',
                latitude: 39.97723,
                longitude: -95.56193,
                timezone: 'America/Chicago'
            },
            {
                id: 3997,
                city: 'Rexford',
                latitude: 39.47167,
                longitude: -100.74348,
                timezone: 'America/Chicago'
            },
            {
                id: 3998,
                city: 'Richfield',
                latitude: 37.26613,
                longitude: -101.78239,
                timezone: 'America/Chicago'
            },
            {
                id: 3999,
                city: 'Richmond',
                latitude: 38.4028,
                longitude: -95.25386,
                timezone: 'America/Chicago'
            },
            {
                id: 4000,
                city: 'Riley',
                latitude: 39.29889,
                longitude: -96.83084,
                timezone: 'America/Chicago'
            },
            {
                id: 4001,
                city: 'Robinson',
                latitude: 39.81667,
                longitude: -95.41053,
                timezone: 'America/Chicago'
            },
            {
                id: 4002,
                city: 'Roeland Park',
                latitude: 39.03751,
                longitude: -94.63218,
                timezone: 'America/Chicago'
            },
            {
                id: 4003,
                city: 'Rolla',
                latitude: 37.12003,
                longitude: -101.63211,
                timezone: 'America/Chicago'
            },
            {
                id: 4004,
                city: 'Rose Hill',
                latitude: 37.55835,
                longitude: -97.13504,
                timezone: 'America/Chicago'
            },
            {
                id: 4005,
                city: 'Roseland',
                latitude: 37.28117,
                longitude: -94.85052,
                timezone: 'America/Chicago'
            },
            {
                id: 4006,
                city: 'Rossville',
                latitude: 39.13611,
                longitude: -95.95166,
                timezone: 'America/Chicago'
            },
            {
                id: 4007,
                city: 'Rozel',
                latitude: 38.19585,
                longitude: -99.40317,
                timezone: 'America/Chicago'
            },
            {
                id: 4008,
                city: 'Rush Center',
                latitude: 38.46529,
                longitude: -99.31011,
                timezone: 'America/Chicago'
            },
            {
                id: 4009,
                city: 'Russell',
                latitude: 38.89529,
                longitude: -98.85981,
                timezone: 'America/Chicago'
            },
            {
                id: 4010,
                city: 'Russell Springs',
                latitude: 38.91334,
                longitude: -101.18155,
                timezone: 'America/Chicago'
            },
            {
                id: 4011,
                city: 'Sabetha',
                latitude: 39.91023,
                longitude: -95.79283,
                timezone: 'America/Chicago'
            },
            {
                id: 4012,
                city: 'Salina',
                latitude: 38.84028,
                longitude: -97.61142,
                timezone: 'America/Chicago'
            },
            {
                id: 4013,
                city: 'Satanta',
                latitude: 37.43725,
                longitude: -100.97211,
                timezone: 'America/Chicago'
            },
            {
                id: 4014,
                city: 'Savonburg',
                latitude: 37.74949,
                longitude: -95.14414,
                timezone: 'America/Chicago'
            },
            {
                id: 4015,
                city: 'Sawyer',
                latitude: 37.49724,
                longitude: -98.68231,
                timezone: 'America/Chicago'
            },
            {
                id: 4016,
                city: 'Scammon',
                latitude: 37.27756,
                longitude: -94.82496,
                timezone: 'America/Chicago'
            },
            {
                id: 4017,
                city: 'Scandia',
                latitude: 39.79445,
                longitude: -97.78365,
                timezone: 'America/Chicago'
            },
            {
                id: 4018,
                city: 'Schoenchen',
                latitude: 38.71335,
                longitude: -99.33233,
                timezone: 'America/Chicago'
            },
            {
                id: 4019,
                city: 'Scott City',
                latitude: 38.48252,
                longitude: -100.90709,
                timezone: 'America/Chicago'
            },
            {
                id: 4020,
                city: 'Scottsville',
                latitude: 39.54362,
                longitude: -97.9531,
                timezone: 'America/Chicago'
            },
            {
                id: 4021,
                city: 'Scranton',
                latitude: 38.78167,
                longitude: -95.7386,
                timezone: 'America/Chicago'
            },
            {
                id: 4022,
                city: 'Sedan',
                latitude: 37.12672,
                longitude: -96.18694,
                timezone: 'America/Chicago'
            },
            {
                id: 4023,
                city: 'Sedgwick',
                latitude: 37.91575,
                longitude: -97.42156,
                timezone: 'America/Chicago'
            },
            {
                id: 4024,
                city: 'Selden',
                latitude: 39.54084,
                longitude: -100.56764,
                timezone: 'America/Chicago'
            },
            {
                id: 4025,
                city: 'Seneca',
                latitude: 39.83417,
                longitude: -96.06417,
                timezone: 'America/Chicago'
            },
            {
                id: 4026,
                city: 'Severance',
                latitude: 39.76722,
                longitude: -95.24998,
                timezone: 'America/Chicago'
            },
            {
                id: 4027,
                city: 'Severy',
                latitude: 37.62225,
                longitude: -96.22805,
                timezone: 'America/Chicago'
            },
            {
                id: 4028,
                city: 'Seward',
                latitude: 38.17779,
                longitude: -98.79481,
                timezone: 'America/Chicago'
            },
            {
                id: 4029,
                city: 'Sharon',
                latitude: 37.24863,
                longitude: -98.42063,
                timezone: 'America/Chicago'
            },
            {
                id: 4030,
                city: 'Sharon Springs',
                latitude: 38.89779,
                longitude: -101.75212,
                timezone: 'America/Denver'
            },
            {
                id: 4031,
                city: 'Shawnee',
                latitude: 39.04167,
                longitude: -94.72024,
                timezone: 'America/Chicago'
            },
            {
                id: 4032,
                city: 'Silver Lake',
                latitude: 39.10417,
                longitude: -95.8586,
                timezone: 'America/Chicago'
            },
            {
                id: 4033,
                city: 'Simpson',
                latitude: 39.38604,
                longitude: -97.934,
                timezone: 'America/Chicago'
            },
            {
                id: 4034,
                city: 'Smith Center',
                latitude: 39.77918,
                longitude: -98.78507,
                timezone: 'America/Chicago'
            },
            {
                id: 4035,
                city: 'Smolan',
                latitude: 38.73862,
                longitude: -97.68448,
                timezone: 'America/Chicago'
            },
            {
                id: 4036,
                city: 'Soldier',
                latitude: 39.53611,
                longitude: -95.96416,
                timezone: 'America/Chicago'
            },
            {
                id: 4037,
                city: 'Solomon',
                latitude: 38.92146,
                longitude: -97.36924,
                timezone: 'America/Chicago'
            },
            {
                id: 4038,
                city: 'South Haven',
                latitude: 37.05197,
                longitude: -97.40532,
                timezone: 'America/Chicago'
            },
            {
                id: 4039,
                city: 'South Hutchinson',
                latitude: 38.02807,
                longitude: -97.94033,
                timezone: 'America/Chicago'
            },
            {
                id: 4040,
                city: 'Spearville',
                latitude: 37.85002,
                longitude: -99.75679,
                timezone: 'America/Chicago'
            },
            {
                id: 4041,
                city: 'Speed',
                latitude: 39.67723,
                longitude: -99.42093,
                timezone: 'America/Chicago'
            },
            {
                id: 4042,
                city: 'Spivey',
                latitude: 37.44585,
                longitude: -98.1634,
                timezone: 'America/Chicago'
            },
            {
                id: 4043,
                city: 'Spring Hill',
                latitude: 38.75668,
                longitude: -94.82098,
                timezone: 'America/Chicago'
            },
            {
                id: 4047,
                city: 'St. Francis',
                latitude: 39.77222,
                longitude: -101.7999,
                timezone: 'America/Chicago'
            },
            {
                id: 4048,
                city: 'St. George',
                latitude: 39.19111,
                longitude: -96.42028,
                timezone: 'America/Chicago'
            },
            {
                id: 4049,
                city: 'St. John',
                latitude: 38.00224,
                longitude: -98.76009,
                timezone: 'America/Chicago'
            },
            {
                id: 4050,
                city: 'St. Marys',
                latitude: 39.19417,
                longitude: -96.06417,
                timezone: 'America/Chicago'
            },
            {
                id: 4052,
                city: 'St. Paul',
                latitude: 37.51894,
                longitude: -95.17331,
                timezone: 'America/Chicago'
            },
            {
                id: 4044,
                city: 'Stafford',
                latitude: 37.96224,
                longitude: -98.60064,
                timezone: 'America/Chicago'
            },
            {
                id: 4045,
                city: 'Stark',
                latitude: 37.69005,
                longitude: -95.14303,
                timezone: 'America/Chicago'
            },
            {
                id: 4046,
                city: 'Sterling',
                latitude: 38.21001,
                longitude: -98.20701,
                timezone: 'America/Chicago'
            },
            {
                id: 4051,
                city: 'Stockton',
                latitude: 39.43807,
                longitude: -99.2651,
                timezone: 'America/Chicago'
            },
            {
                id: 4053,
                city: 'Strong City',
                latitude: 38.39724,
                longitude: -96.53695,
                timezone: 'America/Chicago'
            },
            {
                id: 4054,
                city: 'Sublette',
                latitude: 37.48169,
                longitude: -100.84377,
                timezone: 'America/Chicago'
            },
            {
                id: 4055,
                city: 'Summerfield',
                latitude: 39.99722,
                longitude: -96.35029,
                timezone: 'America/Chicago'
            },
            {
                id: 4056,
                city: 'Sun City',
                latitude: 37.37863,
                longitude: -98.91593,
                timezone: 'America/Chicago'
            },
            {
                id: 4057,
                city: 'Susank',
                latitude: 38.64084,
                longitude: -98.77397,
                timezone: 'America/Chicago'
            },
            {
                id: 4058,
                city: 'Sylvan Grove',
                latitude: 39.00945,
                longitude: -98.39423,
                timezone: 'America/Chicago'
            },
            {
                id: 4059,
                city: 'Sylvia',
                latitude: 37.95779,
                longitude: -98.40813,
                timezone: 'America/Chicago'
            },
            {
                id: 4060,
                city: 'Syracuse',
                latitude: 37.98057,
                longitude: -101.75267,
                timezone: 'America/Denver'
            },
            {
                id: 4061,
                city: 'Tampa',
                latitude: 38.54723,
                longitude: -97.15308,
                timezone: 'America/Chicago'
            },
            {
                id: 4062,
                city: 'Tescott',
                latitude: 39.00806,
                longitude: -97.8756,
                timezone: 'America/Chicago'
            },
            {
                id: 4063,
                city: 'Thayer',
                latitude: 37.49311,
                longitude: -95.47026,
                timezone: 'America/Chicago'
            },
            {
                id: 4064,
                city: 'The Highlands',
                latitude: 38.16228,
                longitude: -97.94661,
                timezone: 'America/Chicago'
            },
            {
                id: 4065,
                city: 'Timken',
                latitude: 38.47362,
                longitude: -99.17816,
                timezone: 'America/Chicago'
            },
            {
                id: 4066,
                city: 'Tipton',
                latitude: 39.34307,
                longitude: -98.4709,
                timezone: 'America/Chicago'
            },
            {
                id: 4067,
                city: 'Tonganoxie',
                latitude: 39.10972,
                longitude: -95.08775,
                timezone: 'America/Chicago'
            },
            {
                id: 4068,
                city: 'Topeka',
                latitude: 39.04833,
                longitude: -95.67804,
                timezone: 'America/Chicago'
            },
            {
                id: 4069,
                city: 'Toronto',
                latitude: 37.79893,
                longitude: -95.94916,
                timezone: 'America/Chicago'
            },
            {
                id: 4070,
                city: 'Towanda',
                latitude: 37.79752,
                longitude: -96.99976,
                timezone: 'America/Chicago'
            },
            {
                id: 4071,
                city: 'Tribune',
                latitude: 38.46974,
                longitude: -101.75267,
                timezone: 'America/Denver'
            },
            {
                id: 4072,
                city: 'Troy',
                latitude: 39.78305,
                longitude: -95.08997,
                timezone: 'America/Chicago'
            },
            {
                id: 4073,
                city: 'Turon',
                latitude: 37.80724,
                longitude: -98.42674,
                timezone: 'America/Chicago'
            },
            {
                id: 4074,
                city: 'Tyro',
                latitude: 37.03785,
                longitude: -95.82137,
                timezone: 'America/Chicago'
            },
            {
                id: 4075,
                city: 'Udall',
                latitude: 37.38752,
                longitude: -97.11421,
                timezone: 'America/Chicago'
            },
            {
                id: 4076,
                city: 'Ulysses',
                latitude: 37.58141,
                longitude: -101.35517,
                timezone: 'America/Chicago'
            },
            {
                id: 4077,
                city: 'Uniontown',
                latitude: 37.84726,
                longitude: -94.97525,
                timezone: 'America/Chicago'
            },
            {
                id: 4078,
                city: 'Utica',
                latitude: 38.6439,
                longitude: -100.16985,
                timezone: 'America/Chicago'
            },
            {
                id: 4079,
                city: 'Valley Center',
                latitude: 37.83473,
                longitude: -97.37338,
                timezone: 'America/Chicago'
            },
            {
                id: 4080,
                city: 'Valley Falls',
                latitude: 39.34333,
                longitude: -95.46025,
                timezone: 'America/Chicago'
            },
            {
                id: 4081,
                city: 'Vermillion',
                latitude: 39.71944,
                longitude: -96.26584,
                timezone: 'America/Chicago'
            },
            {
                id: 4082,
                city: 'Victoria',
                latitude: 38.85279,
                longitude: -99.1476,
                timezone: 'America/Chicago'
            },
            {
                id: 4083,
                city: 'Vining',
                latitude: 39.56732,
                longitude: -97.29361,
                timezone: 'America/Chicago'
            },
            {
                id: 4084,
                city: 'Viola',
                latitude: 37.48307,
                longitude: -97.64394,
                timezone: 'America/Chicago'
            },
            {
                id: 4085,
                city: 'Virgil',
                latitude: 37.98086,
                longitude: -96.01027,
                timezone: 'America/Chicago'
            },
            {
                id: 4086,
                city: 'WaKeeney',
                latitude: 39.02501,
                longitude: -99.87957,
                timezone: 'America/Chicago'
            },
            {
                id: 4087,
                city: 'Wakefield',
                latitude: 39.21333,
                longitude: -97.00557,
                timezone: 'America/Chicago'
            },
            {
                id: 4088,
                city: 'Waldo',
                latitude: 39.11834,
                longitude: -98.79814,
                timezone: 'America/Chicago'
            },
            {
                id: 4089,
                city: 'Waldron',
                latitude: 37.00225,
                longitude: -98.18257,
                timezone: 'America/Chicago'
            },
            {
                id: 4090,
                city: 'Wallace',
                latitude: 38.9114,
                longitude: -101.59156,
                timezone: 'America/Denver'
            },
            {
                id: 4091,
                city: 'Walnut',
                latitude: 37.60144,
                longitude: -95.07803,
                timezone: 'America/Chicago'
            },
            {
                id: 4092,
                city: 'Walton',
                latitude: 38.11779,
                longitude: -97.2567,
                timezone: 'America/Chicago'
            },
            {
                id: 4093,
                city: 'Wamego',
                latitude: 39.20526,
                longitude: -96.31013,
                timezone: 'America/Chicago'
            },
            {
                id: 4094,
                city: 'Washington',
                latitude: 39.81806,
                longitude: -97.05086,
                timezone: 'America/Chicago'
            },
            {
                id: 4095,
                city: 'Waterville',
                latitude: 39.69111,
                longitude: -96.74752,
                timezone: 'America/Chicago'
            },
            {
                id: 4096,
                city: 'Wathena',
                latitude: 39.75916,
                longitude: -94.94969,
                timezone: 'America/Chicago'
            },
            {
                id: 4097,
                city: 'Waverly',
                latitude: 38.39391,
                longitude: -95.60304,
                timezone: 'America/Chicago'
            },
            {
                id: 4098,
                city: 'Webber',
                latitude: 39.93501,
                longitude: -98.03504,
                timezone: 'America/Chicago'
            },
            {
                id: 4099,
                city: 'Weir',
                latitude: 37.31005,
                longitude: -94.7719,
                timezone: 'America/Chicago'
            },
            {
                id: 4100,
                city: 'Wellington',
                latitude: 37.2653,
                longitude: -97.37171,
                timezone: 'America/Chicago'
            },
            {
                id: 4101,
                city: 'Wellsville',
                latitude: 38.71834,
                longitude: -95.08164,
                timezone: 'America/Chicago'
            },
            {
                id: 4102,
                city: 'West Mineral',
                latitude: 37.28422,
                longitude: -94.92302,
                timezone: 'America/Chicago'
            },
            {
                id: 4103,
                city: 'Westmoreland',
                latitude: 39.39389,
                longitude: -96.41361,
                timezone: 'America/Chicago'
            },
            {
                id: 4104,
                city: 'Westphalia',
                latitude: 38.18197,
                longitude: -95.49026,
                timezone: 'America/Chicago'
            },
            {
                id: 4105,
                city: 'Westwood',
                latitude: 39.04056,
                longitude: -94.6169,
                timezone: 'America/Chicago'
            },
            {
                id: 4106,
                city: 'Westwood Hills',
                latitude: 39.03889,
                longitude: -94.60996,
                timezone: 'America/Chicago'
            },
            {
                id: 4107,
                city: 'Wetmore',
                latitude: 39.63333,
                longitude: -95.81138,
                timezone: 'America/Chicago'
            },
            {
                id: 4108,
                city: 'Wheaton',
                latitude: 39.50222,
                longitude: -96.32084,
                timezone: 'America/Chicago'
            },
            {
                id: 4109,
                city: 'White City',
                latitude: 38.79556,
                longitude: -96.73584,
                timezone: 'America/Chicago'
            },
            {
                id: 4110,
                city: 'White Cloud',
                latitude: 39.97639,
                longitude: -95.29692,
                timezone: 'America/Chicago'
            },
            {
                id: 4111,
                city: 'Whitewater',
                latitude: 37.96474,
                longitude: -97.14753,
                timezone: 'America/Chicago'
            },
            {
                id: 4112,
                city: 'Whiting',
                latitude: 39.58972,
                longitude: -95.61276,
                timezone: 'America/Chicago'
            },
            {
                id: 4113,
                city: 'Wichita',
                latitude: 37.69224,
                longitude: -97.33754,
                timezone: 'America/Chicago'
            },
            {
                id: 4114,
                city: 'Willard',
                latitude: 39.09406,
                longitude: -95.94292,
                timezone: 'America/Chicago'
            },
            {
                id: 4115,
                city: 'Williamsburg',
                latitude: 38.48057,
                longitude: -95.46692,
                timezone: 'America/Chicago'
            },
            {
                id: 4116,
                city: 'Willis',
                latitude: 39.725,
                longitude: -95.50581,
                timezone: 'America/Chicago'
            },
            {
                id: 4117,
                city: 'Willowbrook',
                latitude: 38.10196,
                longitude: -97.992,
                timezone: 'America/Chicago'
            },
            {
                id: 4118,
                city: 'Wilmore',
                latitude: 37.33586,
                longitude: -99.21011,
                timezone: 'America/Chicago'
            },
            {
                id: 4119,
                city: 'Wilsey',
                latitude: 38.63612,
                longitude: -96.67529,
                timezone: 'America/Chicago'
            },
            {
                id: 4120,
                city: 'Wilson',
                latitude: 38.82501,
                longitude: -98.47534,
                timezone: 'America/Chicago'
            },
            {
                id: 4121,
                city: 'Winchester',
                latitude: 39.32222,
                longitude: -95.26692,
                timezone: 'America/Chicago'
            },
            {
                id: 4122,
                city: 'Windom',
                latitude: 38.3839,
                longitude: -97.91005,
                timezone: 'America/Chicago'
            },
            {
                id: 4123,
                city: 'Winfield',
                latitude: 37.23975,
                longitude: -96.99559,
                timezone: 'America/Chicago'
            },
            {
                id: 4124,
                city: 'Winona',
                latitude: 39.06334,
                longitude: -101.24433,
                timezone: 'America/Chicago'
            },
            {
                id: 4125,
                city: 'Woodbine',
                latitude: 38.79612,
                longitude: -96.95862,
                timezone: 'America/Chicago'
            },
            {
                id: 4126,
                city: 'Woodston',
                latitude: 39.45529,
                longitude: -99.09565,
                timezone: 'America/Chicago'
            },
            {
                id: 4127,
                city: 'Yates Center',
                latitude: 37.88115,
                longitude: -95.73332,
                timezone: 'America/Chicago'
            },
            {
                id: 4128,
                city: 'Zenda',
                latitude: 37.44224,
                longitude: -98.28202,
                timezone: 'America/Chicago'
            },
            {
                id: 4129,
                city: 'Zurich',
                latitude: 39.23445,
                longitude: -99.43816,
                timezone: 'America/Chicago'
            }
        ]
    },
    {
      id: 34,
      country: 'US',
      stateCode: 'NY',
      stateName: 'New York',
      cities: [
          {
              id: 7363,
              city: 'Albany',
              latitude: 42.65258,
              longitude: -73.75623,
              timezone: 'America/New_York'
          },
          {
              id: 7364,
              city: 'Amsterdam',
              latitude: 42.93869,
              longitude: -74.18819,
              timezone: 'America/New_York'
          },
          {
              id: 7365,
              city: 'Auburn',
              latitude: 42.93173,
              longitude: -76.56605,
              timezone: 'America/New_York'
          },
          {
              id: 7366,
              city: 'Batavia',
              latitude: 42.99812,
              longitude: -78.18752,
              timezone: 'America/New_York'
          },
          {
              id: 7367,
              city: 'Beacon',
              latitude: 41.50482,
              longitude: -73.96958,
              timezone: 'America/New_York'
          },
          {
              id: 7368,
              city: 'Binghamton',
              latitude: 42.09869,
              longitude: -75.91797,
              timezone: 'America/New_York'
          },
          {
              id: 7369,
              city: 'Buffalo',
              latitude: 42.88645,
              longitude: -78.87837,
              timezone: 'America/New_York'
          },
          {
              id: 7370,
              city: 'Canandaigua',
              latitude: 42.87423,
              longitude: -77.28804,
              timezone: 'America/New_York'
          },
          {
              id: 7371,
              city: 'Cohoes',
              latitude: 42.77424,
              longitude: -73.70012,
              timezone: 'America/New_York'
          },
          {
              id: 7372,
              city: 'Corning',
              latitude: 42.14285,
              longitude: -77.05469,
              timezone: 'America/New_York'
          },
          {
              id: 7373,
              city: 'Cortland',
              latitude: 42.60118,
              longitude: -76.18048,
              timezone: 'America/New_York'
          },
          {
              id: 7374,
              city: 'Dunkirk',
              latitude: 42.4795,
              longitude: -79.33393,
              timezone: 'America/New_York'
          },
          {
              id: 7375,
              city: 'Elmira',
              latitude: 42.0898,
              longitude: -76.80773,
              timezone: 'America/New_York'
          },
          {
              id: 7376,
              city: 'Fulton',
              latitude: 43.32285,
              longitude: -76.41716,
              timezone: 'America/New_York'
          },
          {
              id: 7377,
              city: 'Geneva',
              latitude: 42.86349,
              longitude: -76.98272,
              timezone: 'America/New_York'
          },
          {
              id: 7378,
              city: 'Glen Cove',
              latitude: 40.86232,
              longitude: -73.63374,
              timezone: 'America/New_York'
          },
          {
              id: 7379,
              city: 'Glens Falls',
              latitude: 43.30952,
              longitude: -73.64401,
              timezone: 'America/New_York'
          },
          {
              id: 7380,
              city: 'Gloversville',
              latitude: 43.05285,
              longitude: -74.34375,
              timezone: 'America/New_York'
          },
          {
              id: 7381,
              city: 'Hornell',
              latitude: 42.32785,
              longitude: -77.6611,
              timezone: 'America/New_York'
          },
          {
              id: 7382,
              city: 'Hudson',
              latitude: 42.25286,
              longitude: -73.79096,
              timezone: 'America/New_York'
          },
          {
              id: 7383,
              city: 'Ithaca',
              latitude: 42.44063,
              longitude: -76.49661,
              timezone: 'America/New_York'
          },
          {
              id: 7384,
              city: 'Jamestown',
              latitude: 42.097,
              longitude: -79.23533,
              timezone: 'America/New_York'
          },
          {
              id: 7385,
              city: 'Johnstown',
              latitude: 43.00674,
              longitude: -74.36764,
              timezone: 'America/New_York'
          },
          {
              id: 7386,
              city: 'Kingston',
              latitude: 41.92704,
              longitude: -73.99736,
              timezone: 'America/New_York'
          },
          {
              id: 7387,
              city: 'Lackawanna',
              latitude: 42.82561,
              longitude: -78.82337,
              timezone: 'America/New_York'
          },
          {
              id: 7388,
              city: 'Little Falls',
              latitude: 43.0434,
              longitude: -74.8596,
              timezone: 'America/New_York'
          },
          {
              id: 7389,
              city: 'Lockport',
              latitude: 43.17061,
              longitude: -78.69031,
              timezone: 'America/New_York'
          },
          {
              id: 7390,
              city: 'Long Beach',
              latitude: 40.58844,
              longitude: -73.65791,
              timezone: 'America/New_York'
          },
          {
              id: 7391,
              city: 'Mechanicville',
              latitude: 42.90285,
              longitude: -73.68734,
              timezone: 'America/New_York'
          },
          {
              id: 7392,
              city: 'Middletown',
              latitude: 41.44593,
              longitude: -74.42293,
              timezone: 'America/New_York'
          },
          {
              id: 7393,
              city: 'Mount Vernon',
              latitude: 40.9126,
              longitude: -73.83708,
              timezone: 'America/New_York'
          },
          {
              id: 7395,
              city: 'New Rochelle',
              latitude: 40.91149,
              longitude: -73.78235,
              timezone: 'America/New_York'
          },
          {
              id: 7396,
              city: 'New York City',
              latitude: 40.66347,
              longitude: -73.9387,
              timezone: 'America/New_York'
          },
          {
              id: 7394,
              city: 'Newburgh',
              latitude: 41.50343,
              longitude: -74.01042,
              timezone: 'America/New_York'
          },
          {
              id: 7397,
              city: 'Niagara Falls',
              latitude: 43.0945,
              longitude: -79.05671,
              timezone: 'America/New_York'
          },
          {
              id: 7398,
              city: 'North Tonawanda',
              latitude: 43.03867,
              longitude: -78.8642,
              timezone: 'America/New_York'
          },
          {
              id: 7399,
              city: 'Norwich',
              latitude: 42.53118,
              longitude: -75.52351,
              timezone: 'America/New_York'
          },
          {
              id: 7400,
              city: 'Ogdensburg',
              latitude: 44.69423,
              longitude: -75.48634,
              timezone: 'America/New_York'
          },
          {
              id: 7401,
              city: 'Olean',
              latitude: 42.07757,
              longitude: -78.42974,
              timezone: 'America/New_York'
          },
          {
              id: 7402,
              city: 'Oneida',
              latitude: 43.09257,
              longitude: -75.65129,
              timezone: 'America/New_York'
          },
          {
              id: 7403,
              city: 'Oneonta',
              latitude: 42.45286,
              longitude: -75.06377,
              timezone: 'America/New_York'
          },
          {
              id: 7404,
              city: 'Oswego',
              latitude: 43.45535,
              longitude: -76.5105,
              timezone: 'America/New_York'
          },
          {
              id: 7405,
              city: 'Peekskill',
              latitude: 41.29009,
              longitude: -73.92042,
              timezone: 'America/New_York'
          },
          {
              id: 7406,
              city: 'Plattsburgh',
              latitude: 44.69949,
              longitude: -73.45291,
              timezone: 'America/New_York'
          },
          {
              id: 7407,
              city: 'Port Jervis',
              latitude: 41.37509,
              longitude: -74.69266,
              timezone: 'America/New_York'
          },
          {
              id: 7408,
              city: 'Poughkeepsie',
              latitude: 41.70037,
              longitude: -73.92097,
              timezone: 'America/New_York'
          },
          {
              id: 7409,
              city: 'Rensselaer',
              latitude: 42.64258,
              longitude: -73.7429,
              timezone: 'America/New_York'
          },
          {
              id: 7410,
              city: 'Rochester',
              latitude: 43.15478,
              longitude: -77.61556,
              timezone: 'America/New_York'
          },
          {
              id: 7411,
              city: 'Rome',
              latitude: 43.21285,
              longitude: -75.45573,
              timezone: 'America/New_York'
          },
          {
              id: 7412,
              city: 'Rye',
              latitude: 40.98065,
              longitude: -73.68374,
              timezone: 'America/New_York'
          },
          {
              id: 7413,
              city: 'Salamanca',
              latitude: 42.15784,
              longitude: -78.71503,
              timezone: 'America/New_York'
          },
          {
              id: 7414,
              city: 'Saratoga Springs',
              latitude: 43.08313,
              longitude: -73.78457,
              timezone: 'America/New_York'
          },
          {
              id: 7415,
              city: 'Schenectady',
              latitude: 42.81424,
              longitude: -73.93957,
              timezone: 'America/New_York'
          },
          {
              id: 7416,
              city: 'Sherrill',
              latitude: 43.07368,
              longitude: -75.59824,
              timezone: 'America/New_York'
          },
          {
              id: 7417,
              city: 'Syracuse',
              latitude: 43.04812,
              longitude: -76.14742,
              timezone: 'America/New_York'
          },
          {
              id: 7418,
              city: 'Tonawanda',
              latitude: 43.02033,
              longitude: -78.88032,
              timezone: 'America/New_York'
          },
          {
              id: 7419,
              city: 'Troy',
              latitude: 42.72841,
              longitude: -73.69179,
              timezone: 'America/New_York'
          },
          {
              id: 7420,
              city: 'Utica',
              latitude: 43.1009,
              longitude: -75.23266,
              timezone: 'America/New_York'
          },
          {
              id: 7421,
              city: 'Watertown',
              latitude: 43.97478,
              longitude: -75.91076,
              timezone: 'America/New_York'
          },
          {
              id: 7422,
              city: 'Watervliet',
              latitude: 42.73008,
              longitude: -73.70123,
              timezone: 'America/New_York'
          },
          {
              id: 7423,
              city: 'White Plains',
              latitude: 41.03399,
              longitude: -73.76291,
              timezone: 'America/New_York'
          },
          {
              id: 7424,
              city: 'Yonkers',
              latitude: 40.93121,
              longitude: -73.89875,
              timezone: 'America/New_York'
          }
      ]
    },
    {
      id: 43,
      country: 'US',
      stateCode: 'TX',
      stateName: 'Texas',
      cities: [
          {
              id: 8539,
              city: 'Abbott',
              latitude: 31.88488,
              longitude: -97.07334,
              timezone: 'America/Chicago'
          },
          {
              id: 8540,
              city: 'Abernathy',
              latitude: 33.8254,
              longitude: -101.85467,
              timezone: 'America/Chicago'
          },
          {
              id: 8541,
              city: 'Abilene',
              latitude: 32.45451,
              longitude: -99.73815,
              timezone: 'America/Chicago'
          },
          {
              id: 8542,
              city: 'Ackerly',
              latitude: 32.52506,
              longitude: -101.71585,
              timezone: 'America/Chicago'
          },
          {
              id: 8543,
              city: 'Adrian',
              latitude: 35.27478,
              longitude: -102.66521,
              timezone: 'America/Chicago'
          },
          {
              id: 8544,
              city: 'Agua Dulce',
              latitude: 27.78169,
              longitude: -97.90861,
              timezone: 'America/Chicago'
          },
          {
              id: 8545,
              city: 'Alamo',
              latitude: 26.18369,
              longitude: -98.12306,
              timezone: 'America/Chicago'
          },
          {
              id: 8546,
              city: 'Alamo Heights',
              latitude: 29.48495,
              longitude: -98.46585,
              timezone: 'America/Chicago'
          },
          {
              id: 8547,
              city: 'Albany',
              latitude: 32.72345,
              longitude: -99.2973,
              timezone: 'America/Chicago'
          },
          {
              id: 8548,
              city: 'Aledo',
              latitude: 32.69596,
              longitude: -97.60225,
              timezone: 'America/Chicago'
          },
          {
              id: 8549,
              city: 'Alice',
              latitude: 27.75225,
              longitude: -98.06972,
              timezone: 'America/Chicago'
          },
          {
              id: 8550,
              city: 'Allen',
              latitude: 33.10317,
              longitude: -96.67055,
              timezone: 'America/Chicago'
          },
          {
              id: 8551,
              city: 'Alpine',
              latitude: 30.35849,
              longitude: -103.66101,
              timezone: 'America/Chicago'
          },
          {
              id: 8552,
              city: 'Alton',
              latitude: 26.28729,
              longitude: -98.31335,
              timezone: 'America/Chicago'
          },
          {
              id: 8553,
              city: 'Alvarado',
              latitude: 32.40653,
              longitude: -97.21168,
              timezone: 'America/Chicago'
          },
          {
              id: 8554,
              city: 'Alvin',
              latitude: 29.42385,
              longitude: -95.2441,
              timezone: 'America/Chicago'
          },
          {
              id: 8555,
              city: 'Amarillo',
              latitude: 35.19892,
              longitude: -101.83165,
              timezone: 'America/Chicago'
          },
          {
              id: 8556,
              city: 'Ames',
              latitude: 30.05383,
              longitude: -94.74353,
              timezone: 'America/Chicago'
          },
          {
              id: 8557,
              city: 'Amherst',
              latitude: 34.01037,
              longitude: -102.41546,
              timezone: 'America/Chicago'
          },
          {
              id: 8558,
              city: 'Anahuac',
              latitude: 29.773,
              longitude: -94.6827,
              timezone: 'America/Chicago'
          },
          {
              id: 8559,
              city: 'Anderson',
              latitude: 30.48715,
              longitude: -95.9869,
              timezone: 'America/Chicago'
          },
          {
              id: 8560,
              city: 'Andrews',
              latitude: 32.31872,
              longitude: -102.54572,
              timezone: 'America/Chicago'
          },
          {
              id: 8561,
              city: 'Angleton',
              latitude: 29.16941,
              longitude: -95.43188,
              timezone: 'America/Chicago'
          },
          {
              id: 8562,
              city: 'Angus',
              latitude: 32.00627,
              longitude: -96.43304,
              timezone: 'America/Chicago'
          },
          {
              id: 8563,
              city: 'Anna',
              latitude: 33.349,
              longitude: -96.5486,
              timezone: 'America/Chicago'
          },
          {
              id: 8564,
              city: 'Anson',
              latitude: 32.7565,
              longitude: -99.89621,
              timezone: 'America/Chicago'
          },
          {
              id: 8565,
              city: 'Anton',
              latitude: 33.8112,
              longitude: -102.16379,
              timezone: 'America/Chicago'
          },
          {
              id: 8566,
              city: 'Appleby',
              latitude: 31.71629,
              longitude: -94.60493,
              timezone: 'America/Chicago'
          },
          {
              id: 8567,
              city: 'Aquilla',
              latitude: 31.85155,
              longitude: -97.21806,
              timezone: 'America/Chicago'
          },
          {
              id: 8568,
              city: 'Aransas Pass',
              latitude: 27.89021,
              longitude: -97.11847,
              timezone: 'America/Chicago'
          },
          {
              id: 8569,
              city: 'Archer City',
              latitude: 33.59566,
              longitude: -98.62561,
              timezone: 'America/Chicago'
          },
          {
              id: 8570,
              city: 'Arcola',
              latitude: 29.49607,
              longitude: -95.46578,
              timezone: 'America/Chicago'
          },
          {
              id: 8571,
              city: 'Argyle',
              latitude: 33.12123,
              longitude: -97.18335,
              timezone: 'America/Chicago'
          },
          {
              id: 8572,
              city: 'Arlington',
              latitude: 32.73569,
              longitude: -97.10807,
              timezone: 'America/Chicago'
          },
          {
              id: 8573,
              city: 'Arp',
              latitude: 32.22543,
              longitude: -95.05772,
              timezone: 'America/Chicago'
          },
          {
              id: 8574,
              city: 'Asherton',
              latitude: 28.44193,
              longitude: -99.76033,
              timezone: 'America/Chicago'
          },
          {
              id: 8575,
              city: 'Athens',
              latitude: 32.20487,
              longitude: -95.85552,
              timezone: 'America/Chicago'
          },
          {
              id: 8576,
              city: 'Atlanta',
              latitude: 33.11374,
              longitude: -94.16435,
              timezone: 'America/Chicago'
          },
          {
              id: 8577,
              city: 'Aubrey',
              latitude: 33.30428,
              longitude: -96.98612,
              timezone: 'America/Chicago'
          },
          {
              id: 8578,
              city: 'Aurora',
              latitude: 33.06068,
              longitude: -97.50336,
              timezone: 'America/Chicago'
          },
          {
              id: 8579,
              city: 'Austin',
              latitude: 30.30116,
              longitude: -97.7527,
              timezone: 'America/Chicago'
          },
          {
              id: 8580,
              city: 'Austwell',
              latitude: 28.39028,
              longitude: -96.84221,
              timezone: 'America/Chicago'
          },
          {
              id: 8581,
              city: 'Azle',
              latitude: 32.89555,
              longitude: -97.53923,
              timezone: 'America/Chicago'
          },
          {
              id: 8582,
              city: 'Bailey',
              latitude: 33.43205,
              longitude: -96.16581,
              timezone: 'America/Chicago'
          },
          {
              id: 8583,
              city: 'Baird',
              latitude: 32.39402,
              longitude: -99.39424,
              timezone: 'America/Chicago'
          },
          {
              id: 8584,
              city: 'Balch Springs',
              latitude: 32.72874,
              longitude: -96.62277,
              timezone: 'America/Chicago'
          },
          {
              id: 8585,
              city: 'Balcones Heights',
              latitude: 29.48801,
              longitude: -98.55169,
              timezone: 'America/Chicago'
          },
          {
              id: 8586,
              city: 'Ballinger',
              latitude: 31.73821,
              longitude: -99.94731,
              timezone: 'America/Chicago'
          },
          {
              id: 8587,
              city: 'Balmorhea',
              latitude: 30.98431,
              longitude: -103.74463,
              timezone: 'America/Chicago'
          },
          {
              id: 8588,
              city: 'Bandera',
              latitude: 29.72661,
              longitude: -99.07365,
              timezone: 'America/Chicago'
          },
          {
              id: 8589,
              city: 'Bangs',
              latitude: 31.7171,
              longitude: -99.13255,
              timezone: 'America/Chicago'
          },
          {
              id: 8590,
              city: 'Bardwell',
              latitude: 32.26904,
              longitude: -96.6961,
              timezone: 'America/Chicago'
          },
          {
              id: 8591,
              city: 'Barry',
              latitude: 32.09932,
              longitude: -96.6361,
              timezone: 'America/Chicago'
          },
          {
              id: 8592,
              city: 'Barstow',
              latitude: 31.46125,
              longitude: -103.39378,
              timezone: 'America/Chicago'
          },
          {
              id: 8593,
              city: 'Bartlett',
              latitude: 30.79485,
              longitude: -97.4323,
              timezone: 'America/Chicago'
          },
          {
              id: 8594,
              city: 'Bastrop',
              latitude: 30.11049,
              longitude: -97.31527,
              timezone: 'America/Chicago'
          },
          {
              id: 8595,
              city: 'Bay City',
              latitude: 28.98276,
              longitude: -95.9694,
              timezone: 'America/Chicago'
          },
          {
              id: 8596,
              city: 'Bayou Vista',
              latitude: 29.32635,
              longitude: -94.93853,
              timezone: 'America/Chicago'
          },
          {
              id: 8597,
              city: 'Baytown',
              latitude: 29.75955,
              longitude: -94.9681,
              timezone: 'America/Chicago'
          },
          {
              id: 8598,
              city: 'Beach City',
              latitude: 29.66217,
              longitude: -94.88992,
              timezone: 'America/Chicago'
          },
          {
              id: 8599,
              city: 'Beasley',
              latitude: 29.49746,
              longitude: -95.91801,
              timezone: 'America/Chicago'
          },
          {
              id: 8600,
              city: 'Beaumont',
              latitude: 30.08605,
              longitude: -94.10185,
              timezone: 'America/Chicago'
          },
          {
              id: 8601,
              city: 'Beckville',
              latitude: 32.24294,
              longitude: -94.45548,
              timezone: 'America/Chicago'
          },
          {
              id: 8602,
              city: 'Bedford',
              latitude: 32.84402,
              longitude: -97.14307,
              timezone: 'America/Chicago'
          },
          {
              id: 8603,
              city: 'Bedias',
              latitude: 30.77575,
              longitude: -95.9494,
              timezone: 'America/Chicago'
          },
          {
              id: 8604,
              city: 'Bee Cave',
              latitude: 30.30854,
              longitude: -97.94501,
              timezone: 'America/Chicago'
          },
          {
              id: 8605,
              city: 'Beeville',
              latitude: 28.40083,
              longitude: -97.74833,
              timezone: 'America/Chicago'
          },
          {
              id: 8606,
              city: 'Bellaire',
              latitude: 29.70579,
              longitude: -95.45883,
              timezone: 'America/Chicago'
          },
          {
              id: 8607,
              city: 'Bellevue',
              latitude: 33.63649,
              longitude: -98.01393,
              timezone: 'America/Chicago'
          },
          {
              id: 8608,
              city: 'Bellmead',
              latitude: 31.59405,
              longitude: -97.10889,
              timezone: 'America/Chicago'
          },
          {
              id: 8609,
              city: 'Bellville',
              latitude: 29.95023,
              longitude: -96.25719,
              timezone: 'America/Chicago'
          },
          {
              id: 8610,
              city: 'Belton',
              latitude: 31.05601,
              longitude: -97.46445,
              timezone: 'America/Chicago'
          },
          {
              id: 8611,
              city: 'Benavides',
              latitude: 27.59892,
              longitude: -98.40807,
              timezone: 'America/Chicago'
          },
          {
              id: 8612,
              city: 'Benbrook',
              latitude: 32.67319,
              longitude: -97.46058,
              timezone: 'America/Chicago'
          },
          {
              id: 8613,
              city: 'Benjamin',
              latitude: 33.58398,
              longitude: -99.79231,
              timezone: 'America/Chicago'
          },
          {
              id: 8614,
              city: 'Bertram',
              latitude: 30.7438,
              longitude: -98.05558,
              timezone: 'America/Chicago'
          },
          {
              id: 8615,
              city: 'Beverly Hills',
              latitude: 31.52156,
              longitude: -97.15389,
              timezone: 'America/Chicago'
          },
          {
              id: 8616,
              city: 'Bevil Oaks',
              latitude: 30.15021,
              longitude: -94.26963,
              timezone: 'America/Chicago'
          },
          {
              id: 8617,
              city: 'Big Lake',
              latitude: 31.19154,
              longitude: -101.46039,
              timezone: 'America/Chicago'
          },
          {
              id: 8618,
              city: 'Big Spring',
              latitude: 32.2504,
              longitude: -101.47874,
              timezone: 'America/Chicago'
          },
          {
              id: 8619,
              city: 'Big Wells',
              latitude: 28.57332,
              longitude: -99.56866,
              timezone: 'America/Chicago'
          },
          {
              id: 8620,
              city: 'Bishop',
              latitude: 27.58614,
              longitude: -97.79916,
              timezone: 'America/Chicago'
          },
          {
              id: 8621,
              city: 'Blackwell',
              latitude: 32.08505,
              longitude: -100.31936,
              timezone: 'America/Chicago'
          },
          {
              id: 8622,
              city: 'Blanco',
              latitude: 30.09799,
              longitude: -98.42141,
              timezone: 'America/Chicago'
          },
          {
              id: 8623,
              city: 'Blossom',
              latitude: 33.6615,
              longitude: -95.38579,
              timezone: 'America/Chicago'
          },
          {
              id: 8624,
              city: 'Blue Mound',
              latitude: 32.85652,
              longitude: -97.33891,
              timezone: 'America/Chicago'
          },
          {
              id: 8625,
              city: 'Blue Ridge',
              latitude: 33.29789,
              longitude: -96.40165,
              timezone: 'America/Chicago'
          },
          {
              id: 8626,
              city: 'Boerne',
              latitude: 29.79466,
              longitude: -98.73197,
              timezone: 'America/Chicago'
          },
          {
              id: 8627,
              city: 'Bogata',
              latitude: 33.47067,
              longitude: -95.21384,
              timezone: 'America/Chicago'
          },
          {
              id: 8628,
              city: 'Bonham',
              latitude: 33.57733,
              longitude: -96.17831,
              timezone: 'America/Chicago'
          },
          {
              id: 8629,
              city: 'Borger',
              latitude: 35.66782,
              longitude: -101.39739,
              timezone: 'America/Chicago'
          },
          {
              id: 8630,
              city: 'Bovina',
              latitude: 34.51368,
              longitude: -102.883,
              timezone: 'America/Chicago'
          },
          {
              id: 8631,
              city: 'Bowie',
              latitude: 33.559,
              longitude: -97.84865,
              timezone: 'America/Chicago'
          },
          {
              id: 8632,
              city: 'Brackettville',
              latitude: 29.31051,
              longitude: -100.41786,
              timezone: 'America/Chicago'
          },
          {
              id: 8633,
              city: 'Brady',
              latitude: 31.13517,
              longitude: -99.33506,
              timezone: 'America/Chicago'
          },
          {
              id: 8634,
              city: 'Brazoria',
              latitude: 29.04441,
              longitude: -95.56911,
              timezone: 'America/Chicago'
          },
          {
              id: 8635,
              city: 'Brazos Bend',
              latitude: 32.47728,
              longitude: -97.76294,
              timezone: 'America/Chicago'
          },
          {
              id: 8636,
              city: 'Brazos Country',
              latitude: 29.75384,
              longitude: -96.05051,
              timezone: 'America/Chicago'
          },
          {
              id: 8637,
              city: 'Breckenridge',
              latitude: 32.75568,
              longitude: -98.90229,
              timezone: 'America/Chicago'
          },
          {
              id: 8638,
              city: 'Bremond',
              latitude: 31.16518,
              longitude: -96.67692,
              timezone: 'America/Chicago'
          },
          {
              id: 8639,
              city: 'Brenham',
              latitude: 30.16688,
              longitude: -96.39774,
              timezone: 'America/Chicago'
          },
          {
              id: 8640,
              city: 'Briaroaks',
              latitude: 32.50347,
              longitude: -97.30502,
              timezone: 'America/Chicago'
          },
          {
              id: 8641,
              city: 'Bridge City',
              latitude: 30.02077,
              longitude: -93.84573,
              timezone: 'America/Chicago'
          },
          {
              id: 8642,
              city: 'Bridgeport',
              latitude: 33.21012,
              longitude: -97.75476,
              timezone: 'America/Chicago'
          },
          {
              id: 8643,
              city: 'Brookshire',
              latitude: 29.78606,
              longitude: -95.95107,
              timezone: 'America/Chicago'
          },
          {
              id: 8644,
              city: 'Brookside Village',
              latitude: 29.5869,
              longitude: -95.32522,
              timezone: 'America/Chicago'
          },
          {
              id: 8645,
              city: 'Browndell',
              latitude: 31.10908,
              longitude: -93.96297,
              timezone: 'America/Chicago'
          },
          {
              id: 8646,
              city: 'Brownfield',
              latitude: 33.1812,
              longitude: -102.27435,
              timezone: 'America/Chicago'
          },
          {
              id: 8647,
              city: 'Brownsboro',
              latitude: 32.30237,
              longitude: -95.61357,
              timezone: 'America/Chicago'
          },
          {
              id: 8648,
              city: 'Brownsville',
              latitude: 25.90175,
              longitude: -97.49748,
              timezone: 'America/Chicago'
          },
          {
              id: 8649,
              city: 'Brownwood',
              latitude: 31.70932,
              longitude: -98.99116,
              timezone: 'America/Chicago'
          },
          {
              id: 8650,
              city: 'Bruceville-Eddy',
              latitude: 31.30801,
              longitude: -97.25739,
              timezone: 'America/Chicago'
          },
          {
              id: 8651,
              city: 'Bryan',
              latitude: 30.67436,
              longitude: -96.36996,
              timezone: 'America/Chicago'
          },
          {
              id: 8652,
              city: 'Bryson',
              latitude: 33.16123,
              longitude: -98.38561,
              timezone: 'America/Chicago'
          },
          {
              id: 8653,
              city: 'Buda',
              latitude: 30.08521,
              longitude: -97.84028,
              timezone: 'America/Chicago'
          },
          {
              id: 8654,
              city: 'Buffalo',
              latitude: 31.46379,
              longitude: -96.05802,
              timezone: 'America/Chicago'
          },
          {
              id: 8655,
              city: 'Bulverde',
              latitude: 29.74383,
              longitude: -98.45307,
              timezone: 'America/Chicago'
          },
          {
              id: 8656,
              city: 'Bunker Hill Village',
              latitude: 29.76745,
              longitude: -95.52994,
              timezone: 'America/Chicago'
          },
          {
              id: 8657,
              city: 'Burkburnett',
              latitude: 34.09787,
              longitude: -98.57061,
              timezone: 'America/Chicago'
          },
          {
              id: 8658,
              city: 'Burke',
              latitude: 31.23185,
              longitude: -94.76854,
              timezone: 'America/Chicago'
          },
          {
              id: 8659,
              city: 'Burleson',
              latitude: 32.51645,
              longitude: -97.32737,
              timezone: 'America/Chicago'
          },
          {
              id: 8660,
              city: 'Burnet',
              latitude: 30.75824,
              longitude: -98.22836,
              timezone: 'America/Chicago'
          },
          {
              id: 8661,
              city: 'Burton',
              latitude: 30.18216,
              longitude: -96.59553,
              timezone: 'America/Chicago'
          },
          {
              id: 8662,
              city: 'Byers',
              latitude: 34.06815,
              longitude: -98.1906,
              timezone: 'America/Chicago'
          },
          {
              id: 8663,
              city: 'Cactus',
              latitude: 36.05226,
              longitude: -102.0024,
              timezone: 'America/Chicago'
          },
          {
              id: 8664,
              city: 'Caddo Mills',
              latitude: 33.06567,
              longitude: -96.22776,
              timezone: 'America/Chicago'
          },
          {
              id: 8665,
              city: 'Caldwell',
              latitude: 30.53132,
              longitude: -96.69303,
              timezone: 'America/Chicago'
          },
          {
              id: 8666,
              city: 'Callisburg',
              latitude: 33.69788,
              longitude: -97.0089,
              timezone: 'America/Chicago'
          },
          {
              id: 8667,
              city: 'Calvert',
              latitude: 30.97797,
              longitude: -96.67386,
              timezone: 'America/Chicago'
          },
          {
              id: 8668,
              city: 'Cameron',
              latitude: 30.85325,
              longitude: -96.97693,
              timezone: 'America/Chicago'
          },
          {
              id: 8670,
              city: 'Camp Wood',
              latitude: 29.66939,
              longitude: -100.01229,
              timezone: 'America/Chicago'
          },
          {
              id: 8669,
              city: 'Campbell',
              latitude: 33.14817,
              longitude: -95.95136,
              timezone: 'America/Chicago'
          },
          {
              id: 8671,
              city: 'Canadian',
              latitude: 35.91282,
              longitude: -100.38208,
              timezone: 'America/Chicago'
          },
          {
              id: 8672,
              city: 'Canton',
              latitude: 32.55652,
              longitude: -95.8633,
              timezone: 'America/Chicago'
          },
          {
              id: 8673,
              city: 'Canyon',
              latitude: 34.98033,
              longitude: -101.9188,
              timezone: 'America/Chicago'
          },
          {
              id: 8674,
              city: 'Carmine',
              latitude: 30.14938,
              longitude: -96.68609,
              timezone: 'America/Chicago'
          },
          {
              id: 8675,
              city: 'Carrizo Springs',
              latitude: 28.52193,
              longitude: -99.86061,
              timezone: 'America/Chicago'
          },
          {
              id: 8676,
              city: 'Carrollton',
              latitude: 32.98939,
              longitude: -96.89994,
              timezone: 'America/Chicago'
          },
          {
              id: 8677,
              city: 'Carthage',
              latitude: 32.15738,
              longitude: -94.33742,
              timezone: 'America/Chicago'
          },
          {
              id: 8678,
              city: 'Cashion Community',
              latitude: 34.03565,
              longitude: -98.50005,
              timezone: 'America/Chicago'
          },
          {
              id: 8679,
              city: 'Castle Hills',
              latitude: 29.52329,
              longitude: -98.51641,
              timezone: 'America/Chicago'
          },
          {
              id: 8680,
              city: 'Castroville',
              latitude: 29.35579,
              longitude: -98.87864,
              timezone: 'America/Chicago'
          },
          {
              id: 8681,
              city: 'Cedar Hill',
              latitude: 32.58433,
              longitude: -96.9589,
              timezone: 'America/Chicago'
          },
          {
              id: 8682,
              city: 'Cedar Park',
              latitude: 30.51024,
              longitude: -97.81981,
              timezone: 'America/Chicago'
          },
          {
              id: 8683,
              city: 'Celeste',
              latitude: 33.29428,
              longitude: -96.1947,
              timezone: 'America/Chicago'
          },
          {
              id: 8684,
              city: 'Celina',
              latitude: 33.31238,
              longitude: -96.79225,
              timezone: 'America/Chicago'
          },
          {
              id: 8685,
              city: 'Center',
              latitude: 31.79545,
              longitude: -94.17909,
              timezone: 'America/Chicago'
          },
          {
              id: 8686,
              city: 'Centerville',
              latitude: 31.25796,
              longitude: -95.97829,
              timezone: 'America/Chicago'
          },
          {
              id: 8687,
              city: 'Chandler',
              latitude: 32.30793,
              longitude: -95.47996,
              timezone: 'America/Chicago'
          },
          {
              id: 8688,
              city: 'Channing',
              latitude: 35.68365,
              longitude: -102.3302,
              timezone: 'America/Chicago'
          },
          {
              id: 8689,
              city: 'Charlotte',
              latitude: 28.86192,
              longitude: -98.70641,
              timezone: 'America/Chicago'
          },
          {
              id: 8690,
              city: 'Chico',
              latitude: 33.29595,
              longitude: -97.79892,
              timezone: 'America/Chicago'
          },
          {
              id: 8691,
              city: 'Childress',
              latitude: 34.42645,
              longitude: -100.204,
              timezone: 'America/Chicago'
          },
          {
              id: 8692,
              city: 'Chillicothe',
              latitude: 34.25647,
              longitude: -99.51676,
              timezone: 'America/Chicago'
          },
          {
              id: 8693,
              city: 'China',
              latitude: 30.04799,
              longitude: -94.33574,
              timezone: 'America/Chicago'
          },
          {
              id: 8694,
              city: 'Chireno',
              latitude: 31.49935,
              longitude: -94.35187,
              timezone: 'America/Chicago'
          },
          {
              id: 8695,
              city: 'Cibolo',
              latitude: 29.57014,
              longitude: -98.2178,
              timezone: 'America/Chicago'
          },
          {
              id: 8696,
              city: 'Cisco',
              latitude: 32.38819,
              longitude: -98.97923,
              timezone: 'America/Chicago'
          },
          {
              id: 8697,
              city: 'Clarendon',
              latitude: 34.93783,
              longitude: -100.8882,
              timezone: 'America/Chicago'
          },
          {
              id: 8698,
              city: 'Clarksville',
              latitude: 33.61066,
              longitude: -95.05272,
              timezone: 'America/Chicago'
          },
          {
              id: 8699,
              city: 'Clarksville City',
              latitude: 32.53496,
              longitude: -94.89355,
              timezone: 'America/Chicago'
          },
          {
              id: 8700,
              city: 'Claude',
              latitude: 35.11172,
              longitude: -101.36322,
              timezone: 'America/Chicago'
          },
          {
              id: 8701,
              city: 'Clear Lake Shores',
              latitude: 29.54745,
              longitude: -95.03215,
              timezone: 'America/Chicago'
          },
          {
              id: 8702,
              city: 'Cleburne',
              latitude: 32.34764,
              longitude: -97.38668,
              timezone: 'America/Chicago'
          },
          {
              id: 8703,
              city: 'Cleveland',
              latitude: 30.33702,
              longitude: -95.09329,
              timezone: 'America/Chicago'
          },
          {
              id: 8704,
              city: 'Clifton',
              latitude: 31.78238,
              longitude: -97.57669,
              timezone: 'America/Chicago'
          },
          {
              id: 8705,
              city: 'Clute',
              latitude: 29.02469,
              longitude: -95.39883,
              timezone: 'America/Chicago'
          },
          {
              id: 8706,
              city: 'Clyde',
              latitude: 32.40596,
              longitude: -99.49369,
              timezone: 'America/Chicago'
          },
          {
              id: 8707,
              city: 'Cockrell Hill',
              latitude: 32.73624,
              longitude: -96.88695,
              timezone: 'America/Chicago'
          },
          {
              id: 8708,
              city: 'Coldspring',
              latitude: 30.59242,
              longitude: -95.12938,
              timezone: 'America/Chicago'
          },
          {
              id: 8709,
              city: 'Coleman',
              latitude: 31.82737,
              longitude: -99.42645,
              timezone: 'America/Chicago'
          },
          {
              id: 8710,
              city: 'College Station',
              latitude: 30.62798,
              longitude: -96.33441,
              timezone: 'America/Chicago'
          },
          {
              id: 8711,
              city: 'Colleyville',
              latitude: 32.88096,
              longitude: -97.15501,
              timezone: 'America/Chicago'
          },
          {
              id: 8712,
              city: 'Colmesneil',
              latitude: 30.90798,
              longitude: -94.42214,
              timezone: 'America/Chicago'
          },
          {
              id: 8713,
              city: 'Colorado City',
              latitude: 32.38817,
              longitude: -100.86456,
              timezone: 'America/Chicago'
          },
          {
              id: 8714,
              city: 'Columbus',
              latitude: 29.70662,
              longitude: -96.53969,
              timezone: 'America/Chicago'
          },
          {
              id: 8715,
              city: 'Comanche',
              latitude: 31.89737,
              longitude: -98.60366,
              timezone: 'America/Chicago'
          },
          {
              id: 8716,
              city: 'Combine',
              latitude: 32.59008,
              longitude: -96.51716,
              timezone: 'America/Chicago'
          },
          {
              id: 8717,
              city: 'Commerce',
              latitude: 33.24706,
              longitude: -95.89997,
              timezone: 'America/Chicago'
          },
          {
              id: 8718,
              city: 'Conroe',
              latitude: 30.31188,
              longitude: -95.45605,
              timezone: 'America/Chicago'
          },
          {
              id: 8719,
              city: 'Converse',
              latitude: 29.51801,
              longitude: -98.31612,
              timezone: 'America/Chicago'
          },
          {
              id: 8720,
              city: 'Cool',
              latitude: 32.80013,
              longitude: -98.00115,
              timezone: 'America/Chicago'
          },
          {
              id: 8721,
              city: 'Cooper',
              latitude: 33.37344,
              longitude: -95.68829,
              timezone: 'America/Chicago'
          },
          {
              id: 8722,
              city: 'Coppell',
              latitude: 32.96331,
              longitude: -96.99056,
              timezone: 'America/Chicago'
          },
          {
              id: 8723,
              city: 'Copperas Cove',
              latitude: 31.11957,
              longitude: -97.9144,
              timezone: 'America/Chicago'
          },
          {
              id: 8724,
              city: 'Corinth',
              latitude: 33.15401,
              longitude: -97.06473,
              timezone: 'America/Chicago'
          },
          {
              id: 8725,
              city: 'Corpus Christi',
              latitude: 27.75425,
              longitude: -97.17339,
              timezone: 'America/Chicago'
          },
          {
              id: 8726,
              city: 'Corsicana',
              latitude: 32.09543,
              longitude: -96.46887,
              timezone: 'America/Chicago'
          },
          {
              id: 8727,
              city: 'Cottonwood',
              latitude: 32.46792,
              longitude: -96.38915,
              timezone: 'America/Chicago'
          },
          {
              id: 8728,
              city: 'Cottonwood Shores',
              latitude: 30.55575,
              longitude: -98.32391,
              timezone: 'America/Chicago'
          },
          {
              id: 8729,
              city: 'Cotulla',
              latitude: 28.43693,
              longitude: -99.23503,
              timezone: 'America/Chicago'
          },
          {
              id: 8730,
              city: 'Coupland',
              latitude: 30.45993,
              longitude: -97.38861,
              timezone: 'America/Chicago'
          },
          {
              id: 8731,
              city: 'Cove',
              latitude: 29.82744,
              longitude: -94.80242,
              timezone: 'America/Chicago'
          },
          {
              id: 8732,
              city: 'Covington',
              latitude: 32.17848,
              longitude: -97.25807,
              timezone: 'America/Chicago'
          },
          {
              id: 8733,
              city: 'Coyote Flats',
              latitude: 32.35561,
              longitude: -97.29204,
              timezone: 'America/Chicago'
          },
          {
              id: 8734,
              city: 'Crandall',
              latitude: 32.62791,
              longitude: -96.45582,
              timezone: 'America/Chicago'
          },
          {
              id: 8735,
              city: 'Crane',
              latitude: 31.39736,
              longitude: -102.35014,
              timezone: 'America/Chicago'
          },
          {
              id: 8736,
              city: 'Cranfills Gap',
              latitude: 31.77377,
              longitude: -97.82586,
              timezone: 'America/Chicago'
          },
          {
              id: 8737,
              city: 'Creedmoor',
              latitude: 30.08994,
              longitude: -97.73389,
              timezone: 'America/Chicago'
          },
          {
              id: 8738,
              city: 'Cresson',
              latitude: 32.52986,
              longitude: -97.61535,
              timezone: 'America/Chicago'
          },
          {
              id: 8739,
              city: 'Crockett',
              latitude: 31.31824,
              longitude: -95.45661,
              timezone: 'America/Chicago'
          },
          {
              id: 8740,
              city: 'Crosbyton',
              latitude: 33.66008,
              longitude: -101.23793,
              timezone: 'America/Chicago'
          },
          {
              id: 8741,
              city: 'Crowell',
              latitude: 33.98397,
              longitude: -99.72482,
              timezone: 'America/Chicago'
          },
          {
              id: 8742,
              city: 'Crowley',
              latitude: 32.57647,
              longitude: -97.35931,
              timezone: 'America/Chicago'
          },
          {
              id: 8743,
              city: 'Crystal City',
              latitude: 28.67748,
              longitude: -99.82811,
              timezone: 'America/Chicago'
          },
          {
              id: 8744,
              city: 'Cuero',
              latitude: 29.09387,
              longitude: -97.28916,
              timezone: 'America/Chicago'
          },
          {
              id: 8745,
              city: 'Cumby',
              latitude: 33.13734,
              longitude: -95.83941,
              timezone: 'America/Chicago'
          },
          {
              id: 8746,
              city: 'Cushing',
              latitude: 31.81462,
              longitude: -94.84049,
              timezone: 'America/Chicago'
          },
          {
              id: 8747,
              city: 'Cut and Shoot',
              latitude: 30.33327,
              longitude: -95.35799,
              timezone: 'America/Chicago'
          },
          {
              id: 8748,
              city: 'Daingerfield',
              latitude: 33.03179,
              longitude: -94.72187,
              timezone: 'America/Chicago'
          },
          {
              id: 8749,
              city: 'Daisetta',
              latitude: 30.11327,
              longitude: -94.64298,
              timezone: 'America/Chicago'
          },
          {
              id: 8750,
              city: 'Dalhart',
              latitude: 36.05742,
              longitude: -102.51221,
              timezone: 'America/Chicago'
          },
          {
              id: 8751,
              city: 'Dallas',
              latitude: 32.79333,
              longitude: -96.76651,
              timezone: 'America/Chicago'
          },
          {
              id: 8752,
              city: 'Dalworthington Gardens',
              latitude: 32.70291,
              longitude: -97.15529,
              timezone: 'America/Chicago'
          },
          {
              id: 8753,
              city: 'Danbury',
              latitude: 29.2283,
              longitude: -95.34494,
              timezone: 'America/Chicago'
          },
          {
              id: 8754,
              city: 'Dayton',
              latitude: 30.04661,
              longitude: -94.8852,
              timezone: 'America/Chicago'
          },
          {
              id: 8755,
              city: 'Dayton Lakes',
              latitude: 30.14466,
              longitude: -94.82215,
              timezone: 'America/Chicago'
          },
          {
              id: 8760,
              city: 'De Kalb',
              latitude: 33.50873,
              longitude: -94.61632,
              timezone: 'America/Chicago'
          },
          {
              id: 8761,
              city: 'De Leon',
              latitude: 32.11097,
              longitude: -98.53588,
              timezone: 'America/Chicago'
          },
          {
              id: 8756,
              city: 'Dean',
              latitude: 33.95037,
              longitude: -98.34616,
              timezone: 'America/Chicago'
          },
          {
              id: 8757,
              city: 'Decatur',
              latitude: 33.23428,
              longitude: -97.58614,
              timezone: 'America/Chicago'
          },
          {
              id: 8758,
              city: 'DeCordova',
              latitude: 32.42986,
              longitude: -97.69503,
              timezone: 'America/Chicago'
          },
          {
              id: 8759,
              city: 'Deer Park',
              latitude: 29.70523,
              longitude: -95.12382,
              timezone: 'America/Chicago'
          },
          {
              id: 8763,
              city: 'Del Rio',
              latitude: 29.36273,
              longitude: -100.89676,
              timezone: 'America/Chicago'
          },
          {
              id: 8762,
              city: 'Dell City',
              latitude: 31.93872,
              longitude: -105.20135,
              timezone: 'America/Denver'
          },
          {
              id: 8764,
              city: 'Denison',
              latitude: 33.75566,
              longitude: -96.53666,
              timezone: 'America/Chicago'
          },
          {
              id: 8765,
              city: 'Denton',
              latitude: 33.21484,
              longitude: -97.13307,
              timezone: 'America/Chicago'
          },
          {
              id: 8766,
              city: 'Deport',
              latitude: 33.52915,
              longitude: -95.31742,
              timezone: 'America/Chicago'
          },
          {
              id: 8767,
              city: 'DeSoto',
              latitude: 32.58986,
              longitude: -96.85695,
              timezone: 'America/Chicago'
          },
          {
              id: 8768,
              city: 'Devers',
              latitude: 30.02744,
              longitude: -94.59158,
              timezone: 'America/Chicago'
          },
          {
              id: 8769,
              city: 'Devine',
              latitude: 29.13996,
              longitude: -98.90531,
              timezone: 'America/Chicago'
          },
          {
              id: 8770,
              city: 'Diboll',
              latitude: 31.18713,
              longitude: -94.78104,
              timezone: 'America/Chicago'
          },
          {
              id: 8771,
              city: 'Dickens',
              latitude: 33.62175,
              longitude: -100.83652,
              timezone: 'America/Chicago'
          },
          {
              id: 8772,
              city: 'Dickinson',
              latitude: 29.46079,
              longitude: -95.05132,
              timezone: 'America/Chicago'
          },
          {
              id: 8773,
              city: 'Dilley',
              latitude: 28.66748,
              longitude: -99.17059,
              timezone: 'America/Chicago'
          },
          {
              id: 8774,
              city: 'Dimmitt',
              latitude: 34.5509,
              longitude: -102.31186,
              timezone: 'America/Chicago'
          },
          {
              id: 8775,
              city: 'Donna',
              latitude: 26.17035,
              longitude: -98.05195,
              timezone: 'America/Chicago'
          },
          {
              id: 8776,
              city: 'Dorchester',
              latitude: 33.53039,
              longitude: -96.68944,
              timezone: 'America/Chicago'
          },
          {
              id: 8777,
              city: 'Dripping Springs',
              latitude: 30.19021,
              longitude: -98.08668,
              timezone: 'America/Chicago'
          },
          {
              id: 8778,
              city: 'Driscoll',
              latitude: 27.67447,
              longitude: -97.74861,
              timezone: 'America/Chicago'
          },
          {
              id: 8779,
              city: 'Dublin',
              latitude: 32.08514,
              longitude: -98.34199,
              timezone: 'America/Chicago'
          },
          {
              id: 8780,
              city: 'Dumas',
              latitude: 35.86559,
              longitude: -101.97324,
              timezone: 'America/Chicago'
          },
          {
              id: 8781,
              city: 'Duncanville',
              latitude: 32.6518,
              longitude: -96.90834,
              timezone: 'America/Chicago'
          },
          {
              id: 8782,
              city: 'Eagle Lake',
              latitude: 29.58968,
              longitude: -96.33358,
              timezone: 'America/Chicago'
          },
          {
              id: 8783,
              city: 'Eagle Pass',
              latitude: 28.70914,
              longitude: -100.49952,
              timezone: 'America/Chicago'
          },
          {
              id: 8784,
              city: 'Early',
              latitude: 31.7421,
              longitude: -98.94561,
              timezone: 'America/Chicago'
          },
          {
              id: 8785,
              city: 'Earth',
              latitude: 34.23314,
              longitude: -102.41075,
              timezone: 'America/Chicago'
          },
          {
              id: 8786,
              city: 'East Bernard',
              latitude: 29.53107,
              longitude: -96.07107,
              timezone: 'America/Chicago'
          },
          {
              id: 8788,
              city: 'East Mountain',
              latitude: 32.58583,
              longitude: -94.85798,
              timezone: 'America/Chicago'
          },
          {
              id: 8790,
              city: 'East Tawakoni',
              latitude: 32.88429,
              longitude: -95.92913,
              timezone: 'America/Chicago'
          },
          {
              id: 8787,
              city: 'Eastland',
              latitude: 32.40152,
              longitude: -98.81756,
              timezone: 'America/Chicago'
          },
          {
              id: 8789,
              city: 'Easton',
              latitude: 32.38193,
              longitude: -94.59124,
              timezone: 'America/Chicago'
          },
          {
              id: 8791,
              city: 'Ector',
              latitude: 33.57733,
              longitude: -96.27331,
              timezone: 'America/Chicago'
          },
          {
              id: 8792,
              city: 'Edcouch',
              latitude: 26.29396,
              longitude: -97.96056,
              timezone: 'America/Chicago'
          },
          {
              id: 8793,
              city: 'Eden',
              latitude: 31.21628,
              longitude: -99.84563,
              timezone: 'America/Chicago'
          },
          {
              id: 8794,
              city: 'Edinburg',
              latitude: 26.30174,
              longitude: -98.16334,
              timezone: 'America/Chicago'
          },
          {
              id: 8795,
              city: 'Edna',
              latitude: 28.97859,
              longitude: -96.64609,
              timezone: 'America/Chicago'
          },
          {
              id: 8796,
              city: 'Edom',
              latitude: 32.37237,
              longitude: -95.60885,
              timezone: 'America/Chicago'
          },
          {
              id: 8797,
              city: 'El Campo',
              latitude: 29.19664,
              longitude: -96.26969,
              timezone: 'America/Chicago'
          },
          {
              id: 8798,
              city: 'El Cenizo',
              latitude: 27.35224,
              longitude: -99.49254,
              timezone: 'America/Chicago'
          },
          {
              id: 8802,
              city: 'El Lago',
              latitude: 29.56356,
              longitude: -95.04521,
              timezone: 'America/Chicago'
          },
          {
              id: 8804,
              city: 'El Paso',
              latitude: 31.75872,
              longitude: -106.48693,
              timezone: 'America/Denver'
          },
          {
              id: 8799,
              city: 'Eldorado',
              latitude: 30.86017,
              longitude: -100.60093,
              timezone: 'America/Chicago'
          },
          {
              id: 8800,
              city: 'Electra',
              latitude: 34.02926,
              longitude: -98.91896,
              timezone: 'America/Chicago'
          },
          {
              id: 8801,
              city: 'Elgin',
              latitude: 30.35193,
              longitude: -97.38783,
              timezone: 'America/Chicago'
          },
          {
              id: 8803,
              city: 'Elmendorf',
              latitude: 29.25333,
              longitude: -98.32303,
              timezone: 'America/Chicago'
          },
          {
              id: 8805,
              city: 'Elsa',
              latitude: 26.2934,
              longitude: -97.99306,
              timezone: 'America/Chicago'
          },
          {
              id: 8806,
              city: 'Emory',
              latitude: 32.87457,
              longitude: -95.76552,
              timezone: 'America/Chicago'
          },
          {
              id: 8807,
              city: 'Encinal',
              latitude: 28.04112,
              longitude: -99.35448,
              timezone: 'America/Chicago'
          },
          {
              id: 8808,
              city: 'Ennis',
              latitude: 32.32931,
              longitude: -96.62527,
              timezone: 'America/Chicago'
          },
          {
              id: 8809,
              city: 'Escobares',
              latitude: 26.41062,
              longitude: -98.96253,
              timezone: 'America/Chicago'
          },
          {
              id: 8810,
              city: 'Euless',
              latitude: 32.83707,
              longitude: -97.08195,
              timezone: 'America/Chicago'
          },
          {
              id: 8811,
              city: 'Eureka',
              latitude: 32.01266,
              longitude: -96.29581,
              timezone: 'America/Chicago'
          },
          {
              id: 8812,
              city: 'Eustace',
              latitude: 32.30709,
              longitude: -96.00664,
              timezone: 'America/Chicago'
          },
          {
              id: 8813,
              city: 'Everman',
              latitude: 32.63097,
              longitude: -97.28918,
              timezone: 'America/Chicago'
          },
          {
              id: 8815,
              city: 'Fair Oaks Ranch',
              latitude: 29.74608,
              longitude: -98.63811,
              timezone: 'America/Chicago'
          },
          {
              id: 8814,
              city: 'Fairfield',
              latitude: 31.72461,
              longitude: -96.16525,
              timezone: 'America/Chicago'
          },
          {
              id: 8816,
              city: 'Falfurrias',
              latitude: 27.22699,
              longitude: -98.14417,
              timezone: 'America/Chicago'
          },
          {
              id: 8817,
              city: 'Falls City',
              latitude: 28.98275,
              longitude: -98.0175,
              timezone: 'America/Chicago'
          },
          {
              id: 8818,
              city: 'Farmers Branch',
              latitude: 32.92651,
              longitude: -96.89612,
              timezone: 'America/Chicago'
          },
          {
              id: 8819,
              city: 'Farmersville',
              latitude: 33.16345,
              longitude: -96.35998,
              timezone: 'America/Chicago'
          },
          {
              id: 8820,
              city: 'Farwell',
              latitude: 34.38341,
              longitude: -103.038,
              timezone: 'America/Chicago'
          },
          {
              id: 8821,
              city: 'Fate',
              latitude: 32.94151,
              longitude: -96.38137,
              timezone: 'America/Chicago'
          },
          {
              id: 8822,
              city: 'Fayetteville',
              latitude: 29.90578,
              longitude: -96.67275,
              timezone: 'America/Chicago'
          },
          {
              id: 8823,
              city: 'Ferris',
              latitude: 32.53672,
              longitude: -96.67554,
              timezone: 'America/Chicago'
          },
          {
              id: 8824,
              city: 'Florence',
              latitude: 30.8413,
              longitude: -97.79363,
              timezone: 'America/Chicago'
          },
          {
              id: 8825,
              city: 'Floresville',
              latitude: 29.13358,
              longitude: -98.15612,
              timezone: 'America/Chicago'
          },
          {
              id: 8826,
              city: 'Floydada',
              latitude: 33.98452,
              longitude: -101.33766,
              timezone: 'America/Chicago'
          },
          {
              id: 8827,
              city: 'Follett',
              latitude: 36.43392,
              longitude: -100.14152,
              timezone: 'America/Chicago'
          },
          {
              id: 8828,
              city: 'Forest Hill',
              latitude: 32.67208,
              longitude: -97.26918,
              timezone: 'America/Chicago'
          },
          {
              id: 8829,
              city: 'Forney',
              latitude: 32.74818,
              longitude: -96.47193,
              timezone: 'America/Chicago'
          },
          {
              id: 8830,
              city: 'Forsan',
              latitude: 32.10985,
              longitude: -101.36623,
              timezone: 'America/Chicago'
          },
          {
              id: 8831,
              city: 'Fort Stockton',
              latitude: 30.89404,
              longitude: -102.87932,
              timezone: 'America/Chicago'
          },
          {
              id: 8832,
              city: 'Fort Worth',
              latitude: 32.78152,
              longitude: -97.34675,
              timezone: 'America/Chicago'
          },
          {
              id: 8833,
              city: 'Franklin',
              latitude: 31.02602,
              longitude: -96.48524,
              timezone: 'America/Chicago'
          },
          {
              id: 8834,
              city: 'Fredericksburg',
              latitude: 30.2752,
              longitude: -98.87198,
              timezone: 'America/Chicago'
          },
          {
              id: 8835,
              city: 'Freeport',
              latitude: 28.95414,
              longitude: -95.35966,
              timezone: 'America/Chicago'
          },
          {
              id: 8836,
              city: 'Freer',
              latitude: 27.8828,
              longitude: -98.61779,
              timezone: 'America/Chicago'
          },
          {
              id: 8837,
              city: 'Friendswood',
              latitude: 29.51008,
              longitude: -95.19613,
              timezone: 'America/Chicago'
          },
          {
              id: 8838,
              city: 'Friona',
              latitude: 34.64173,
              longitude: -102.7241,
              timezone: 'America/Chicago'
          },
          {
              id: 8839,
              city: 'Frisco',
              latitude: 33.15543,
              longitude: -96.8226,
              timezone: 'America/Chicago'
          },
          {
              id: 8840,
              city: 'Fritch',
              latitude: 35.64307,
              longitude: -101.59643,
              timezone: 'America/Chicago'
          },
          {
              id: 8841,
              city: 'Frost',
              latitude: 32.08015,
              longitude: -96.80666,
              timezone: 'America/Chicago'
          },
          {
              id: 8842,
              city: 'Fruitvale',
              latitude: 32.68319,
              longitude: -95.8033,
              timezone: 'America/Chicago'
          },
          {
              id: 8843,
              city: 'Fulshear',
              latitude: 29.68996,
              longitude: -95.89968,
              timezone: 'America/Chicago'
          },
          {
              id: 8844,
              city: 'Gainesville',
              latitude: 33.62594,
              longitude: -97.13335,
              timezone: 'America/Chicago'
          },
          {
              id: 8845,
              city: 'Galena Park',
              latitude: 29.73356,
              longitude: -95.23021,
              timezone: 'America/Chicago'
          },
          {
              id: 8846,
              city: 'Gallatin',
              latitude: 31.891,
              longitude: -95.1455,
              timezone: 'America/Chicago'
          },
          {
              id: 8847,
              city: 'Galveston',
              latitude: 29.30139,
              longitude: -94.79778,
              timezone: 'America/Chicago'
          },
          {
              id: 8848,
              city: 'Ganado',
              latitude: 29.04054,
              longitude: -96.51358,
              timezone: 'America/Chicago'
          },
          {
              id: 8849,
              city: 'Garden Ridge',
              latitude: 29.63467,
              longitude: -98.30529,
              timezone: 'America/Chicago'
          },
          {
              id: 8850,
              city: 'Garland',
              latitude: 32.90983,
              longitude: -96.63033,
              timezone: 'America/Chicago'
          },
          {
              id: 8851,
              city: 'Garrison',
              latitude: 31.82434,
              longitude: -94.49104,
              timezone: 'America/Chicago'
          },
          {
              id: 8852,
              city: 'Gatesville',
              latitude: 31.43516,
              longitude: -97.74391,
              timezone: 'America/Chicago'
          },
          {
              id: 8854,
              city: 'George West',
              latitude: 28.3325,
              longitude: -98.11751,
              timezone: 'America/Chicago'
          },
          {
              id: 8853,
              city: 'Georgetown',
              latitude: 30.63269,
              longitude: -97.67723,
              timezone: 'America/Chicago'
          },
          {
              id: 8855,
              city: 'Gholson',
              latitude: 31.701,
              longitude: -97.2164,
              timezone: 'America/Chicago'
          },
          {
              id: 8856,
              city: 'Giddings',
              latitude: 30.18272,
              longitude: -96.93637,
              timezone: 'America/Chicago'
          },
          {
              id: 8857,
              city: 'Gilmer',
              latitude: 32.72875,
              longitude: -94.94244,
              timezone: 'America/Chicago'
          },
          {
              id: 8858,
              city: 'Gladewater',
              latitude: 32.54255,
              longitude: -94.94714,
              timezone: 'America/Chicago'
          },
          {
              id: 8860,
              city: 'Glen Rose',
              latitude: 32.23459,
              longitude: -97.75531,
              timezone: 'America/Chicago'
          },
          {
              id: 8859,
              city: 'Glenn Heights',
              latitude: 32.5513,
              longitude: -96.85439,
              timezone: 'America/Chicago'
          },
          {
              id: 8861,
              city: 'Godley',
              latitude: 32.44903,
              longitude: -97.52669,
              timezone: 'America/Chicago'
          },
          {
              id: 8862,
              city: 'Goldsmith',
              latitude: 31.98067,
              longitude: -102.61515,
              timezone: 'America/Chicago'
          },
          {
              id: 8863,
              city: 'Goldthwaite',
              latitude: 31.44989,
              longitude: -98.57088,
              timezone: 'America/Chicago'
          },
          {
              id: 8864,
              city: 'Goliad',
              latitude: 28.66833,
              longitude: -97.38833,
              timezone: 'America/Chicago'
          },
          {
              id: 8865,
              city: 'Golinda',
              latitude: 31.36233,
              longitude: -97.0735,
              timezone: 'America/Chicago'
          },
          {
              id: 8866,
              city: 'Gonzales',
              latitude: 29.50163,
              longitude: -97.45249,
              timezone: 'America/Chicago'
          },
          {
              id: 8867,
              city: 'Goodlow',
              latitude: 32.10842,
              longitude: -96.2156,
              timezone: 'America/Chicago'
          },
          {
              id: 8868,
              city: 'Goodrich',
              latitude: 30.60548,
              longitude: -94.9466,
              timezone: 'America/Chicago'
          },
          {
              id: 8869,
              city: 'Gordon',
              latitude: 32.54846,
              longitude: -98.36922,
              timezone: 'America/Chicago'
          },
          {
              id: 8870,
              city: 'Goree',
              latitude: 33.46732,
              longitude: -99.52453,
              timezone: 'America/Chicago'
          },
          {
              id: 8871,
              city: 'Gorman',
              latitude: 32.21375,
              longitude: -98.67061,
              timezone: 'America/Chicago'
          },
          {
              id: 8872,
              city: 'Graford',
              latitude: 32.93762,
              longitude: -98.24699,
              timezone: 'America/Chicago'
          },
          {
              id: 8873,
              city: 'Graham',
              latitude: 33.10706,
              longitude: -98.5895,
              timezone: 'America/Chicago'
          },
          {
              id: 8874,
              city: 'Granbury',
              latitude: 32.44208,
              longitude: -97.7942,
              timezone: 'America/Chicago'
          },
          {
              id: 8875,
              city: 'Grand Prairie',
              latitude: 32.68611,
              longitude: -97.0208,
              timezone: 'America/Chicago'
          },
          {
              id: 8876,
              city: 'Grand Saline',
              latitude: 32.67346,
              longitude: -95.70941,
              timezone: 'America/Chicago'
          },
          {
              id: 8877,
              city: 'Grandview',
              latitude: 32.27042,
              longitude: -97.17918,
              timezone: 'America/Chicago'
          },
          {
              id: 8878,
              city: 'Granger',
              latitude: 30.71769,
              longitude: -97.44278,
              timezone: 'America/Chicago'
          },
          {
              id: 8879,
              city: 'Granite Shoals',
              latitude: 30.58908,
              longitude: -98.38392,
              timezone: 'America/Chicago'
          },
          {
              id: 8880,
              city: 'Granjeno',
              latitude: 26.1348,
              longitude: -98.30474,
              timezone: 'America/Chicago'
          },
          {
              id: 8881,
              city: 'Grapeland',
              latitude: 31.49185,
              longitude: -95.47856,
              timezone: 'America/Chicago'
          },
          {
              id: 8882,
              city: 'Grapevine',
              latitude: 32.93411,
              longitude: -97.07653,
              timezone: 'America/Chicago'
          },
          {
              id: 8883,
              city: 'Greenville',
              latitude: 33.13845,
              longitude: -96.11081,
              timezone: 'America/Chicago'
          },
          {
              id: 8884,
              city: 'Gregory',
              latitude: 27.92224,
              longitude: -97.28999,
              timezone: 'America/Chicago'
          },
          {
              id: 8885,
              city: 'Grey Forest',
              latitude: 29.6155,
              longitude: -98.68086,
              timezone: 'America/Chicago'
          },
          {
              id: 8886,
              city: 'Groesbeck',
              latitude: 31.52434,
              longitude: -96.53387,
              timezone: 'America/Chicago'
          },
          {
              id: 8887,
              city: 'Groves',
              latitude: 29.94827,
              longitude: -93.91712,
              timezone: 'America/Chicago'
          },
          {
              id: 8888,
              city: 'Groveton',
              latitude: 31.05491,
              longitude: -95.12577,
              timezone: 'America/Chicago'
          },
          {
              id: 8889,
              city: 'Gruver',
              latitude: 36.26503,
              longitude: -101.40627,
              timezone: 'America/Chicago'
          },
          {
              id: 8890,
              city: 'Gun Barrel City',
              latitude: 32.33459,
              longitude: -96.15136,
              timezone: 'America/Chicago'
          },
          {
              id: 8891,
              city: 'Gunter',
              latitude: 33.44789,
              longitude: -96.74749,
              timezone: 'America/Chicago'
          },
          {
              id: 8892,
              city: 'Hale Center',
              latitude: 34.06424,
              longitude: -101.84379,
              timezone: 'America/Chicago'
          },
          {
              id: 8893,
              city: 'Hallettsville',
              latitude: 29.44385,
              longitude: -96.94109,
              timezone: 'America/Chicago'
          },
          {
              id: 8894,
              city: 'Hallsburg',
              latitude: 31.53878,
              longitude: -96.95611,
              timezone: 'America/Chicago'
          },
          {
              id: 8895,
              city: 'Hallsville',
              latitude: 32.50432,
              longitude: -94.57409,
              timezone: 'America/Chicago'
          },
          {
              id: 8896,
              city: 'Haltom City',
              latitude: 32.79957,
              longitude: -97.26918,
              timezone: 'America/Chicago'
          },
          {
              id: 8897,
              city: 'Hamilton',
              latitude: 31.70377,
              longitude: -98.12392,
              timezone: 'America/Chicago'
          },
          {
              id: 8898,
              city: 'Hamlin',
              latitude: 32.88999,
              longitude: -100.1325,
              timezone: 'America/Chicago'
          },
          {
              id: 8899,
              city: 'Hardin',
              latitude: 30.15243,
              longitude: -94.73909,
              timezone: 'America/Chicago'
          },
          {
              id: 8900,
              city: 'Harker Heights',
              latitude: 31.08351,
              longitude: -97.65974,
              timezone: 'America/Chicago'
          },
          {
              id: 8901,
              city: 'Harlingen',
              latitude: 26.19063,
              longitude: -97.6961,
              timezone: 'America/Chicago'
          },
          {
              id: 8902,
              city: 'Hart',
              latitude: 34.38507,
              longitude: -102.11574,
              timezone: 'America/Chicago'
          },
          {
              id: 8903,
              city: 'Haskell',
              latitude: 33.1576,
              longitude: -99.7337,
              timezone: 'America/Chicago'
          },
          {
              id: 8904,
              city: 'Haslet',
              latitude: 32.96718,
              longitude: -97.33692,
              timezone: 'America/Chicago'
          },
          {
              id: 8905,
              city: 'Hawk Cove',
              latitude: 32.88401,
              longitude: -96.08108,
              timezone: 'America/Chicago'
          },
          {
              id: 8906,
              city: 'Hawkins',
              latitude: 32.58847,
              longitude: -95.20411,
              timezone: 'America/Chicago'
          },
          {
              id: 8907,
              city: 'Hawley',
              latitude: 32.61206,
              longitude: -99.81426,
              timezone: 'America/Chicago'
          },
          {
              id: 8908,
              city: 'Hays',
              latitude: 30.12151,
              longitude: -97.87239,
              timezone: 'America/Chicago'
          },
          {
              id: 8909,
              city: 'Hearne',
              latitude: 30.87852,
              longitude: -96.59303,
              timezone: 'America/Chicago'
          },
          {
              id: 8910,
              city: 'Heath',
              latitude: 32.85351,
              longitude: -96.46364,
              timezone: 'America/Chicago'
          },
          {
              id: 8911,
              city: 'Hedley',
              latitude: 34.867,
              longitude: -100.66041,
              timezone: 'America/Chicago'
          },
          {
              id: 8912,
              city: 'Hedwig Village',
              latitude: 29.77745,
              longitude: -95.51716,
              timezone: 'America/Chicago'
          },
          {
              id: 8913,
              city: 'Helotes',
              latitude: 29.57801,
              longitude: -98.68975,
              timezone: 'America/Chicago'
          },
          {
              id: 8914,
              city: 'Hemphill',
              latitude: 31.34074,
              longitude: -93.84685,
              timezone: 'America/Chicago'
          },
          {
              id: 8915,
              city: 'Hempstead',
              latitude: 30.09744,
              longitude: -96.07829,
              timezone: 'America/Chicago'
          },
          {
              id: 8916,
              city: 'Henderson',
              latitude: 32.15322,
              longitude: -94.79938,
              timezone: 'America/Chicago'
          },
          {
              id: 8917,
              city: 'Henrietta',
              latitude: 33.81732,
              longitude: -98.19532,
              timezone: 'America/Chicago'
          },
          {
              id: 8918,
              city: 'Hereford',
              latitude: 34.81506,
              longitude: -102.3977,
              timezone: 'America/Chicago'
          },
          {
              id: 8919,
              city: 'Hewitt',
              latitude: 31.46239,
              longitude: -97.19584,
              timezone: 'America/Chicago'
          },
          {
              id: 8920,
              city: 'Hico',
              latitude: 31.98511,
              longitude: -98.0284,
              timezone: 'America/Chicago'
          },
          {
              id: 8921,
              city: 'Hidalgo',
              latitude: 26.10035,
              longitude: -98.26307,
              timezone: 'America/Chicago'
          },
          {
              id: 8922,
              city: 'Hideaway',
              latitude: 32.49042,
              longitude: -95.45746,
              timezone: 'America/Chicago'
          },
          {
              id: 8923,
              city: 'Higgins',
              latitude: 36.11976,
              longitude: -100.02429,
              timezone: 'America/Chicago'
          },
          {
              id: 8924,
              city: 'Highland Haven',
              latitude: 30.60824,
              longitude: -98.39586,
              timezone: 'America/Chicago'
          },
          {
              id: 8925,
              city: 'Highland Village',
              latitude: 33.09179,
              longitude: -97.04668,
              timezone: 'America/Chicago'
          },
          {
              id: 8926,
              city: 'Hill Country Village',
              latitude: 29.58245,
              longitude: -98.49085,
              timezone: 'America/Chicago'
          },
          {
              id: 8927,
              city: 'Hillsboro',
              latitude: 32.01099,
              longitude: -97.13001,
              timezone: 'America/Chicago'
          },
          {
              id: 8928,
              city: 'Hilshire Village',
              latitude: 29.79078,
              longitude: -95.48911,
              timezone: 'America/Chicago'
          },
          {
              id: 8929,
              city: 'Hitchcock',
              latitude: 29.34829,
              longitude: -95.01604,
              timezone: 'America/Chicago'
          },
          {
              id: 8930,
              city: 'Holliday',
              latitude: 33.81621,
              longitude: -98.69506,
              timezone: 'America/Chicago'
          },
          {
              id: 8931,
              city: 'Hondo',
              latitude: 29.34746,
              longitude: -99.14142,
              timezone: 'America/Chicago'
          },
          {
              id: 8932,
              city: 'Honey Grove',
              latitude: 33.58344,
              longitude: -95.90997,
              timezone: 'America/Chicago'
          },
          {
              id: 8933,
              city: 'Hooks',
              latitude: 33.46623,
              longitude: -94.28853,
              timezone: 'America/Chicago'
          },
          {
              id: 8934,
              city: 'Horizon City',
              latitude: 31.69261,
              longitude: -106.20748,
              timezone: 'America/Denver'
          },
          {
              id: 8935,
              city: 'Horseshoe Bay',
              latitude: 30.54076,
              longitude: -98.38057,
              timezone: 'America/Chicago'
          },
          {
              id: 8936,
              city: 'Houston',
              latitude: 29.78574,
              longitude: -95.38881,
              timezone: 'America/Chicago'
          },
          {
              id: 8937,
              city: 'Howardwick',
              latitude: 35.03727,
              longitude: -100.90681,
              timezone: 'America/Chicago'
          },
          {
              id: 8938,
              city: 'Hubbard',
              latitude: 31.84849,
              longitude: -96.79722,
              timezone: 'America/Chicago'
          },
          {
              id: 8939,
              city: 'Hudson',
              latitude: 31.32268,
              longitude: -94.77826,
              timezone: 'America/Chicago'
          },
          {
              id: 8940,
              city: 'Hudson Oaks',
              latitude: 32.75707,
              longitude: -97.7067,
              timezone: 'America/Chicago'
          },
          {
              id: 8941,
              city: 'Hughes Springs',
              latitude: 32.99866,
              longitude: -94.63107,
              timezone: 'America/Chicago'
          },
          {
              id: 8942,
              city: 'Humble',
              latitude: 29.99883,
              longitude: -95.26216,
              timezone: 'America/Chicago'
          },
          {
              id: 8943,
              city: 'Hunters Creek Village',
              latitude: 29.77051,
              longitude: -95.4955,
              timezone: 'America/Chicago'
          },
          {
              id: 8944,
              city: 'Huntington',
              latitude: 31.27769,
              longitude: -94.57659,
              timezone: 'America/Chicago'
          },
          {
              id: 8945,
              city: 'Huntsville',
              latitude: 30.72353,
              longitude: -95.55078,
              timezone: 'America/Chicago'
          },
          {
              id: 8946,
              city: 'Hurst',
              latitude: 32.82346,
              longitude: -97.17057,
              timezone: 'America/Chicago'
          },
          {
              id: 8947,
              city: 'Hutchins',
              latitude: 32.6493,
              longitude: -96.71305,
              timezone: 'America/Chicago'
          },
          {
              id: 8948,
              city: 'Hutto',
              latitude: 30.5427,
              longitude: -97.54667,
              timezone: 'America/Chicago'
          },
          {
              id: 8949,
              city: 'Huxley',
              latitude: 31.76239,
              longitude: -93.87713,
              timezone: 'America/Chicago'
          },
          {
              id: 8950,
              city: 'Idalou',
              latitude: 33.66647,
              longitude: -101.68294,
              timezone: 'America/Chicago'
          },
          {
              id: 8951,
              city: 'Industry',
              latitude: 29.97245,
              longitude: -96.50219,
              timezone: 'America/Chicago'
          },
          {
              id: 8952,
              city: 'Ingleside',
              latitude: 27.87061,
              longitude: -97.20791,
              timezone: 'America/Chicago'
          },
          {
              id: 8953,
              city: 'Ingleside on the Bay',
              latitude: 27.82947,
              longitude: -97.22332,
              timezone: 'America/Chicago'
          },
          {
              id: 8954,
              city: 'Ingram',
              latitude: 30.07743,
              longitude: -99.24032,
              timezone: 'America/Chicago'
          },
          {
              id: 8955,
              city: 'Iola',
              latitude: 30.77186,
              longitude: -96.07496,
              timezone: 'America/Chicago'
          },
          {
              id: 8956,
              city: 'Iowa Park',
              latitude: 33.95148,
              longitude: -98.66867,
              timezone: 'America/Chicago'
          },
          {
              id: 8957,
              city: 'Iraan',
              latitude: 30.91405,
              longitude: -101.89791,
              timezone: 'America/Chicago'
          },
          {
              id: 8958,
              city: 'Iredell',
              latitude: 31.98515,
              longitude: -97.87197,
              timezone: 'America/Chicago'
          },
          {
              id: 8959,
              city: 'Irving',
              latitude: 32.81402,
              longitude: -96.94889,
              timezone: 'America/Chicago'
          },
          {
              id: 8960,
              city: 'Itasca',
              latitude: 32.15959,
              longitude: -97.15001,
              timezone: 'America/Chicago'
          },
          {
              id: 8961,
              city: 'Ivanhoe',
              latitude: 30.67954,
              longitude: -94.4139,
              timezone: 'America/Chicago'
          },
          {
              id: 8962,
              city: 'Jacinto City',
              latitude: 29.76745,
              longitude: -95.23382,
              timezone: 'America/Chicago'
          },
          {
              id: 8963,
              city: 'Jacksboro',
              latitude: 33.21845,
              longitude: -98.15866,
              timezone: 'America/Chicago'
          },
          {
              id: 8964,
              city: 'Jacksonville',
              latitude: 31.96378,
              longitude: -95.2705,
              timezone: 'America/Chicago'
          },
          {
              id: 8965,
              city: 'Jamaica Beach',
              latitude: 29.18968,
              longitude: -94.97965,
              timezone: 'America/Chicago'
          },
          {
              id: 8966,
              city: 'Jarrell',
              latitude: 30.82491,
              longitude: -97.60445,
              timezone: 'America/Chicago'
          },
          {
              id: 8967,
              city: 'Jasper',
              latitude: 30.9202,
              longitude: -93.99658,
              timezone: 'America/Chicago'
          },
          {
              id: 8968,
              city: 'Jayton',
              latitude: 33.24815,
              longitude: -100.57373,
              timezone: 'America/Chicago'
          },
          {
              id: 8969,
              city: 'Jefferson',
              latitude: 32.75736,
              longitude: -94.34519,
              timezone: 'America/Chicago'
          },
          {
              id: 8970,
              city: 'Jersey Village',
              latitude: 29.88773,
              longitude: -95.563,
              timezone: 'America/Chicago'
          },
          {
              id: 8971,
              city: 'Jewett',
              latitude: 31.36157,
              longitude: -96.14413,
              timezone: 'America/Chicago'
          },
          {
              id: 8972,
              city: 'Joaquin',
              latitude: 31.96572,
              longitude: -94.0538,
              timezone: 'America/Chicago'
          },
          {
              id: 8973,
              city: 'Johnson City',
              latitude: 30.27687,
              longitude: -98.41197,
              timezone: 'America/Chicago'
          },
          {
              id: 8974,
              city: 'Jolly',
              latitude: 33.86399,
              longitude: -98.34949,
              timezone: 'America/Chicago'
          },
          {
              id: 8975,
              city: 'Jonestown',
              latitude: 30.49547,
              longitude: -97.92335,
              timezone: 'America/Chicago'
          },
          {
              id: 8976,
              city: 'Josephine',
              latitude: 33.06311,
              longitude: -96.31664,
              timezone: 'America/Chicago'
          },
          {
              id: 8977,
              city: 'Joshua',
              latitude: 32.46153,
              longitude: -97.38807,
              timezone: 'America/Chicago'
          },
          {
              id: 8978,
              city: 'Jourdanton',
              latitude: 28.91803,
              longitude: -98.54641,
              timezone: 'America/Chicago'
          },
          {
              id: 8979,
              city: 'Junction',
              latitude: 30.48936,
              longitude: -99.77201,
              timezone: 'America/Chicago'
          },
          {
              id: 8980,
              city: 'Justin',
              latitude: 33.08484,
              longitude: -97.29613,
              timezone: 'America/Chicago'
          },
          {
              id: 8981,
              city: 'Karnes City',
              latitude: 28.88498,
              longitude: -97.90084,
              timezone: 'America/Chicago'
          },
          {
              id: 8982,
              city: 'Katy',
              latitude: 29.79092,
              longitude: -95.84071,
              timezone: 'America/Chicago'
          },
          {
              id: 8983,
              city: 'Kaufman',
              latitude: 32.58902,
              longitude: -96.30887,
              timezone: 'America/Chicago'
          },
          {
              id: 8984,
              city: 'Keene',
              latitude: 32.39681,
              longitude: -97.3239,
              timezone: 'America/Chicago'
          },
          {
              id: 8985,
              city: 'Keller',
              latitude: 32.93457,
              longitude: -97.25168,
              timezone: 'America/Chicago'
          },
          {
              id: 8986,
              city: 'Kemah',
              latitude: 29.54273,
              longitude: -95.02048,
              timezone: 'America/Chicago'
          },
          {
              id: 8987,
              city: 'Kemp',
              latitude: 32.44264,
              longitude: -96.22998,
              timezone: 'America/Chicago'
          },
          {
              id: 8988,
              city: 'Kempner',
              latitude: 31.08101,
              longitude: -98.00252,
              timezone: 'America/Chicago'
          },
          {
              id: 8989,
              city: 'Kendleton',
              latitude: 29.4508,
              longitude: -95.99468,
              timezone: 'America/Chicago'
          },
          {
              id: 8990,
              city: 'Kenedy',
              latitude: 28.81915,
              longitude: -97.84861,
              timezone: 'America/Chicago'
          },
          {
              id: 8991,
              city: 'Kennard',
              latitude: 31.35963,
              longitude: -95.18327,
              timezone: 'America/Chicago'
          },
          {
              id: 8992,
              city: 'Kennedale',
              latitude: 32.6468,
              longitude: -97.22585,
              timezone: 'America/Chicago'
          },
          {
              id: 8993,
              city: 'Kerens',
              latitude: 32.13321,
              longitude: -96.22775,
              timezone: 'America/Chicago'
          },
          {
              id: 8994,
              city: 'Kermit',
              latitude: 31.85763,
              longitude: -103.09267,
              timezone: 'America/Chicago'
          },
          {
              id: 8995,
              city: 'Kerrville',
              latitude: 30.04743,
              longitude: -99.14032,
              timezone: 'America/Chicago'
          },
          {
              id: 8996,
              city: 'Kilgore',
              latitude: 32.39667,
              longitude: -94.86001,
              timezone: 'America/Chicago'
          },
          {
              id: 8997,
              city: 'Killeen',
              latitude: 31.11712,
              longitude: -97.7278,
              timezone: 'America/Chicago'
          },
          {
              id: 8998,
              city: 'Kingsbury',
              latitude: 29.64801,
              longitude: -97.82806,
              timezone: 'America/Chicago'
          },
          {
              id: 8999,
              city: 'Kingsville',
              latitude: 27.51587,
              longitude: -97.85611,
              timezone: 'America/Chicago'
          },
          {
              id: 9000,
              city: 'Kirby',
              latitude: 29.46329,
              longitude: -98.38557,
              timezone: 'America/Chicago'
          },
          {
              id: 9001,
              city: 'Kirbyville',
              latitude: 30.66048,
              longitude: -93.89268,
              timezone: 'America/Chicago'
          },
          {
              id: 9002,
              city: 'Knollwood',
              latitude: 33.68955,
              longitude: -96.61916,
              timezone: 'America/Chicago'
          },
          {
              id: 9003,
              city: 'Kountze',
              latitude: 30.3716,
              longitude: -94.31241,
              timezone: 'America/Chicago'
          },
          {
              id: 9004,
              city: 'Kress',
              latitude: 34.36645,
              longitude: -101.74851,
              timezone: 'America/Chicago'
          },
          {
              id: 9005,
              city: 'Krugerville',
              latitude: 33.28151,
              longitude: -96.99056,
              timezone: 'America/Chicago'
          },
          {
              id: 9006,
              city: 'Krum',
              latitude: 33.26151,
              longitude: -97.23807,
              timezone: 'America/Chicago'
          },
          {
              id: 9007,
              city: 'Kyle',
              latitude: 29.98911,
              longitude: -97.87723,
              timezone: 'America/Chicago'
          },
          {
              id: 9010,
              city: 'La Feria',
              latitude: 26.15896,
              longitude: -97.82389,
              timezone: 'America/Chicago'
          },
          {
              id: 9012,
              city: 'La Grange',
              latitude: 29.9055,
              longitude: -96.87665,
              timezone: 'America/Chicago'
          },
          {
              id: 9013,
              city: 'La Grulla',
              latitude: 26.26951,
              longitude: -98.64725,
              timezone: 'America/Chicago'
          },
          {
              id: 9014,
              city: 'La Joya',
              latitude: 26.24702,
              longitude: -98.48141,
              timezone: 'America/Chicago'
          },
          {
              id: 9022,
              city: 'La Marque',
              latitude: 29.36857,
              longitude: -94.97131,
              timezone: 'America/Chicago'
          },
          {
              id: 9026,
              city: 'La Porte',
              latitude: 29.66578,
              longitude: -95.01937,
              timezone: 'America/Chicago'
          },
          {
              id: 9029,
              city: 'La Vernia',
              latitude: 29.35635,
              longitude: -98.11556,
              timezone: 'America/Chicago'
          },
          {
              id: 9030,
              city: 'La Villa',
              latitude: 26.29868,
              longitude: -97.92861,
              timezone: 'America/Chicago'
          },
          {
              id: 9032,
              city: 'La Ward',
              latitude: 28.84388,
              longitude: -96.46414,
              timezone: 'America/Chicago'
          },
          {
              id: 9008,
              city: 'LaCoste',
              latitude: 29.31079,
              longitude: -98.81003,
              timezone: 'America/Chicago'
          },
          {
              id: 9009,
              city: 'Lacy-Lakeview',
              latitude: 31.62933,
              longitude: -97.10278,
              timezone: 'America/Chicago'
          },
          {
              id: 9011,
              city: 'Lago Vista',
              latitude: 30.4602,
              longitude: -97.98835,
              timezone: 'America/Chicago'
          },
          {
              id: 9015,
              city: 'Lake Bridgeport',
              latitude: 33.20706,
              longitude: -97.82865,
              timezone: 'America/Chicago'
          },
          {
              id: 9016,
              city: 'Lake Dallas',
              latitude: 33.11929,
              longitude: -97.02556,
              timezone: 'America/Chicago'
          },
          {
              id: 9017,
              city: 'Lake Jackson',
              latitude: 29.03386,
              longitude: -95.43439,
              timezone: 'America/Chicago'
          },
          {
              id: 9021,
              city: 'Lake Worth',
              latitude: 32.80485,
              longitude: -97.44502,
              timezone: 'America/Chicago'
          },
          {
              id: 9018,
              city: 'Lakeport',
              latitude: 32.40904,
              longitude: -94.70521,
              timezone: 'America/Chicago'
          },
          {
              id: 9019,
              city: 'Lakeway',
              latitude: 30.36798,
              longitude: -97.99168,
              timezone: 'America/Chicago'
          },
          {
              id: 9020,
              city: 'Lakewood Village',
              latitude: 33.14262,
              longitude: -96.96945,
              timezone: 'America/Chicago'
          },
          {
              id: 9023,
              city: 'Lamesa',
              latitude: 32.7376,
              longitude: -101.95099,
              timezone: 'America/Chicago'
          },
          {
              id: 9024,
              city: 'Lampasas',
              latitude: 31.06378,
              longitude: -98.1817,
              timezone: 'America/Chicago'
          },
          {
              id: 9025,
              city: 'Lancaster',
              latitude: 32.59208,
              longitude: -96.75611,
              timezone: 'America/Chicago'
          },
          {
              id: 9027,
              city: 'Laredo',
              latitude: 27.50641,
              longitude: -99.50754,
              timezone: 'America/Chicago'
          },
          {
              id: 9028,
              city: 'Latexo',
              latitude: 31.39518,
              longitude: -95.47412,
              timezone: 'America/Chicago'
          },
          {
              id: 9031,
              city: 'Lavon',
              latitude: 33.02762,
              longitude: -96.43415,
              timezone: 'America/Chicago'
          },
          {
              id: 9033,
              city: 'League City',
              latitude: 29.49006,
              longitude: -95.10909,
              timezone: 'America/Chicago'
          },
          {
              id: 9034,
              city: 'Leakey',
              latitude: 29.72884,
              longitude: -99.76145,
              timezone: 'America/Chicago'
          },
          {
              id: 9035,
              city: 'Leander',
              latitude: 30.57391,
              longitude: -97.86257,
              timezone: 'America/Chicago'
          },
          {
              id: 9036,
              city: 'Leary',
              latitude: 33.46012,
              longitude: -94.20769,
              timezone: 'America/Chicago'
          },
          {
              id: 9039,
              city: 'Leon Valley',
              latitude: 29.49523,
              longitude: -98.61863,
              timezone: 'America/Chicago'
          },
          {
              id: 9037,
              city: 'Leona',
              latitude: 31.15463,
              longitude: -95.96912,
              timezone: 'America/Chicago'
          },
          {
              id: 9038,
              city: 'Leonard',
              latitude: 33.37955,
              longitude: -96.24748,
              timezone: 'America/Chicago'
          },
          {
              id: 9040,
              city: 'Leroy',
              latitude: 31.73155,
              longitude: -97.01778,
              timezone: 'America/Chicago'
          },
          {
              id: 9041,
              city: 'Levelland',
              latitude: 33.58732,
              longitude: -102.37796,
              timezone: 'America/Chicago'
          },
          {
              id: 9042,
              city: 'Lewisville',
              latitude: 33.04655,
              longitude: -96.98183,
              timezone: 'America/Chicago'
          },
          {
              id: 9043,
              city: 'Liberty',
              latitude: 30.05799,
              longitude: -94.79548,
              timezone: 'America/Chicago'
          },
          {
              id: 9044,
              city: 'Liberty Hill',
              latitude: 30.66491,
              longitude: -97.92252,
              timezone: 'America/Chicago'
          },
          {
              id: 9045,
              city: 'Lindale',
              latitude: 32.5157,
              longitude: -95.4094,
              timezone: 'America/Chicago'
          },
          {
              id: 9046,
              city: 'Linden',
              latitude: 33.01235,
              longitude: -94.36547,
              timezone: 'America/Chicago'
          },
          {
              id: 9047,
              city: 'Lindsay',
              latitude: 33.63594,
              longitude: -97.22279,
              timezone: 'America/Chicago'
          },
          {
              id: 9048,
              city: 'Lipan',
              latitude: 32.51847,
              longitude: -98.04587,
              timezone: 'America/Chicago'
          },
          {
              id: 9049,
              city: 'Little Elm',
              latitude: 33.16262,
              longitude: -96.93751,
              timezone: 'America/Chicago'
          },
          {
              id: 9051,
              city: 'Little River-Academy',
              latitude: 30.98629,
              longitude: -97.35861,
              timezone: 'America/Chicago'
          },
          {
              id: 9050,
              city: 'Littlefield',
              latitude: 33.91731,
              longitude: -102.3249,
              timezone: 'America/Chicago'
          },
          {
              id: 9052,
              city: 'Live Oak',
              latitude: 29.56523,
              longitude: -98.3364,
              timezone: 'America/Chicago'
          },
          {
              id: 9053,
              city: 'Liverpool',
              latitude: 29.29496,
              longitude: -95.27882,
              timezone: 'America/Chicago'
          },
          {
              id: 9054,
              city: 'Llano',
              latitude: 30.75935,
              longitude: -98.67504,
              timezone: 'America/Chicago'
          },
          {
              id: 9055,
              city: 'Lockhart',
              latitude: 29.88494,
              longitude: -97.67,
              timezone: 'America/Chicago'
          },
          {
              id: 9056,
              city: 'Log Cabin',
              latitude: 32.22237,
              longitude: -96.02191,
              timezone: 'America/Chicago'
          },
          {
              id: 9057,
              city: 'Lometa',
              latitude: 31.21711,
              longitude: -98.39337,
              timezone: 'America/Chicago'
          },
          {
              id: 9058,
              city: 'Lone Oak',
              latitude: 32.99678,
              longitude: -95.94025,
              timezone: 'America/Chicago'
          },
          {
              id: 9059,
              city: 'Lone Star',
              latitude: 32.94402,
              longitude: -94.70715,
              timezone: 'America/Chicago'
          },
          {
              id: 9060,
              city: 'Longview',
              latitude: 32.51934,
              longitude: -94.76459,
              timezone: 'America/Chicago'
          },
          {
              id: 9061,
              city: 'Lorena',
              latitude: 31.38656,
              longitude: -97.21556,
              timezone: 'America/Chicago'
          },
          {
              id: 9062,
              city: 'Lorenzo',
              latitude: 33.67064,
              longitude: -101.53516,
              timezone: 'America/Chicago'
          },
          {
              id: 9063,
              city: 'Los Fresnos',
              latitude: 26.07174,
              longitude: -97.47637,
              timezone: 'America/Chicago'
          },
          {
              id: 9064,
              city: 'Los Ybanez',
              latitude: 32.71899,
              longitude: -101.91738,
              timezone: 'America/Chicago'
          },
          {
              id: 9065,
              city: 'Lott',
              latitude: 31.20351,
              longitude: -97.03666,
              timezone: 'America/Chicago'
          },
          {
              id: 9066,
              city: 'Lovelady',
              latitude: 31.12685,
              longitude: -95.4455,
              timezone: 'America/Chicago'
          },
          {
              id: 9067,
              city: 'Lowry Crossing',
              latitude: 33.15484,
              longitude: -96.54721,
              timezone: 'America/Chicago'
          },
          {
              id: 9068,
              city: 'Lubbock',
              latitude: 33.57786,
              longitude: -101.85517,
              timezone: 'America/Chicago'
          },
          {
              id: 9069,
              city: 'Lucas',
              latitude: 33.08429,
              longitude: -96.57666,
              timezone: 'America/Chicago'
          },
          {
              id: 9070,
              city: 'Lueders',
              latitude: 32.80043,
              longitude: -99.62322,
              timezone: 'America/Chicago'
          },
          {
              id: 9071,
              city: 'Lufkin',
              latitude: 31.33824,
              longitude: -94.7291,
              timezone: 'America/Chicago'
          },
          {
              id: 9072,
              city: 'Luling',
              latitude: 29.68175,
              longitude: -97.6467,
              timezone: 'America/Chicago'
          },
          {
              id: 9073,
              city: 'Lumberton',
              latitude: 30.26577,
              longitude: -94.19963,
              timezone: 'America/Chicago'
          },
          {
              id: 9074,
              city: 'Lyford',
              latitude: 26.41229,
              longitude: -97.78972,
              timezone: 'America/Chicago'
          },
          {
              id: 9075,
              city: 'Lytle',
              latitude: 29.23462,
              longitude: -98.79368,
              timezone: 'America/Chicago'
          },
          {
              id: 9076,
              city: 'Madisonville',
              latitude: 30.94991,
              longitude: -95.91162,
              timezone: 'America/Chicago'
          },
          {
              id: 9077,
              city: 'Magnolia',
              latitude: 30.20938,
              longitude: -95.75078,
              timezone: 'America/Chicago'
          },
          {
              id: 9078,
              city: 'Malakoff',
              latitude: 32.1696,
              longitude: -96.01247,
              timezone: 'America/Chicago'
          },
          {
              id: 9079,
              city: 'Manor',
              latitude: 30.34076,
              longitude: -97.55695,
              timezone: 'America/Chicago'
          },
          {
              id: 9080,
              city: 'Mansfield',
              latitude: 32.56919,
              longitude: -97.12053,
              timezone: 'America/Chicago'
          },
          {
              id: 9081,
              city: 'Manvel',
              latitude: 29.46274,
              longitude: -95.35799,
              timezone: 'America/Chicago'
          },
          {
              id: 9082,
              city: 'Marble Falls',
              latitude: 30.57824,
              longitude: -98.2728,
              timezone: 'America/Chicago'
          },
          {
              id: 9083,
              city: 'Marfa',
              latitude: 30.30794,
              longitude: -104.01907,
              timezone: 'America/Chicago'
          },
          {
              id: 9084,
              city: 'Marion',
              latitude: 29.57134,
              longitude: -98.14029,
              timezone: 'America/Chicago'
          },
          {
              id: 9085,
              city: 'Marlin',
              latitude: 31.30629,
              longitude: -96.89804,
              timezone: 'America/Chicago'
          },
          {
              id: 9086,
              city: 'Marquez',
              latitude: 31.23935,
              longitude: -96.25358,
              timezone: 'America/Chicago'
          },
          {
              id: 9087,
              city: 'Marshall',
              latitude: 32.54487,
              longitude: -94.36742,
              timezone: 'America/Chicago'
          },
          {
              id: 9088,
              city: 'Mart',
              latitude: 31.54212,
              longitude: -96.82929,
              timezone: 'America/Chicago'
          },
          {
              id: 9089,
              city: 'Martindale',
              latitude: 29.8455,
              longitude: -97.84084,
              timezone: 'America/Chicago'
          },
          {
              id: 9090,
              city: 'Mason',
              latitude: 30.74879,
              longitude: -99.23061,
              timezone: 'America/Chicago'
          },
          {
              id: 9091,
              city: 'Mathis',
              latitude: 28.09446,
              longitude: -97.82805,
              timezone: 'America/Chicago'
          },
          {
              id: 9092,
              city: 'Maud',
              latitude: 33.3329,
              longitude: -94.3427,
              timezone: 'America/Chicago'
          },
          {
              id: 9093,
              city: 'Maypearl',
              latitude: 32.3132,
              longitude: -97.01167,
              timezone: 'America/Chicago'
          },
          {
              id: 9094,
              city: 'McAllen',
              latitude: 26.20341,
              longitude: -98.23001,
              timezone: 'America/Chicago'
          },
          {
              id: 9095,
              city: 'McCamey',
              latitude: 31.13598,
              longitude: -102.2243,
              timezone: 'America/Chicago'
          },
          {
              id: 9096,
              city: 'McGregor',
              latitude: 31.41864,
              longitude: -97.42835,
              timezone: 'America/Chicago'
          },
          {
              id: 9097,
              city: 'McKinney',
              latitude: 33.19762,
              longitude: -96.61527,
              timezone: 'America/Chicago'
          },
          {
              id: 9098,
              city: 'McLendon-Chisholm',
              latitude: 32.84235,
              longitude: -96.38054,
              timezone: 'America/Chicago'
          },
          {
              id: 9099,
              city: 'Meadowlakes',
              latitude: 30.56241,
              longitude: -98.29641,
              timezone: 'America/Chicago'
          },
          {
              id: 9100,
              city: 'Meadows Place',
              latitude: 29.65134,
              longitude: -95.588,
              timezone: 'America/Chicago'
          },
          {
              id: 9101,
              city: 'Melissa',
              latitude: 33.28595,
              longitude: -96.57277,
              timezone: 'America/Chicago'
          },
          {
              id: 9102,
              city: 'Memphis',
              latitude: 34.72478,
              longitude: -100.53401,
              timezone: 'America/Chicago'
          },
          {
              id: 9103,
              city: 'Menard',
              latitude: 30.91767,
              longitude: -99.78646,
              timezone: 'America/Chicago'
          },
          {
              id: 9104,
              city: 'Mercedes',
              latitude: 26.1498,
              longitude: -97.91361,
              timezone: 'America/Chicago'
          },
          {
              id: 9105,
              city: 'Meridian',
              latitude: 31.92321,
              longitude: -97.65669,
              timezone: 'America/Chicago'
          },
          {
              id: 9106,
              city: 'Mertzon',
              latitude: 31.26183,
              longitude: -100.81733,
              timezone: 'America/Chicago'
          },
          {
              id: 9107,
              city: 'Mesquite',
              latitude: 32.76288,
              longitude: -96.58877,
              timezone: 'America/Chicago'
          },
          {
              id: 9108,
              city: 'Mexia',
              latitude: 31.67989,
              longitude: -96.4822,
              timezone: 'America/Chicago'
          },
          {
              id: 9109,
              city: 'Miami',
              latitude: 35.69143,
              longitude: -100.63819,
              timezone: 'America/Chicago'
          },
          {
              id: 9110,
              city: 'Midland',
              latitude: 32.02464,
              longitude: -102.11347,
              timezone: 'America/Chicago'
          },
          {
              id: 9111,
              city: 'Midlothian',
              latitude: 32.48236,
              longitude: -96.99445,
              timezone: 'America/Chicago'
          },
          {
              id: 9112,
              city: 'Midway',
              latitude: 31.02602,
              longitude: -95.7505,
              timezone: 'America/Chicago'
          },
          {
              id: 9113,
              city: 'Milano',
              latitude: 30.71047,
              longitude: -96.86331,
              timezone: 'America/Chicago'
          },
          {
              id: 9114,
              city: 'Miles',
              latitude: 31.59738,
              longitude: -100.18231,
              timezone: 'America/Chicago'
          },
          {
              id: 9115,
              city: 'Mineola',
              latitude: 32.66319,
              longitude: -95.48829,
              timezone: 'America/Chicago'
          },
          {
              id: 9116,
              city: 'Mineral Wells',
              latitude: 32.82348,
              longitude: -98.0788,
              timezone: 'America/Chicago'
          },
          {
              id: 9117,
              city: 'Mingus',
              latitude: 32.53791,
              longitude: -98.42227,
              timezone: 'America/Chicago'
          },
          {
              id: 9118,
              city: 'Mission',
              latitude: 26.21591,
              longitude: -98.32529,
              timezone: 'America/Chicago'
          },
          {
              id: 9119,
              city: 'Missouri City',
              latitude: 29.56294,
              longitude: -95.536,
              timezone: 'America/Chicago'
          },
          {
              id: 9120,
              city: 'Mobeetie',
              latitude: 35.5131,
              longitude: -100.4418,
              timezone: 'America/Chicago'
          },
          {
              id: 9121,
              city: 'Mobile City',
              latitude: 32.92262,
              longitude: -96.4111,
              timezone: 'America/Chicago'
          },
          {
              id: 9122,
              city: 'Monahans',
              latitude: 31.63877,
              longitude: -103.06759,
              timezone: 'America/Chicago'
          },
          {
              id: 9123,
              city: 'Mont Belvieu',
              latitude: 29.85832,
              longitude: -94.88553,
              timezone: 'America/Chicago'
          },
          {
              id: 9124,
              city: 'Montgomery',
              latitude: 30.38826,
              longitude: -95.69634,
              timezone: 'America/Chicago'
          },
          {
              id: 9125,
              city: 'Moody',
              latitude: 31.30823,
              longitude: -97.3614,
              timezone: 'America/Chicago'
          },
          {
              id: 9126,
              city: 'Moore Station',
              latitude: 32.18182,
              longitude: -95.5669,
              timezone: 'America/Chicago'
          },
          {
              id: 9127,
              city: 'Moran',
              latitude: 32.54762,
              longitude: -99.16591,
              timezone: 'America/Chicago'
          },
          {
              id: 9128,
              city: 'Morgan',
              latitude: 32.01876,
              longitude: -97.60836,
              timezone: 'America/Chicago'
          },
          {
              id: 9129,
              city: "Morgan's Point",
              latitude: 29.67437,
              longitude: -95.00004,
              timezone: 'America/Chicago'
          },
          {
              id: 9130,
              city: "Morgan's Point Resort",
              latitude: 31.15456,
              longitude: -97.45919,
              timezone: 'America/Chicago'
          },
          {
              id: 9131,
              city: 'Morton',
              latitude: 33.7251,
              longitude: -102.75938,
              timezone: 'America/Chicago'
          },
          {
              id: 9133,
              city: 'Mount Calm',
              latitude: 31.75627,
              longitude: -96.87916,
              timezone: 'America/Chicago'
          },
          {
              id: 9134,
              city: 'Mount Enterprise',
              latitude: 31.91795,
              longitude: -94.68104,
              timezone: 'America/Chicago'
          },
          {
              id: 9135,
              city: 'Mount Pleasant',
              latitude: 33.15679,
              longitude: -94.96827,
              timezone: 'America/Chicago'
          },
          {
              id: 9132,
              city: 'Mountain City',
              latitude: 30.03716,
              longitude: -97.88695,
              timezone: 'America/Chicago'
          },
          {
              id: 9136,
              city: 'Muenster',
              latitude: 33.65177,
              longitude: -97.37641,
              timezone: 'America/Chicago'
          },
          {
              id: 9137,
              city: 'Muleshoe',
              latitude: 34.22647,
              longitude: -102.72383,
              timezone: 'America/Chicago'
          },
          {
              id: 9138,
              city: 'Munday',
              latitude: 33.44926,
              longitude: -99.62286,
              timezone: 'America/Chicago'
          },
          {
              id: 9139,
              city: 'Murchison',
              latitude: 32.27848,
              longitude: -95.74969,
              timezone: 'America/Chicago'
          },
          {
              id: 9140,
              city: 'Murphy',
              latitude: 33.01512,
              longitude: -96.61305,
              timezone: 'America/Chicago'
          },
          {
              id: 9141,
              city: 'Mustang Ridge',
              latitude: 30.05111,
              longitude: -97.70159,
              timezone: 'America/Chicago'
          },
          {
              id: 9142,
              city: 'Nacogdoches',
              latitude: 31.60351,
              longitude: -94.65549,
              timezone: 'America/Chicago'
          },
          {
              id: 9143,
              city: 'Naples',
              latitude: 33.20318,
              longitude: -94.68021,
              timezone: 'America/Chicago'
          },
          {
              id: 9144,
              city: 'Nash',
              latitude: 33.44235,
              longitude: -94.13075,
              timezone: 'America/Chicago'
          },
          {
              id: 9145,
              city: 'Nassau Bay',
              latitude: 29.54468,
              longitude: -95.09104,
              timezone: 'America/Chicago'
          },
          {
              id: 9146,
              city: 'Natalia',
              latitude: 29.18968,
              longitude: -98.86253,
              timezone: 'America/Chicago'
          },
          {
              id: 9147,
              city: 'Navasota',
              latitude: 30.38738,
              longitude: -96.08909,
              timezone: 'America/Chicago'
          },
          {
              id: 9148,
              city: 'Nazareth',
              latitude: 34.54423,
              longitude: -102.10269,
              timezone: 'America/Chicago'
          },
          {
              id: 9149,
              city: 'Nederland',
              latitude: 29.97438,
              longitude: -93.9924,
              timezone: 'America/Chicago'
          },
          {
              id: 9150,
              city: 'Needville',
              latitude: 29.39941,
              longitude: -95.83773,
              timezone: 'America/Chicago'
          },
          {
              id: 9151,
              city: 'Nevada',
              latitude: 33.04234,
              longitude: -96.37387,
              timezone: 'America/Chicago'
          },
          {
              id: 9153,
              city: 'New Berlin',
              latitude: 29.46412,
              longitude: -98.10112,
              timezone: 'America/Chicago'
          },
          {
              id: 9154,
              city: 'New Boston',
              latitude: 33.45984,
              longitude: -94.41548,
              timezone: 'America/Chicago'
          },
          {
              id: 9155,
              city: 'New Braunfels',
              latitude: 29.69931,
              longitude: -98.11513,
              timezone: 'America/Chicago'
          },
          {
              id: 9157,
              city: 'New Chapel Hill',
              latitude: 32.30515,
              longitude: -95.173,
              timezone: 'America/Chicago'
          },
          {
              id: 9158,
              city: 'New Fairview',
              latitude: 33.09917,
              longitude: -97.44639,
              timezone: 'America/Chicago'
          },
          {
              id: 9159,
              city: 'New Home',
              latitude: 33.32648,
              longitude: -101.91211,
              timezone: 'America/Chicago'
          },
          {
              id: 9160,
              city: 'New London',
              latitude: 32.23877,
              longitude: -94.94049,
              timezone: 'America/Chicago'
          },
          {
              id: 9161,
              city: 'New Summerfield',
              latitude: 31.98072,
              longitude: -95.09383,
              timezone: 'America/Chicago'
          },
          {
              id: 9163,
              city: 'New Waverly',
              latitude: 30.5377,
              longitude: -95.48328,
              timezone: 'America/Chicago'
          },
          {
              id: 9152,
              city: 'Newark',
              latitude: 33.01354,
              longitude: -97.48842,
              timezone: 'America/Chicago'
          },
          {
              id: 9156,
              city: 'Newcastle',
              latitude: 33.194,
              longitude: -98.73867,
              timezone: 'America/Chicago'
          },
          {
              id: 9162,
              city: 'Newton',
              latitude: 30.84853,
              longitude: -93.7574,
              timezone: 'America/Chicago'
          },
          {
              id: 9164,
              city: 'Niederwald',
              latitude: 29.99419,
              longitude: -97.77575,
              timezone: 'America/Chicago'
          },
          {
              id: 9165,
              city: 'Nixon',
              latitude: 29.26967,
              longitude: -97.76588,
              timezone: 'America/Chicago'
          },
          {
              id: 9166,
              city: 'Nocona',
              latitude: 33.78677,
              longitude: -97.72586,
              timezone: 'America/Chicago'
          },
          {
              id: 9167,
              city: 'Nolanville',
              latitude: 31.07879,
              longitude: -97.60557,
              timezone: 'America/Chicago'
          },
          {
              id: 9168,
              city: 'Nome',
              latitude: 30.03577,
              longitude: -94.42436,
              timezone: 'America/Chicago'
          },
          {
              id: 9169,
              city: 'Noonday',
              latitude: 32.23571,
              longitude: -95.40607,
              timezone: 'America/Chicago'
          },
          {
              id: 9170,
              city: 'Nordheim',
              latitude: 28.92109,
              longitude: -97.60972,
              timezone: 'America/Chicago'
          },
          {
              id: 9171,
              city: 'North Cleveland',
              latitude: 30.34188,
              longitude: -95.14188,
              timezone: 'America/Chicago'
          },
          {
              id: 9172,
              city: 'North Richland Hills',
              latitude: 32.8343,
              longitude: -97.2289,
              timezone: 'America/Chicago'
          },
          {
              id: 9173,
              city: 'Novice',
              latitude: 31.98959,
              longitude: -99.62369,
              timezone: 'America/Chicago'
          },
          {
              id: 9177,
              city: "O'Brien",
              latitude: 33.3801,
              longitude: -99.8437,
              timezone: 'America/Chicago'
          },
          {
              id: 9180,
              city: "O'Donnell",
              latitude: 32.9652,
              longitude: -101.83084,
              timezone: 'America/Chicago'
          },
          {
              id: 9174,
              city: 'Oak Leaf',
              latitude: 32.52042,
              longitude: -96.85472,
              timezone: 'America/Chicago'
          },
          {
              id: 9175,
              city: 'Oak Point',
              latitude: 33.19012,
              longitude: -96.99167,
              timezone: 'America/Chicago'
          },
          {
              id: 9176,
              city: 'Oak Ridge North',
              latitude: 30.16022,
              longitude: -95.44438,
              timezone: 'America/Chicago'
          },
          {
              id: 9178,
              city: 'Odem',
              latitude: 27.95057,
              longitude: -97.58222,
              timezone: 'America/Chicago'
          },
          {
              id: 9179,
              city: 'Odessa',
              latitude: 31.88339,
              longitude: -102.3399,
              timezone: 'America/Chicago'
          },
          {
              id: 9181,
              city: 'Oglesby',
              latitude: 31.4185,
              longitude: -97.50724,
              timezone: 'America/Chicago'
          },
          {
              id: 9182,
              city: 'Old River-Winfree',
              latitude: 29.87445,
              longitude: -94.82677,
              timezone: 'America/Chicago'
          },
          {
              id: 9183,
              city: 'Olmos Park',
              latitude: 29.47884,
              longitude: -98.48752,
              timezone: 'America/Chicago'
          },
          {
              id: 9184,
              city: 'Olney',
              latitude: 33.37066,
              longitude: -98.75284,
              timezone: 'America/Chicago'
          },
          {
              id: 9185,
              city: 'Olton',
              latitude: 34.18341,
              longitude: -102.13463,
              timezone: 'America/Chicago'
          },
          {
              id: 9186,
              city: 'Omaha',
              latitude: 33.18068,
              longitude: -94.7441,
              timezone: 'America/Chicago'
          },
          {
              id: 9187,
              city: 'Onalaska',
              latitude: 30.80575,
              longitude: -95.11633,
              timezone: 'America/Chicago'
          },
          {
              id: 9188,
              city: 'Orange',
              latitude: 30.09299,
              longitude: -93.73655,
              timezone: 'America/Chicago'
          },
          {
              id: 9189,
              city: 'Orange Grove',
              latitude: 27.95668,
              longitude: -97.93694,
              timezone: 'America/Chicago'
          },
          {
              id: 9190,
              city: 'Orchard',
              latitude: 29.60413,
              longitude: -95.96968,
              timezone: 'America/Chicago'
          },
          {
              id: 9191,
              city: 'Ore City',
              latitude: 32.80014,
              longitude: -94.72076,
              timezone: 'America/Chicago'
          },
          {
              id: 9192,
              city: 'Overton',
              latitude: 32.27564,
              longitude: -94.97254,
              timezone: 'America/Chicago'
          },
          {
              id: 9193,
              city: 'Ovilla',
              latitude: 32.54129,
              longitude: -96.88347,
              timezone: 'America/Chicago'
          },
          {
              id: 9194,
              city: 'Oyster Creek',
              latitude: 29.00302,
              longitude: -95.33188,
              timezone: 'America/Chicago'
          },
          {
              id: 9195,
              city: 'Palacios',
              latitude: 28.70805,
              longitude: -96.21747,
              timezone: 'America/Chicago'
          },
          {
              id: 9196,
              city: 'Palestine',
              latitude: 31.76212,
              longitude: -95.63079,
              timezone: 'America/Chicago'
          },
          {
              id: 9198,
              city: 'Palm Valley',
              latitude: 26.20174,
              longitude: -97.75416,
              timezone: 'America/Chicago'
          },
          {
              id: 9197,
              city: 'Palmhurst',
              latitude: 26.25841,
              longitude: -98.31807,
              timezone: 'America/Chicago'
          },
          {
              id: 9199,
              city: 'Palmview',
              latitude: 26.23341,
              longitude: -98.37085,
              timezone: 'America/Chicago'
          },
          {
              id: 9200,
              city: 'Pampa',
              latitude: 35.53616,
              longitude: -100.95987,
              timezone: 'America/Chicago'
          },
          {
              id: 9201,
              city: 'Panorama Village',
              latitude: 30.38104,
              longitude: -95.49355,
              timezone: 'America/Chicago'
          },
          {
              id: 9202,
              city: 'Paradise',
              latitude: 33.15012,
              longitude: -97.68725,
              timezone: 'America/Chicago'
          },
          {
              id: 9203,
              city: 'Paris',
              latitude: 33.66094,
              longitude: -95.55551,
              timezone: 'America/Chicago'
          },
          {
              id: 9204,
              city: 'Parker',
              latitude: 33.0554,
              longitude: -96.62194,
              timezone: 'America/Chicago'
          },
          {
              id: 9205,
              city: 'Pasadena',
              latitude: 29.69106,
              longitude: -95.2091,
              timezone: 'America/Chicago'
          },
          {
              id: 9206,
              city: 'Pattison',
              latitude: 29.82523,
              longitude: -95.99496,
              timezone: 'America/Chicago'
          },
          {
              id: 9207,
              city: 'Patton Village',
              latitude: 30.19299,
              longitude: -95.16882,
              timezone: 'America/Chicago'
          },
          {
              id: 9208,
              city: 'Pearland',
              latitude: 29.55576,
              longitude: -95.32307,
              timezone: 'America/Chicago'
          },
          {
              id: 9209,
              city: 'Pearsall',
              latitude: 28.89219,
              longitude: -99.09503,
              timezone: 'America/Chicago'
          },
          {
              id: 9210,
              city: 'Pecan Gap',
              latitude: 33.43896,
              longitude: -95.85306,
              timezone: 'America/Chicago'
          },
          {
              id: 9211,
              city: 'Pecan Hill',
              latitude: 32.48653,
              longitude: -96.78583,
              timezone: 'America/Chicago'
          },
          {
              id: 9212,
              city: 'Pecos',
              latitude: 31.42291,
              longitude: -103.49323,
              timezone: 'America/Chicago'
          },
          {
              id: 9213,
              city: 'Pelican Bay',
              latitude: 32.92096,
              longitude: -97.51836,
              timezone: 'America/Chicago'
          },
          {
              id: 9214,
              city: 'Penitas',
              latitude: 26.23063,
              longitude: -98.44474,
              timezone: 'America/Chicago'
          },
          {
              id: 9215,
              city: 'Perryton',
              latitude: 36.40003,
              longitude: -100.80265,
              timezone: 'America/Chicago'
          },
          {
              id: 9216,
              city: 'Petersburg',
              latitude: 33.86952,
              longitude: -101.59739,
              timezone: 'America/Chicago'
          },
          {
              id: 9217,
              city: 'Petrolia',
              latitude: 34.01315,
              longitude: -98.23227,
              timezone: 'America/Chicago'
          },
          {
              id: 9218,
              city: 'Petronila',
              latitude: 27.67198,
              longitude: -97.63583,
              timezone: 'America/Chicago'
          },
          {
              id: 9219,
              city: 'Pflugerville',
              latitude: 30.44776,
              longitude: -97.60212,
              timezone: 'America/Chicago'
          },
          {
              id: 9220,
              city: 'Pharr',
              latitude: 26.1948,
              longitude: -98.18362,
              timezone: 'America/Chicago'
          },
          {
              id: 9221,
              city: 'Pilot Point',
              latitude: 33.3957,
              longitude: -96.95027,
              timezone: 'America/Chicago'
          },
          {
              id: 9222,
              city: 'Pine Forest',
              latitude: 30.18132,
              longitude: -94.03434,
              timezone: 'America/Chicago'
          },
          {
              id: 9223,
              city: 'Pinehurst',
              latitude: 30.10715,
              longitude: -93.77461,
              timezone: 'America/Chicago'
          },
          {
              id: 9224,
              city: 'Pineland',
              latitude: 31.24797,
              longitude: -93.97436,
              timezone: 'America/Chicago'
          },
          {
              id: 9225,
              city: 'Piney Point Village',
              latitude: 29.75995,
              longitude: -95.51716,
              timezone: 'America/Chicago'
          },
          {
              id: 9226,
              city: 'Pittsburg',
              latitude: 32.9954,
              longitude: -94.96577,
              timezone: 'America/Chicago'
          },
          {
              id: 9227,
              city: 'Plainview',
              latitude: 34.18479,
              longitude: -101.70684,
              timezone: 'America/Chicago'
          },
          {
              id: 9228,
              city: 'Plano',
              latitude: 33.05077,
              longitude: -96.74794,
              timezone: 'America/Chicago'
          },
          {
              id: 9229,
              city: 'Plantersville',
              latitude: 30.33299,
              longitude: -95.8619,
              timezone: 'America/Chicago'
          },
          {
              id: 9230,
              city: 'Pleasanton',
              latitude: 28.96719,
              longitude: -98.47863,
              timezone: 'America/Chicago'
          },
          {
              id: 9231,
              city: 'Plum Grove',
              latitude: 30.21466,
              longitude: -95.09493,
              timezone: 'America/Chicago'
          },
          {
              id: 9232,
              city: 'Point',
              latitude: 32.93151,
              longitude: -95.87135,
              timezone: 'America/Chicago'
          },
          {
              id: 9233,
              city: 'Point Blank',
              latitude: 30.74575,
              longitude: -95.21272,
              timezone: 'America/Chicago'
          },
          {
              id: 9234,
              city: 'Point Comfort',
              latitude: 28.67972,
              longitude: -96.56025,
              timezone: 'America/Chicago'
          },
          {
              id: 9235,
              city: 'Port Aransas',
              latitude: 27.83392,
              longitude: -97.0611,
              timezone: 'America/Chicago'
          },
          {
              id: 9236,
              city: 'Port Arthur',
              latitude: 29.8334,
              longitude: -93.96632,
              timezone: 'America/Chicago'
          },
          {
              id: 9237,
              city: 'Port Isabel',
              latitude: 26.07341,
              longitude: -97.20858,
              timezone: 'America/Chicago'
          },
          {
              id: 9239,
              city: 'Port Lavaca',
              latitude: 28.615,
              longitude: -96.62609,
              timezone: 'America/Chicago'
          },
          {
              id: 9240,
              city: 'Port Neches',
              latitude: 29.99132,
              longitude: -93.95851,
              timezone: 'America/Chicago'
          },
          {
              id: 9238,
              city: 'Portland',
              latitude: 27.88711,
              longitude: -97.33064,
              timezone: 'America/Chicago'
          },
          {
              id: 9241,
              city: 'Post',
              latitude: 33.19093,
              longitude: -101.37819,
              timezone: 'America/Chicago'
          },
          {
              id: 9242,
              city: 'Poteet',
              latitude: 29.04052,
              longitude: -98.56807,
              timezone: 'America/Chicago'
          },
          {
              id: 9243,
              city: 'Prairie View',
              latitude: 30.09327,
              longitude: -95.98773,
              timezone: 'America/Chicago'
          },
          {
              id: 9244,
              city: 'Premont',
              latitude: 27.36059,
              longitude: -98.12362,
              timezone: 'America/Chicago'
          },
          {
              id: 9245,
              city: 'Presidio',
              latitude: 29.56074,
              longitude: -104.37215,
              timezone: 'America/Chicago'
          },
          {
              id: 9246,
              city: 'Princeton',
              latitude: 33.18012,
              longitude: -96.49804,
              timezone: 'America/Chicago'
          },
          {
              id: 9247,
              city: 'Progreso',
              latitude: 26.0923,
              longitude: -97.95722,
              timezone: 'America/Chicago'
          },
          {
              id: 9248,
              city: 'Progreso Lakes',
              latitude: 26.07174,
              longitude: -97.95889,
              timezone: 'America/Chicago'
          },
          {
              id: 9249,
              city: 'Quanah',
              latitude: 34.29786,
              longitude: -99.74037,
              timezone: 'America/Chicago'
          },
          {
              id: 9250,
              city: 'Queen City',
              latitude: 33.14874,
              longitude: -94.15019,
              timezone: 'America/Chicago'
          },
          {
              id: 9251,
              city: 'Quinlan',
              latitude: 32.9104,
              longitude: -96.13553,
              timezone: 'America/Chicago'
          },
          {
              id: 9252,
              city: 'Quitaque',
              latitude: 34.36618,
              longitude: -101.05709,
              timezone: 'America/Chicago'
          },
          {
              id: 9253,
              city: 'Quitman',
              latitude: 32.79596,
              longitude: -95.45106,
              timezone: 'America/Chicago'
          },
          {
              id: 9254,
              city: 'Ralls',
              latitude: 33.67425,
              longitude: -101.38766,
              timezone: 'America/Chicago'
          },
          {
              id: 9255,
              city: 'Ranger',
              latitude: 32.46985,
              longitude: -98.67895,
              timezone: 'America/Chicago'
          },
          {
              id: 9256,
              city: 'Rankin',
              latitude: 31.22265,
              longitude: -101.93791,
              timezone: 'America/Chicago'
          },
          {
              id: 9257,
              city: 'Ravenna',
              latitude: 33.67288,
              longitude: -96.24165,
              timezone: 'America/Chicago'
          },
          {
              id: 9258,
              city: 'Raymondville',
              latitude: 26.48146,
              longitude: -97.78305,
              timezone: 'America/Chicago'
          },
          {
              id: 9259,
              city: 'Red Lick',
              latitude: 33.46485,
              longitude: -94.17103,
              timezone: 'America/Chicago'
          },
          {
              id: 9260,
              city: 'Red Oak',
              latitude: 32.51764,
              longitude: -96.80444,
              timezone: 'America/Chicago'
          },
          {
              id: 9261,
              city: 'Redwater',
              latitude: 33.35818,
              longitude: -94.25436,
              timezone: 'America/Chicago'
          },
          {
              id: 9262,
              city: 'Reklaw',
              latitude: 31.86659,
              longitude: -94.98155,
              timezone: 'America/Chicago'
          },
          {
              id: 9263,
              city: 'Reno',
              latitude: 32.94883,
              longitude: -97.56599,
              timezone: 'America/Chicago'
          },
          {
              id: 9264,
              city: 'Rhome',
              latitude: 33.05346,
              longitude: -97.47197,
              timezone: 'America/Chicago'
          },
          {
              id: 9265,
              city: 'Rice',
              latitude: 32.24376,
              longitude: -96.4986,
              timezone: 'America/Chicago'
          },
          {
              id: 9266,
              city: 'Richardson',
              latitude: 32.97229,
              longitude: -96.70807,
              timezone: 'America/Chicago'
          },
          {
              id: 9267,
              city: 'Richland Hills',
              latitude: 32.81596,
              longitude: -97.22807,
              timezone: 'America/Chicago'
          },
          {
              id: 9268,
              city: 'Richmond',
              latitude: 29.58218,
              longitude: -95.76078,
              timezone: 'America/Chicago'
          },
          {
              id: 9269,
              city: 'Richwood',
              latitude: 29.05608,
              longitude: -95.40994,
              timezone: 'America/Chicago'
          },
          {
              id: 9270,
              city: 'Riesel',
              latitude: 31.47489,
              longitude: -96.92333,
              timezone: 'America/Chicago'
          },
          {
              id: 9271,
              city: 'Rio Bravo',
              latitude: 27.36419,
              longitude: -99.48004,
              timezone: 'America/Chicago'
          },
          {
              id: 9272,
              city: 'Rio Grande City',
              latitude: 26.37979,
              longitude: -98.8203,
              timezone: 'America/Chicago'
          },
          {
              id: 9273,
              city: 'Rio Hondo',
              latitude: 26.23535,
              longitude: -97.58193,
              timezone: 'America/Chicago'
          },
          {
              id: 9274,
              city: 'Rio Vista',
              latitude: 32.23348,
              longitude: -97.37446,
              timezone: 'America/Chicago'
          },
          {
              id: 9275,
              city: 'River Oaks',
              latitude: 32.77707,
              longitude: -97.39446,
              timezone: 'America/Chicago'
          },
          {
              id: 9276,
              city: 'Riverside',
              latitude: 30.85297,
              longitude: -95.40355,
              timezone: 'America/Chicago'
          },
          {
              id: 9277,
              city: 'Roanoke',
              latitude: 33.01474,
              longitude: -97.22903,
              timezone: 'America/Chicago'
          },
          {
              id: 9278,
              city: 'Robert Lee',
              latitude: 31.89237,
              longitude: -100.48482,
              timezone: 'America/Chicago'
          },
          {
              id: 9279,
              city: 'Robinson',
              latitude: 31.46767,
              longitude: -97.11472,
              timezone: 'America/Chicago'
          },
          {
              id: 9280,
              city: 'Robstown',
              latitude: 27.7903,
              longitude: -97.66888,
              timezone: 'America/Chicago'
          },
          {
              id: 9281,
              city: 'Roby',
              latitude: 32.74483,
              longitude: -100.37761,
              timezone: 'America/Chicago'
          },
          {
              id: 9282,
              city: 'Rockdale',
              latitude: 30.65548,
              longitude: -97.00137,
              timezone: 'America/Chicago'
          },
          {
              id: 9283,
              city: 'Rockport',
              latitude: 28.02057,
              longitude: -97.05443,
              timezone: 'America/Chicago'
          },
          {
              id: 9284,
              city: 'Rockwall',
              latitude: 32.93123,
              longitude: -96.45971,
              timezone: 'America/Chicago'
          },
          {
              id: 9285,
              city: 'Rollingwood',
              latitude: 30.27687,
              longitude: -97.79112,
              timezone: 'America/Chicago'
          },
          {
              id: 9286,
              city: 'Roma',
              latitude: 26.40526,
              longitude: -99.01581,
              timezone: 'America/Chicago'
          },
          {
              id: 9287,
              city: 'Roman Forest',
              latitude: 30.1791,
              longitude: -95.16243,
              timezone: 'America/Chicago'
          },
          {
              id: 9288,
              city: 'Ropesville',
              latitude: 33.41342,
              longitude: -102.15434,
              timezone: 'America/Chicago'
          },
          {
              id: 9289,
              city: 'Roscoe',
              latitude: 32.44595,
              longitude: -100.53872,
              timezone: 'America/Chicago'
          },
          {
              id: 9291,
              city: 'Rose City',
              latitude: 30.10271,
              longitude: -94.05184,
              timezone: 'America/Chicago'
          },
          {
              id: 9292,
              city: 'Rose Hill Acres',
              latitude: 30.19827,
              longitude: -94.19491,
              timezone: 'America/Chicago'
          },
          {
              id: 9290,
              city: 'Rosebud',
              latitude: 31.07296,
              longitude: -96.9786,
              timezone: 'America/Chicago'
          },
          {
              id: 9293,
              city: 'Rosenberg',
              latitude: 29.55718,
              longitude: -95.80856,
              timezone: 'America/Chicago'
          },
          {
              id: 9294,
              city: 'Ross',
              latitude: 31.7185,
              longitude: -97.11917,
              timezone: 'America/Chicago'
          },
          {
              id: 9295,
              city: 'Rotan',
              latitude: 32.85205,
              longitude: -100.46566,
              timezone: 'America/Chicago'
          },
          {
              id: 9296,
              city: 'Round Rock',
              latitude: 30.52524,
              longitude: -97.66595,
              timezone: 'America/Chicago'
          },
          {
              id: 9297,
              city: 'Rowlett',
              latitude: 32.91593,
              longitude: -96.54859,
              timezone: 'America/Chicago'
          },
          {
              id: 9298,
              city: 'Roxton',
              latitude: 33.54622,
              longitude: -95.72579,
              timezone: 'America/Chicago'
          },
          {
              id: 9299,
              city: 'Royse City',
              latitude: 32.97975,
              longitude: -96.31643,
              timezone: 'America/Chicago'
          },
          {
              id: 9300,
              city: 'Runaway Bay',
              latitude: 33.16789,
              longitude: -97.87837,
              timezone: 'America/Chicago'
          },
          {
              id: 9301,
              city: 'Rusk',
              latitude: 31.79601,
              longitude: -95.15022,
              timezone: 'America/Chicago'
          },
          {
              id: 9302,
              city: 'Sabinal',
              latitude: 29.31746,
              longitude: -99.46644,
              timezone: 'America/Chicago'
          },
          {
              id: 9303,
              city: 'Sachse',
              latitude: 32.96902,
              longitude: -96.5795,
              timezone: 'America/Chicago'
          },
          {
              id: 9304,
              city: 'Sadler',
              latitude: 33.68261,
              longitude: -96.84833,
              timezone: 'America/Chicago'
          },
          {
              id: 9305,
              city: 'Saginaw',
              latitude: 32.86013,
              longitude: -97.36391,
              timezone: 'America/Chicago'
          },
          {
              id: 9306,
              city: 'San Angelo',
              latitude: 31.46377,
              longitude: -100.43704,
              timezone: 'America/Chicago'
          },
          {
              id: 9307,
              city: 'San Antonio',
              latitude: 29.46594,
              longitude: -98.5247,
              timezone: 'America/Chicago'
          },
          {
              id: 9308,
              city: 'San Augustine',
              latitude: 31.5299,
              longitude: -94.10603,
              timezone: 'America/Chicago'
          },
          {
              id: 9309,
              city: 'San Benito',
              latitude: 26.13258,
              longitude: -97.6311,
              timezone: 'America/Chicago'
          },
          {
              id: 9310,
              city: 'San Diego',
              latitude: 27.76089,
              longitude: -98.23891,
              timezone: 'America/Chicago'
          },
          {
              id: 9313,
              city: 'San Elizario',
              latitude: 31.58511,
              longitude: -106.27276,
              timezone: 'America/Denver'
          },
          {
              id: 9315,
              city: 'San Juan',
              latitude: 26.18924,
              longitude: -98.15529,
              timezone: 'America/Chicago'
          },
          {
              id: 9316,
              city: 'San Marcos',
              latitude: 29.8729,
              longitude: -97.93773,
              timezone: 'America/Chicago'
          },
          {
              id: 9317,
              city: 'San Patricio',
              latitude: 27.95446,
              longitude: -97.77194,
              timezone: 'America/Chicago'
          },
          {
              id: 9318,
              city: 'San Perlita',
              latitude: 26.50118,
              longitude: -97.63971,
              timezone: 'America/Chicago'
          },
          {
              id: 9319,
              city: 'San Saba',
              latitude: 31.19572,
              longitude: -98.7181,
              timezone: 'America/Chicago'
          },
          {
              id: 9311,
              city: 'Sandy Oaks',
              latitude: 29.18139,
              longitude: -98.40753,
              timezone: 'America/Chicago'
          },
          {
              id: 9312,
              city: 'Sandy Point',
              latitude: 29.38552,
              longitude: -95.48105,
              timezone: 'America/Chicago'
          },
          {
              id: 9314,
              city: 'Sanger',
              latitude: 33.3821,
              longitude: -97.16541,
              timezone: 'America/Chicago'
          },
          {
              id: 9320,
              city: 'Sansom Park',
              latitude: 32.80596,
              longitude: -97.40307,
              timezone: 'America/Chicago'
          },
          {
              id: 9321,
              city: 'Santa Clara',
              latitude: 29.5119,
              longitude: -98.1214,
              timezone: 'America/Chicago'
          },
          {
              id: 9322,
              city: 'Santa Fe',
              latitude: 29.37801,
              longitude: -95.10576,
              timezone: 'America/Chicago'
          },
          {
              id: 9323,
              city: 'Savoy',
              latitude: 33.59927,
              longitude: -96.36665,
              timezone: 'America/Chicago'
          },
          {
              id: 9324,
              city: 'Schertz',
              latitude: 29.56333,
              longitude: -98.25086,
              timezone: 'America/Chicago'
          },
          {
              id: 9325,
              city: 'Schulenburg',
              latitude: 29.6819,
              longitude: -96.90304,
              timezone: 'America/Chicago'
          },
          {
              id: 9326,
              city: 'Scotland',
              latitude: 33.6601,
              longitude: -98.47061,
              timezone: 'America/Chicago'
          },
          {
              id: 9327,
              city: 'Scottsville',
              latitude: 32.54043,
              longitude: -94.23825,
              timezone: 'America/Chicago'
          },
          {
              id: 9328,
              city: 'Seabrook',
              latitude: 29.59297,
              longitude: -94.99342,
              timezone: 'America/Chicago'
          },
          {
              id: 9329,
              city: 'Seadrift',
              latitude: 28.41528,
              longitude: -96.71359,
              timezone: 'America/Chicago'
          },
          {
              id: 9330,
              city: 'Seagoville',
              latitude: 32.65338,
              longitude: -96.54506,
              timezone: 'America/Chicago'
          },
          {
              id: 9331,
              city: 'Seagraves',
              latitude: 32.94427,
              longitude: -102.56492,
              timezone: 'America/Chicago'
          },
          {
              id: 9332,
              city: 'Sealy',
              latitude: 29.78079,
              longitude: -96.15718,
              timezone: 'America/Chicago'
          },
          {
              id: 9333,
              city: 'Seguin',
              latitude: 29.56884,
              longitude: -97.96473,
              timezone: 'America/Chicago'
          },
          {
              id: 9334,
              city: 'Selma',
              latitude: 29.58647,
              longitude: -98.31529,
              timezone: 'America/Chicago'
          },
          {
              id: 9335,
              city: 'Seminole',
              latitude: 32.71899,
              longitude: -102.64491,
              timezone: 'America/Chicago'
          },
          {
              id: 9336,
              city: 'Seven Oaks',
              latitude: 30.85214,
              longitude: -94.86715,
              timezone: 'America/Chicago'
          },
          {
              id: 9337,
              city: 'Seven Points',
              latitude: 32.33866,
              longitude: -96.23442,
              timezone: 'America/Chicago'
          },
          {
              id: 9338,
              city: 'Seymour',
              latitude: 33.59426,
              longitude: -99.26035,
              timezone: 'America/Chicago'
          },
          {
              id: 9339,
              city: 'Shallowater',
              latitude: 33.68897,
              longitude: -101.99823,
              timezone: 'America/Chicago'
          },
          {
              id: 9340,
              city: 'Shamrock',
              latitude: 35.21422,
              longitude: -100.24901,
              timezone: 'America/Chicago'
          },
          {
              id: 9341,
              city: 'Shavano Park',
              latitude: 29.58495,
              longitude: -98.55252,
              timezone: 'America/Chicago'
          },
          {
              id: 9342,
              city: 'Shenandoah',
              latitude: 30.18022,
              longitude: -95.45577,
              timezone: 'America/Chicago'
          },
          {
              id: 9343,
              city: 'Shepherd',
              latitude: 30.49798,
              longitude: -94.9966,
              timezone: 'America/Chicago'
          },
          {
              id: 9344,
              city: 'Sherman',
              latitude: 33.63566,
              longitude: -96.60888,
              timezone: 'America/Chicago'
          },
          {
              id: 9345,
              city: 'Shiner',
              latitude: 29.42913,
              longitude: -97.17054,
              timezone: 'America/Chicago'
          },
          {
              id: 9346,
              city: 'Shoreacres',
              latitude: 29.62099,
              longitude: -95.01899,
              timezone: 'America/Chicago'
          },
          {
              id: 9347,
              city: 'Silsbee',
              latitude: 30.3491,
              longitude: -94.17796,
              timezone: 'America/Chicago'
          },
          {
              id: 9348,
              city: 'Silverton',
              latitude: 34.47423,
              longitude: -101.30461,
              timezone: 'America/Chicago'
          },
          {
              id: 9349,
              city: 'Simonton',
              latitude: 29.6794,
              longitude: -95.97718,
              timezone: 'America/Chicago'
          },
          {
              id: 9350,
              city: 'Sinton',
              latitude: 28.03668,
              longitude: -97.50916,
              timezone: 'America/Chicago'
          },
          {
              id: 9351,
              city: 'Slaton',
              latitude: 33.43731,
              longitude: -101.64349,
              timezone: 'America/Chicago'
          },
          {
              id: 9352,
              city: 'Smiley',
              latitude: 29.26774,
              longitude: -97.63583,
              timezone: 'America/Chicago'
          },
          {
              id: 9353,
              city: 'Smithville',
              latitude: 30.00855,
              longitude: -97.15943,
              timezone: 'America/Chicago'
          },
          {
              id: 9354,
              city: 'Snook',
              latitude: 30.48882,
              longitude: -96.46441,
              timezone: 'America/Chicago'
          },
          {
              id: 9355,
              city: 'Snyder',
              latitude: 32.71789,
              longitude: -100.91762,
              timezone: 'America/Chicago'
          },
          {
              id: 9356,
              city: 'Socorro',
              latitude: 31.65456,
              longitude: -106.30331,
              timezone: 'America/Denver'
          },
          {
              id: 9357,
              city: 'Somerset',
              latitude: 29.22635,
              longitude: -98.6578,
              timezone: 'America/Chicago'
          },
          {
              id: 9358,
              city: 'Somerville',
              latitude: 30.34604,
              longitude: -96.5283,
              timezone: 'America/Chicago'
          },
          {
              id: 9359,
              city: 'Sonora',
              latitude: 30.56685,
              longitude: -100.64343,
              timezone: 'America/Chicago'
          },
          {
              id: 9360,
              city: 'Sour Lake',
              latitude: 30.14021,
              longitude: -94.41102,
              timezone: 'America/Chicago'
          },
          {
              id: 9361,
              city: 'South Houston',
              latitude: 29.66301,
              longitude: -95.23549,
              timezone: 'America/Chicago'
          },
          {
              id: 9362,
              city: 'Southlake',
              latitude: 32.95449,
              longitude: -97.14887,
              timezone: 'America/Chicago'
          },
          {
              id: 9363,
              city: 'Southmayd',
              latitude: 33.63038,
              longitude: -96.76916,
              timezone: 'America/Chicago'
          },
          {
              id: 9364,
              city: 'Southside Place',
              latitude: 29.70606,
              longitude: -95.43688,
              timezone: 'America/Chicago'
          },
          {
              id: 9365,
              city: 'Spearman',
              latitude: 36.19837,
              longitude: -101.19238,
              timezone: 'America/Chicago'
          },
          {
              id: 9366,
              city: 'Splendora',
              latitude: 30.23299,
              longitude: -95.16104,
              timezone: 'America/Chicago'
          },
          {
              id: 9367,
              city: 'Spofford',
              latitude: 29.17524,
              longitude: -100.41369,
              timezone: 'America/Chicago'
          },
          {
              id: 9368,
              city: 'Spring Branch',
              latitude: 29.88994,
              longitude: -98.4253,
              timezone: 'America/Chicago'
          },
          {
              id: 9370,
              city: 'Spring Valley Village',
              latitude: 29.78976,
              longitude: -95.50403,
              timezone: 'America/Chicago'
          },
          {
              id: 9369,
              city: 'Springtown',
              latitude: 32.96932,
              longitude: -97.68042,
              timezone: 'America/Chicago'
          },
          {
              id: 9371,
              city: 'Spur',
              latitude: 33.47648,
              longitude: -100.85569,
              timezone: 'America/Chicago'
          },
          {
              id: 9380,
              city: 'St. Jo',
              latitude: 33.69483,
              longitude: -97.52252,
              timezone: 'America/Chicago'
          },
          {
              id: 9372,
              city: 'Stafford',
              latitude: 29.62572,
              longitude: -95.56574,
              timezone: 'America/Chicago'
          },
          {
              id: 9373,
              city: 'Stamford',
              latitude: 32.94202,
              longitude: -99.8156,
              timezone: 'America/Chicago'
          },
          {
              id: 9374,
              city: 'Stanton',
              latitude: 32.12929,
              longitude: -101.78846,
              timezone: 'America/Chicago'
          },
          {
              id: 9375,
              city: 'Staples',
              latitude: 29.78133,
              longitude: -97.83611,
              timezone: 'America/Chicago'
          },
          {
              id: 9376,
              city: 'Star Harbor',
              latitude: 32.1921,
              longitude: -96.05303,
              timezone: 'America/Chicago'
          },
          {
              id: 9377,
              city: 'Stephenville',
              latitude: 32.2207,
              longitude: -98.20226,
              timezone: 'America/Chicago'
          },
          {
              id: 9378,
              city: 'Sterling City',
              latitude: 31.83625,
              longitude: -100.98483,
              timezone: 'America/Chicago'
          },
          {
              id: 9379,
              city: 'Stinnett',
              latitude: 35.82698,
              longitude: -101.44294,
              timezone: 'America/Chicago'
          },
          {
              id: 9381,
              city: 'Stockdale',
              latitude: 29.23691,
              longitude: -97.96,
              timezone: 'America/Chicago'
          },
          {
              id: 9382,
              city: 'Stratford',
              latitude: 36.33614,
              longitude: -102.07212,
              timezone: 'America/Chicago'
          },
          {
              id: 9383,
              city: 'Strawn',
              latitude: 32.55207,
              longitude: -98.49811,
              timezone: 'America/Chicago'
          },
          {
              id: 9384,
              city: 'Sudan',
              latitude: 34.06786,
              longitude: -102.52436,
              timezone: 'America/Chicago'
          },
          {
              id: 9385,
              city: 'Sugar Land',
              latitude: 29.61968,
              longitude: -95.63495,
              timezone: 'America/Chicago'
          },
          {
              id: 9386,
              city: 'Sullivan City',
              latitude: 26.27757,
              longitude: -98.56363,
              timezone: 'America/Chicago'
          },
          {
              id: 9387,
              city: 'Sulphur Springs',
              latitude: 33.13845,
              longitude: -95.60107,
              timezone: 'America/Chicago'
          },
          {
              id: 9392,
              city: 'Sun Valley',
              latitude: 33.66455,
              longitude: -95.42829,
              timezone: 'America/Chicago'
          },
          {
              id: 9388,
              city: 'Sundown',
              latitude: 33.45621,
              longitude: -102.48936,
              timezone: 'America/Chicago'
          },
          {
              id: 9389,
              city: 'Sunray',
              latitude: 36.0167,
              longitude: -101.82462,
              timezone: 'America/Chicago'
          },
          {
              id: 9390,
              city: 'Sunrise Beach Village',
              latitude: 30.59963,
              longitude: -98.41003,
              timezone: 'America/Chicago'
          },
          {
              id: 9391,
              city: 'Sunset Valley',
              latitude: 30.22576,
              longitude: -97.80362,
              timezone: 'America/Chicago'
          },
          {
              id: 9393,
              city: 'Surfside Beach',
              latitude: 28.94441,
              longitude: -95.28883,
              timezone: 'America/Chicago'
          },
          {
              id: 9394,
              city: 'Sweeny',
              latitude: 29.03886,
              longitude: -95.69856,
              timezone: 'America/Chicago'
          },
          {
              id: 9395,
              city: 'Sweetwater',
              latitude: 32.47095,
              longitude: -100.40594,
              timezone: 'America/Chicago'
          },
          {
              id: 9396,
              city: 'Taft',
              latitude: 27.97891,
              longitude: -97.3986,
              timezone: 'America/Chicago'
          },
          {
              id: 9397,
              city: 'Tahoka',
              latitude: 33.16676,
              longitude: -101.79377,
              timezone: 'America/Chicago'
          },
          {
              id: 9398,
              city: 'Talco',
              latitude: 33.36261,
              longitude: -95.10466,
              timezone: 'America/Chicago'
          },
          {
              id: 9399,
              city: 'Tatum',
              latitude: 32.31588,
              longitude: -94.51888,
              timezone: 'America/Chicago'
          },
          {
              id: 9400,
              city: 'Taylor',
              latitude: 30.57076,
              longitude: -97.40944,
              timezone: 'America/Chicago'
          },
          {
              id: 9401,
              city: 'Taylor Lake Village',
              latitude: 29.57523,
              longitude: -95.05021,
              timezone: 'America/Chicago'
          },
          {
              id: 9402,
              city: 'Taylor Landing',
              latitude: 29.86222,
              longitude: -94.13108,
              timezone: 'America/Chicago'
          },
          {
              id: 9403,
              city: 'Teague',
              latitude: 31.62711,
              longitude: -96.28386,
              timezone: 'America/Chicago'
          },
          {
              id: 9404,
              city: 'Temple',
              latitude: 31.09823,
              longitude: -97.34278,
              timezone: 'America/Chicago'
          },
          {
              id: 9405,
              city: 'Terrell',
              latitude: 32.73596,
              longitude: -96.27526,
              timezone: 'America/Chicago'
          },
          {
              id: 9406,
              city: 'Terrell Hills',
              latitude: 29.47495,
              longitude: -98.45085,
              timezone: 'America/Chicago'
          },
          {
              id: 9407,
              city: 'Texarkana',
              latitude: 33.42513,
              longitude: -94.04769,
              timezone: 'America/Chicago'
          },
          {
              id: 9408,
              city: 'Texas City',
              latitude: 29.43372,
              longitude: -94.89269,
              timezone: 'America/Chicago'
          },
          {
              id: 9409,
              city: 'Texhoma',
              latitude: 36.4937,
              longitude: -101.79377,
              timezone: 'America/Chicago'
          },
          {
              id: 9410,
              city: 'The Colony',
              latitude: 33.08901,
              longitude: -96.88639,
              timezone: 'America/Chicago'
          },
          {
              id: 9411,
              city: 'Thorndale',
              latitude: 30.61402,
              longitude: -97.20649,
              timezone: 'America/Chicago'
          },
          {
              id: 9412,
              city: 'Thrall',
              latitude: 30.59048,
              longitude: -97.29694,
              timezone: 'America/Chicago'
          },
          {
              id: 9413,
              city: 'Three Rivers',
              latitude: 28.46027,
              longitude: -98.18251,
              timezone: 'America/Chicago'
          },
          {
              id: 9414,
              city: 'Timpson',
              latitude: 31.90378,
              longitude: -94.3952,
              timezone: 'America/Chicago'
          },
          {
              id: 9415,
              city: 'Toco',
              latitude: 33.65483,
              longitude: -95.64607,
              timezone: 'America/Chicago'
          },
          {
              id: 9416,
              city: 'Todd Mission',
              latitude: 30.2616,
              longitude: -95.83023,
              timezone: 'America/Chicago'
          },
          {
              id: 9417,
              city: 'Tolar',
              latitude: 32.38903,
              longitude: -97.92059,
              timezone: 'America/Chicago'
          },
          {
              id: 9419,
              city: 'Tom Bean',
              latitude: 33.52011,
              longitude: -96.48387,
              timezone: 'America/Chicago'
          },
          {
              id: 9418,
              city: 'Tomball',
              latitude: 30.09508,
              longitude: -95.61968,
              timezone: 'America/Chicago'
          },
          {
              id: 9420,
              city: 'Tool',
              latitude: 32.26792,
              longitude: -96.17025,
              timezone: 'America/Chicago'
          },
          {
              id: 9421,
              city: 'Trenton',
              latitude: 33.42626,
              longitude: -96.34459,
              timezone: 'America/Chicago'
          },
          {
              id: 9422,
              city: 'Trinidad',
              latitude: 32.14404,
              longitude: -96.09108,
              timezone: 'America/Chicago'
          },
          {
              id: 9423,
              city: 'Trinity',
              latitude: 30.94519,
              longitude: -95.3755,
              timezone: 'America/Chicago'
          },
          {
              id: 9424,
              city: 'Troup',
              latitude: 32.14581,
              longitude: -95.12256,
              timezone: 'America/Chicago'
          },
          {
              id: 9425,
              city: 'Troy',
              latitude: 31.20684,
              longitude: -97.30278,
              timezone: 'America/Chicago'
          },
          {
              id: 9426,
              city: 'Tulia',
              latitude: 34.53589,
              longitude: -101.75852,
              timezone: 'America/Chicago'
          },
          {
              id: 9427,
              city: 'Turkey',
              latitude: 34.39256,
              longitude: -100.89764,
              timezone: 'America/Chicago'
          },
          {
              id: 9428,
              city: 'Tuscola',
              latitude: 32.20958,
              longitude: -99.79675,
              timezone: 'America/Chicago'
          },
          {
              id: 9429,
              city: 'Tye',
              latitude: 32.45762,
              longitude: -99.87148,
              timezone: 'America/Chicago'
          },
          {
              id: 9430,
              city: 'Tyler',
              latitude: 32.35126,
              longitude: -95.30106,
              timezone: 'America/Chicago'
          },
          {
              id: 9431,
              city: 'Uhland',
              latitude: 29.96021,
              longitude: -97.79756,
              timezone: 'America/Chicago'
          },
          {
              id: 9432,
              city: 'Uncertain',
              latitude: 32.71209,
              longitude: -94.1213,
              timezone: 'America/Chicago'
          },
          {
              id: 9433,
              city: 'Union Grove',
              latitude: 32.57125,
              longitude: -94.92049,
              timezone: 'America/Chicago'
          },
          {
              id: 9434,
              city: 'Union Valley',
              latitude: 32.92734,
              longitude: -96.25109,
              timezone: 'America/Chicago'
          },
          {
              id: 9435,
              city: 'Universal City',
              latitude: 29.54801,
              longitude: -98.29112,
              timezone: 'America/Chicago'
          },
          {
              id: 9436,
              city: 'University Park',
              latitude: 32.85013,
              longitude: -96.80028,
              timezone: 'America/Chicago'
          },
          {
              id: 9437,
              city: 'Uvalde',
              latitude: 29.20968,
              longitude: -99.78617,
              timezone: 'America/Chicago'
          },
          {
              id: 9438,
              city: 'Valley Mills',
              latitude: 31.6586,
              longitude: -97.472,
              timezone: 'America/Chicago'
          },
          {
              id: 9439,
              city: 'Valley View',
              latitude: 33.48817,
              longitude: -97.16501,
              timezone: 'America/Chicago'
          },
          {
              id: 9440,
              city: 'Van',
              latitude: 32.52486,
              longitude: -95.63718,
              timezone: 'America/Chicago'
          },
          {
              id: 9441,
              city: 'Van Alstyne',
              latitude: 33.42009,
              longitude: -96.58338,
              timezone: 'America/Chicago'
          },
          {
              id: 9442,
              city: 'Vega',
              latitude: 35.24283,
              longitude: -102.42826,
              timezone: 'America/Chicago'
          },
          {
              id: 9443,
              city: 'Vernon',
              latitude: 34.15453,
              longitude: -99.26508,
              timezone: 'America/Chicago'
          },
          {
              id: 9444,
              city: 'Victoria',
              latitude: 28.80527,
              longitude: -97.0036,
              timezone: 'America/Chicago'
          },
          {
              id: 9445,
              city: 'Vidor',
              latitude: 30.1316,
              longitude: -94.01545,
              timezone: 'America/Chicago'
          },
          {
              id: 9446,
              city: 'Von Ormy',
              latitude: 29.28913,
              longitude: -98.64446,
              timezone: 'America/Chicago'
          },
          {
              id: 9447,
              city: 'Waco',
              latitude: 31.54933,
              longitude: -97.14667,
              timezone: 'America/Chicago'
          },
          {
              id: 9448,
              city: 'Waelder',
              latitude: 29.69329,
              longitude: -97.29916,
              timezone: 'America/Chicago'
          },
          {
              id: 9449,
              city: 'Wake Village',
              latitude: 33.42679,
              longitude: -94.1063,
              timezone: 'America/Chicago'
          },
          {
              id: 9450,
              city: 'Waller',
              latitude: 30.06318,
              longitude: -95.92236,
              timezone: 'America/Chicago'
          },
          {
              id: 9451,
              city: 'Wallis',
              latitude: 29.63135,
              longitude: -96.06524,
              timezone: 'America/Chicago'
          },
          {
              id: 9452,
              city: 'Walnut Springs',
              latitude: 32.05765,
              longitude: -97.74947,
              timezone: 'America/Chicago'
          },
          {
              id: 9453,
              city: 'Warren City',
              latitude: 32.55125,
              longitude: -94.90491,
              timezone: 'America/Chicago'
          },
          {
              id: 9454,
              city: 'Waskom',
              latitude: 32.47876,
              longitude: -94.05963,
              timezone: 'America/Chicago'
          },
          {
              id: 9455,
              city: 'Watauga',
              latitude: 32.85791,
              longitude: -97.25474,
              timezone: 'America/Chicago'
          },
          {
              id: 9456,
              city: 'Waxahachie',
              latitude: 32.38653,
              longitude: -96.84833,
              timezone: 'America/Chicago'
          },
          {
              id: 9457,
              city: 'Weatherford',
              latitude: 32.7593,
              longitude: -97.79725,
              timezone: 'America/Chicago'
          },
          {
              id: 9458,
              city: 'Webster',
              latitude: 29.53773,
              longitude: -95.11826,
              timezone: 'America/Chicago'
          },
          {
              id: 9459,
              city: 'Weimar',
              latitude: 29.70301,
              longitude: -96.78053,
              timezone: 'America/Chicago'
          },
          {
              id: 9460,
              city: 'Weinert',
              latitude: 33.3226,
              longitude: -99.67259,
              timezone: 'America/Chicago'
          },
          {
              id: 9461,
              city: 'Weir',
              latitude: 30.6738,
              longitude: -97.58473,
              timezone: 'America/Chicago'
          },
          {
              id: 9462,
              city: 'Wellington',
              latitude: 34.85617,
              longitude: -100.21373,
              timezone: 'America/Chicago'
          },
          {
              id: 9463,
              city: 'Wellman',
              latitude: 33.04843,
              longitude: -102.42797,
              timezone: 'America/Chicago'
          },
          {
              id: 9464,
              city: 'Weslaco',
              latitude: 26.15952,
              longitude: -97.99084,
              timezone: 'America/Chicago'
          },
          {
              id: 9465,
              city: 'West',
              latitude: 31.80238,
              longitude: -97.09167,
              timezone: 'America/Chicago'
          },
          {
              id: 9467,
              city: 'West Columbia',
              latitude: 29.14386,
              longitude: -95.64522,
              timezone: 'America/Chicago'
          },
          {
              id: 9468,
              city: 'West Lake Hills',
              latitude: 30.29798,
              longitude: -97.80195,
              timezone: 'America/Chicago'
          },
          {
              id: 9471,
              city: 'West Orange',
              latitude: 30.08215,
              longitude: -93.75822,
              timezone: 'America/Chicago'
          },
          {
              id: 9472,
              city: 'West Tawakoni',
              latitude: 32.89373,
              longitude: -96.02941,
              timezone: 'America/Chicago'
          },
          {
              id: 9473,
              city: 'West University Place',
              latitude: 29.71801,
              longitude: -95.43383,
              timezone: 'America/Chicago'
          },
          {
              id: 9466,
              city: 'Westbrook',
              latitude: 32.3554,
              longitude: -101.01373,
              timezone: 'America/Chicago'
          },
          {
              id: 9469,
              city: 'Weston',
              latitude: 33.349,
              longitude: -96.66944,
              timezone: 'America/Chicago'
          },
          {
              id: 9470,
              city: 'Weston Lakes',
              latitude: 29.68324,
              longitude: -95.93571,
              timezone: 'America/Chicago'
          },
          {
              id: 9474,
              city: 'Westworth Village',
              latitude: 32.76195,
              longitude: -97.42326,
              timezone: 'America/Chicago'
          },
          {
              id: 9475,
              city: 'Wharton',
              latitude: 29.31164,
              longitude: -96.10274,
              timezone: 'America/Chicago'
          },
          {
              id: 9476,
              city: 'Wheeler',
              latitude: 35.44533,
              longitude: -100.27096,
              timezone: 'America/Chicago'
          },
          {
              id: 9478,
              city: 'White Oak',
              latitude: 32.52792,
              longitude: -94.86133,
              timezone: 'America/Chicago'
          },
          {
              id: 9480,
              city: 'White Settlement',
              latitude: 32.75957,
              longitude: -97.45835,
              timezone: 'America/Chicago'
          },
          {
              id: 9477,
              city: 'Whitehouse',
              latitude: 32.22682,
              longitude: -95.2255,
              timezone: 'America/Chicago'
          },
          {
              id: 9479,
              city: 'Whitesboro',
              latitude: 33.65622,
              longitude: -96.90695,
              timezone: 'America/Chicago'
          },
          {
              id: 9481,
              city: 'Wichita Falls',
              latitude: 33.91371,
              longitude: -98.49339,
              timezone: 'America/Chicago'
          },
          {
              id: 9482,
              city: 'Willis',
              latitude: 30.42493,
              longitude: -95.47994,
              timezone: 'America/Chicago'
          },
          {
              id: 9483,
              city: 'Willow Park',
              latitude: 32.76263,
              longitude: -97.65058,
              timezone: 'America/Chicago'
          },
          {
              id: 9484,
              city: 'Wills Point',
              latitude: 32.7093,
              longitude: -96.0083,
              timezone: 'America/Chicago'
          },
          {
              id: 9485,
              city: 'Wilmer',
              latitude: 32.58902,
              longitude: -96.68527,
              timezone: 'America/Chicago'
          },
          {
              id: 9486,
              city: 'Wilson',
              latitude: 33.31704,
              longitude: -101.72405,
              timezone: 'America/Chicago'
          },
          {
              id: 9487,
              city: 'Wimberley',
              latitude: 29.99744,
              longitude: -98.09862,
              timezone: 'America/Chicago'
          },
          {
              id: 9488,
              city: 'Windcrest',
              latitude: 29.51551,
              longitude: -98.38029,
              timezone: 'America/Chicago'
          },
          {
              id: 9489,
              city: 'Winfield',
              latitude: 33.16734,
              longitude: -95.11188,
              timezone: 'America/Chicago'
          },
          {
              id: 9490,
              city: 'Wink',
              latitude: 31.75124,
              longitude: -103.15989,
              timezone: 'America/Chicago'
          },
          {
              id: 9491,
              city: 'Winnsboro',
              latitude: 32.9559,
              longitude: -95.29032,
              timezone: 'America/Chicago'
          },
          {
              id: 9492,
              city: 'Winters',
              latitude: 31.95653,
              longitude: -99.96231,
              timezone: 'America/Chicago'
          },
          {
              id: 9493,
              city: 'Wixon Valley',
              latitude: 30.76214,
              longitude: -96.31885,
              timezone: 'America/Chicago'
          },
          {
              id: 9494,
              city: 'Wolfe City',
              latitude: 33.37067,
              longitude: -96.06886,
              timezone: 'America/Chicago'
          },
          {
              id: 9495,
              city: 'Wolfforth',
              latitude: 33.50592,
              longitude: -102.00906,
              timezone: 'America/Chicago'
          },
          {
              id: 9496,
              city: 'Woodbranch',
              latitude: 30.18105,
              longitude: -95.18882,
              timezone: 'America/Chicago'
          },
          {
              id: 9497,
              city: 'Woodcreek',
              latitude: 30.02827,
              longitude: -98.11112,
              timezone: 'America/Chicago'
          },
          {
              id: 9498,
              city: 'Woodway',
              latitude: 31.506,
              longitude: -97.20501,
              timezone: 'America/Chicago'
          },
          {
              id: 9499,
              city: 'Wylie',
              latitude: 33.03582,
              longitude: -96.52005,
              timezone: 'America/Chicago'
          },
          {
              id: 9500,
              city: 'Yoakum',
              latitude: 29.2932,
              longitude: -97.14701,
              timezone: 'America/Chicago'
          },
          {
              id: 9501,
              city: 'Yorktown',
              latitude: 28.98109,
              longitude: -97.50277,
              timezone: 'America/Chicago'
          },
          {
              id: 9502,
              city: 'Zavalla',
              latitude: 31.15852,
              longitude: -94.42631,
              timezone: 'America/Chicago'
          }
      ]
    },
    {
      id: 47,
      country: 'US',
      stateCode: 'WA',
      stateName: 'Washington',
      cities: [
          {
              id: 9695,
              city: 'Aberdeen',
              latitude: 46.97537,
              longitude: -123.81572,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9696,
              city: 'Airway Heights',
              latitude: 47.64461,
              longitude: -117.59327,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9697,
              city: 'Algona',
              latitude: 47.27899,
              longitude: -122.25206,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9698,
              city: 'Anacortes',
              latitude: 48.5126,
              longitude: -122.61267,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9699,
              city: 'Arlington',
              latitude: 48.19871,
              longitude: -122.12514,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9700,
              city: 'Asotin',
              latitude: 46.33933,
              longitude: -117.04821,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9701,
              city: 'Auburn',
              latitude: 47.30377,
              longitude: -122.21,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9702,
              city: 'Bainbridge Island',
              latitude: 47.62621,
              longitude: -122.52124,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9703,
              city: 'Battle Ground',
              latitude: 45.78095,
              longitude: -122.53343,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9704,
              city: 'Bellevue',
              latitude: 47.61038,
              longitude: -122.20068,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9705,
              city: 'Bellingham',
              latitude: 48.75955,
              longitude: -122.48822,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9706,
              city: 'Benton City',
              latitude: 46.26319,
              longitude: -119.4878,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9707,
              city: 'Bingen',
              latitude: 45.71484,
              longitude: -121.46452,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9708,
              city: 'Black Diamond',
              latitude: 47.30871,
              longitude: -122.00317,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9709,
              city: 'Blaine',
              latitude: 48.99372,
              longitude: -122.74712,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9710,
              city: 'Bonney Lake',
              latitude: 47.17705,
              longitude: -122.18651,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9711,
              city: 'Bothell',
              latitude: 47.77353,
              longitude: -122.20438,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9712,
              city: 'Bremerton',
              latitude: 47.56732,
              longitude: -122.63264,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9713,
              city: 'Brewster',
              latitude: 48.09598,
              longitude: -119.78062,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9714,
              city: 'Bridgeport',
              latitude: 48.0082,
              longitude: -119.67116,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9715,
              city: 'Brier',
              latitude: 47.78454,
              longitude: -122.27429,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9716,
              city: 'Buckley',
              latitude: 47.16316,
              longitude: -122.02678,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9717,
              city: 'Burien',
              latitude: 47.47038,
              longitude: -122.34679,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9718,
              city: 'Burlington',
              latitude: 48.47566,
              longitude: -122.32544,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9719,
              city: 'Camas',
              latitude: 45.58706,
              longitude: -122.39954,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9720,
              city: 'Carnation',
              latitude: 47.64788,
              longitude: -121.91401,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9721,
              city: 'Cashmere',
              latitude: 47.52235,
              longitude: -120.4698,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9722,
              city: 'Castle Rock',
              latitude: 46.27511,
              longitude: -122.90761,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9723,
              city: 'Centralia',
              latitude: 46.71621,
              longitude: -122.9543,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9724,
              city: 'Chehalis',
              latitude: 46.66205,
              longitude: -122.96402,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9725,
              city: 'Chelan',
              latitude: 47.84097,
              longitude: -120.01646,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9726,
              city: 'Cheney',
              latitude: 47.48739,
              longitude: -117.57576,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9727,
              city: 'Chewelah',
              latitude: 48.27629,
              longitude: -117.71552,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9728,
              city: 'Clarkston',
              latitude: 46.41627,
              longitude: -117.04516,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9729,
              city: 'Cle Elum',
              latitude: 47.1954,
              longitude: -120.93925,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9730,
              city: 'Clyde Hill',
              latitude: 47.63177,
              longitude: -122.2179,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9731,
              city: 'Colfax',
              latitude: 46.88017,
              longitude: -117.36435,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9732,
              city: 'College Place',
              latitude: 46.0493,
              longitude: -118.3883,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9733,
              city: 'Colville',
              latitude: 48.54657,
              longitude: -117.90554,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9734,
              city: 'Connell',
              latitude: 46.66347,
              longitude: -118.86111,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9735,
              city: 'Cosmopolis',
              latitude: 46.95537,
              longitude: -123.77378,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9736,
              city: 'Covington',
              latitude: 47.35818,
              longitude: -122.12216,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9737,
              city: 'Davenport',
              latitude: 47.65405,
              longitude: -118.14997,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9738,
              city: 'Dayton',
              latitude: 46.32375,
              longitude: -117.97244,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9739,
              city: 'Deer Park',
              latitude: 47.95434,
              longitude: -117.47689,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9740,
              city: 'Des Moines',
              latitude: 47.40177,
              longitude: -122.32429,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9741,
              city: 'DuPont',
              latitude: 47.09676,
              longitude: -122.63124,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9742,
              city: 'Duvall',
              latitude: 47.74232,
              longitude: -121.98568,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9743,
              city: 'East Wenatchee',
              latitude: 47.41568,
              longitude: -120.29313,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9744,
              city: 'Edgewood',
              latitude: 47.2501,
              longitude: -122.29373,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9745,
              city: 'Edmonds',
              latitude: 47.81065,
              longitude: -122.37736,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9746,
              city: 'Electric City',
              latitude: 47.93237,
              longitude: -119.03808,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9747,
              city: 'Ellensburg',
              latitude: 46.99651,
              longitude: -120.54785,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9748,
              city: 'Elma',
              latitude: 47.00343,
              longitude: -123.40877,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9749,
              city: 'Entiat',
              latitude: 47.67596,
              longitude: -120.20841,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9750,
              city: 'Enumclaw',
              latitude: 47.20218,
              longitude: -121.98898,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9751,
              city: 'Ephrata',
              latitude: 47.31764,
              longitude: -119.55365,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9752,
              city: 'Everett',
              latitude: 47.97898,
              longitude: -122.20208,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9753,
              city: 'Everson',
              latitude: 48.92012,
              longitude: -122.34266,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9754,
              city: 'Federal Way',
              latitude: 47.32232,
              longitude: -122.31262,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9755,
              city: 'Ferndale',
              latitude: 48.8465,
              longitude: -122.59101,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9756,
              city: 'Fife',
              latitude: 47.23927,
              longitude: -122.35707,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9757,
              city: 'Fircrest',
              latitude: 47.23954,
              longitude: -122.51596,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9758,
              city: 'Forks',
              latitude: 47.95036,
              longitude: -124.38549,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9759,
              city: 'George',
              latitude: 47.07902,
              longitude: -119.85588,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9760,
              city: 'Gig Harbor',
              latitude: 47.32926,
              longitude: -122.58013,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9761,
              city: 'Gold Bar',
              latitude: 47.85677,
              longitude: -121.69706,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9762,
              city: 'Goldendale',
              latitude: 45.82068,
              longitude: -120.82173,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9763,
              city: 'Grand Coulee',
              latitude: 47.94154,
              longitude: -119.00335,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9764,
              city: 'Grandview',
              latitude: 46.25097,
              longitude: -119.9017,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9765,
              city: 'Granger',
              latitude: 46.34207,
              longitude: -120.18727,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9766,
              city: 'Granite Falls',
              latitude: 48.08399,
              longitude: -121.96874,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9767,
              city: 'Harrington',
              latitude: 47.48099,
              longitude: -118.25442,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9768,
              city: 'Hoquiam',
              latitude: 46.98092,
              longitude: -123.88933,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9769,
              city: 'Ilwaco',
              latitude: 46.30899,
              longitude: -124.04321,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9770,
              city: 'Issaquah',
              latitude: 47.5301,
              longitude: -122.03262,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9771,
              city: 'Kahlotus',
              latitude: 46.6432,
              longitude: -118.55693,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9772,
              city: 'Kalama',
              latitude: 46.00845,
              longitude: -122.84455,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9773,
              city: 'Kelso',
              latitude: 46.14678,
              longitude: -122.90844,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9774,
              city: 'Kenmore',
              latitude: 47.75732,
              longitude: -122.24401,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9775,
              city: 'Kennewick',
              latitude: 46.21125,
              longitude: -119.13723,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9776,
              city: 'Kent',
              latitude: 47.38093,
              longitude: -122.23484,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9777,
              city: 'Kettle Falls',
              latitude: 48.61074,
              longitude: -118.05582,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9778,
              city: 'Kirkland',
              latitude: 47.68149,
              longitude: -122.20874,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9779,
              city: 'Kittitas',
              latitude: 46.98318,
              longitude: -120.41701,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9780,
              city: 'La Center',
              latitude: 45.86234,
              longitude: -122.67038,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9781,
              city: 'Lacey',
              latitude: 47.03426,
              longitude: -122.82319,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9782,
              city: 'Lake Forest Park',
              latitude: 47.75676,
              longitude: -122.28096,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9783,
              city: 'Lake Stevens',
              latitude: 48.0151,
              longitude: -122.06374,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9784,
              city: 'Lakewood',
              latitude: 47.17176,
              longitude: -122.51846,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9785,
              city: 'Langley',
              latitude: 48.04009,
              longitude: -122.40626,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9786,
              city: 'Leavenworth',
              latitude: 47.59623,
              longitude: -120.66148,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9787,
              city: 'Liberty Lake',
              latitude: 47.64823,
              longitude: -117.09242,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9788,
              city: 'Long Beach',
              latitude: 46.35232,
              longitude: -124.05432,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9789,
              city: 'Longview',
              latitude: 46.13817,
              longitude: -122.93817,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9790,
              city: 'Lynden',
              latitude: 48.9465,
              longitude: -122.45211,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9791,
              city: 'Lynnwood',
              latitude: 47.82093,
              longitude: -122.31513,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9792,
              city: 'Mabton',
              latitude: 46.21485,
              longitude: -119.99671,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9793,
              city: 'Maple Valley',
              latitude: 47.39272,
              longitude: -122.04641,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9794,
              city: 'Marysville',
              latitude: 48.05176,
              longitude: -122.17708,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9795,
              city: 'Mattawa',
              latitude: 46.73791,
              longitude: -119.90282,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9796,
              city: 'McCleary',
              latitude: 47.05315,
              longitude: -123.26543,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9797,
              city: 'Medical Lake',
              latitude: 47.57294,
              longitude: -117.68216,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9798,
              city: 'Medina',
              latitude: 47.62093,
              longitude: -122.22762,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9799,
              city: 'Mercer Island',
              latitude: 47.57065,
              longitude: -122.22207,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9800,
              city: 'Mesa',
              latitude: 46.57625,
              longitude: -119.00667,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9801,
              city: 'Mill Creek',
              latitude: 47.8601,
              longitude: -122.2043,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9802,
              city: 'Millwood',
              latitude: 47.68128,
              longitude: -117.28271,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9803,
              city: 'Milton',
              latitude: 47.25199,
              longitude: -122.31729,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9804,
              city: 'Monroe',
              latitude: 47.85538,
              longitude: -121.97096,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9805,
              city: 'Montesano',
              latitude: 46.98121,
              longitude: -123.60266,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9806,
              city: 'Morton',
              latitude: 46.55844,
              longitude: -122.2751,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9807,
              city: 'Moses Lake',
              latitude: 47.13014,
              longitude: -119.27808,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9808,
              city: 'Mossyrock',
              latitude: 46.52955,
              longitude: -122.48511,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9810,
              city: 'Mount Vernon',
              latitude: 48.42122,
              longitude: -122.33405,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9809,
              city: 'Mountlake Terrace',
              latitude: 47.78815,
              longitude: -122.30874,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9811,
              city: 'Moxee',
              latitude: 46.55374,
              longitude: -120.38312,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9812,
              city: 'Mukilteo',
              latitude: 47.94454,
              longitude: -122.30458,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9813,
              city: 'Napavine',
              latitude: 46.57455,
              longitude: -122.90818,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9814,
              city: 'Newcastle',
              latitude: 47.53899,
              longitude: -122.15568,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9815,
              city: 'Newport',
              latitude: 48.17963,
              longitude: -117.04326,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9816,
              city: 'Nooksack',
              latitude: 48.92762,
              longitude: -122.32155,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9817,
              city: 'Normandy Park',
              latitude: 47.43621,
              longitude: -122.34068,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9818,
              city: 'North Bend',
              latitude: 47.49566,
              longitude: -121.78678,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9819,
              city: 'North Bonneville',
              latitude: 45.63734,
              longitude: -121.97119,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9820,
              city: 'Oak Harbor',
              latitude: 48.29316,
              longitude: -122.64322,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9821,
              city: 'Oakville',
              latitude: 46.84038,
              longitude: -123.23237,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9822,
              city: 'Ocean Shores',
              latitude: 46.9737,
              longitude: -124.15629,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9823,
              city: 'Okanogan',
              latitude: 48.36126,
              longitude: -119.58339,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9824,
              city: 'Olympia',
              latitude: 47.03787,
              longitude: -122.9007,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9825,
              city: 'Omak',
              latitude: 48.41099,
              longitude: -119.52755,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9826,
              city: 'Oroville',
              latitude: 48.93905,
              longitude: -119.43562,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9827,
              city: 'Orting',
              latitude: 47.09788,
              longitude: -122.20428,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9828,
              city: 'Othello',
              latitude: 46.82597,
              longitude: -119.17529,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9829,
              city: 'Pacific',
              latitude: 47.26197,
              longitude: -122.25243,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9830,
              city: 'Palouse',
              latitude: 46.91017,
              longitude: -117.07573,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9831,
              city: 'Pasco',
              latitude: 46.23958,
              longitude: -119.10057,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9832,
              city: 'Pateros',
              latitude: 48.05098,
              longitude: -119.9034,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9833,
              city: 'Pomeroy',
              latitude: 46.47487,
              longitude: -117.60269,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9834,
              city: 'Port Angeles',
              latitude: 48.11815,
              longitude: -123.43074,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9835,
              city: 'Port Orchard',
              latitude: 47.54037,
              longitude: -122.63625,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9836,
              city: 'Port Townsend',
              latitude: 48.11704,
              longitude: -122.76045,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9837,
              city: 'Poulsbo',
              latitude: 47.73593,
              longitude: -122.64654,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9838,
              city: 'Prescott',
              latitude: 46.29958,
              longitude: -118.31497,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9839,
              city: 'Prosser',
              latitude: 46.2068,
              longitude: -119.76892,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9840,
              city: 'Pullman',
              latitude: 46.73127,
              longitude: -117.17962,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9841,
              city: 'Puyallup',
              latitude: 47.18538,
              longitude: -122.2929,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9842,
              city: 'Quincy',
              latitude: 47.2343,
              longitude: -119.85255,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9843,
              city: 'Rainier',
              latitude: 46.88816,
              longitude: -122.68846,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9844,
              city: 'Raymond',
              latitude: 46.68649,
              longitude: -123.73294,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9845,
              city: 'Redmond',
              latitude: 47.67399,
              longitude: -122.12151,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9846,
              city: 'Renton',
              latitude: 47.48288,
              longitude: -122.21707,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9847,
              city: 'Republic',
              latitude: 48.64822,
              longitude: -118.73781,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9848,
              city: 'Richland',
              latitude: 46.28569,
              longitude: -119.28446,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9849,
              city: 'Ridgefield',
              latitude: 45.81512,
              longitude: -122.7426,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9850,
              city: 'Ritzville',
              latitude: 47.12737,
              longitude: -118.37998,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9851,
              city: 'Rock Island',
              latitude: 47.37707,
              longitude: -120.14395,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9852,
              city: 'Roslyn',
              latitude: 47.22345,
              longitude: -120.99314,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9853,
              city: 'Roy',
              latitude: 47.00426,
              longitude: -122.53985,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9854,
              city: 'Royal City',
              latitude: 46.90097,
              longitude: -119.63059,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9855,
              city: 'Sammamish',
              latitude: 47.64177,
              longitude: -122.0804,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9856,
              city: 'SeaTac',
              latitude: 47.45371,
              longitude: -122.32179,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9857,
              city: 'Seattle',
              latitude: 47.60621,
              longitude: -122.33207,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9858,
              city: 'Sedro-Woolley',
              latitude: 48.50389,
              longitude: -122.23611,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9859,
              city: 'Selah',
              latitude: 46.65402,
              longitude: -120.53007,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9860,
              city: 'Sequim',
              latitude: 48.07954,
              longitude: -123.10184,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9861,
              city: 'Shelton',
              latitude: 47.21509,
              longitude: -123.10071,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9862,
              city: 'Shoreline',
              latitude: 47.75565,
              longitude: -122.34152,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9863,
              city: 'Snohomish',
              latitude: 47.91288,
              longitude: -122.09818,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9864,
              city: 'Snoqualmie',
              latitude: 47.52871,
              longitude: -121.82539,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9865,
              city: 'Soap Lake',
              latitude: 47.38931,
              longitude: -119.49059,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9866,
              city: 'South Bend',
              latitude: 46.66315,
              longitude: -123.80461,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9867,
              city: 'Spangle',
              latitude: 47.42739,
              longitude: -117.3802,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9868,
              city: 'Spokane',
              latitude: 47.65878,
              longitude: -117.42605,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9869,
              city: 'Spokane Valley',
              latitude: 47.67323,
              longitude: -117.23937,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9870,
              city: 'Sprague',
              latitude: 47.30016,
              longitude: -117.97551,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9871,
              city: 'Stanwood',
              latitude: 48.24121,
              longitude: -122.37071,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9872,
              city: 'Stevenson',
              latitude: 45.69567,
              longitude: -121.88452,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9873,
              city: 'Sultan',
              latitude: 47.8626,
              longitude: -121.81651,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9874,
              city: 'Sumas',
              latitude: 49.00012,
              longitude: -122.26488,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9875,
              city: 'Sumner',
              latitude: 47.20316,
              longitude: -122.2404,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9876,
              city: 'Sunnyside',
              latitude: 46.32374,
              longitude: -120.00865,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9877,
              city: 'Tacoma',
              latitude: 47.25288,
              longitude: -122.44429,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9878,
              city: 'Tekoa',
              latitude: 47.22323,
              longitude: -117.07212,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9879,
              city: 'Tenino',
              latitude: 46.85677,
              longitude: -122.85291,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9880,
              city: 'Tieton',
              latitude: 46.70207,
              longitude: -120.75535,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9881,
              city: 'Toledo',
              latitude: 46.43983,
              longitude: -122.84678,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9882,
              city: 'Tonasket',
              latitude: 48.70515,
              longitude: -119.4395,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9883,
              city: 'Toppenish',
              latitude: 46.37735,
              longitude: -120.30867,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9884,
              city: 'Tukwila',
              latitude: 47.47399,
              longitude: -122.26096,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9885,
              city: 'Tumwater',
              latitude: 47.00732,
              longitude: -122.90931,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9886,
              city: 'Union Gap',
              latitude: 46.55735,
              longitude: -120.47506,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9887,
              city: 'University Place',
              latitude: 47.23565,
              longitude: -122.5504,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9888,
              city: 'Vader',
              latitude: 46.40261,
              longitude: -122.9604,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9889,
              city: 'Vancouver',
              latitude: 45.63873,
              longitude: -122.66149,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9890,
              city: 'Waitsburg',
              latitude: 46.27042,
              longitude: -118.15329,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9891,
              city: 'Walla Walla',
              latitude: 46.06458,
              longitude: -118.34302,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9892,
              city: 'Wapato',
              latitude: 46.44763,
              longitude: -120.42034,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9893,
              city: 'Warden',
              latitude: 46.96764,
              longitude: -119.03973,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9894,
              city: 'Washougal',
              latitude: 45.58262,
              longitude: -122.35342,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9895,
              city: 'Wenatchee',
              latitude: 47.42346,
              longitude: -120.31035,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9897,
              city: 'West Richland',
              latitude: 46.3043,
              longitude: -119.36141,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9896,
              city: 'Westport',
              latitude: 46.89009,
              longitude: -124.10406,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9898,
              city: 'White Salmon',
              latitude: 45.72762,
              longitude: -121.48646,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9899,
              city: 'Winlock',
              latitude: 46.49122,
              longitude: -122.9379,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9900,
              city: 'Woodinville',
              latitude: 47.75427,
              longitude: -122.16346,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9901,
              city: 'Woodland',
              latitude: 45.91818,
              longitude: -122.7535,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9902,
              city: 'Woodway',
              latitude: 47.79621,
              longitude: -122.38291,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9903,
              city: 'Yakima',
              latitude: 46.60207,
              longitude: -120.5059,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9904,
              city: 'Yelm',
              latitude: 46.94204,
              longitude: -122.60596,
              timezone: 'America/Los_Angeles'
          },
          {
              id: 9905,
              city: 'Zillah',
              latitude: 46.40207,
              longitude: -120.262,
              timezone: 'America/Los_Angeles'
          }
      ]
    },
    ];
